const shopifyPage = window.Shopify?.template || '';
const params = new URLSearchParams(window.location.search);
window.skipInitialChatLoad = false;

 if (!sessionStorage.getItem('is_history')) {
    sessionStorage.setItem('is_history', 'true');
  }

 //$('.preloader').show();

 // For User Name in user-message and profile-pic start

function getInitials(name) {
  if (!name) return 'You'; // fallback
  let parts = name.trim().split(' ').filter(Boolean);
  let initials = parts[0]?.charAt(0).toUpperCase() || '';
  if (parts.length > 1) {
    initials += parts[parts.length - 1].charAt(0).toUpperCase();
  }
  return initials || 'You';
}

function getUserInitials() {
  let userName = localStorage.getItem('user_name');
  return getInitials(userName);
}
function updateUserInitials() {
  let userName = localStorage.getItem('user_name');
  let userInitials = getInitials(userName);
  $('.profile-pic').text(userInitials);
}

// ✅ Run once on page load
updateUserInitials();

 // For User Name in user-message and profile-pic ends

// freezeActions and releaseActions used to disable the buttons etc untill server response

// --- 🚫 Freeze / 🔓 Release actions ---
// function freezeActions() {
//   console.log("🧊 Actions frozen");
//   $('.delete-filter, .change-filter, .prompt-btn').prop('disabled', true);
//   $('#chat_input_text, #chat_send_btn').prop('disabled', true);

//     $('.suggestion-wrapper').empty();
//     $('.register-chat-suggestions').empty();
//     $('.subcategory-wrapper').empty();
//     $('.history-toggle-1, .history-toggle-2').hide();
//     $('.toggle-makeyours, .toggle-refilter').css({'pointer-events': 'none','opacity': '0.5'});
//     $('#global-chat-dropdown li').css({'pointer-events': 'none','opacity': '0.5','cursor': 'not-allowed' });
  
// }

// function releaseActions() {
//   console.log("🔥 Actions released");
//   $('.delete-filter, .change-filter, .prompt-btn').prop('disabled', false);
//   $('#chat_input_text, #chat_send_btn').prop('disabled', false);
//   $('.mobile-screen').css('height', '');
//   // $(".message-update-size").remove();
//   $('.suggestion-wrapper').empty();
//   $('.register-chat-suggestions').empty();
//   $('.subcategory-wrapper').empty();
//   $('.history-toggle-1, .history-toggle-2').hide();
//   $('.toggle-makeyours, .toggle-refilter').css({'pointer-events': '','opacity': ''});
//   $('#global-chat-dropdown li').css({'pointer-events': '','opacity': '','cursor': ''});
//   hideDuplicateUserMessages();
// }

function freezeActions() {
  console.log("🧊 Actions frozen");

  const $deleteFilter = $('.delete-filter');
  const $changeFilter = $('.change-filter');
  const $promptBtn = $('.prompt-btn');
  if ($deleteFilter.length) $deleteFilter.prop('disabled', true);
  if ($changeFilter.length) $changeFilter.prop('disabled', true);
  if ($promptBtn.length) $promptBtn.prop('disabled', true);

  const $chatInput = $('#chat_input_text');
  const $chatSend = $('#chat_send_btn');
  if ($chatInput.length) $chatInput.prop('disabled', true);
  if ($chatSend.length) $chatSend.prop('disabled', true);

  const $suggestionWrapper = $('.suggestion-wrapper');
  const $registerSuggestions = $('.register-chat-suggestions');
  const $subcategoryWrapper = $('.subcategory-wrapper');
  if ($suggestionWrapper.length) $suggestionWrapper.empty();
  if ($registerSuggestions.length) $registerSuggestions.empty();
  if ($subcategoryWrapper.length) $subcategoryWrapper.empty();

  const $historyToggle1 = $('.history-toggle-1');
  const $historyToggle2 = $('.history-toggle-2');
  if ($historyToggle1.length) $historyToggle1.hide();
  if ($historyToggle2.length) $historyToggle2.hide();

  const $toggleMakeyours = $('.toggle-makeyours');
  const $toggleRefilter = $('.toggle-refilter');
  if ($toggleMakeyours.length) $toggleMakeyours.css({'pointer-events': 'none', 'opacity': '0.5'});
  if ($toggleRefilter.length) $toggleRefilter.css({'pointer-events': 'none', 'opacity': '0.5'});

  $('.chat-tag-dropdown').hide();
  const $dropdownLi = $('#global-chat-dropdown li');
  if ($dropdownLi.length) $dropdownLi.css({'pointer-events': 'none', 'opacity': '0.5', 'cursor': 'not-allowed'});
  

  // Chat sidebar
  const $sidebarAddToCart = $('.chat-sidebar-add-to-cart');
  const $sidebarWishlist = $('.chat-sidebar-wishlist');
  const $sidebarSizeGuide = $('.chat-sidebar-size-guide');
  const $chatColor = $('input[name="chat-color"]');
  const $chatSize = $('input[name="chat-size"]');
  if ($sidebarAddToCart.length) $sidebarAddToCart.prop('disabled', true);
  if ($sidebarWishlist.length) $sidebarWishlist.css({'pointer-events': 'none', 'opacity': '0.5'});
  if ($sidebarSizeGuide.length) $sidebarSizeGuide.prop('disabled', true);
  if ($chatColor.length) $chatColor.prop('disabled', true);
  if ($chatSize.length) $chatSize.prop('disabled', true);

  // Product card buttons
  const $findSimilar = $('.chat-find-similar-item');
  const $cartBtn = $('.cart-btn');
  const $addBtnAction = $('.add-btn-action');
  const $cancelBtnAction = $('.cancel-btn-action');
  const $colourTag = $('.colour-tag');
  const $sizePill = $('.size-pill');
  const $renderInSidebar = $('.render-in-sidebar');
  if ($findSimilar.length) $findSimilar.prop('disabled', true);
  if ($cartBtn.length) $cartBtn.prop('disabled', true);
  if ($addBtnAction.length) $addBtnAction.prop('disabled', true);
  if ($cancelBtnAction.length) $cancelBtnAction.prop('disabled', true);
  if ($colourTag.length) $colourTag.prop('disabled', true);
  if ($sizePill.length) $sizePill.prop('disabled', true);
  if ($renderInSidebar.length) $renderInSidebar.css({'pointer-events': 'none'});

  // Load more
  const $loadMore = $('.chat-load-more');
  if ($loadMore.length) $loadMore.prop('disabled', true);

  // Size update buttons
  const $sizeUpdateOpen = $('.chat-update-size-btn-open');
  const $sizeUpdateTrigger = $('.chat-update-size-btn-trigger');
  const $sizeUpdateBtn = $('.chat-update-size-btn');
  const $sizeUpdateSave = $('#chat-update-size-save');
  const $sizeUpdateClose = $('#chat-update-size-close');
  if ($sizeUpdateOpen.length) $sizeUpdateOpen.prop('disabled', true);
  if ($sizeUpdateTrigger.length) $sizeUpdateTrigger.prop('disabled', true);
  if ($sizeUpdateBtn.length) $sizeUpdateBtn.prop('disabled', true);
  if ($sizeUpdateSave.length) $sizeUpdateSave.prop('disabled', true);
  if ($sizeUpdateClose.length) $sizeUpdateClose.prop('disabled', true);

  // Profile / user data
  const $profilePic = $('.profile-pic');
  const $userDataSave = $('#chat-update-user-data-save');
  const $userDataClose = $('#chat-update-user-data-close');
  if ($profilePic.length) $profilePic.prop('disabled', true);
  if ($userDataSave.length) $userDataSave.prop('disabled', true);
  if ($userDataClose.length) $userDataClose.prop('disabled', true);

  // Reset buttons
  const $resetBtn = $('#resetBtn');
  const $resetBtnTop = $('#reset-btn-top');
  const $resetBtnTopLink = $('#reset-btn-top-link');
  if ($resetBtn.length) $resetBtn.prop('disabled', true).css({'pointer-events': 'none', 'opacity': '0.5'});
  if ($resetBtnTop.length) $resetBtnTop.prop('disabled', true).css({'pointer-events': 'none', 'opacity': '0.5'});
  if ($resetBtnTopLink.length) $resetBtnTopLink.prop('disabled', true).css({'pointer-events': 'none', 'opacity': '0.5'});

  // Mic button
  const $micBtn = $('#mic_btn');
  if ($micBtn.length) $micBtn.css({'pointer-events': 'none', 'opacity': '0.5'});

  // Swipe card buttons
  const $love = $('#love');
  const $nope = $('#nope');
  const $undo = $('#undo');
  const $getStarted = $('.chat-like-dislike-get-started');
  if ($love.length) $love.prop('disabled', true);
  if ($nope.length) $nope.prop('disabled', true);
  if ($undo.length) $undo.prop('disabled', true);
  if ($getStarted.length) $getStarted.prop('disabled', true);

  // Welcome intro buttons
  const $introNext = $('#chat-welcome-intro-next-btn');
  const $introPrev = $('#chat-welcome-intro-prev-btn');
  const $introSkip = $('#chat-welcome-intro-skip-btn');
  if ($introNext.length) $introNext.prop('disabled', true);
  if ($introPrev.length) $introPrev.prop('disabled', true);
  if ($introSkip.length) $introSkip.prop('disabled', true);

  // Discount claim button
  const $discountBtn = $('.show_discount-btn-primary');
  if ($discountBtn.length) $discountBtn.prop('disabled', true).css({'pointer-events': 'none'});

  // Register form
  const $registerSendBtn = $('.chat-register-new-send-button');
  const $registerSuggestionBtn = $('.chat-register-new-suggestion-button');
  if ($registerSendBtn.length) $registerSendBtn.prop('disabled', true);
  if ($registerSuggestionBtn.length) $registerSuggestionBtn.prop('disabled', true);

  // Your sizes
  const $yourSizeBtn = $('.your-size-btn');
  if ($yourSizeBtn.length) $yourSizeBtn.css({'pointer-events': 'none', 'opacity': '0.5'});

  // Alternative section & filter buttons
  const $altSectionBtn = $('.chat-alternative-section button');
  const $filterBtn = $('.filter-btn');
  if ($altSectionBtn.length) $altSectionBtn.prop('disabled', true);
  if ($filterBtn.length) $filterBtn.prop('disabled', true);

  // ai-page return/exchange/alteration panels
  const aiPageReturnPanelSelectors = [
    '.ai-page-li-checkbox',
    '.ai-page-li-reason',
    '.ai-page-li-process-btn',
    '.ai-page-li-view-details-btn',
    '.ai-page-li-outlet-radio',
    '.ai-page-li-addtoprev-radio',
    '.ai-page-li-terms-chk',
    '.ai-page-li-outlet-acc-header',
    '.ai-page-li-specific-reason',
    '.ai-page-li-upload-btn',
    '.ai-page-li-faulty-remove',
    '.ai-page-li-opt-card',
    '.ai-page-li-file-input',
    '.ai-page-ex-chk',
    '.ai-page-ex-available-option',
    '.ai-page-ex-reason',
    '.ai-page-ex-specific-reason',
    '.ai-page-ex-terms-chk',
    '.ai-page-alt-chk',
    '.ai-page-alt-length',
    '.ai-page-alt-note',
    '.ai-page-alt-terms-chk',
    '.ai-page-pay-now-btn',
    '.ai-page-pay-acc-header',
    '.ai-page-pay-close',
    '.ai-page-li-req-acc-header',
    '.ai-page-req-dl-btn',
    '.ai-page-li-req-show-more-btn',
    '.ai-page-req-show-more-btn',
    '.ai-page-req-faulty-thumb',
    '.ai-page-img-popup-nav',
    '.ai-page-img-popup-close',
  ];
  aiPageReturnPanelSelectors.forEach(selector => {
    const els = document.querySelectorAll(selector);
    if (els.length) {
      els.forEach(el => {
        el.disabled = true;
        el.style.pointerEvents = 'none';
        el.style.opacity = '0.5';
      });
    }
  });

  document.querySelectorAll(
    '.ai-page-li-panel button, .ai-page-ex-panel button, .ai-page-alt-panel button'
  ).forEach(btn => {
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.5';
  });

  document.querySelectorAll(
    '.ai-page-li-requested-separator button, ' +
    '.ai-page-li-req-accordion .ai-page-li-req-acc-header, ' +
    '.ai-page-li-requested-only button'
  ).forEach(btn => {
    btn.disabled = true;
    btn.style.pointerEvents = 'none';
    btn.style.opacity = '0.5';
  });
}

function releaseActions() {
  console.log("🔥 Actions released");

  const $deleteFilter = $('.delete-filter');
  const $changeFilter = $('.change-filter');
  const $promptBtn = $('.prompt-btn');
  if ($deleteFilter.length) $deleteFilter.prop('disabled', false);
  if ($changeFilter.length) $changeFilter.prop('disabled', false);
  if ($promptBtn.length) $promptBtn.prop('disabled', false);

  const $chatInput = $('#chat_input_text');
  const $chatSend = $('#chat_send_btn');
  if ($chatInput.length) $chatInput.prop('disabled', false);
  if ($chatSend.length) $chatSend.prop('disabled', false);

  const $mobileScreen = $('.mobile-screen');
  if ($mobileScreen.length) $mobileScreen.css('height', '');

  const $suggestionWrapper = $('.suggestion-wrapper');
  const $registerSuggestions = $('.register-chat-suggestions');
  const $subcategoryWrapper = $('.subcategory-wrapper');
  if ($suggestionWrapper.length) $suggestionWrapper.empty();
  if ($registerSuggestions.length) $registerSuggestions.empty();
  if ($subcategoryWrapper.length) $subcategoryWrapper.empty();

  const $historyToggle1 = $('.history-toggle-1');
  const $historyToggle2 = $('.history-toggle-2');
  if ($historyToggle1.length) $historyToggle1.hide();
  if ($historyToggle2.length) $historyToggle2.hide();

  const $toggleMakeyours = $('.toggle-makeyours');
  const $toggleRefilter = $('.toggle-refilter');
  if ($toggleMakeyours.length) $toggleMakeyours.css({'pointer-events': '', 'opacity': ''});
  if ($toggleRefilter.length) $toggleRefilter.css({'pointer-events': '', 'opacity': ''});

  
  const $dropdownLi = $('#global-chat-dropdown li');
  if ($dropdownLi.length) $dropdownLi.css({'pointer-events': '', 'opacity': '', 'cursor': ''});

  // Chat sidebar
  const $sidebarAddToCart = $('.chat-sidebar-add-to-cart');
  const $sidebarWishlist = $('.chat-sidebar-wishlist');
  const $sidebarSizeGuide = $('.chat-sidebar-size-guide');
  const $chatColor = $('input[name="chat-color"]');
  const $chatSize = $('input[name="chat-size"]');
  if ($sidebarAddToCart.length) $sidebarAddToCart.prop('disabled', false);
  if ($sidebarWishlist.length) $sidebarWishlist.css({'pointer-events': '', 'opacity': ''});
  if ($sidebarSizeGuide.length) $sidebarSizeGuide.prop('disabled', false);
  if ($chatColor.length) $chatColor.prop('disabled', false);
  if ($chatSize.length) $chatSize.prop('disabled', false);

  // Product card buttons
  const $findSimilar = $('.chat-find-similar-item');
  const $cartBtn = $('.cart-btn');
  const $addBtnAction = $('.add-btn-action');
  const $cancelBtnAction = $('.cancel-btn-action');
  const $colourTag = $('.colour-tag');
  const $sizePill = $('.size-pill');
  const $renderInSidebar = $('.render-in-sidebar');
  if ($findSimilar.length) $findSimilar.prop('disabled', false);
  if ($cartBtn.length) $cartBtn.prop('disabled', false);
  if ($addBtnAction.length) $addBtnAction.prop('disabled', false);
  if ($cancelBtnAction.length) $cancelBtnAction.prop('disabled', false);
  if ($colourTag.length) $colourTag.prop('disabled', false);
  if ($sizePill.length) $sizePill.prop('disabled', false);
  if ($renderInSidebar.length) $renderInSidebar.css({'pointer-events': ''});

  // Load more
  const $loadMore = $('.chat-load-more');
  if ($loadMore.length) $loadMore.prop('disabled', false);

  // Size update buttons
  const $sizeUpdateOpen = $('.chat-update-size-btn-open');
  const $sizeUpdateTrigger = $('.chat-update-size-btn-trigger');
  const $sizeUpdateBtn = $('.chat-update-size-btn');
  const $sizeUpdateSave = $('#chat-update-size-save');
  const $sizeUpdateClose = $('#chat-update-size-close');
  if ($sizeUpdateOpen.length) $sizeUpdateOpen.prop('disabled', false);
  if ($sizeUpdateTrigger.length) $sizeUpdateTrigger.prop('disabled', false);
  if ($sizeUpdateBtn.length) $sizeUpdateBtn.prop('disabled', false);
  if ($sizeUpdateSave.length) $sizeUpdateSave.prop('disabled', false);
  if ($sizeUpdateClose.length) $sizeUpdateClose.prop('disabled', false);

  // Profile / user data
  const $profilePic = $('.profile-pic');
  const $userDataSave = $('#chat-update-user-data-save');
  const $userDataClose = $('#chat-update-user-data-close');
  if ($profilePic.length) $profilePic.prop('disabled', false);
  if ($userDataSave.length) $userDataSave.prop('disabled', false);
  if ($userDataClose.length) $userDataClose.prop('disabled', false);

  // Reset buttons
  const $resetBtn = $('#resetBtn');
  const $resetBtnTop = $('#reset-btn-top');
  const $resetBtnTopLink = $('#reset-btn-top-link');
  if ($resetBtn.length) $resetBtn.prop('disabled', false).css({'pointer-events': '', 'opacity': ''});
  if ($resetBtnTop.length) $resetBtnTop.prop('disabled', false).css({'pointer-events': '', 'opacity': ''});
  if ($resetBtnTopLink.length) $resetBtnTopLink.prop('disabled', false).css({'pointer-events': '', 'opacity': ''});

  // Mic button
  const $micBtn = $('#mic_btn');
  if ($micBtn.length) $micBtn.css({'pointer-events': '', 'opacity': ''});

  // Swipe card buttons
  const $love = $('#love');
  const $nope = $('#nope');
  const $undo = $('#undo');
  const $getStarted = $('.chat-like-dislike-get-started');
  if ($love.length) $love.prop('disabled', false);
  if ($nope.length) $nope.prop('disabled', false);
  if ($undo.length) $undo.prop('disabled', false);
  if ($getStarted.length) $getStarted.prop('disabled', false);

  // Welcome intro buttons
  const $introNext = $('#chat-welcome-intro-next-btn');
  const $introPrev = $('#chat-welcome-intro-prev-btn');
  const $introSkip = $('#chat-welcome-intro-skip-btn');
  if ($introNext.length) $introNext.prop('disabled', false);
  if ($introPrev.length) $introPrev.prop('disabled', false);
  if ($introSkip.length) $introSkip.prop('disabled', false);

  // Discount claim button
  const $discountBtn = $('.show_discount-btn-primary');
  if ($discountBtn.length) $discountBtn.prop('disabled', false).css({'pointer-events': ''});

  // Register form
  const $registerSendBtn = $('.chat-register-new-send-button');
  const $registerSuggestionBtn = $('.chat-register-new-suggestion-button');
  if ($registerSendBtn.length) $registerSendBtn.prop('disabled', false);
  if ($registerSuggestionBtn.length) $registerSuggestionBtn.prop('disabled', false);

  // Your sizes
  const $yourSizeBtn = $('.your-size-btn');
  if ($yourSizeBtn.length) $yourSizeBtn.css({'pointer-events': '', 'opacity': ''});

  // Alternative section & filter buttons
  const $altSectionBtn = $('.chat-alternative-section button');
  const $filterBtn = $('.filter-btn');
  if ($altSectionBtn.length) $altSectionBtn.prop('disabled', false);
  if ($filterBtn.length) $filterBtn.prop('disabled', false);

  hideDuplicateUserMessages();

  // ai-page return/exchange/alteration panels
  const aiPageReturnPanelSelectors = [
    '.ai-page-li-checkbox',
    '.ai-page-li-reason',
    '.ai-page-li-process-btn',
    '.ai-page-li-view-details-btn',
    '.ai-page-li-outlet-radio',
    '.ai-page-li-addtoprev-radio',
    '.ai-page-li-terms-chk',
    '.ai-page-li-outlet-acc-header',
    '.ai-page-li-specific-reason',
    '.ai-page-li-upload-btn',
    '.ai-page-li-faulty-remove',
    '.ai-page-li-opt-card',
    '.ai-page-li-file-input',
    '.ai-page-ex-chk',
    '.ai-page-ex-available-option',
    '.ai-page-ex-reason',
    '.ai-page-ex-specific-reason',
    '.ai-page-ex-terms-chk',
    '.ai-page-alt-chk',
    '.ai-page-alt-length',
    '.ai-page-alt-note',
    '.ai-page-alt-terms-chk',
    '.ai-page-pay-now-btn',
    '.ai-page-pay-acc-header',
    '.ai-page-pay-close',
    '.ai-page-li-req-acc-header',
    '.ai-page-req-dl-btn',
    '.ai-page-li-req-show-more-btn',
    '.ai-page-req-show-more-btn',
    '.ai-page-req-faulty-thumb',
    '.ai-page-img-popup-nav',
    '.ai-page-img-popup-close',
  ];
  aiPageReturnPanelSelectors.forEach(selector => {
    const els = document.querySelectorAll(selector);
    if (els.length) {
      els.forEach(el => {
        el.style.pointerEvents = '';
        el.style.opacity = '';
        const frozenPanel = el.closest(
          '.ai-page-li-panel-frozen, .ai-page-panel-stale'
        );
        if (!frozenPanel) {
          el.disabled = false;
        }
      });
    }
  });

  document.querySelectorAll(
    '.ai-page-li-panel button, .ai-page-ex-panel button, .ai-page-alt-panel button'
  ).forEach(btn => {
    const frozenPanel = btn.closest(
      '.ai-page-li-panel-frozen, .ai-page-panel-stale'
    );
    btn.style.pointerEvents = frozenPanel ? 'none' : '';
    btn.style.opacity = frozenPanel ? '0.5' : '';
    if (!frozenPanel) {
      btn.disabled = false;
    }
  });

  document.querySelectorAll(
    '.ai-page-li-requested-separator button, ' +
    '.ai-page-li-req-accordion .ai-page-li-req-acc-header, ' +
    '.ai-page-li-requested-only button'
  ).forEach(btn => {
    const frozenPanel = btn.closest(
      '.ai-page-li-panel-frozen, .ai-page-panel-stale'
    );
    btn.style.pointerEvents = frozenPanel ? 'none' : '';
    btn.style.opacity = frozenPanel ? '0.5' : '';
    if (!frozenPanel) {
      btn.disabled = false;
    }
  });
}

function hideDuplicateUserMessages() {
  $('#chat_message .user-message.error').each(function () {
    const $retry = $(this);
    const retryText = $retry.find('.retry-message').text().replace(/\s+/g, ' ').trim();
    // Find normal user message with the same text
    $('#chat_message .user-message').not('.error').each(function () {
      const $normal = $(this);
      const normalText = $normal.find('.user-text').text().replace(/\s+/g, ' ').trim();
      if (retryText && retryText === normalText) {
        $normal.hide();
      }
    });
  });
}

function getAiToken() {
    const access = localStorage.getItem("ai_access_token");
    const refresh = localStorage.getItem("ai_refresh_token");

    return access || refresh || null;
}



  function register(){

        $.ajax({
          url: 'https://ai.mygoddiva.com/get-data', // Sample API endpoint
          type: 'GET',
          success: function(response) {
          let option_html=""; 
          let option_chkhtml=''; // for new welcome screen sizes
          let prompt_html="";  
          //let promt_radiohtml='' // for new welcome screem prompt
          $.each(response.sizes, function(index, value) {
               option_html+="<option value="+value.Id+">"+value.Name+"</option>";

               option_chkhtml+=`<input class="form-check-input size-checkbox" 
                                type="checkbox" 
                                name="size_option" 
                                id="size_${value.Id}" 
                                value="${value.Id}">
                          <label class="form-check-label" for="size_${value.Id}">
                              ${value.Name}
                          </label>`
          });
             $('#multiSelect').empty();
             $('#multiSelect').append(option_html);
            // $('#multiselectsize').empty().append(option_chkhtml);
             $('#multiSelect').select2(
               {placeholder:"select size"}
             );
          $.each(response.prompts[0], function(index, value) {
               prompt_html+="<li data-id="+value.id+">"+value.message+"</li>";
              //  promt_radiohtml+=`
              //   <input class="form-check-input" type="radio" 
              //           name="prompt_option" 
              //           id="prompt_${value.id}" 
              //           value="${value.id}"
              //           required>
              //     <label class="form-check-label" for="prompt_${value.id}">
              //         ${value.message}
              //     </label>
              // `;
          });
            $('#popular_prompt').empty();
            $('#popular_prompt').append(prompt_html);
          //  $('.chat-welcome-screen-quick-actions').empty().append(promt_radiohtml);
           

            $('.preloader').hide();
            handleMobileRedirect();
          },
          error: function(xhr, status, error) {
            $('.api-error').text('An error occurred. Please try again.').show();
            $('#type_looader').hide();
            $('#gooeyEffect').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
            console.error('AJAX Error:', error);
      }
    });


 const validator=$('#myForm').validate({
    rules: {
      name: {
        required: true,
  
      },
      email: {
        required: true,
        email: true
      },
      size:{
        required:true
      }
    },
    messages: {
      username: {
        required: "Please enter your name",
      },
      email: {
        required: "Please enter your email",
        email: "Please enter a valid email address"
      }
    },
    errorElement: 'div',
    errorPlacement: function(error, element) {
      error.css('color', 'red');
                if (element.hasClass('select2-hidden-accessible')) {
      error.insertAfter(element.next('.select2')); // insert after Select2 container
    } else {
      error.insertAfter(element);
    }

    }
  });
  
  let trafficInfo = sessionStorage.getItem("trafficInfo");
  let parsedTrafficInfo = trafficInfo ? JSON.parse(trafficInfo) : {};

  $(document).on('click', '#popular_prompt li', function() {
    $('#myForm').valid()
    const errors=validator.errorList;   
    
    errors.forEach(function(error) {
      console.log(error);
        ;
           return false;;
      })
    if (errors.length >0){
        $(errors[0].element).focus()
      return false;
    }
    const size = $('#multiSelect').select2('data').map(function(item) {
      return {id:item.id,name:item.text};
    });
    $('#popular_prompt').hide();
        const prompt={
              id:$(this).data('id'),
              text:$(this).text(),
              is_delete:0
            }
          let userInitials = getUserInitials();
           $('#type_looader').show();
           $('#section-register').hide();
           $('#section-chat').show()
            $('#chat_message').append('<div class="user-message">' +
                        '<div class="user-logo">' + userInitials + '</div>' +
                        '<div class="user-text">' + $(this).text() + '</div>' +
                      '</div>');
    $.ajax({
          url: 'https://ai.mygoddiva.com/user-register', // Sample API endpoint
          type: 'POST',
         contentType: 'application/json',
          data:JSON.stringify({
            name: $('#assitant_name').val(),
            email: $('#assistant_email').val(),
            size: size,
            ppc_source: parsedTrafficInfo
          }),
          success: function(response) {
           localStorage.setItem('session_id',response.session_id);
           localStorage.setItem('user_id', response.user_id);
           localStorage.setItem('user_email', $('#assistant_email').val());
           localStorage.setItem('user_name', $('#assitant_name').val());
           $('#span_user_name').text($('#assitant_name').val());

           updateUserInitials();
    
            ajaxChat(prompt,null);
        
                
          },
          error: function(xhr, status, error) {
            $('.api-error').text('An error occurred. Please try again.').show();
            $('#gooeyEffect').hide();
            $('#type_looader').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
            console.error('AJAX Error:', error);
      }
    });


    });
  $('#multiSelect').on('change', function () {
       $('#myForm').valid()
  });
  }
  

function aiProductContextHtml(product) {
  return `
    <div class="ai-page-product-context">
      <a href="/products/${product.handle}" target="_blank">
        ${product.title}
      </a>
    </div>
  `;
}


function chatAssistant(id){

   $("#ai-page-underMaintainance").css("display", "none");
   

  if (window.skipInitialChatLoad) {
    window.skipInitialChatLoad = false;
    return;
  }
console.log('chatassistant calling');

  const token = getAiToken();
  const refresh_token = localStorage.getItem("ai_refresh_token");

  $.ajax({
    url: 'https://ai.mygoddiva.com/get-session',
    type: 'POST',                    
    contentType: 'application/json',
    data: JSON.stringify({
      id: id, 
      refresh_token: refresh_token
    }),

    success: function(response) {

      if (response.token) {
          localStorage.setItem("ai_access_token", response.token.access);
          localStorage.setItem("ai_refresh_token", response.token.refresh);
      }

      if(response.session_id){
        localStorage.setItem('session_id',response.session_id);
      }

      $('#chat_message').empty();

      if(response.messages){
        $.each(response.messages, function(index, value) {

          if(value.more_like && value.more_like.length){
            $('#chat_message').append(moreLikeHtml(value.more_like));

          } else {

            if (value.product_info && value.product_info.title) {
                $('#chat_message').append(
                  aiProductContextHtml(value.product_info)
                );
              }

            let userInitials = getUserInitials();
            $('#chat_message').append(`
              <div class="user-message">
                <div class="user-logo">${userInitials}</div>
                <div class="user-text">${value.user_message}</div>
              </div>
            `);
          }

          $('#chat_message').append(
            botResponseHandel(value.bot_response, value.filters, value.prompt_id)
          );

          if (value.products && value.products.total > 0) {
                // ✅ Create the container
                $('#chat_message').append(`
                  <div class="drag-scroll"
                      data-id="${value.id}"
                      data-total="${value.products.total}"
                      data-page="1"
                      data-has="true">
                      <div class="chat-product-item-wrapper"></div>
                  </div>
                `);

                const $newScroll = $('.drag-scroll').last();
                const message_id = $newScroll.data('id');
                
                // ✅ Pass the products from session to initLazyLoad
                initLazyLoad($newScroll, message_id, value.products);
              }

        });
      }

      if(response.selected_filter){
        selectedFilter(response.selected_filter);

        if ($.trim($('#change_Filter_suggestion').html()) !== "") {
          $('.tag-container').hide();
        } else {
          $('.tag-container').show();
        }
      }

      initForm();

      if (response.filter_key) {
        currentFilterKey = response.filter_key;
      }

      console.log('currentFilterKey get-session', currentFilterKey);

      promptHandel(response.prompts, response.filter_key);
      displayChatSuggestions();


      if (response.size && response.size.length) {
        $('#your-sizes').empty();

        const ukIds = $('.chat-register-new-size-checkbox').map(function () {
          return Number($(this).data('id'));
        }).get();

        const uniqueUkSizes = response.size.filter(
          item => ukIds.includes(item.id) && item.name.toLowerCase() !== 'onesize'
        );

        let sizesHtml = '';

        if (uniqueUkSizes.length > 1) {
          const remainingCount = uniqueUkSizes.length - 1;

          const allSizes = uniqueUkSizes
            .map((item, index) => {
              const hiddenClass = index > 0 ? 'hidden-size' : '';
              return `
                <li class="your-size-btn ${hiddenClass}" data-id="${item.id}">
                  ${item.name.trim()}
                </li>
              `;
            })
            .join('');

          sizesHtml = `
            ${allSizes}
            <li class="your-size-btn your-size-more">+ ${remainingCount} more</li>
          `;

        } else if (uniqueUkSizes.length === 1) {
          const onlySize = uniqueUkSizes[0];
          sizesHtml = `
            <li class="your-size-btn" data-id="${onlySize.id}">
              ${onlySize.name.trim()}
            </li>
          `;
        }

        $('#your-sizes').html(sizesHtml);
      }


      // append current product from session
      const storedProduct = sessionStorage.getItem("lastProductId");
      const title = sessionStorage.getItem("lastProductTitle");
      const handle = sessionStorage.getItem("lastProductHandle");


      if (storedProduct && title && handle ) {
        $('#chat_message').append(
          aiProductContextHtml({
            title: title,
            handle: handle
          })
        );
      }


      $('.preloader').hide();
      handleMobileRedirect();
    },

    error: function(xhr, status, error) {
      $("#ai-page-underMaintainance").css("display", "flex");
      if(xhr.status == 422){
        handleMobileRedirect();
        $('#section-register').show();
        $('#section-chat').hide();
        register();
        $('.preloader').hide();
        handleMobileRedirect();
      }

      $('.api-error').text('An error occurred. Please try again.').show();
      $('#gooeyEffect').hide();
      $('#type_looader').hide();

      setTimeout(function() {
        $('.api-error').fadeOut();
      }, 2000);
    }
  });
}

// 🔹 Open size update popup
$(".chat-update-size-btn-open").on("click", function () {

  if ($(this).data("programmatic") === true) {
    // triggered via .trigger('click')
    $(this).data("programmatic", false); // reset
    console.log("Programmatic open → NOT clearing sizeMentioned");
  } else {
    // real user click
    console.log("User clicked open → clearing sizeMentioned");
    sessionStorage.removeItem("sizeMentioned");
  }

  
  // clear previous active states
  $(".chat-update-size-btn").removeClass("active");

  // get all data-id values from #your-sizes li
  const selectedIds = $("#your-sizes .your-size-btn").map(function () {
    return $(this).data("id");
  }).get();

  // add active class to popup buttons that match
  $(".chat-update-size-btn").each(function () {
    if (selectedIds.includes($(this).data("id"))) {
      $(this).addClass("active");
    }
  });

  // ✅ always keep onesize active (even if hidden)
  const oneSizeBtn = $('.chat-update-size-btn[data-id="2"]');
  if (oneSizeBtn.length) {
    oneSizeBtn.addClass("active");
  }

  // finally open popup
  $("#chat-update-size-popup").css("display", "flex");
});

// 🔹 Close popup (visual reset only)
$("#chat-update-size-close").on("click", function () {

    const lastUserMessage = $("#chat_message .user-message .user-text").last().text()?.trim();
    // Check sessionStorage
      const sizeMentioned = sessionStorage.getItem('sizeMentioned') === 'true';

      if (sizeMentioned && lastUserMessage) {
          console.log("Re-sending last user message: when cancel", lastUserMessage);
          chatQuery(
                lastUserMessage,
                "product_suggestion_request", 
                "add" 
          );
      } else {
          console.log("Size mentioned when cancel, not re-sending message");
      }

  // visually close the popup
  $("#chat-update-size-popup").hide();

  sessionStorage.removeItem("sizeMentioned");
  $('.size-reminder').remove();

});

// 🔹 Toggle buttons inside popup
$(document).on("click", ".chat-update-size-btn", function () {
  // skip hidden onesize toggle
  if ($(this).data("id") === 2) return;

  $(this).toggleClass("active");
  if ($(".chat-update-size-btn.active").length > 0) {
    $(".update-size-error").hide();
  }
});

// 🔹 Fetch sizes and update UI
function fetchSizesAndAppend(id) {
  
  const token = getAiToken();
  const refresh_token = localStorage.getItem("ai_refresh_token");
  $.ajax({
    url: "https://ai.mygoddiva.com/get-session",
    type: "POST",
    contentType: "application/json",
    data: JSON.stringify({
      id: id,                   // number or string
      refresh_token: refresh_token // string
    }),

    success: function (response) {
      if (response.size && response.size.length) {
        $("#your-sizes").empty();

        // ✅ Filter only UK sizes (exclude onesize + intl)
        const ukIds = $(".chat-register-new-size-checkbox")
          .map(function () {
            return Number($(this).data("id"));
          })
          .get();

        const uniqueUkSizes = response.size.filter(
          (item) =>
            ukIds.includes(item.id) &&
            item.name.toLowerCase() !== "onesize"
        );

        let sizesHtml = "";

        if (uniqueUkSizes.length > 1) {
          const remainingCount = uniqueUkSizes.length - 1;

          const allSizes = uniqueUkSizes
            .map((item, index) => {
              const hiddenClass = index > 0 ? "hidden-size" : "";
              return `
                <li class="your-size-btn ${hiddenClass}" data-id="${item.id}">
                  ${item.name.replace(/UK/g, "").trim()}
                </li>
              `;
            })
            .join("");

          sizesHtml = `
            ${allSizes}
            <li class="your-size-btn your-size-more">+ ${remainingCount} more</li>
          `;
        } else if (uniqueUkSizes.length === 1) {
          const onlySize = uniqueUkSizes[0];
          sizesHtml = `
            <li class="your-size-btn" data-id="${onlySize.id}">
              ${onlySize.name.replace(/UK/g, "").trim()}
            </li>
          `;
        }

        $("#your-sizes").html(sizesHtml);
      }
    },
    error: function (xhr, status, error) {
      $(".api-error").text("An error occurred. Please try again.").show();
      $("#type_looader").hide();
      setTimeout(function () {
        $(".api-error").fadeOut();
      }, 2000);
      console.error("Error fetching sizes:", error);
    },
  });
}

// 🔹 Save updated sizes
$("#chat-update-size-save").on("click", function () {
  const selectedSizes = [];

  // ✅ Loop through all active size buttons
  $(".chat-update-size-btn.active").each(function () {
    const ukId = Number($(this).data("id"));
    const ukName = $(this).text().trim();
    const intlId = Number($(this).data("international-id"));
    const intlName = $(this).data("international");

    // Add both UK + International, if valid
    selectedSizes.push({ id: ukId, name: ukName });
    if (intlId && intlName && intlName.toLowerCase() !== "null") {
      selectedSizes.push({ id: intlId, name: intlName });
    }
  });

  // ✅ Always include hidden "onesize"
  const oneSizeBtn = $('.chat-update-size-btn[data-id="2"]');
  if (oneSizeBtn.length && !selectedSizes.some((s) => s.id === 2)) {
    selectedSizes.push({ id: 2, name: "onesize" });
  }

  // 🟠 Validation
  const visibleSelected = selectedSizes.filter(
    (s) => s.name.toLowerCase() !== "onesize"
  );
  if (visibleSelected.length === 0) {
    $(".update-size-error").show();
    return;
  }

  // 🟢 Proceed with update
  updateUserSizes(selectedSizes);
  sessionStorage.setItem("is_history", "false");

  // only hide popup visually — don’t clear active states
  $("#chat-update-size-popup").hide();

  
});

function updateUserSizes(selectedSizes) {
  const user_id = localStorage.getItem("user_id");
  if (!user_id) {
    console.error("No user_id found in localStorage.");
    return;
  }

  // 🧹 Helper to clean name
  const cleanSizeName = (name) => name.replace(/\s+/g, " ").trim();

  // 🔹 Get previous sizes
  const prevSizes = $("#your-sizes .your-size-btn")
    .not(".your-size-more")
    .map(function () {
      return cleanSizeName($(this).text());
    })
    .get()
    .join(", ") || "None";

  // 🔹 Get new sizes
  const newSizesArray = $(".chat-update-size-btn.active")
    .not('[data-id="2"]')
    .map(function () {
      return cleanSizeName($(this).text());
    })
    .get();

  const formattedPrevSizes = prevSizes.replace(/,\s*$/, "");

  // ✅ Payload remains same
  const payload = {
    id: user_id,
    size: selectedSizes,
  };

  const token = getAiToken();


  $.ajax({
    url: "https://ai.mygoddiva.com/user/size-update",
    type: "POST",
    contentType: "application/json",
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: JSON.stringify(payload),
    success: (response) => {
   
      sessionStorage.setItem('is_history', 'false');
      
      const sessionId = localStorage.getItem("session_id");
      if (sessionId) fetchSizesAndAppend(sessionId);

      $(".message-update-size").remove();

      // 🟢 Build show more/less
      let newSizesDisplay = "";
      let toggleButton = "";

      if (newSizesArray.length > 1) {
        const visibleSizes = newSizesArray.slice(0, 1).join(", ");
        const hiddenSizes = newSizesArray.slice(1).join(", ");
        const hiddenCount = newSizesArray.length - 1;

        newSizesDisplay = `
          <span class="sizes-visible">${visibleSizes}</span>
          <span class="more-indicator"> +${hiddenCount} more</span>
          <span class="sizes-hidden" style="display:none;">, ${hiddenSizes}</span>
        `.trim();

        toggleButton = `<button type="button" class="toggle-sizes-btn">Show more</button>`;
      } else {
        newSizesDisplay = newSizesArray.join(", ");
      }

      // ✅ Message template (no space before period)
      let message = `
        <div class="message-update-size">
          Size has been changed from <strong>${formattedPrevSizes}</strong> to 
          <strong class="sizes-container">${newSizesDisplay}</strong>${toggleButton}. Please start again.
        </div>
      `;

      // ✨ Final cleanup — remove any whitespace before ".Please"
      message = message.replace(/\s+\.(Please)/g, '.$1');

      $("#chat_message").append(message);

      $("#chat_message").animate(
        { scrollTop: $("#chat_message")[0].scrollHeight },
        300
      );

      const lastUserMessage = $("#chat_message .user-message .user-text").last().text()?.trim();

      // if (lastUserMessage) {
      //   console.log("🔁 Re-sending last user message:", lastUserMessage);
      //   chatQuery(lastUserMessage);
      // }

      // Check sessionStorage
        const sizeMentioned = sessionStorage.getItem('sizeMentioned') === 'true';

        if (sizeMentioned && lastUserMessage) {
            console.log("Re-sending last user message:", lastUserMessage);
            chatQuery(
                  lastUserMessage,
                  "product_suggestion_request", 
                  "add" 
            );
        } else {
            console.log("Size mentioned, not re-sending message");
        }
        $('.size-reminder').remove();
      
    },
    error: (xhr, status, error) => {
      $(".api-error").text("An error occurred. Please try again.").show();
      $("#type_looader").hide();
      setTimeout(() => $(".api-error").fadeOut(), 2000);
      console.error("❌ Error updating size:", error, xhr.responseText);
    },
  });
}

// 🟢 Toggle Show more / Show less
$(document).on("click", ".toggle-sizes-btn", function () {
  const $container = $(this).siblings(".sizes-container");
  const $hidden = $container.find(".sizes-hidden");
  const $moreIndicator = $container.find(".more-indicator");
  const isVisible = $hidden.is(":visible");

  if (isVisible) {
    $hidden.hide();
    $moreIndicator.show();
    $(this).text("Show more");
  } else {
    $hidden.show();
    $moreIndicator.hide();
    $(this).text("Show less");
  }
});



// ==============================================
// ✅ FINAL COMPLETE SCRIPT (Unified + Hiding Clicked Filter Button)
// ==============================================

let $lastFilterButton = null;
let originalHiddenButtonsHTML = ''; // store hidden non-id prompt buttons

// ----------------------------------------------
// 🔹 SVG for chevron
// ----------------------------------------------
function getChevronSVG() {
  return `
 <svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" width="448" height="448" viewBox="0 0 448 448" id="svg2" version="1.1" inkscape:version="0.91 r13725" sodipodi:docname="chevron-down.svg">
    <title id="title3340">chevron-down</title>
    <defs id="defs4" />
    <sodipodi:namedview id="base" pagecolor="#ffffff" bordercolor="#666666" borderopacity="1.0" inkscape:pageopacity="0.0" inkscape:pageshadow="2" inkscape:zoom="0.7" inkscape:cx="83.19264" inkscape:cy="244.19737" inkscape:document-units="px" inkscape:current-layer="layer1" showgrid="true" fit-margin-top="448" fit-margin-right="384" fit-margin-left="0" fit-margin-bottom="0" units="px" inkscape:window-width="1196" inkscape:window-height="852" inkscape:window-x="761" inkscape:window-y="439" inkscape:window-maximized="0" inkscape:snap-bbox="true" inkscape:bbox-nodes="true">
      <inkscape:grid type="xygrid" id="grid3347" spacingx="16" spacingy="16" empspacing="2" originx="0" originy="-1.7498462e-005" />
    </sodipodi:namedview>
    <metadata id="metadata7">
      <rdf:RDF>
        <cc:Work rdf:about="">
          <dc:format>image/svg+xml</dc:format>
          <dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" />
          <dc:title>chevron-down</dc:title>
        </cc:Work>
      </rdf:RDF>
    </metadata>
    <g inkscape:label="Layer 1" inkscape:groupmode="layer" id="layer1" transform="translate(0,-604.36224)">
      <path style="fill-opacity:1;stroke-width:32;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none" d="M 384,784.79929 346.53984,748.36226 223.99999,867.55528 101.46016,748.36226 64,784.79929 l 37.42566,36.40349 0.0344,-0.0335 L 224,940.36226 346.53983,821.16924 l 0.0344,0.0335 37.42568,-36.4035 z" id="rect4331" inkscape:connector-curvature="0" />
    </g>
  </svg>`;
}

// ----------------------------------------------
// 🔹 GENERIC PROMPT BUTTON CLICK HANDLER (ALL IN ONE)
// ----------------------------------------------

let activeFilterButton = null;

$(document).on('click', '#prompt_suggestion button,.chat-alternative-section button', function (e) {
  const $btn = $(this);
  const btnId = $btn.data('id');
  const btnFilter = $btn.data('filter');
  const btnText = $btn.text().trim();
  const btnType = $btn.data('type');
  const btnAction = $btn.data('action');
  const btnIsReset = $btn.data('is-reset');
  const btnCondition = $btn.data('condition');

  // Skip toggles — handled separately
  if (
    $btn.hasClass('toggle-makeyours') ||
    $btn.hasClass('toggle-refilter') ||
    $btn.hasClass('filter-btn-user-getsession')
  ) return;

  // ===============================
  // 🔹 CHANGE FILTER BUTTON
  // ===============================
  if (btnId === "changed_1") {
    changeFilterAjax();

    const userEmail = localStorage.getItem('user_email')?.toLowerCase();
    const allowed = ['yathu@citygoddess.co.uk', 'methan@akhitsolutions.com'];

    if (allowed.includes(userEmail)) {
        $('#top-bar').attr('style', '');
        $('#top-bar').show();
        $('#prompt_suggestion').show();
      } else {
        $('#top-bar').attr('style', 'display:none !important;');
      }
    return;
  }

  // ===============================
  // 🔹 ASSISTANT FILTER BUTTON (data-filter="filter")
  // ===============================
  if (btnFilter === "filter") {

    const btnMessage = $btn.data('message') || btnText;

    if (activeFilterButton && activeFilterButton.is($btn)) {

        // panel is currently visible → collapse it
        if ($('.assistant-expand-panel').is(':visible')) {
            $('.data-filter-chev').removeClass('rotated');
            $('.assistant-expand-panel').slideUp(200);
            return;  
        }
    }

    activeFilterButton = $btn;

    // Update title
    $('#promt-btn-text-value').text(btnMessage);

    // Rotate chevron
    $('.data-filter-chev').removeClass('rotated');
    $btn.find('.data-filter-chev').addClass('rotated');

    // Hide assistant panel before refill
    $('.assistant-expand-panel').stop(true, true).slideUp(200).empty();

    // ✅ Hide clicked filter button, restore previous
    if ($lastFilterButton) $lastFilterButton.data('hidden-by-user', false).show();
    $btn.data('hidden-by-user', true).show();
    $lastFilterButton = $btn;

    // Fetch assistant filter results
    getAssistantFilterValues({
      id: localStorage.getItem('session_id'),
      prompt_id: btnId,
      category: '',
      renderInPanel: true
    });
    return;
  }

  // ===============================
  // 🔹 NATURAL LANGUAGE BUTTONS (no ID)
  // ===============================
  if (!btnId) {
    $("#type_looader").show();
    $("#change_Filter_suggestion").hide();
    if (typeof shopifyPage !== "undefined" && shopifyPage !== "page.assistant") {
      scrollToElementInDrawer("#type_looader");
    }

    const initials = getUserInitials();
    $("#chat_message").append(`
      <div class="user-message">
        <div class="user-logo">${initials}</div>
        <div class="user-text">${btnText}</div>
      </div>
    `);

    $("#prompt_suggestion").hide();
    $('.chat-alternative-section').remove();
    $(".filter-panel").hide();
    $("#chat_input_text").val("");

    const isHistory = btnIsReset === 1 ? false : true;
    sessionStorage.setItem('is_history', isHistory);

    chatQuery(btnText, btnType, btnAction, null, btnId);
    return;
  }

  // ===============================
  // 🔹 FILTER-ID (custom filters)
  // ===============================
  if ($btn.data('filter-id')) {
    filterOnclick($btn.data('filter-id'), $btn.data('filter-name'), btnId);
    return;
  }

  // ===============================
  // 🔹 DEFAULT CHAT BUTTONS (with ID)
  // ===============================
  const initials = getUserInitials();
  $('#chat_message').append(`
    <div class="user-message">
      <div class="user-logo">${initials}</div>
      <div class="user-text">${btnText}</div>
    </div>
  `);
  ajaxChat({ id: btnId, text: btnText, is_delete: 0 }, null);
});


$(document).on('click', '.chat-alternative-section button', function (e) {
  e.preventDefault();

  const $target = $('#type_looader');
  if (!$target.length) return;

  // Chat header height
  const headerH = $('.chat-sticky-header').outerHeight() || 0;

  // Top bar height (only if visible)
  const topBar = $('#top-bar');
  const topBarH = (topBar.is(':visible') && topBar.css('display') !== 'none') 
    ? topBar.outerHeight() 
    : 0;

  const totalOffset = headerH + topBarH + 20; // +20 extra breathing room

  $('html, body').animate({
    scrollTop: $target.offset().top - totalOffset
  }, 400);
});


function promptHandel(prompts, filterKey = null) {
  if (!prompts || !Array.isArray(prompts) || prompts.length === 0) {
    console.log("No prompts → exiting");
    return;
  }

  let reFilterPrompts = [],
    nonIdPrompts = [],
    idPrompts = [],
    alternativePrompts = [];
  let specificInquiry = [];
  let similarRequest = [];

  $.each(prompts, function (i, value) {
    const type = value.type || {};
    const isObj = typeof type === "object";
    const typeName = isObj ? type.name || "" : type;
    const isReset = isObj && "is_reset" in type ? type.is_reset : null;
    const action = isObj && "action" in type ? type.action : null;
    const condition = isObj && "condition" in type ? type.condition : null;

    let attrs = `data-id="${value.id || ""}" data-message="${(
      value.message || ""
    ).replace(/"/g, "&quot;")}"`;

    if (isObj) {
      if (typeName) attrs += ` data-type="${typeName}"`;
      if (isReset !== null) attrs += ` data-is-reset="${isReset}"`;
      if (action !== null) attrs += ` data-action="${action}"`;
      if (condition !== null) attrs += ` data-condition="${condition}"`;
    } else if (type) {
      attrs += ` data-filter="${type}"`;
    }

    const html =
      type === "filter" ||
      typeName === "filter" ||
      attrs.includes('data-filter="filter"')
        ? `<button class="prompt-btn get-session-btn ${value.message
            .toLowerCase()
            .replace(/\s+/g, "-")}" ${attrs}>
             ${value.message}<span class="data-filter-chev">${getChevronSVG()}</span>
           </button>`
        : `<button class="prompt-btn get-session-btn ${value.message
            .toLowerCase()
            .replace(/\s+/g, "-")}" ${attrs}>
             ${value.message}
           </button>`;

    // Handle special inquiry types first - these should only go to their specific sections
    if (typeName === "specific_product_inquiry") {
      specificInquiry.push(html);
      return; // Skip further categorization
    } else if (typeName === "similar_product_request") {
      similarRequest.push(html);
      return; // Skip further categorization
    }

    // Categorize all other buttons
    if (!value.id && condition === "alternative") {
      alternativePrompts.push(html);
    } else if (!value.id && condition === "re_filter") {
      reFilterPrompts.push(html);
    } else if (!value.id) {
      nonIdPrompts.push(html);
    } else {
      idPrompts.push(html);
    }
  });

  // ------------------------------------------------
  // FILTER KEY BUTTON
  // ------------------------------------------------
  let filterButtonHTML = "";
  if (filterKey && filterKey.id && filterKey.name) {
    const safeName = filterKey.name.replace(/"/g, "&quot;");
    filterButtonHTML = `
      <button class="prompt-btn get-session-btn ${safeName
        .toLowerCase()
        .replace(/\s+/g, "-")}"
        data-id="${filterKey.id}"
        data-message="${safeName}"
        data-filter="filter">
        ${safeName}<span class="data-filter-chev">${getChevronSVG()}</span>
      </button>`;
  }

  // ------------------------------------------------
  // REORDER ID BUTTONS
  // ------------------------------------------------
  let filterKeyButton = "";
  let filterButtonsWithId = [];
  let otherIdButtons = [];
  let modifyResultButton = "";

  idPrompts.forEach((btn) => {
    if (filterKey && btn.includes(`data-id="${filterKey.id}"`)) {
      filterKeyButton = btn; // first in Make It Yours
    } else if (btn.includes('data-id="changed_1"')) {
      modifyResultButton = btn; // always last
    } else if (btn.includes(`data-filter="filter"`)) {
      filterButtonsWithId.push(btn);
    } else {
      otherIdButtons.push(btn);
    }
  });

  const orderedIdButtons = [
    filterKeyButton,
    ...filterButtonsWithId,
    ...otherIdButtons,
    modifyResultButton,
  ].join("");

  // ------------------------------------------------
  // NON-ID BUTTON VISIBILITY
  // ------------------------------------------------
  let visible = "";
  let hidden = "";

  if (filterKey) {
    visible = "";
    hidden = nonIdPrompts.join("");
  } else {
    visible = nonIdPrompts.slice(0, 4).join("");
    hidden = nonIdPrompts.slice(4).join("");
  }

  originalHiddenButtonsHTML = hidden;

  // Only create makeYoursHTML if there are buttons to display OR if there's a filterKey
  const hasMakeYoursContent = filterKey || nonIdPrompts.length > 0 || idPrompts.length > 0;
  
  let makeYoursHTML = "";
  if (hasMakeYoursContent) {
    const headingHTML = filterKey
      ? `<p class="make-your-text make-yours-filter">
            <strong>Make it yours - </strong>
            <span id="spantext">
              Refine your results: tap a 
              <span id="promt-btn-text-value" data-id="${filterKey.id}">${
          filterKey.name
        }</span> 
              or adjust your filters below
            </span>
          </p>`
      : `<strong class="suggestedsuggested-searches-heading">Suggested Searches:</strong>`;

    // ------------------------------------------------
    // SHOW MORE
    // ------------------------------------------------
    let showMoreHTML = "";
    if (!filterKey && nonIdPrompts.length > 4) {
      showMoreHTML = `<div class="toggle-makeyours" role="button" tabindex="0">Show More</div>`;
    }

    // ------------------------------------------------
    // FINAL MAKE-YOURS SECTION (WITH CORRECT ORDERING)
    // ------------------------------------------------
    makeYoursHTML = `
      <div class="suggested-make-it-yours-wrapper">
        ${headingHTML}

        <div class="prompt-btn-wrapper ${
          filterKey ? "make-yours-filter" : "suggested-search-wrapper"
        }">

          ${filterButtonHTML}

          <!-- NON-ID first when filterKey NULL -->
          ${!filterKey ? visible : ""}

          <!-- ID buttons (but remove modify here when filterKey NULL) -->
          ${
            filterKey
              ? orderedIdButtons
              : orderedIdButtons.replace(modifyResultButton, "")
          }

          <!-- Modify ALWAYS last when filterKey NULL -->
          ${!filterKey ? modifyResultButton : ""}

          ${showMoreHTML}
        </div>

        <div class="make-yours-expand-panel" style="display:none;">
          <div class="make-yours-expand-button-wrapper">${hidden}</div>
        </div>

        <div class="assistant-expand-panel" style="display:none;"></div>
      </div>
    `;
  }

  // ------------------------------------------------
  // FIND THE ONE SECTION
  // ------------------------------------------------
  let findTheOneHTML = "";
  if (reFilterPrompts.length) {
    const rawFirst = (reFilterPrompts[0] || "")
      .replace(/<[^>]+>/g, "")
      .trim();
    let firstWord = rawFirst.split(/\s+/)[0] || "this selection";

    const genericWords = [
      "show",
      "view",
      "see",
      "find",
      "all",
      "these",
      "the",
      "this",
      "check",
      "explore",
      "browse",
      "discover",
      "try",
    ];
    if (genericWords.includes(firstWord.toLowerCase()))
      firstWord = "this selection";

    findTheOneHTML = `
      <div class="refilter-section">
        <p class="find-heading-subheading">
          <strong class="find-the-one-heading">Find the one - </strong>
          <span class="find-the-one-subtext">Do you want to explore all variants related to "${firstWord}"?</span>
        </p>
        <div class="prompt-btn-wrapper re-filter-wrapper">
          ${reFilterPrompts.join("")}
          ${
            reFilterPrompts.length > 4
              ? `<div class="toggle-refilter" role="button" tabindex="0">View All<span class="chev">${getChevronSVG()}</span></div>`
              : ""
          }
        </div>
      </div>`;
  }

  // ------------------------------------------------
  // ALTERNATIVE SECTION
  // ------------------------------------------------
  if (alternativePrompts.length) {
    const alternativeHTML = `
      <div class="chat-alternative-section" data-injected="true">
        <div class="alternative-btn-wrapper">${alternativePrompts.join(
          ""
        )}</div>
      </div>
    `;

    const $lastBotMsg = $("#chat_message .bot-message").last();
    if ($lastBotMsg.length) {
      $lastBotMsg.next(".chat-alternative-section").remove();
      $lastBotMsg.after(alternativeHTML);
    }
  }

  // ------------------------------------------------
  // SPECIFIC INQUIRY SECTION
  // ------------------------------------------------
  const inquiryHTML = specificInquiry.length
    ? `
  <div class="ai-page-specific-product-inquiry-section">
    <p class="ai-page-specific-product-heading">
      <strong class="ai-page-specific-product-heading-strong">Product details you may want to know</strong>
    </p>
    <div class="prompt-btn-wrapper ai-page-specific-product-inquiry-wrapper">
      ${specificInquiry.join("")}
    </div>
  </div>
`
    : "";

  // ------------------------------------------------
  // SIMILAR REQUEST SECTION
  // ------------------------------------------------
  const similarHTML = similarRequest.length
    ? `
  <div class="ai-page-similar-product-request-section">
    <p class="ai-page-similar-product-heading">
      <strong class="ai-page-similar-product-heading-strong">Explore similar styles</strong>
    </p>
    <div class="prompt-btn-wrapper ai-page-similar-product-request-wrapper">
      ${similarRequest.join("")}
    </div>
  </div>
`
    : "";

  // ------------------------------------------------
  // WRITE TO DOM - only include sections that have content
  // ------------------------------------------------
  const sectionsHTML = [
    inquiryHTML,
    similarHTML,
    makeYoursHTML,
    findTheOneHTML
    
  ].filter(section => section !== "").join("\n");

  $("#prompt_suggestion").html(`
    <div class="prompt-sections-wrapper">
      ${sectionsHTML}
    </div>
  `);

  applyInitialPromptVisibility();
}

// ----------------------------------------------
// 🔹 FIND THE ONE: Toggle View All
// ----------------------------------------------
$(document).on('click', '.toggle-refilter', function (e) {
  e.preventDefault();
  const $t = $(this);
  const $wrap = $t.closest('.re-filter-wrapper');
  const expanded = $wrap.hasClass('expanded');
  $wrap.toggleClass('expanded', !expanded);
  $t.contents().filter(function(){ return this.nodeType === 3; })
    .first().replaceWith(expanded ? 'View All ' : 'View Less ');
});

// ----------------------------------------------
// 🔹 SHOW MORE / SHOW LESS (Independent)
// ----------------------------------------------
$(document).on('click', '.toggle-makeyours', function (e) {
  e.preventDefault();
  const $t = $(this);
  const $panel = $('.make-yours-expand-panel');
  const showMore = $t.text().trim().toLowerCase() === 'show more';

  if (showMore) {
    $panel.stop(true, true).slideDown(300);
    $t.text('Show Less');
  } else {
    $panel.stop(true, true).slideUp(300);
    $t.text('Show More');
  }
});

// ----------------------------------------------
// 🔹 ASSISTANT RESPONSE HANDLER (Separate Panel)
// ----------------------------------------------
function handleAssistantFilterResponse(response, payload) {
  if (!payload || payload.dropdown === 'top-bar-filter') return;

  const renderInPanel = payload.renderInPanel || false;
  const filterKey = Object.keys(response)[0];
  const filterValues = response[filterKey] || [];
  const $panel = $('.assistant-expand-panel');

  if (!renderInPanel) return;

  if (!filterValues.length) {
    $panel.stop(true, true).slideUp(200).empty();
    return;
  }

  const html = `
    <div class="assistant-buttons">
      ${filterValues.map(v => `
        <button class="prompt-btn assistant-btn ${v.name.toLowerCase().replace(/\s+/g, '-')}" data-message="${v.name}">
          ${v.name}
        </button>
      `).join('')}
    </div>
  `;

  $panel.html(html).stop(true, true).slideDown(260);
}

// ----------------------------------------------
// 🔹 KEEP STRUCTURE CLEAN
// ----------------------------------------------
function applyInitialPromptVisibility() {
  const $refilter = $('.re-filter-wrapper');
  const $makeYours = $('.prompt-btn-wrapper.make-yours-filter');
  $refilter.find('.prompt-btn[data-filter], .filter-btn-user-getsession').appendTo($makeYours);
}



$(document).ready(function() {
  if(shopifyPage == "page.assistant"){

    init_page();
  }else{
      if(params.has('gclsrc')){
          init_page();
          $('.chatbot-offer-banner').show(); 
          drawer.classList.add('drawer--open');
      }
  }    
});

const drawer = document.getElementById('custom-drawer');
const openButtons = document.querySelectorAll('[data-open-drawer]');
const closeButton = document.querySelector('.drawer__close-button');

// Open drawer
openButtons.forEach(button => {
  button.addEventListener('click', () => {
     init_page();
    drawer.classList.add('drawer--open');
  });
});

// Close drawer
if (closeButton){
closeButton.addEventListener('click', () => {
  drawer.classList.remove('drawer--open');
});
}


  function init_page(){
     $('.preloader').show();
      if(localStorage.getItem('user_id')){
        handleMobileRedirect();
           $('#section-register').hide();
           $('#section-chat').show();
           $('#span_user_name').text(localStorage.getItem('user_name'))
           chatAssistant(localStorage.getItem('session_id'));
        }else{
          handleMobileRedirect();
             $('#section-register').show();
             $('#section-chat').hide();
             register();
        }
      if(shopifyPage == "page.assistant"){
          // const topBar = document.getElementById('top-bar');
          // const threshold = topBar.offsetTop;
        
          // window.addEventListener('scroll', () => {
          //   if (window.scrollY > threshold) {
          //     topBar.classList.add('fixed');
          //   } else {
          //     topBar.classList.remove('fixed');
          //   }
          // });

          const topBar = document.getElementById('top-bar');
          const header = document.querySelector('.chat-header');

            function getThreshold() {
              return topBar.getBoundingClientRect().top + window.scrollY;
            }

            let threshold = getThreshold();
            let ticking = false;

            function onScroll() {
              if (!ticking) {
                window.requestAnimationFrame(() => {
                  if (window.scrollY > threshold) {
                    topBar.classList.add('fixed');
                    header.classList.add('chat-sticky-header');
                  } else {
                    topBar.classList.remove('fixed');
                    header.classList.remove('chat-sticky-header');
                  }
                  ticking = false;
                });
                ticking = true;
              }
            }

            window.addEventListener('scroll', onScroll);

            window.addEventListener('resize', () => {
              threshold = getThreshold();
            });

            window.addEventListener('load', () => {
              threshold = getThreshold();
            });

      }
  }


function productHandel(product, id, is_direct = 1) {
  let productHtml = '';

  if (is_direct == 1) {
    productHtml = `
      <div class="products drag-scroll-wrapper">
        <div class="drag-scroll"
          data-page="${product.page}"
          data-has="${product.has_next}"
          data-id="${id}"
          data-total="${product.total}">
          <div class="chat-product-item-wrapper">
    `;
  }

  let items = product.items || [];

  // 🧠 Split into multiple colour-based products only if 1 item and more than 1 colour
  if (items.length === 1 && items[0].colour && items[0].colour.length > 1) {
    const singleItem = items[0];
    const expandedItems = singleItem.colour.map(col => {
      const colourVariants = (singleItem.variants || []).filter(v => v.colour === col.name);
      const variantHandle = colourVariants[0]?.handel || singleItem.handle;

      return {
        ...singleItem,
        handle: variantHandle,
        image: col.image,
        name: `${singleItem.name.split('-')[0].trim()} - ${col.name}`,
        // 🔥 ONLY THIS COLOUR
        colour: [col],
        // 🔥 OVERRIDE PRICE FROM THIS COLOUR
        price: col.price,
        sale_price: col.sale_price,
        // 🔥 ONLY variants for this colour
        variants: colourVariants
      };
    });

    items = expandedItems;
  }

  // 🔁 Loop through final items
  $.each(items, function (index, value) {
    const countdownId = `countdown-${index}-${id}-${value.shopify_ids}`;
    
      let selectedColourPrice = value.price;
      let selectedColourSalePrice = value.sale_price;


      if (value.colour && value.colour.length > 1 && !value.colour[0].price) {
        const sortedColours = [...value.colour].sort((a, b) => {
          const aPrice = a.price ?? Infinity;
          const bPrice = b.price ?? Infinity;
          return aPrice - bPrice;
        });
        selectedColourPrice = sortedColours[0].price ?? value.price;
        selectedColourSalePrice = sortedColours[0].sale_price ?? null;
      }

      let discountValid = false;
      let discountPercentage = 0;
      let amountSaved = 0;

      if (value.discount && value.discount.expire_at) {
        const expireTimestamp = Date.parse(value.discount.expire_at);
        if (window.dateNowTs < expireTimestamp) {
          if (value.discount.type === 1 && value.discount.amount > 0) {
            discountValid = true;
          } else if (value.discount.type === 2 && value.discount.percentage > 0) {
            discountValid = true;
            discountPercentage = Math.round(value.discount.percentage * 100);
          }
        }
      }

      let basePrice = selectedColourSalePrice ?? selectedColourPrice;
      basePrice = Number(basePrice) || 0;

      let vipPrice = basePrice;
      if (discountValid) {
        if (value.discount.type === 1) {
          vipPrice = basePrice - value.discount.amount;                  // amount IS the VIP price
          amountSaved = value.discount.amount;   // actual saving
          discountPercentage = Math.round((amountSaved / basePrice) * 100);
        } else {
          vipPrice = basePrice * (1 - (discountPercentage / 100));
          amountSaved = basePrice - vipPrice;
        }
      }
      vipPrice = Number(vipPrice.toFixed(2));
      amountSaved = Number(amountSaved.toFixed(2));
    

    // ✅ Unique colors with their pricing
    const uniqueColors = [...new Set((value.variants || []).map(v => v.colour))];
    const colorVariants = uniqueColors.map(color => {
      const variant = (value.variants || []).find(v => v.colour === color);
      const colourObj = (value.colour || []).find(c => c.name === color) || {};
      return {
        id: colourObj.id || '',
        name: color,
        handle: variant ? variant.handel || variant.handle || '' : '',
        image: colourObj.image || '',
        price: typeof colourObj.price !== 'undefined' ? Number(colourObj.price) : null,
        sale_price: typeof colourObj.sale_price !== 'undefined' ? 
          (colourObj.sale_price === null ? null : Number(colourObj.sale_price)) : null
      };
    });

    // ✅ Unique sizes
    const uniqueSizes = [...new Set((value.variants || []).map(v => v.size))];
    const sizeVariants = uniqueSizes.map(size => {
      const variant = value.variants.find(v => v.size === size);
      return {
        id: (value.size || []).find(s => s.name === size)?.id || '',
        name: size,
        handle: variant ? variant.handle : ''
      };
    });

    // Determine effective price for cart buttons - use colour pricing
    let effectivePrice = discountValid ? vipPrice : 
                        (selectedColourSalePrice ?? selectedColourPrice);

    // Calculate remaining time for data attributes
    let remainingMinutes = 0;
    let remainingSeconds = 0;
    if (discountValid && value.discount?.expire_at) {
      const expireTimestamp = Date.parse(value.discount.expire_at);
      remainingSeconds = Math.max(0, Math.floor((expireTimestamp - window.dateNowTs) / 1000));
      remainingMinutes = Math.floor(remainingSeconds / 60);
    }

    // Show deal badge only if discount is valid
    const hasDealBadge = discountValid;

    const colourList = value.colour || [];
    const firstColourValue = colourList.length ? colourList[0].name : '';


    // 🧩 Build Product HTML - Show colour-specific pricing
    productHtml += `
      <div class="product-card item">
        <div class="chat-product-wrapper">
          <div class="image-wrapper">
            <img src="${value.image}" alt="${value.name}">
            ${
              hasDealBadge ? `
              <div class="deal-timer overlay-btn">
                Deal
                <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chatclockicon-4.png?v=1760010677">
                <span class="countdown-inline" id="${countdownId}" data-timer> </span>
              </div>` : ''
            }

            <div class="view-product view-chat-product overlay-btn render-in-sidebar"
              data-id="${value.id}"
              data-code="${value.code}"
              data-name="${value.name}"
              data-price="${selectedColourPrice}"
              data-sale-price="${selectedColourSalePrice}"
              data-discounted-price="${vipPrice}"
              data-discount-percentage="${discountPercentage}"
              data-discount-type="${value.discount?.type || 2}"
              data-discount-amount="${value.discount?.type === 1 ? value.discount.amount : 0}"
              data-img="${value.image}"
              data-discount-remaining-time="${remainingMinutes}"
              data-remaining-seconds="${remainingSeconds}"
              data-shopify-ids="${value.shopify_ids}"
              data-variants='${JSON.stringify(value.variants || [])}'
              data-colours='${JSON.stringify(colorVariants)}'
              data-first-colour='${firstColourValue}'
              data-sizes='${JSON.stringify(sizeVariants)}'>
              View Product
            </div>
          </div>

          <div class="product-info${discountValid ? ' ai-page-col-direct' : ''}">
            <div class="price-section">
              ${
                discountValid
                  ? `
                    <div class="ai-page-price-main">
                    ${
                      selectedColourSalePrice
                        ? `
                        <span class="old-price">£${selectedColourPrice.toFixed(2)}</span>
                        <span class="new-price aistrike">£${selectedColourSalePrice.toFixed(2)}</span>
                        `
                        : `
                        <span class="old-price aistrike">£${selectedColourPrice.toFixed(2)}</span>
                        `
                    }
                    </div>
                    <div class="ai-vip-price">
                      <span class="ai-personalized-off">
                        ${value.discount?.type === 1
                          ? `£${amountSaved.toFixed(2)} OFF`
                          : `${discountPercentage}% OFF`
                        }
                      </span>
                      <span class="ai-personalized-price"> VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span></span>
                    </div>
                    `
                  : selectedColourSalePrice
                  ? `
                    <!-- Regular sale price (no active discount) -->
                    <span class="old-price">£${selectedColourPrice.toFixed(2)}</span>
                    <span class="new-price">£${selectedColourSalePrice.toFixed(2)}</span>
                    `
                  : `
                    <!-- Regular price only -->
                    <span class="new-price">£${selectedColourPrice.toFixed(2)}</span>
                    `
              }
            </div>

            <div class="icons">
              <button class="chat-find-similar-item"
                title="Find similar item"
                data-product-id="${value.id}"
                data-product-name="${value.name}"
                data-product-price="${effectivePrice.toFixed(2)}"
                onclick="moreLike(${value.id},'${value.image}','${value.name}')">
                <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-find-similar-5.png?v=1760027753">
              </button>
              <button class="cart-btn add-btn chataiaddbuttn"
                onclick="addToCart(this,'${value.code}')"
                title="Add to cart"
                data-product-id="${value.code}"
                data-product-name="${value.name}"
                data-product-price="${effectivePrice.toFixed(2)}">
                <img class="chataiaddbuttn"
                  src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/icons8-add-to-cart-48.png?v=1759985945">
              </button>
            </div>
          </div>
        </div>

        <div class="variant-info" style="display:none;">
          ${(value.variants || []).map(v => `
            <div class="variant-data"
              data-variant-id="${v.variant_id}"
              data-colour="${v.colour}"
              data-size="${v.size}"
              data-stock="${v.quantity}"
              data-handle="${v.handel}">
            </div>
          `).join('')}
        </div>

        <div class="card-overlay">
          <div class="overlay-content">
            <div class="overlay-scrollable">
              <div class="overlay-title colour-tag-title" style="margin-top: 15px;">
                Color: <span class="selected-value"></span>
              </div>
              <div class="colour-tags">
                ${(value.colour || []).map((colour, idx) => `
                  <button
                    class="colour-tag ${((value.colour).length)==1 ? "active" : ""}"
                    onClick="colourAdd(this)"
                    data-id="${colour.id}"
                    data-name="${colour.name}"
                    title="${colour.name}">
                      ${colour.image
                        ? `<img src="${colour.image}" alt="${colour.name}" class="colour-swatch">`
                        : colour.name.slice(0, 1)}
                  </button>
                `).join('')}
              </div>

              <div class="overlay-title size-tag-title" style="margin-top:15px;">
                Size: <span class="selected-value"></span>
              </div>
              <div class="size-pills">
                ${(value.size || [])
                  .sort((a, b) => {
                    const aNum = parseFloat(a.name), bNum = parseFloat(b.name);
                    const aIsNum = !isNaN(aNum), bIsNum = !isNaN(bNum);
                    if (aIsNum && bIsNum) return aNum - bNum;
                    if (aIsNum) return -1;
                    if (bIsNum) return 1;
                    return a.name.localeCompare(b.name);
                  })
                  .map((size, idx) => `
                    <button
                      onClick="sizeAdd(this)"
                      data-id="${size.id}"
                      data-name="${size.name}"
                      title="${size.name}"
                      class="size-pill ${((value.size).length)==1?"active":""}">
                      ${size.name}
                    </button>
                  `).join('')}
              </div>
            </div>

            <div class="overlay-buttons">
              <button
                disabled
                onClick="addItemToCart(this,'${value.code}')"
                type="button"
                class="add-btn-action chataiaddbuttn"
                data-product-id="${value.code}"
                data-product-name="${value.name}"
                data-product-price="${effectivePrice.toFixed(2)}">
                Add
              </button>
              <button onClick="cancelCart(this)" type="button" class="cancel-btn-action">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    `;

    // Start countdown if discount is valid
    if (discountValid && value.discount?.expire_at) {
      const expireTimestamp = Date.parse(value.discount.expire_at);
      const remainingSeconds = Math.max(0, Math.floor((expireTimestamp - window.dateNowTs) / 1000));
      
      setTimeout(() => {
        startHmsCountdown(countdownId, remainingSeconds, value.shopify_ids);
      }, 100);
    }
  });

  if (is_direct == 1) {
    productHtml += '</div></div></div>';
  }

  return productHtml;
}

  
function addToCart(button, code) {
  const card = button.closest('.product-card');
  const cardt = $(button).closest('.product-card');
  const sizeOptions = cardt.find('.size-pill');
  const colourOptions = cardt.find('.colour-tag');

  const size_id = cardt.find('.size-pill.active').data('id');
  const colour_id = cardt.find('.colour-tag.active').data('id');

  // case: only one option each → auto-add
  if (sizeOptions.length === 1 && colourOptions.length === 1) {
    getProductForCart(code, colour_id, size_id);

     const $btn = $(button);
     sendUserFeedback($btn, 'add_to_cart', {
      size: size_id,
      colour: colour_id
    });


  } else {
    // multiple options → show overlay
    card.classList.add('show-overlay');

    // set defaults (first pre-selected) in overlay
   const overlay = $(card).find('.overlay-content');
   initOverlaySelections(card);

    // mark first as active if none already selected
    if (overlay.find('.colour-tag.active').length === 0) {
      overlay.find('.colour-tag').first().addClass('active');
    }
    if (overlay.find('.size-pill.active').length === 0) {
      overlay.find('.size-pill').first().addClass('active');
    }

    // update selected text
    const firstColour = overlay.find('.colour-tag.active').attr('title');
    const firstSize = overlay.find('.size-pill.active').attr('title');
    overlay.find('.colour-tag-title .selected-value').text(firstColour || '');
    overlay.find('.size-tag-title .selected-value').text(firstSize || '');

    // disable/enable add button
    disableButton(overlay.find('.size-pill.active'));
  }
}


function addItemToCart(button, code) {
  const overlay = $(button).closest('.overlay-content');
  const size_id = overlay.find('.size-pill.active').data('id');
  const colour_id = overlay.find('.colour-tag.active').data('id');

  if (colour_id && size_id) {
    getProductForCart(code, colour_id, size_id);
    cancelCart(button);

     const $btn = $(button).closest('.product-card').find('.cart-btn');
     sendUserFeedback($btn, 'add_to_cart', {
      size: size_id,
      colour: colour_id
     });

  }
}

function cancelCart(button) {
  const card = button.closest('.product-card');
  card.classList.remove('show-overlay');
  const overlay = $(button).closest('.overlay-content');

  // Reset selections
  overlay.find('.size-pill.active').removeClass('active');
  overlay.find('.colour-tag.active').removeClass('active');

  disableButton(button);
}


function colourAdd(button) {
  const $btn = $(button);
  const overlay = $btn.closest('.overlay-content');
  const colourName = $btn.data('name');
  const $sizeButtons = overlay.find('.size-pill');

  // Activate clicked color
  $btn.closest('.colour-tags').find('.colour-tag').removeClass('active');
  $btn.addClass('active');
  overlay.find('.colour-tag-title .selected-value').text(colourName);

  // Get variants from hidden block in same card
  const variants = $btn.closest('.product-card').find('.variant-data').map(function() {
    return {
      colour: $(this).data('colour'),
      size: $(this).data('size'),
      stock: $(this).data('stock')
    };
  }).get();

  // Find which sizes are available for this color
  const availableSizes = variants
    .filter(v => v.colour === colourName && v.stock > 0)
    .map(v => v.size);

  // Disable unavailable sizes
  $sizeButtons.each(function() {
    const $size = $(this);
    const sizeName = $size.data('name');
    if (!availableSizes.includes(sizeName)) {
      $size.addClass('disabled').attr('disabled', true);
    } else {
      $size.removeClass('disabled').removeAttr('disabled');
    }
  });

  // Auto-select first available size
  const $firstEnabled = $sizeButtons.filter(':enabled').first();
  $sizeButtons.removeClass('active');
  if ($firstEnabled.length) {
    $firstEnabled.addClass('active');
    overlay.find('.size-tag-title .selected-value').text($firstEnabled.data('name'));
  }

  disableButton(button);
}

function sizeAdd(button) {
  const $btn = $(button);
  if ($btn.hasClass('disabled')) return;

  const overlay = $btn.closest('.overlay-content');
  $btn.closest('.size-pills').find('.size-pill').removeClass('active');
  $btn.addClass('active');
  overlay.find('.size-tag-title .selected-value').text($btn.data('name'));

  disableButton(button);
}

function disableButton(button) {
  const overlay = $(button).closest('.overlay-content');
  const colorSelected = overlay.find('.colour-tag.active').length > 0;
  const sizeSelected = overlay.find('.size-pill.active').length > 0;
  const bothValid = colorSelected && sizeSelected;

  overlay.find('.add-btn-action').prop('disabled', !bothValid);
}

function initOverlaySelections(card) {
  const $card = $(card);
  const overlay = $card.find('.overlay-content');

  // 1️⃣ If no color selected yet, pick first
  let $firstColor = overlay.find('.colour-tag.active');
  if (!$firstColor.length) {
    $firstColor = overlay.find('.colour-tag').first().addClass('active');
  }

  // 2️⃣ Trigger color logic (to filter sizes & update text)
  if ($firstColor.length) {
    const colorName = $firstColor.data('name');
    overlay.find('.colour-tag-title .selected-value').text(colorName);

    // Collect variants
    const variants = $card.find('.variant-data').map(function() {
      return {
        colour: $(this).data('colour'),
        size: $(this).data('size'),
        stock: $(this).data('stock')
      };
    }).get();

    // Available sizes for this color
    const availableSizes = variants
      .filter(v => v.colour === colorName && v.stock > 0)
      .map(v => v.size);

    const $sizeButtons = overlay.find('.size-pill');
    $sizeButtons.each(function() {
      const $size = $(this);
      const sizeName = $size.data('name');
      if (!availableSizes.includes(sizeName)) {
        $size.addClass('disabled').attr('disabled', true);
      } else {
        $size.removeClass('disabled').removeAttr('disabled');
      }
    });

    // Auto-select first enabled size
    let $firstSize = overlay.find('.size-pill.active');
    if (!$firstSize.length) {
      $firstSize = overlay.find('.size-pill:enabled').first().addClass('active');
    }

    if ($firstSize.length) {
      overlay.find('.size-tag-title .selected-value').text($firstSize.data('name'));
    }
  }

  // 3️⃣ Finally, check add button state
  disableButton(overlay);
}


function getProductForCart(code, colour, size) {
  const token = getAiToken();
  $.ajax({
    url: 'https://ai.mygoddiva.com/get-product-for-cart',
    type: 'GET',
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: {
      id: localStorage.getItem('session_id'),
      code: code,
      colour: colour,
      size: size
    },
    success: function (response) {
      // ✅ Defensive check for variant
      if (!response || !response.variant || !response.variant.shopify_variant_id) {
        console.error('Invalid response from get-product-for-cart:', response);
        return;
      }

      // ✅ Use the correct nested structure
      const variantId = response.variant.shopify_variant_id;
      const stock = Number(response.variant.inventory_variant__qty || 0);
      const discountCode = response.discount || null;

      // ✅ Check current cart quantity for this variant
      Shopify.getCart(cart => {
        const existing = cart.items.find(i => i.variant_id == variantId);
        const currentQty = existing ? existing.quantity : 0;

        if (currentQty + 1 > stock) {
          $('body').addClass('has-warning');
          $('.halo-warning-content').text('The maximum quantity of this item is already in your cart.');
          setTimeout(function () {
            $('body').removeClass('has-warning');
            $('.halo-warning-content').text('');
          }, 2000);
          return;
        }

        // ✅ Safe to add to cart
        addToShoppingCart(variantId, discountCode);
      });
    },
    error: function (xhr, status, error) {
      $('.api-error').text('An error occurred. Please try again.').show();
       $('#gooeyEffect').hide();
      $('#type_looader').hide();
      setTimeout(function () {
        $('.api-error').fadeOut();
      }, 2000);
      console.error('AJAX Error:', error);
    }
  });
}


// 🔽 Add to cart with optional discount
function addToShoppingCart(variantId, discountCode) {
  let formData = {
    items: [
      {
        id: variantId,
        quantity: 1
      }
    ],
    attributes: {
      DudeAi: "true"
    }
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(response => response.json())
    .then(data => {
      console.log('Added to cart:', data);

      const addedItem = data.items ? data.items.find(i => i.variant_id == variantId) : null;

      if (discountCode) {
        return addDiscount(discountCode).then(cart => {
          updateSidebar(cart, addedItem ? addedItem.variant_id : null);
        });
      } else {
        Shopify.getCart(cart => {
          updateSidebar(cart, addedItem ? addedItem.variant_id : null);
        });
      }
    })
    .catch(error => {
      console.error('Error:', error);
    });
}


// 🔧 Helper function to update sidebar cart
function updateSidebar(cart, variantId) {
  if (window.halo && typeof window.halo.updateSidebarCart === 'function') {
    console.log('Calling updateSidebarCart with variant ID:', variantId);
    window.halo.updateSidebarCart(cart, variantId);
    $('body').addClass('cart-sidebar-show');
  }
}

async function addDiscount(code) {
  try {
    // 1. Get current cart first
    const cart = await fetch('/cart.js').then(r => r.json());

    // 2. Extract existing discount codes
    const existing = cart.discount_codes?.map(d => d.code) || [];

    // 3. If already applied → do nothing
    if (existing.includes(code)) {
      console.log('Discount already applied:', code);
      return cart;
    }

    // 4. Send FULL list back (important!)
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: [...existing, code].join(',')
      })
    });

    if (!response.ok) {
      throw new Error(`Discount failed: ${response.statusText}`);
    }

    const updatedCart = await response.json();

    console.log('Cart after discount:', updatedCart);

    return updatedCart;

  } catch (error) {
    console.error('Error applying discount:', error);
  }
}


// -------------------------------------
// Reusable function to load product data
// -------------------------------------

function loadProductData(handle) {
  if (!handle) return;
  console.log(`Loading product data for handle: ${handle}`);

  $(".chat-sidebar-loader").show();
  $(".chat-sidebar-main-data").hide();

  // -------------------------------------
  // 🟢 FETCH PRODUCT DETAILS
  // -------------------------------------
  $.getJSON(`/products/${handle}.js`)
    .done(function (product) {
     // console.log("Product data loaded successfully:", product);

      $(".chat-sidebar-add-to-cart").attr("data-product-name", product.title);

      const $imgContainer = $(".chat-sidebar-product-images");

      // Reset slick
      if ($imgContainer.hasClass("slick-initialized")) {
        $imgContainer.slick("unslick");
      }
      $imgContainer.empty();

      // --- Add images ---
      if (Array.isArray(product.images) && product.images.length > 0) {
        product.images.forEach((img) => {
          $imgContainer.append(
            `<div><img src="${img}" alt="${product.title}" /></div>`
          );
        });

        // Initialize slick
        $imgContainer.slick({
          dots: false,
          arrows: true,
          infinite: true,
          draggable: true,
          touchMove: true,
          slidesToShow: 1,
          slidesToScroll: 1,
        });

        // Small delay to fix layout
        setTimeout(() => {
          $imgContainer.slick("setPosition");
        }, 100);
      }

      // --- Product title & description ---
      $(".chat-sidebar-title").text(product.title);
      $(".chat-sidebar-why-this-pick p").html(product.description);

      // --- Wishlist attributes ---
      $(".chat-sidebar-wishlist")
        .attr("data-chat-wishlist-handle", product.handle)
        .attr("data-chat-product-id", product.id);

      // --- Size chart attributes ---
      $(".chat-sidebar-size-guide")
        .attr("data-sidebar-chat-title", product.title)
        .attr("data-sidebar-chat-vendor", product.vendor);

      updateWishlistButtonState(product.handle);
    })
    .fail(function (jqxhr, textStatus, error) {
      console.error(
        `Failed to load product data for ${handle}:`,
        textStatus,
        error
      );
    })
    .always(function () {
      $(".chat-sidebar-loader").hide();
      $(".chat-sidebar-main-data").show();
      $(".chat-sidebar-product-images.slick-initialized").slick("setPosition");
    });

  // -------------------------------------
  // 🟢 WAIT FOR SLICK HELPER
  // -------------------------------------
  function waitForSlick($slider, callback) {
    if ($slider.hasClass("slick-initialized")) {
      callback();
    } else {
      const observer = new MutationObserver(() => {
        if ($slider.hasClass("slick-initialized")) {
          observer.disconnect();
          callback();
        }
      });
      observer.observe($slider[0], { attributes: true });
    }
  }

  // -------------------------------------
  // 🟢 FETCH VIDEO VIA LIQUID VIEW
  // -------------------------------------
  $.ajax({
    url: `/products/${handle}?view=chat-product-video`,
    type: "GET",
    dataType: "html",
    success: function (html) {
     
      // Clean whitespace
      const cleanHTML = $.trim(html);

      // Try jQuery parse first
      let $videoEl = $(cleanHTML).filter("video").first();
      if (!$videoEl.length) {
        $videoEl = $(cleanHTML).find("video").first();
      }

      // Fallback — regex extract video if jQuery failed
      if (!$videoEl.length) {
        const videoMatch = cleanHTML.match(/<video[\s\S]*?<\/video>/i);
        if (videoMatch && videoMatch[0]) {
          $videoEl = $(videoMatch[0]);
        }
      }

      // ✅ Now confirm
      if (!$videoEl.length) {
        console.warn("⚠️ No <video> element detected in Liquid output");
        return;
      }

      //console.log("✅ Video element parsed:", $videoEl[0]);

      // Fix src and poster
      $videoEl.find("source").each(function () {
        const src = $(this).attr("src");
        if (src && src.startsWith("//"))
          $(this).attr("src", "https:" + src);
      });

      const poster = $videoEl.attr("poster");
      if (poster && poster.startsWith("//"))
        $videoEl.attr("poster", "https:" + poster);

      // --- Build custom HTML with play/pause ---
      const videoHTML = `
        <div class="video-slide custom-video-slide">
          ${$videoEl.prop("outerHTML")}
          <button class="play-pause-btn">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
              <path d="M6 19h4V5H6zm8-14v14h4V5h-4z"/>
            </svg>
          </button>
        </div>
      `;

      const $slider = $(".chat-sidebar-product-images");

      const videoSlidePosition = 0; 

      // Wait until Slick is ready
      waitForSlick($slider, function () {
       // console.log("✅ Slick ready — adding video slide");

        if (
          videoSlidePosition !== null &&
          typeof videoSlidePosition === "number"
        ) {
          $slider.slick("slickAdd", videoHTML, videoSlidePosition);
         // console.log(`🎬 Video added at position ${videoSlidePosition}`);
        } else {
          $slider.slick("slickAdd", videoHTML);
         // console.log("🎬 Video added at end (default)");
        }

        // Recalculate layout
        $slider.slick("setPosition");

        // --- Play / Pause button ---
        $(document)
          .off("click.playpause")
          .on("click.playpause", ".play-pause-btn", function () {
            const $btn = $(this);
            const video = $btn.siblings("video").get(0);

            $("video").each(function () {
              if (this !== video) this.pause();
            });

            if (video.paused) {
              video.play();
              $btn.html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
                  <path d="M6 19h4V5H6zm8-14v14h4V5h-4z"/>
                </svg>
              `);
            } else {
              video.pause();
              $btn.html(`
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
                  <path d="M8 5v14l11-7z"/>
                </svg>
              `);
            }

          });

        // --- Pause video when slide changes ---
        $slider.on("beforeChange", function (event, slick, currentSlide) {
          $(slick.$slides[currentSlide])
            .find("video")
            .each(function () {
              this.pause();
            });
          $(".play-pause-btn").html(`
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="white" viewBox="0 0 24 24">
              <path d="M8 5v14l11-7z"/>
            </svg>
          `);
        });
      });
    },
    error: function (xhr, status, error) {
      console.error("Error fetching product video:", error);
    },
  });

  
  $.get(`/products/${handle}`, function (html) {
  const $container = $(".chat-sidebar-product-rating");
  const $tempDom = $("<div>").html(html);
  const $rating = $tempDom.find("#lipscore-rating");

  if ($rating.length) {
    // Hide the container to prevent flicker
    $container.hide().html($rating.prop("outerHTML"));

    // ⏳ Poll for the review link up to 5 seconds
    const checkInterval = 200; // ms
    const maxTime = 5000; // 5 seconds
    let elapsed = 0;

    const intervalId = setInterval(() => {
      const $reviewLink = $container.find("a.lipscore-rating-review-link");

      if ($reviewLink.length) {
        // Clean up the link
        $reviewLink.removeAttr("href title");
        const newHtml = $reviewLink.html().replace(/Reviews\s*/i, "").trim();
        $reviewLink.html(newHtml);

        // ✅ Stop checking and show smoothly
        clearInterval(intervalId);
        $container.fadeIn(200);
      }

      elapsed += checkInterval;
      if (elapsed >= maxTime) {
        // ⛔️ Stop after 5 seconds even if not found
        clearInterval(intervalId);
        $container.fadeIn(200);
      }
    }, checkInterval);
  } else {
    $container.hide().html("");
  }
});

}

$(document).on("click", ".render-in-sidebar", function () {
  const sidebar = $(".chat-sidebar-details");
  sidebar.addClass("active");
  $("body").addClass("chat-sidebar-details-active");

  $(".chat-sidebar-loader").show();
  $(".chat-sidebar-main-data").hide();

  const $el = $(this);
  const productShopifyId = $el.data("shopify-ids");
  const remainingSeconds = $el.data("remaining-seconds");
  let discountPercentage = Number($el.data("discount-percentage")) || 0;
  
  currentViewedProduct = productShopifyId;

  // --- Deal timer ---
  const discountValid = discountPercentage > 0 && remainingSeconds > 0 && window.dateNowTs;
  
  if (!discountValid) {
    $(".chat-side-bar-deal-badge").hide();
  } else {
    $(".chat-side-bar-deal-badge").show();
    startHmsCountdown(`timer-${productShopifyId}`, remainingSeconds, productShopifyId);
    startSidebarCountdown(productShopifyId);
  }

  const productCode = $el.data("code");

 const firstColorName = $el.attr("data-first-colour");

  sidebar.data("product-code", productCode);

  $(".chat-sidebar-add-to-cart").attr("data-product-id", productCode);

  // --- Extract data ---
  let variants = $el.data("variants") || [];
  let colours = $el.data("colours") || [];
  let sizes = $el.data("sizes") || [];

  if (typeof variants === "string") { try { variants = JSON.parse(variants); } catch { variants = []; } }
  if (typeof colours === "string") { try { colours = JSON.parse(colours); } catch { colours = []; } }
  if (typeof sizes === "string") { try { sizes = JSON.parse(sizes); } catch { sizes = []; } }

  sidebar.data("product-data", { variants, colours, sizes });

  // ✅ Sort sizes smartly
  sizes.sort((a, b) => {
    const aNum = parseFloat(a.name);
    const bNum = parseFloat(b.name);
    const aIsNum = !isNaN(aNum);
    const bIsNum = !isNaN(bNum);
    if (aIsNum && bIsNum) return aNum - bNum;
    if (aIsNum) return -1;
    if (bIsNum) return 1;
    return a.name.localeCompare(b.name);
  });

  
  // --- Colours ---
  colours.sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }));
  
  const colorContainer = sidebar.find(".chat-sidebar-color-options");
  colorContainer.empty();

  colours.forEach((c, index) => {
    const inputId = `chat-color-${index}`;
    const swatchContent = c.image
      ? `<img src="${c.image}" alt="${c.name}" class="color-swatch">`
      : `<span class="color-text">${c.name.slice(0, 1)}</span>`;

    colorContainer.append(`
      <div class="chat-sidebar-color-option">
        <input type="radio" 
               name="chat-color" 
               id="${inputId}" 
               value="${c.name}" 
               data-id="${c.id}" 
               ${index === 0 ? "checked" : ""}>
        <label for="${inputId}" title="${c.name}">${swatchContent}</label>
      </div>
    `);
  });

  const $firstColor = colorContainer.find("input[name='chat-color']:checked");
  const selectedColorName = $firstColor.val() || null;
  if (selectedColorName) {
    $(".chat-sidebar-section-title.color").text(`Color: ${selectedColorName}`);
  }


  /* -------------------------------------------
  UPDATED PRICING LOGIC - USING EXISTING ELEMENTS
  ------------------------------------------- */
/* -------------------------------------------
  UPDATED PRICING LOGIC - USING EXISTING ELEMENTS
  ------------------------------------------- */

  // Function to update price display using COLOUR-LEVEL pricing
  function updatePriceDisplay(selectedColorName) {
    // Find the selected colour object to get its specific pricing
    let selectedColourObj = null;
    if (selectedColorName && Array.isArray(colours)) {
      selectedColourObj = colours.find(
        c => String(c.name).toLowerCase() === String(selectedColorName).toLowerCase()
      ) || null;
    }

    // DEFAULT to first colour if none selected (shouldn't happen)
    if (!selectedColourObj && colours.length > 0) {
      selectedColourObj = colours[0];
    }

    // Get pricing from the COLOUR object, not from element data
    let colourPrice = 0;
    let colourSalePrice = null;
    
    if (selectedColourObj) {
      // Use colour-specific price
      if (typeof selectedColourObj.price === "number") {
        colourPrice = Number(selectedColourObj.price);
      }
      
      // Use colour-specific sale_price
      if (typeof selectedColourObj.sale_price !== "undefined") {
        colourSalePrice = selectedColourObj.sale_price === null
          ? null
          : Number(selectedColourObj.sale_price);
      }
    } else {
      // Fallback to element data if no colour object found
      colourPrice = Number($el.data("price")) || 0;
      colourSalePrice = $el.data("sale-price") !== undefined && $el.data("sale-price") !== "null"
        ? Number($el.data("sale-price"))
        : null;
    }

    // Calculate base price for VIP calculation - use colour sale price if available
    let priceForVip = colourSalePrice !== null ? colourSalePrice : colourPrice;
    priceForVip = Number(priceForVip) || 0;
    
    // Calculate VIP price if discount is valid
    let vipPrice = priceForVip;
    let amountSaved = 0;

    if (discountValid) {
      const discountType = Number($el.data("discountType")) || 2;
      const discountAmountRaw = Number($el.data("discountAmount")) || 0;

      if (discountType === 1 && discountAmountRaw > 0) {
        vipPrice = priceForVip - discountAmountRaw;                       // amount IS the VIP price
        amountSaved = discountAmountRaw;      // actual saving
        discountPercentage = Math.round((amountSaved / priceForVip) * 100);
      } else {
        vipPrice = priceForVip * (1 - (discountPercentage / 100));
        amountSaved = priceForVip - vipPrice;
      }
      vipPrice = Number(vipPrice.toFixed(2));
      amountSaved = Number(amountSaved.toFixed(2));
    }
    // Determine effective price
    let effectivePrice = colourPrice;

    // FIX: Only remove VIP price from the sidebar, not from product cards
    // Scope the selection to the sidebar only
    sidebar.find(".ai-vip-price").remove();

    // Get the price compare container within the sidebar
    const priceCompareContainer = sidebar.find(".chat-sidebar-price-comapre-price");

    if (discountValid) {
      // When discount is valid
      if (colourSalePrice !== null && colourSalePrice > 0) {
        
        sidebar.find(".chat-sidebar-compare-price")
          .text(`£${colourPrice.toFixed(2)}`)
          .show();
        
        sidebar.find(".chat-sidebar-price")
          .text(`£${colourSalePrice.toFixed(2)}`)
          .addClass("side-bar-strike")
          .removeClass("regular")
          .show();
        
        sidebar.find(".chat-sidebar-discounted-price").hide().empty();
        
        // Add VIP price container after the price compare container
        priceCompareContainer.after(`
          <div class="ai-vip-price">
           <span class="ai-personalized-off">
            ${Number($el.data("discountType")) === 1
              ? `£${amountSaved.toFixed(2)} OFF`
              : `${discountPercentage}% OFF`
            }
          </span>
            <span class="ai-personalized-price"> VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span></span>
          </div>
        `);
        
        effectivePrice = vipPrice;
      } else {
        
        sidebar.find(".chat-sidebar-compare-price")
          .text(`£${colourPrice.toFixed(2)}`)
          .addClass("side-bar-strike")
          .show();
        
        
        sidebar.find(".chat-sidebar-price")
          .hide()
          .empty();
        
        sidebar.find(".chat-sidebar-discounted-price").hide().empty();
        
        // Add VIP price container after the price compare container
        priceCompareContainer.after(`
          <div class="ai-vip-price">
            <span class="ai-personalized-off">
              ${Number($el.data("discountType")) === 1
                ? `£${amountSaved.toFixed(2)} OFF`
                : `${discountPercentage}% OFF`
              }
            </span>
            <span class="ai-personalized-price"> VIP Price - <span class="money">£${vipPrice.toFixed(2)}</span></span>
          </div>
        `);
        
        effectivePrice = vipPrice;
      }
      sidebar.find(".chat-sidebar-price-rating").addClass("side-bar-col-direction");
    } else if (colourSalePrice !== null && colourSalePrice > 0) {
      
      sidebar.find(".chat-sidebar-compare-price")
        .text(`£${colourPrice.toFixed(2)}`)
        .show();
      
      sidebar.find(".chat-sidebar-price")
        .text(`£${colourSalePrice.toFixed(2)}`)
        .removeClass("regular side-bar-strike")
        .show();
      
      sidebar.find(".chat-sidebar-discounted-price").hide().empty();
      effectivePrice = colourSalePrice;
      sidebar.find(".chat-sidebar-price-rating").removeClass("side-bar-col-direction");
    } else {
      
      sidebar.find(".chat-sidebar-compare-price").hide();
      
      sidebar.find(".chat-sidebar-price")
        .text(`£${colourPrice.toFixed(2)}`)
        .removeClass("regular side-bar-strike")
        .show();
      
      sidebar.find(".chat-sidebar-discounted-price").hide().empty();
      effectivePrice = colourPrice;
      sidebar.find(".chat-sidebar-price-rating").removeClass("side-bar-col-direction");
    }

    // Update add-to-cart button price
    sidebar.find(".chat-sidebar-add-to-cart").attr("data-product-price", effectivePrice.toFixed(2));
  }
  

  // Initial price update
  updatePriceDisplay(selectedColorName);

  // --- Sizes (show only available sizes for selected colour) ---
  const sizeContainer = sidebar.find(".chat-sidebar-size-options");
  sizeContainer.empty();

  function renderSizesForColor(colorName) {
    const colorVariants = variants.filter(v => v.colour === colorName);
    sizeContainer.empty();

    // Filter sizes to only show those available for this colour
    const availableSizes = sizes.filter(s => 
      colorVariants.some(v => v.size === s.name)
    );

    availableSizes.forEach((s, index) => {
      const inputId = `chat-size-${index}`;
      sizeContainer.append(`
        <div class="chat-sidebar-size-option">
          <input type="radio"
                name="chat-size"
                id="${inputId}"
                value="${s.name}"
                data-id="${s.id}"
                ${index === 0 ? "checked" : ""}>
          <label for="${inputId}">${s.name}</label>
        </div>
      `);
    });

    // Auto-select first available size
    const $firstEnabled = sizeContainer.find("input[name='chat-size']:enabled").first();
    if ($firstEnabled.length) {
      $firstEnabled.prop("checked", true);
      $(".chat-sidebar-section-title.size").text(`Size: ${$firstEnabled.val()}`);
    }
  }

  // Initial render - show sizes for first colour
  renderSizesForColor(selectedColorName);

  // --- Hide loader ---
  $(".chat-sidebar-loader").hide();
  $(".chat-sidebar-main-data").show();

  // --- Load initial variant ---
  const selectedSizeName = sizeContainer.find("input[name='chat-size']:checked").val() || null;
  const initialVariant = variants.find(v => v.colour === selectedColorName && v.size === selectedSizeName);
  if (initialVariant) {
    loadProductData(initialVariant.handel);
  } else {
    loadProductData($el.data("handle"));
  }

  // --- Handle colour change dynamically ---

  $(document)
  .off("change", "input[name='chat-color']")
  .on("change", "input[name='chat-color']", function () {
      const newColor = $(this).val();
      $(".chat-sidebar-section-title.color").text(`Color: ${newColor}`);

      // Re-render sizes for selected color (only show available sizes)
      renderSizesForColor(newColor);

      // Lookup the selected size
      const selectedSize = sizeContainer.find("input[name='chat-size']:checked").val();

      // Find matching variant
      const newVariant = variants.find(v => v.colour === newColor && v.size === selectedSize);
      if (newVariant) loadProductData(newVariant.handel);

      // Update price display for new colour
      updatePriceDisplay(newColor);
  });

  
  // --- Handle size change dynamically ---
  $(document)
    .off("change", "input[name='chat-size']")
    .on("change", "input[name='chat-size']", function () {
      const newSize = $(this).val();
      $(".chat-sidebar-section-title.size").text(`Size: ${newSize}`);
      const selectedColor = $("input[name='chat-color']:checked").val();
      const newVariant = variants.find(v => v.colour === selectedColor && v.size === newSize);
      if (newVariant) loadProductData(newVariant.handel);
    });

  // --- Fetch additional product details ---


// const selectedColorCode = $("input[name='chat-color']:checked").val();

  $.ajax({
    url: "https://ai.mygoddiva.com/get-product-by-code",
    method: "GET",
    data: { 
      code: productCode,
      colour: firstColorName
    },
    dataType: "json",
    success: function (data) {
      let sectionHtml = "";
      const sections = [
        { key: "available_length", title: "Different Lengths" },
        { key: "available_fit", title: "Different Fit" },
        { key: "available_in", title: "Available In" },
        { key: "available_diffab", title: "Different Fabrics" },
      ];

      sections.forEach(sec => {
        if (data[sec.key]?.length) {
          sectionHtml += `
            <div class="chat-availability-row">
              <div class="chat-availability-title">${sec.title}</div>
              <div class="chat-availability-items">
                ${data[sec.key]
                  .map(item => `<div class="chat-availability-item" data-value="${item.values?.[0] || ""}">${item.type}</div>`)
                  .join("")}
              </div>
            </div>`;
        }
      });

      if (sectionHtml) {
        $(".chat-sidebar-availability-table").html(sectionHtml);
        $(".chat-sidebar-availability-section").show();
      } else {
        $(".chat-sidebar-availability-section").hide();
      }

      $(".chat-availability-item").on("click", function () {
        const value = $(this).data("value") || "";
        $("#chat_input_text").val(value).focus().trigger("input");
      });
    },
    error: function () {
      $(".api-error").text("An error occurred. Please try again.").show();
      setTimeout(() => $(".api-error").fadeOut(), 2000);
    },
  });
});



$(document).on('click', '.chat-sidebar-add-to-cart', function () {
  const $sidebar = $('.chat-sidebar-details');
  const productCode = $sidebar.data('product-code');
  const $btn = $(this);

  // ✅ Use data-id instead of val()
  const selectedColor = $("input[name='chat-color']:checked").data('id');
  const selectedSize = $("input[name='chat-size']:checked").data('id');

  if (!selectedColor || !selectedSize) {
    alert("⚠️ Please select both color and size.");
    return;
  }

  console.log("🎨 Selected Color ID:", selectedColor, "📏 Size ID:", selectedSize, "🆔 Product Code:", productCode);

  // ✅ Call backend API to get variant + discount

  const token = getAiToken();
  
  $.ajax({
    url: 'https://ai.mygoddiva.com/get-product-for-cart',
    type: 'GET',
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: {
      id: localStorage.getItem('session_id'),
      code: productCode,
      colour: selectedColor,
      size: selectedSize
    },
    success: function (response) {
      if (!response || !response.variant || !response.variant.shopify_variant_id) {
        console.error('❌ Invalid response:', response);
        alert("⚠️ Unable to fetch product details. Try again.");
        return;
      }

      // ✅ Extract correct values
      const variantId = response.variant.shopify_variant_id;
      const stock = Number(response.variant.inventory_variant__qty || 0);
      const discountCode = response.discount || null;

      console.log("✅ Variant ID:", variantId, "📦 Stock:", stock, "🎟️ Discount:", discountCode);

      // ✅ Check current cart quantity
      Shopify.getCart(cart => {
        const existing = cart.items.find(i => i.variant_id == variantId);
        const currentQty = existing ? existing.quantity : 0;

        if (currentQty + 1 > stock) {
          $('body').addClass('has-warning');
          $('.halo-warning-content').text('The maximum quantity of this item is already in your cart.');
          setTimeout(() => {
            $('body').removeClass('has-warning');
            $('.halo-warning-content').text('');
          }, 2000);
          return;
        }

        // ✅ Add to cart safely
        addToShoppingCart(variantId, discountCode);

        // ✅ Send user feedback (analytics / tracking)
        sendUserFeedback($btn, 'chat_sidebar_add_to_cart', {
          size: selectedSize,
          colour: selectedColor
        });
      });
    },
    error: function (xhr, status, error) {
      console.error('API Error:', error);
      alert("⚠️ Something went wrong while getting product details.");
    }
  });
});


// ----------------------------
// ✅ Shopify Add to Cart + Discount (shared logic)
// ----------------------------
function addToShoppingCart(variantId, discountCode) {
 const formData = {
    items: [
      {
        id: variantId,
        quantity: 1
      }
    ],
    attributes: {
      DudeAi: "true"
    }
  };

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData)
  })
    .then(res => res.json())
    .then(data => {
      console.log('✅ Added to cart:', data);
      $(".chat-sidebar-details").removeClass("active");
      $("body").removeClass("chat-sidebar-details-active");

      const addedItem = data.items ? data.items.find(i => i.variant_id == variantId) : null;

      // ✅ Apply discount if available
      if (discountCode) {
        console.log(`🎟️ Applying discount ${discountCode}`);
        return addDiscount(discountCode).then(cart => {
          updateSidebar(cart, addedItem ? addedItem.variant_id : null);
        });
      } else {
        Shopify.getCart(cart => {
          updateSidebar(cart, addedItem ? addedItem.variant_id : null);
        });
      }
    })
    .catch(err => {
      console.error('❌ Error adding to cart:', err);
      alert("⚠️ Unable to add this item to cart at the moment.");
    });
}


// Click event handler for wishlist button
$(document).on("click", ".chat-sidebar-wishlist", function(e) {
    e.preventDefault();
    
    const productHandle = $(this).attr("data-chat-wishlist-handle");
    if (!productHandle) return; // Exit if no product handle set
    
    toggleWishlistItem(productHandle);
    updateWishlistButtonState(productHandle);
});

// Function to toggle item in wishlist
function toggleWishlistItem(productHandle) {
    // Get current wishlist from localStorage or initialize empty array
    let wishlist = JSON.parse(localStorage.getItem('wishlistItem')) || [];
    
    // Check if product is already in wishlist
    const index = wishlist.indexOf(productHandle);
    
    if (index === -1) {
        // Add to wishlist if not present
        wishlist.push(productHandle);
    } else {
        // Remove from wishlist if already present
        wishlist.splice(index, 1);
    }
    
    // Save updated wishlist to localStorage
    localStorage.setItem('wishlistItem', JSON.stringify(wishlist));
}

// Function to update button appearance based on wishlist status
function updateWishlistButtonState(productHandle) {
    if (!productHandle) return;
    
    const wishlist = JSON.parse(localStorage.getItem('wishlistItem')) || [];
    const isInWishlist = wishlist.includes(productHandle);
    
    const button = $(".chat-sidebar-wishlist");
    
    if (isInWishlist) {
        button.addClass('in-wishlist');
       // button.text('Saved to Wishlist');
    } else {
        button.removeClass('in-wishlist');
       // button.text('Save to Wishlist');
    }
}


    let sidebarCountdownInterval = null;
    let currentViewedProduct = null;
    const productEndTimes = {}; 

    // Main countdown for product page / card
    function startHmsCountdown(elementId, remainingSeconds, productId = null) {
        const el = document.getElementById(elementId);
        if (!el) return;

        // Calculate and store endTime for this product if not already stored
        if (!productEndTimes[productId]) {
            productEndTimes[productId] = Date.now() + remainingSeconds * 1000;
        }
        const endTime = productEndTimes[productId];

        function updateTimer() {
            const diff = Math.floor((endTime - Date.now()) / 1000);

            if (diff <= 0) {
                el.dataset.timer = 'expired';
                stopSidebarCountdown();
                return;
            }

            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor((diff % 3600) / 60);
            const seconds = diff % 60;

            // Update timer in data attribute instead of textContent
            el.dataset.timer = `${hours}h ${minutes}m ${seconds}s`;

            // Update sidebar if this is the currently viewed product
            if (productId === currentViewedProduct) {
                updateSidebarCountdown(diff);
            }

            setTimeout(updateTimer, 1000);
        }

        updateTimer();
    }

    // Sidebar countdown — uses stored endTime
    function startSidebarCountdown(productId) {
        stopSidebarCountdown();

        const sidebarEl = $('.chat-sidebar-countdown-inline')[0];
        if (!sidebarEl) return;

        const endTime = productEndTimes[productId];
        if (!endTime) return; // no countdown started for this product yet

        function updateSidebar() {
            const diff = Math.floor((endTime - Date.now()) / 1000);

            if (diff <= 0) {
                sidebarEl.dataset.timer = 'expired';
                stopSidebarCountdown();
                return;
            }

            const hours = Math.floor(diff / 3600);
            const minutes = Math.floor((diff % 3600) / 60);
            const seconds = diff % 60;

            // Update sidebar timer in data attribute
            sidebarEl.dataset.timer = `${hours}h ${minutes}m ${seconds}s`;
        }

        updateSidebar();
        sidebarCountdownInterval = setInterval(updateSidebar, 1000);
    }

    // Update sidebar timer from main timer
    function updateSidebarCountdown(seconds) {
        const sidebarEl = $('.chat-sidebar-countdown-inline')[0];
        if (!sidebarEl) return;

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secondsRemaining = seconds % 60;

        sidebarEl.dataset.timer = `${hours}h ${minutes}m ${secondsRemaining}s`;
    }

    // Stop sidebar countdown interval
    function stopSidebarCountdown() {
        if (sidebarCountdownInterval) {
            clearInterval(sidebarCountdownInterval);
            sidebarCountdownInterval = null;
        }
    }


  function botResponseHandel(botResponse,filter,promptId){
        let  filterHtml="";
         if(filter){
           filterHtml+=`<div class="filter-label filter-panel filter-panel-${promptId}">${filter.label}</div><div class="filter-panel filter-panel-${promptId}">`;
               $.each(filter.value, function(index, value) {
                 filterHtml+=`<button class="filter-btn" onclick="filterOnclick(${value.id},'${value.name}','${promptId}')" data-id="${value.id}">${value.name}</button>`;
               });
            filterHtml+=`</div>`; 
                 
         }
        return `
           <div class="bot-message botResponseHandel">
           <span class="bot-logo"><img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-bot-message-logo.png?v=1759938397" height="24px" width="24px"></span>
            <span class="bot-text">
              ${botResponse}
              ${filterHtml ? filterHtml : ""}
            </span>
           </div>
        `;
    
  }
  function filterOnclick(id,name,promptId){
            $('#change_Filter_suggestion').hide();
     const filter={
       prompt_id:promptId,
       value:[{id:id,name:name}]
     }
    ajaxChat(null,filter)
  }
  
  function ajaxChat(prompt, filter, productId = null) {
   
    freezeActions(); 
    $('#type_looader').show();
    if (shopifyPage != "page.assistant") {
        scrollToElementInDrawer('#type_looader');
    }
    
    $('#change_Filter_suggestion').show();
    $('#prompt_suggestion').hide();
    $('.chat-alternative-section').remove();

    promptId = prompt ? prompt.id : "";

    const token = getAiToken();

    
    $.ajax({
        url: 'https://ai.mygoddiva.com/chat',
        type: 'POST',
        contentType: 'application/json',
        headers: token ? { "Authorization": "Bearer " + token } : {},
        data: JSON.stringify({
            assistant_id: localStorage.getItem('session_id'),
            prompt: prompt,
            filter: filter,
            product_id: productId
        }),
        success: function(response) {
           // showRetryButtonInMessage(prompt?.message, ajaxChat, [prompt, filter, productId]);
            chatReponse(response, filter, productId, promptId);
            releaseActions(); 

        },
        error: function(xhr, status, error) {

          showRetryButtonInMessage(prompt?.message, ajaxChat, [prompt, filter, productId]);

          $('.api-error').text('An error occurred. Please try again.').show();
           $('#gooeyEffect').hide();
          $('#type_looader').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
            console.error('AJAX Error:', error);
            releaseActions(); 
        }
    });
}

var currentFilterKey = null;

  function chatReponse(response, filter, productId, promptId){
            $('#type_looader').hide();
            
            const gooeyEffect = document.getElementById('gooeyEffect');
            gooeyEffect.classList.remove('gooey-active');

            $('#prompt_suggestion').show();
            if(response.message && !productId){
            
            const lastUserMessage = $('#chat_message .user-message').last();
            let userInitials = getUserInitials();
            if (!lastUserMessage.length || lastUserMessage.text().trim() !== response.message.trim()) {
                $('#chat_message').append(
                  '<div class="user-message">' +
                    '<div class="user-logo">' + userInitials + '</div>' +
                    '<div class="user-text">' + response.message + '</div>' +
                  '</div>'
                );
            }
            


             // $('#chat_message').append('<div class="user-message">'+response.message+'</div>');

            }
            if(filter){
              $(`.filter-panel-${filter.prompt_id}`).hide();
            }
            //$('#chat_message').append('<div class="bot-message">'+response.response+'</div>');
            $('#chat_message').append(botResponseHandel(response.response,response.filters,promptId));

         

          if (response.products && response.products.total > 0) {
              // ✅ Create the container
              $('#chat_message').append(`
                <div class="drag-scroll" 
                    data-id="${response.id}" 
                    data-total="${response.products.total}" 
                    data-page="1" 
                    data-has="true">
                    <div class="chat-product-item-wrapper"></div>
                </div>
              `);

              const $newScroll = $('.drag-scroll').last();
              const message_id = $newScroll.data('id');
              
              // ✅ Pass the products from response to initLazyLoad
              initLazyLoad($newScroll, message_id, response.products);
              
              if ($('.drag-scroll').length === 1) {
                // yathu asked to remove 3 oct
                //$('#chat_message').append(productRecommendationFeedback(message_id));
              }
            }

           
             if(response.selected_filter){  
              selectedFilter(response.selected_filter); 
             }

             if ($.trim($('#change_Filter_suggestion').html()) !== "") {
                  $('.tag-container').hide();
              } else {
                  $('.tag-container').show();
              }

              $('.tag-container').animate({
                  scrollLeft:  $('.tag-container').width()+100
              }, 400);
              
            if (response.filter_key) {
                currentFilterKey = response.filter_key; 
            }
            console.log('currentFilterKey user-query', currentFilterKey)
            if(response.suggestions){
               promptHandel(response.suggestions, response.filter_key);
            }

            if (response.trigger_prompt_id) {
              const $triggerPromptIdBtn = $(`.prompt-btn[data-id="${response.trigger_prompt_id}"]`);
              setTimeout(() => {
               if($triggerPromptIdBtn.length && $triggerPromptIdBtn.data('filter') === 'filter'){
                  $triggerPromptIdBtn.trigger('click');
               }
              }, 200);

            }

            if(shopifyPage != "page.assistant"){
              scrollToElementInDrawer('#prompt_suggestion');
            }

            if (response.is_size_mentioned === 1) {
                setTimeout(() => {
                    // Check if the message already exists
                        $('.bot-message.size-reminder').remove();
                        $('#chat_message').append(`
                            <div class="bot-message size-reminder">
                                <span class="bot-logo">
                                    <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-bot-message-logo.png?v=1759938397" height="24" width="24" alt="Bot">
                                </span>
                                <span class="bot-text">
                                   Looking for different Size(s)? Tap below to update<br>
                                   <button class="chat-update-size-btn-trigger">Change Your Size</button>
                                </span>
                            </div>
                        `);

                        scrollToBottom();
                   
                }, 600);
            }

          //return portal start
          
            
            var chat_message = document.getElementById('chat_message');
            
            let requestType = '';
            if (response.type) {
              requestType = response.type;
            }

            if (response.line_items) {
              const lineItems = response.line_items;
              const originalQuery = response._originalQuery || response.message || '';

              // ── Build last_return_items from complete_label ──
              const completeLabels = lineItems?.requested?.return?.return_label?.complete_label || [];
              const rawLastReturn  = [];
              completeLabels.forEach(returnRequest => {
                returnRequest.items?.forEach(seller => {
                  seller.items?.forEach(item => {
                    if (item.is_return == 3 || item.alteration_request_status != null) return;
                    rawLastReturn.push({
                      brand_id      : item.brand_id,
                      brand_name    : item.brand,
                      requested_date: item.requested_date,
                    });
                  });
                });
              });
              const latestByBrand = new Map();
              rawLastReturn
                .sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date))
                .forEach(item => {
                  if (!latestByBrand.has(item.brand_id)) latestByBrand.set(item.brand_id, item);
                });
              lineItems.last_return_items = Array.from(latestByBrand.values());

              // ── Build last_pending_fees_items from pending_label ──
              const pendingLabels = lineItems?.requested?.return?.return_label?.pending_label || [];
              const rawPendingFees = [];
              pendingLabels.forEach(label => {
                label.items?.forEach(seller => {
                  seller.items?.forEach(item => {
                    rawPendingFees.push({
                      brand_id      : item.brand_id,
                      brand_name    : item.brand,
                      requested_date: item.requested_date,
                    });
                  });
                });
              });
              const latestPendingByBrand = new Map();
              rawPendingFees
                .sort((a, b) => new Date(b.requested_date) - new Date(a.requested_date))
                .forEach(item => {
                  if (!latestPendingByBrand.has(item.brand_id)) latestPendingByBrand.set(item.brand_id, item);
                });
              lineItems.last_pending_fees_items = Array.from(latestPendingByBrand.values());

              // ── Flatten items ──
              const notRequestedItems = (lineItems.not_requested || []).flatMap(s => s.items || []);
              const outletReturnItems = (lineItems.partner_id == 1)
                ? (lineItems.outlet || []).flatMap(s => s.items || [])
                : [];
              const allReturnItems = [...notRequestedItems, ...outletReturnItems];
              let newPanel = null;

              // ── Return panel ──
              if (requestType == 'return_request') {
                if (allReturnItems.length > 0) {
                  // Freeze all existing return panels
                  chat_message.querySelectorAll('.ai-page-li-panel').forEach(p => {
                    aiPageResetPanel(p);
                    aiPageFreezePanel(p, 'Updated return panel available below');
                  });

                  const html = aiPageRenderLineItems(allReturnItems, lineItems);
                  chat_message.insertAdjacentHTML('beforeend', html);

                  const allReturnPanels = chat_message.querySelectorAll('.ai-page-li-panel');
                  newPanel = allReturnPanels[allReturnPanels.length - 1];

                  if (newPanel) {
                    aiPageSetPanelReasons(newPanel, lineItems.reasons || []);
                    aiPageUpdateGiftBag(newPanel);
                    newPanel.dataset.originalQuery = originalQuery;
                    newPanel.dataset.pendingLabels = JSON.stringify(pendingLabels);
                    newPanel.dataset.shippingCode  = lineItems.shipping_country_code || '';
                    newPanel.dataset.returnFee     = lineItems.return_fee || 0;
                  }
                }

                // ── Requested items (read-only history) ──
              const requestedHtml = aiPageRenderRequestedItems(lineItems, newPanel?.id || null);
                if (requestedHtml) {
                  if (newPanel) {
                    newPanel.insertAdjacentHTML('beforeend', requestedHtml);
                  } else {
                    const wrapperId = `ai-page-req-wrapper_${Date.now()}`;
                    chat_message.insertAdjacentHTML('beforeend', `
                      <div class="ai-page-li-requested-only"
                          id="${wrapperId}"
                          data-order-id="${lineItems.order || ''}"
                          data-customer-id="${lineItems.customer || ''}"
                          data-pending-labels='${aiPageEscHtml(JSON.stringify(pendingLabels))}'
                          data-shipping-code="${lineItems.shipping_country_code || ''}"
                          data-return-fee="${lineItems.return_fee || 0}"
                          data-original-query="${aiPageEscHtml(originalQuery)}">
                        ${requestedHtml}
                        ${aiPageRenderRequestedPopups(wrapperId)}
                      </div>
                    `);
                  }
                }

                // ── Auto-show payment popup if pending labels exist ──
                if (pendingLabels.length > 0) {
                  const targetPanel = newPanel
                    || chat_message.querySelector('.ai-page-li-requested-only:last-child');

                  if (targetPanel) {
                    // Small delay to ensure DOM is ready
                    setTimeout(() => {
                      const payBtn = targetPanel.querySelector(
                        '[data-invoice-url][onclick*="aiPageOpenPaymentFromPending"]'
                      );
                      if (payBtn) payBtn.click();
                    }, 500);
                  }
                }

              }

              if (requestType == 'exchange_request') {
                const hasExchangeData = notRequestedItems.length > 0
                  || lineItems?.requested?.exchange?.length > 0
                  || lineItems?.requested?.return?.return_label?.complete_label?.length > 0
                  || lineItems?.requested?.return?.return_label?.pending_label?.length > 0
                  || lineItems?.requested?.alteration?.length > 0
                  || (lineItems.outlet || []).length > 0
                  || (lineItems.nonReturnableItems || []).length > 0;

                if (hasExchangeData) {
                  chat_message.querySelectorAll('.ai-page-ex-panel').forEach(p => {
                    aiPageResetPanel(p);
                    aiPageFreezePanel(p, 'Updated exchange panel available below');
                  });
                  const exHtml = aiPageRenderExchangePanel(notRequestedItems, lineItems);
                  if (exHtml) {
                    chat_message.insertAdjacentHTML('beforeend', exHtml);
                    // Store original query on exchange panel
                    const allExPanels = chat_message.querySelectorAll('.ai-page-ex-panel');
                    const exPanel = allExPanels[allExPanels.length - 1];
                    if (exPanel) exPanel.dataset.originalQuery = originalQuery;
                  }
                }
              }

              if (requestType == 'alteration_request') {
                const hasAlterationData = notRequestedItems.length > 0
                || (lineItems.outlet || []).length > 0
                || lineItems?.requested?.alteration?.length > 0
                || lineItems?.requested?.return?.return_label?.complete_label?.length > 0
                || lineItems?.requested?.return?.return_label?.pending_label?.length > 0
                || lineItems?.requested?.exchange?.length > 0;

                if (hasAlterationData) {
                  chat_message.querySelectorAll('.ai-page-alt-panel').forEach(p => {
                    aiPageResetPanel(p);
                    aiPageFreezePanel(p, 'Updated alteration panel available below');
                  });
                  const altHtml = aiPageRenderAlterationPanel(notRequestedItems, lineItems);
                  if (altHtml) {
                    chat_message.insertAdjacentHTML('beforeend', altHtml);
                    // Store original query on alteration panel
                    const allAltPanels = chat_message.querySelectorAll('.ai-page-alt-panel');
                    const altPanel = allAltPanels[allAltPanels.length - 1];
                    if (altPanel) altPanel.dataset.originalQuery = originalQuery;
                  }
                }
              }
            }

            //return portal ends
  }


  $(document).on('click', '.chat-update-size-btn-trigger', function() {
    $('.chat-update-size-btn-open').data('programmatic', true);
    sessionStorage.setItem('sizeMentioned', 'true');
    $('.chat-update-size-btn-open').trigger('click');
  });
 
  function scrollToElementInDrawer(elementSelector) {
      const drawerContent = document.querySelector('.drawer__content');
      const targetElement = drawerContent.querySelector(elementSelector);
      
      if (targetElement) {
        targetElement.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
   }

  function changeFilterAjax(){
          $('#type_looader').show();
          $('#prompt_suggestion').hide();
          $('.chat-alternative-section').remove();
          const token = getAiToken();

        $.ajax({
          url: 'https://ai.mygoddiva.com/get-selected-filter', // Sample API endpoint
          headers: token ? { "Authorization": "Bearer " + token } : {},
          data:{
            id: localStorage.getItem('session_id')
          },
          success: function(response) {
            
             const $tagcontainer = $('.tag-container');
             $tagcontainer.empty().hide();
         
            $('#type_looader').hide();
            $('#top-bar').show();
            $('#prompt_suggestion').show();
            $('#global-chat-dropdown').hide().detach().appendTo('body');
            $('#change_Filter_suggestion').empty();
            $('#change_Filter_suggestion').append(changeFilterHtml(response.selected_filters));
            $('#change_Filter_suggestion').show();
            $('.filter-panel').hide();
       
          },
          error: function(xhr, status, error) {
            $('.api-error').text('An error occurred. Please try again.').show();
             $('#gooeyEffect').hide();
            $('#type_looader').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
            console.error('AJAX Error:', error);
      }
    });
  }
  function moreLike(id,image,name){

     $('#chat_message').append(moreLikeHtml({title:name,image:image}));

     if(shopifyPage == "page.assistant"){ 
        $('html, body').animate({
            scrollTop: $('#prompt_suggestion').offset().top-200
        }, 500);
     }

    $('#global-chat-dropdown').hide().detach().appendTo('body');
    $('#change_Filter_suggestion').empty();
    ajaxChat(null,null,id);

  }

  function moreLikeHtml(value){
    let userInitials = getUserInitials();
      const html=`  <div class="card-wrapper">
        <div class="more-like-this-card">
          <div class="top-row">
            <div class="title-text">${value.title}</div>
            <img src="${value.image}" alt="Product" class="product-image">
          </div>
          <div class="cta-text">Show me more like this</div>
        </div>
         <div class="user-logo"> ${userInitials}</div>
      </div>`;
      return html;
  }


  function selectedFilter(filters) {
      let filterHtml = "";
      $.each(filters, function(index, value) {
        filterHtml += `<span class="tag filter-tag">${value.label ? value.label + " : " : ""}${value.value}</span>`;
      });

      // ✅ Keep existing search-query tags
      const existingSearchTags = $('.tag-container .search-query').clone();

      // ✅ Replace tag container content with filters
      $('.tag-container').html(filterHtml).show();

      // ✅ Add back the preserved search-query tags at the top
      $('.tag-container').prepend(existingSearchTags).show();

      // $('#top-bar').show();

        // ✅ Show/hide logic commented for below useremail
      // if (filters.length >= 3) {
      //   $('.looking-for, #top-bar').show();
      // } else {
      //   $('.looking-for, #top-bar').hide();
      // }

      const userEmail = localStorage.getItem('user_email')?.toLowerCase();
      const allowed = ['yathu@citygoddess.co.uk', 'methan@akhitsolutions.com','sai@citygoddess.co.uk'];

    
      if (filters.length >= 3) {
        $('.looking-for, #top-bar').show();
      } else {
       $('.looking-for, #top-bar').hide();
      }

      if (allowed.includes(userEmail)) {
         if (filters.length >= 3) {
        $('.looking-for, #top-bar').show();
        }
      } else {
        $('#top-bar').attr('style', 'display:none !important;');
      }
}



   function changeFilterHtml(filters){
    console.log(filters,'filters');
    let filterHtml=`<div class="filter-wrapper">`;
    $.each(filters, function(index, value) {
        const hasChanged = value.is_has_changed == 1;
        filterHtml+=`<div class="change-filter-btn-wrapper">
          <button 
              class="change-filter" 
              data-category="${value.filter}" 
              data-ishaschanged="${value.is_has_changed}"
              ${hasChanged ? `onclick="changeFilterhandel('${value.prompt_id}','${value.message}','${value.filter}')"` : ''}>
              ${value.filter ? `<span class="filter-category">${value.filter} :</span>` : ''}
              <span class="filter-value">${value.label}</span>
              ${hasChanged ? `
              <span class="chat-dropdown-toggle">
                  <svg class="drop-icon-svg" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M7 10l5 5 5-5z"></path>
                  </svg>
              </span>` : ''}
          </button>
          <button 
              data-category="${value.filter}" 
              data-prompt-id="${value.prompt_id}" 
              data-value="${value.label}" 
              data-id="${value.prompt_id}" 
              data-ishaschanged="${value.is_has_changed}" 
              data-name="product_suggestion_request" 
              data-action="remove" 
              class="delete-filter">x</button>
        </div>`;
    });
    filterHtml+=`</div>`
    console.log('filters.length',filters.length);
    if (filters.length >= 3) {
        $(".looking-for, #top-bar").show();
    } else {
        $(".looking-for").hide();
    }

    return filterHtml;
}


// Handle delete filter button clicks
$(document).on('click', '.delete-filter', function() {
    const $deleteButton = $(this);
    const $wrapper = $deleteButton.closest('.change-filter-btn-wrapper');
    
    const category     = $deleteButton.data('category');
    const id           = $deleteButton.data('id');
    const value        = $deleteButton.data('value');
    const promptId     = $deleteButton.data('prompt-id');
    const ishaschanged = parseInt($deleteButton.data('ishaschanged'));
    const name         = $deleteButton.data('name');
    const action       = $deleteButton.data('action');
    const $dropdown = $('#global-chat-dropdown');

    $dropdown.hide().detach().appendTo('body');

    $wrapper.remove();
    
    if ($('.change-filter-btn-wrapper').length === 0) {
        $('#change_Filter_suggestion').hide();
    }
    
    const deleteLabel = `remove ${value}`;
     let userInitials = getUserInitials();
    $('#chat_message').append('<div class="user-message">' +
                        '<div class="user-logo">' + userInitials + '</div>' +
                        '<div class="user-text">' + deleteLabel + '</div>' +
                      '</div>');
    $('#type_looader').show();
    
    // chatQuery(deleteLabel, name, action, category.toLowerCase());

    if (ishaschanged == 0) {
        chatQuery(deleteLabel, name, action, null, promptId);
    } else {
        chatQuery(deleteLabel, name, action, category.toLowerCase());
    }
});

function changeFilterhandel(id, label, category) {
    const $tagcontainer = $('.tag-container');
    $tagcontainer.empty().hide();

    getAssistantFilterValues({
        id: localStorage.getItem('session_id'),
        prompt_id: id,
        category: category,
        dropdown: 'top-bar-filter'
    });
}

function getAssistantFilterValues(payload) {
   freezeActions();
   const token = getAiToken();
    $.ajax({
        url: "https://ai.mygoddiva.com/get-assistant-filter-values",
        type: "POST",
        contentType: "application/json",
        headers: token ? { "Authorization": "Bearer " + token } : {},
        data: JSON.stringify(payload || {}),
        success: function (response) {
            console.log("Filter Values Response:", response);

            // Always update prompt buttons
            handleAssistantFilterResponse(response, payload);

            // Build dropdown if data exists
            const categoryKey = payload.category.toLowerCase().replace(/\s+/g, '_');
            if (response[categoryKey] && response[categoryKey].length > 0) {
                addDropdownToggleToFilter(payload.category, payload.prompt_id);
                createFilterDropdown(
                    response[categoryKey], 
                    payload.category, 
                    payload.prompt_id
                );
            }
             releaseActions();
        },
        error: function (xhr, status, error) {
           releaseActions();
          $('.api-error').text('An error occurred. Please try again.').show();
           $('#gooeyEffect').hide();
          $('#type_looader').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
            console.error("Error fetching filter values:", status, error);
            console.log("Response:", xhr.responseText);
        }
    });
}


function addDropdownToggleToFilter(category, promptId) {
    const $button = $(`button.change-filter[data-category="${category}"]`);
    const $deleteBtn = $(`button.delete-filter[data-category="${category}"]`);

    if (!$button.length || !$deleteBtn.length) return;

    $button.siblings('.chat-dropdown-toggle').remove();

    const $toggle = $(`
        <span class="chat-dropdown-toggle">
            <svg class="drop-icon-svg" viewBox="0 0 24 24" fill="currentColor">
                <path d="M7 10l5 5 5-5z"></path>
            </svg>
        </span>
    `);

    $toggle.off('click').on('click', function (e) {
        e.stopPropagation();
        toggleFilterDropdown(category, promptId);
    });

    $button.find('.filter-category, .filter-value, .chat-dropdown-toggle')
        .off('click')
        .on('click', function (e) {
            e.stopPropagation();
            toggleFilterDropdown(category, promptId);
        });
}

function toggleFilterDropdown(category, promptId) {
    const $dropdown = $('#global-chat-dropdown');
    const $wrapper = $(`button.change-filter[data-category="${category}"]`)
        .closest('.change-filter-btn-wrapper');

    $('.change-filter-btn-wrapper').removeClass('active');

    if ($dropdown.is(':visible') && $dropdown.data('category') === category) {
        $dropdown.hide().removeData('category');
        $wrapper.removeClass('active');
        return false;
    }

    $dropdown.hide().removeData('category');

    $wrapper.addClass('active');
    $dropdown.data('category', category);

    getAssistantFilterValues({
        id: localStorage.getItem('session_id'),
        prompt_id: promptId,
        category: category
    });
}


// Outside click close
$(document).on('click', function (event) {
    const $dropdown = $('#global-chat-dropdown');
    if (
        $dropdown.is(':visible') &&
        !$(event.target).closest('#global-chat-dropdown').length &&
        !$(event.target).closest('.change-filter-btn-wrapper').length
    ) {
        const activeCategory = $dropdown.data('category');
        if (activeCategory) {
            $(`button.change-filter[data-category="${activeCategory}"]`)
                .closest('.change-filter-btn-wrapper')
                .removeClass('active');
        }
        $dropdown.hide().removeData('category');
    }
});


function createFilterDropdown(categoryData, category, promptId) {
    const $dropdown = $('#global-chat-dropdown');
    $dropdown.empty();

    if (!Array.isArray(categoryData) || categoryData.length === 0) {
        $dropdown.hide();
        return;
    }
categoryData.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
    categoryData.forEach(item => {
        const $li = $('<li/>', {
            text: item.name,
            'data-id': item.id,
            'data-value': item.name,
            'data-category': category,
            'data-name': 'product_suggestion_request',
            'data-action': 'update'
        });
        $dropdown.append($li);
    });

    $dropdown.data('category', category);
    positionDropdownNearFilterButton(category);
    $dropdown.show();
    
    
}


function positionDropdownNearFilterButton(category) {
    const $dropdown = $('#global-chat-dropdown');
    const $wrapper = $(`button.change-filter[data-category="${category}"]`)
        .closest('.change-filter-btn-wrapper');

    if ($wrapper.length) {
        const wrapperWidth = $wrapper[0].getBoundingClientRect().width;
        $wrapper.css('position', 'relative');
        $wrapper.append($dropdown);
        $dropdown.css({
            position: 'absolute',
            top: '100%',
            left: '0',
            minWidth: Math.max(wrapperWidth, 200) + 'px',
            zIndex: 99
        });
    }
}


// Handle dropdown click (update filter)
$(document).on('click', '#global-chat-dropdown li', function () {
    const $li = $(this);
    const value = $li.text();
    const id = $li.data('id');
    const category = $('#global-chat-dropdown').data('category');
    if (!category || !value) return;

    const $wrapper = $(`button.change-filter[data-category="${category}"]`).closest('.change-filter-btn-wrapper');
    const $changeButton = $wrapper.find('.change-filter');
    const $deleteButton = $wrapper.find('.delete-filter');

    const name = $li.data('name');
    const action = $li.data('action');
    const label = category ? category.toLowerCase() : null;

    $changeButton.find('.filter-value').text(value);
    $changeButton.data('value', value).attr('data-value', value);
    $changeButton.data('id', id).attr('data-id', id);

    $deleteButton.data('value', value).attr('data-value', value);
    $deleteButton.data('id', id).attr('data-id', id);

    $('#global-chat-dropdown').hide().removeData('category');
    $wrapper.removeClass('active');
   
    $('#type_looader').show();
    //const message = `Only ${value}`;
     const message = `${value}`;
      let userInitials = getUserInitials();
    $("#chat_message").append('<div class="user-message">' +
                        '<div class="user-logo">' + userInitials + '</div>' +
                        '<div class="user-text">' + message + '</div>' +
                      '</div>');

    chatQuery(message, name, action, label);
});



  function initalDrag(element){

      element.dragScroll({
      threshold: 100,
      onLazyLoad: function () {
         const message_id=$(element).data('id')
         const page=Number($(element).data('page'))+1;
        const is_has_more_page=$(element).data('has');
         if (!is_has_more_page) return Promise.resolve();
         const token = getAiToken();

    
        return $.ajax({
          url: 'https://ai.mygoddiva.com/get-product?page=' + page+'&id='+localStorage.getItem('session_id')+'&message_id='+message_id,
          headers: token ? { "Authorization": "Bearer " + token } : {},
          method: 'GET'
        }).done(function(response) {
          // Append HTML
          element.append(productHandel(response.products,message_id,0));
          $(element).data('page',page);
          $(element).data('has',response.products.has_next)
          element.dragScroll(); // Re-init for new elements
        
  
        });
      }
    });
    
  }



function initLazyLoad($container, message_id, initialProducts = null) {
  let page = initialProducts ? 2 : 1;
  let isLoading = false;
  const INITIAL_LOAD = 5;
  const LOAD_MORE_COUNT = 10;

  let hasTriggeredAllViewed = false;

  // -----------------------------
  // INITIAL PRODUCT SETUP
  // -----------------------------
  let allInitialProducts = [];
  if (initialProducts?.items?.length) {
    allInitialProducts = [...initialProducts.items];
  }

  let initialItemsToShow = allInitialProducts.slice(0, INITIAL_LOAD);
  let shownCount = initialItemsToShow.length;

  let total = initialProducts
    ? Number(initialProducts.total)
    : Number($container.data("total")) || Infinity;

  const $wrapper = $container.find(".chat-product-item-wrapper");

  if (initialItemsToShow.length) {
    $wrapper.append(productHandel({ items: initialItemsToShow }, message_id, 0));
  }

  // -----------------------------
  // LOADER
  // -----------------------------
  if (!$container.find(".chat-lazy-loader").length) {
    $container.append(`
      <div class="chat-lazy-loader" style="display:none;">
        <div class="chat-productspinner"></div>
      </div>
    `);
  }

  const $loader = $container.find(".chat-lazy-loader");

  function showLoader() { 
    $loader.show(); 
  }

  function hideLoader() { 
    $loader.hide(); 
  }

  // -----------------------------
  // LOAD MORE BUTTON
  // -----------------------------
  if (!$container.find(".chat-load-more").length) {
    $loader.before(`<button class="chat-load-more">Load More</button>`);
  }

  const $loadMoreBtn = $container.find(".chat-load-more");

  function updateButtonText() {
    const remaining = total - shownCount;

    if (total <= INITIAL_LOAD) {
      $loadMoreBtn.hide();
      return;
    }

    if (shownCount >= total) {
      $loadMoreBtn.text("Show Less Curated Styles");
      return;
    }

    $loadMoreBtn.text(
      `Show ${remaining} More Curated Style${remaining > 1 ? "s" : ""}`
    );
  }

  function updateLoadMoreVisibility() {
    if (total <= INITIAL_LOAD) {
      $loadMoreBtn.hide();
      return;
    }

    $loadMoreBtn.show();
    updateButtonText();
  }

  // -----------------------------
  // FINAL LOAD DETECTION
  // -----------------------------
  function checkIfAllViewed() {

    const isCurrentlyLast = $container.is($('.drag-scroll').last());

    if (
      isCurrentlyLast &&
      !hasTriggeredAllViewed &&
      typeof total === "number" &&
      total > 0 &&
      shownCount >= total
    ) {
      hasTriggeredAllViewed = true;
      handleAllProductsViewed();
    }
  }

  // -----------------------------
  // FETCH PRODUCTS
  // -----------------------------
  function appendNext(itemsNeeded) {

    if (isLoading) {
      return;
    }

    if (shownCount >= total) {
      return;
    }

    isLoading = true;
    showLoader();
    $loadMoreBtn.prop("disabled", true);

    // -------------------------
    // SHOW REMAINING INITIAL PRODUCTS
    // -------------------------
    if (allInitialProducts.length > 0 && shownCount < allInitialProducts.length) {

      const remainingInitial = allInitialProducts.length - shownCount;
      const toShow = Math.min(itemsNeeded, remainingInitial);

      const items = allInitialProducts.slice(
        shownCount,
        shownCount + toShow
      );


      if (items.length) {
        $wrapper.append(productHandel({ items }, message_id, 0));
        shownCount += items.length;
      }


      isLoading = false;
      hideLoader();
      $loadMoreBtn.prop("disabled", false);
      updateLoadMoreVisibility();

      checkIfAllViewed();
      return;
    }

    // -------------------------
    // FETCH FROM API
    // -------------------------
    const token = getAiToken();

    $.ajax({
      url:
        "https://ai.mygoddiva.com/get-product?page=" +
        page +
        "&id=" +
        localStorage.getItem("session_id") +
        "&message_id=" +
        message_id,
      headers: token ? { Authorization: "Bearer " + token } : {},
      method: "GET",
    })
      .done(function (response) {

        const items = response?.products?.items || [];

        if (typeof response?.products?.total === "number") {
          total = response.products.total;
        }

        if (items.length) {
          $wrapper.append(productHandel({ items }, message_id, 0));
          shownCount += items.length;
          page++;
        }

        isLoading = false;
        hideLoader();
        $loadMoreBtn.prop("disabled", false);
        updateLoadMoreVisibility();

        checkIfAllViewed();
      })
      .fail(function () {
        isLoading = false;
        hideLoader();
        $loadMoreBtn.prop("disabled", false);
        updateLoadMoreVisibility();
      });
  }

  // -----------------------------
  // RESET
  // -----------------------------
  function resetToInitial() {
    hasTriggeredAllViewed = false;

    $wrapper.empty();

    shownCount = Math.min(INITIAL_LOAD, allInitialProducts.length);
    page = initialProducts ? 2 : 1;

    if (allInitialProducts.length) {
      const items = allInitialProducts.slice(0, INITIAL_LOAD);
      $wrapper.append(productHandel({ items }, message_id, 0));
    } else {
      appendNext(INITIAL_LOAD);
    }

    updateLoadMoreVisibility();
  }

  // -----------------------------
  // BUTTON CLICK
  // -----------------------------
  $loadMoreBtn.on("click", function () {
    if (shownCount >= total) {
      resetToInitial();
    } else {
      const remaining = total - shownCount;
      const toLoad = Math.min(LOAD_MORE_COUNT, remaining);
      appendNext(toLoad);
    }
  });

  updateLoadMoreVisibility();
}


function handleAllProductsViewed() {

  const token = getAiToken();

  $.ajax({
    url: "https://ai.mygoddiva.com/get-reset-prompts",
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: "Bearer " + token } : {})
    },
    data: JSON.stringify({
      assistant_id: localStorage.getItem('session_id'),
      collection: window.collectionHandle || null
    })
  })
  .done(function (response) {

    if (!response?.prompts?.length) return;
    if (!response || !Array.isArray(response.prompts) || response.prompts.length === 0) {
      return;
    }

    $("#prompt_suggestion .suggested-make-it-yours-wrapper").remove();
    $("#prompt_suggestion .refilter-section").remove();
    $("#prompt_suggestion").addClass('get-reset-prompts');

    promptHandel(response.prompts);

  })
  .fail(function () {
    console.log("Failed to fetch reset prompts");
  });
}



function chatQuery(message, name = null, action = null, label = null, promptId = null) {
  freezeActions();

  

  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;

  const payload = {
    query: message,
    assistant_id: localStorage.getItem('session_id'),
    is_history: isHistory
  };

  // Include type/action only if available
  if (name && action) {
    payload.type = { name, action };

    if (label) payload.type.label = label;
    if (promptId) payload.type.prompt_id = promptId;
  }

  console.log("📤 Sending payload:", payload);
  const token = getAiToken();

  $.ajax({
    url: 'https://ai.mygoddiva.com/user-query',
    type: 'POST',
    contentType: 'application/json',
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: JSON.stringify(payload),
    success: function (response) {
      const prompt_id = response.prompt_id ? response.prompt_id : null;
      //showRetryButtonInMessage(message, chatQuery, [message, name, action, label, promptId]);

      response._originalQuery = message;

      chatReponse(response, null, null, prompt_id);

    // for return portal implemenations
      document.querySelectorAll('.ai-page-panel-stale').forEach(el => {
        el.classList.remove('ai-page-panel-stale');
        const loader = el.querySelector('.ai-page-panel-loader');
        if (loader) loader.remove();
      });

      releaseActions();
      $('#chat_input_text').val('');
    },
    error: function (xhr) {

      showRetryButtonInMessage(message, chatQuery, [message, name, action, label, promptId]);

      $('.api-error').text('An error occurred. Please try again.').show();
       $('#gooeyEffect').hide();
      $('#type_looader').hide();
      setTimeout(() => $('.api-error').fadeOut(), 2000);
      console.error('Error:', xhr.responseText);
      releaseActions();
    }
  });
}



$('#historyToggle').on('change', function () {
    if ($(this).prop('checked')) {
     //  $('.toggle-label').text("from this results")
      console.log('history continue from this result');
    } else {
    //   $('.toggle-label').text("new results")
     console.log('new result, no hsitory');
    }
});

//added by sai

// scroll to bottom chat content on load

// const chatContent = document.querySelector('.chat-content');

// function scrollToBottom() {
//     chatContent.scrollTop = chatContent.scrollHeight;
// }


 // suggestions from json file start

let searchQueries = []; // temporary variable to store queries

function addTag(text) {
 
  const $tagContainer = $('.tag-container');
  text = text.trim();
  if (!text) return;

  // ✅ Prevent duplicates
  if (!searchQueries.includes(text)) {
    searchQueries.push(text);
  }

  return;
  //return as yathu do not want search queries in top bar's tag container 10 oct

  // ✅ Clear previous tags
  $tagContainer.empty();

  // ✅ Show only if 3 or more search queries exist
  if (searchQueries.length >= 3) {
    searchQueries.forEach(q => {
      const $tag = $('<span class="tag search-query"></span>').text(q);
      $tagContainer.append($tag);
    });
  }
}


let selectedSuggestion = null;

function initSuggestions(inputSelector, suggestionWrapperSelector, jsonUrl, minLength = 3) {
  let allSuggestions = [];
  

  // Load JSON once
  $.getJSON(jsonUrl, function(data) {
    allSuggestions = data;
  });

  const $input = $(inputSelector);
  const $wrapper = $(suggestionWrapperSelector);
  const $tagContainer = $('.tag-container');
  const $emailField = $('.chat-email-field');
  const $orderField = $('.chat-order-id-field');

  const $registerOrderField = $('.register-chat-order-id-field');

  function matchesInput(item, value) {
    const stopwords = [
      "i","me","my","mine","you","your","yours",
      "am","is","are","was","were","be","been","being",
      "do","does","did","done",
      "have","has","had","having",
      "will","would","shall","should","can","could","may","might","must",
      "a","an","the",
      "for","to","in","on","at","with","of","by","about",
      "and","or","but","if","than","then",
      "this","that","these","those",
      "here","there",
      "looking","searching","want","need","find","show","give","get",
      "yahoo","gmail","hotmail","outlook","aol","icloud","protonmail",
      "com","co","uk","net","org","gov","edu","info","biz",
      "@"
    ];
    const tokens = value.toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);

    // Remove stopwords
    const meaningfulTokens = tokens.filter(t => !stopwords.includes(t));

    if (meaningfulTokens.length === 0) return false;

    const text = item.text.toLowerCase();
    const keywords = (item.keywords || []).map(k => k.toLowerCase());
    const words = text.split(/[^a-z0-9]+/).filter(Boolean);

    // Match only on meaningful tokens
    return meaningfulTokens.every(token =>
      words.some(w => w === token || w.startsWith(token)) ||
      keywords.some(k => k === token || k.startsWith(token))
    );
  }


  // Input event
  $input.on('input', function () {

    const value = $.trim($(this).val()).toLowerCase();

    const stopwords = [
      "i","me","my","mine","you","your","yours",
      "am","is","are","was","were","be","been","being",
      "do","does","did","done",
      "have","has","had","having",
      "will","would","shall","should","can","could","may","might","must",
      "a","an","the",
      "for","to","in","on","at","with","of","by","about",
      "and","or","but","if","than","then",
      "this","that","these","those",
      "here","there",
      "looking","searching","want","need","find","show","give","get",
      "yahoo","gmail","hotmail","outlook","aol","icloud","protonmail",
      "com","co","uk","net","org","gov","edu","info","biz",
      "@"
    ];
    const tokens = value.split(/[^a-z0-9]+/).filter(Boolean);
    const meaningfulTokens = tokens.filter(t => !stopwords.includes(t));

    const synonyms = {
      "rad": "red",
      "retorn": "return",
      "retrn": "return",
      "reurn": "return",
      "adress": "address",
      "ordr": "order"
    };

   //  Correct common typos
    const correctedTokens = meaningfulTokens.map(t => synonyms[t] || t);

    //  Only continue if at least one corrected token meets minLength
    if (!correctedTokens.some(t => t.length >= minLength) || value.includes('@') || /\b\w+\.(com|co|uk|net|org|gov|edu|info|biz)\b/.test(value)) {
      $wrapper.empty();
      $('.subcategory-wrapper').empty();
      return;
    }

    //  Build corrected search string
    const correctedValue = correctedTokens.join(" ");

    

   // Exact matches
    let exactMatches = allSuggestions.filter(item =>
      item.text.toLowerCase() === correctedValue ||
      (item.keywords || []).map(k => k.toLowerCase()).includes(correctedValue)
    );
  


    //Partial matches (start of word or keyword)
    let startsWithMatches = allSuggestions.filter(item =>
      matchesInput(item, correctedValue) &&
      item.text.toLowerCase() !== correctedValue
    );
  


    // Remove duplicates (in case of overlap)
    const seen = new Set(exactMatches.map(i => i.id));
    startsWithMatches = startsWithMatches.filter(i => !seen.has(i.id));

    // Sort each group by priority
    exactMatches.sort((a, b) => a.priority - b.priority);
    startsWithMatches.sort((a, b) => a.priority - b.priority);

    // Combine all results
    let results = [...exactMatches, ...startsWithMatches];

    // First try only priority 1 & 2
    let filtered = results.filter(item => item.priority === 1 || item.priority === 2);

    // If none found, fallback to priority 3
    if (filtered.length === 0) {
      filtered = results.filter(item => item.priority === 3);
    }

    results = filtered;

    // 🔹 Filter out suggestions if input exactly matches their ignore_words
      results = results.filter(item => {
        if (!item.ignore_words || !Array.isArray(item.ignore_words)) return true;

        // check if the WHOLE correctedValue equals an ignore_word
        return !item.ignore_words.some(ig =>
          correctedValue === ig.toLowerCase()
        );
      });


    // Group by source and priority
    const groupedResults = {};
    results.forEach(item => {
      const key = `${item.source}-${item.priority}`;
      if (!groupedResults[key]) {
        groupedResults[key] = {
          source: item.source,
          priority: item.priority,
          items: []
        };
      }
      groupedResults[key].items.push(item);
    });

    // Sort groups by priority
    const sortedGroups = Object.values(groupedResults).sort((a, b) => a.priority - b.priority);

    // Build HTML
    let groupedHtml = '';
    sortedGroups.forEach(group => {
      // groupedHtml += `<li class="suggestion-header">${group.source} (Priority ${group.priority})</li>`;
      group.items.forEach(item => {
        const isExactMatch = item.text.toLowerCase() === correctedValue;
        const highlightClass = isExactMatch ? 'exact-match' : '';
          groupedHtml += `<li class="suggestion-item ${highlightClass}" data-id="${item.id}">${item.text}</li>`;

      });
    });

    $wrapper.html(groupedHtml);

    $('.subcategory-wrapper').empty();

    // scrollToBottom();
  });

  // click handler
  $wrapper.on('click', '.suggestion-item', function () {
    const text = $(this).text();
    const id = $(this).data('id');
    const matches = allSuggestions.filter(s => String(s.id) === id && s.text === text);
    selectedSuggestion = matches.length ? matches[0] : null;

    $input.val(text).focus();
    $('.suggestion-wrapper').empty();
    $('.subcategory-wrapper').empty();
    $('.register-chat-suggestions').empty();

    if (selectedSuggestion?.subcategory && selectedSuggestion.subcategory.length > 0) {
        // Show subcategories only when array exists and not empty
        selectedSuggestion.subcategory.forEach(sub => {
          $('.subcategory-wrapper').append(
            `<li class="subcategory-item" data-parent="${id}">${sub}</li>`
          );
        });
      } else {
        // No subcategories
        if (selectedSuggestion?.required_fields) {
          if (selectedSuggestion.required_fields.includes('order_number')) {
            $orderField.show().prop('required', true);
            $registerOrderField.show().prop('required', true);
          }
        }
      }

  });

  $('.subcategory-wrapper').on('click', '.subcategory-item', function () {
    const text = $(this).text();
    $input.val(text).focus(); 
    $('.suggestion-wrapper').empty();
    $('.subcategory-wrapper').empty();
    $('.register-chat-suggestions').empty();
    
  });

  $input.on('keydown', function(e) {
    if (e.key === 'Enter') {
      e.preventDefault();
      const value = $.trim($(this).val());
      if (value) {
        addTag(`Search Query : ${value}`);
        $(this).val('');
        $wrapper.empty();
      }
    }
  });



}


initSuggestions(
  '#chat_input_text', 
  '.suggestion-wrapper', 
  'https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-suugestion-ignore_new_1_1_1.json?v=1760464442',
  3
);





// suggestions ends here



 let submitCount = 0;

function initForm(){
  const $form = $('#chat_form');
  const $tagContainer = $('.tag-container');
  const $emailField = $('#chat-email-field');
  const $orderField = $('#chat-order-id-field');
  const $hiddenEmail = $('#hidden-chat-email');
  const $hiddenOrder = $('#hidden-chat-order-id');
  const $chatInput = $('#chat_input_text');
  const toggle1 = $('.history-toggle-1');
  const toggle2 = $('.history-toggle-2');
  const startBtn = $('#startBtn');
  const resetBtn = $('#resetBtn');
  const continueBtn = $('#continueBtn');

  
 

  if (!sessionStorage.getItem('is_history')) {
    sessionStorage.setItem('is_history', 'true');
  }

  toggle1.hide();
  toggle2.hide();

  // Prevent native validation
  $form.attr('novalidate', 'true');

  $form.off('submit').on('submit', function(e) {
    e.preventDefault();
   
    submitCount++;
     console.log('submitCount',submitCount);
      handleFormSubmit();
  });

  $chatInput.off('keydown').on('keydown', function(e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      
      submitCount++;
       console.log('submitCount',submitCount);
       handleFormSubmit();
    }
  });

 

  // Remove error when typing in order field
  $orderField.on('input', function() {
    if ($(this).hasClass('field-error')) {
      $(this).removeClass('field-error');
      hideFieldError($(this));
      // Restore placeholder if it was removed
      if (!$(this).attr('placeholder')) {
        $(this).attr('placeholder', 'Enter your order number');
      }
    }
  });

  // Remove error when typing in chat input
  $chatInput.on('input', function() {
    if ($(this).hasClass('field-error')) {
      $(this).removeClass('field-error');
      hideFieldError($(this));
    }
  });

  // Hide order field when new text is typed (new suggestion)

$(document).on('input', '#chat_input_text', function() {
  const currentText = $(this).val().trim();
  
  if (currentText.length > 0) {
    $(".history-toggle-1").show();
    $(".history-toggle-2").hide();
  } else {
    $(".history-toggle-1").hide();
    $(".history-toggle-2").hide();
  }
});


  $chatInput.on('input', function() {
    
    const currentText = $(this).val().trim();

    const gooeyEffect = document.getElementById('gooeyEffect');

  
    

    if (!currentText || currentText.length <= 0) {
        resetOrderField();
        selectedSuggestion = null;
    }
    
    if (!currentText || currentText.length <= 0) {
       gooeyEffect.classList.remove('gooey-active');
       
     }else{
      gooeyEffect.classList.add('gooey-active');
     }

     if (!currentText || currentText.length <= 0) {
        // $('.tag-change-notice').hide();
        // $(".history-toggle-1").hide();
        // $(".history-toggle-2").hide();
     }

     if (!currentText || currentText.length <= 0) {
      // toggle1.hide();
      // toggle2.hide();
      // return;
    }
    

    if (submitCount === 0) {
      // toggle1.hide();
      // toggle2.hide();
      // return;
    }
    if (submitCount === 1) {
     // toggle1.hide();
      // $('.toggle-1-text').hide();
      // $('.tag-0-text').hide();
      // toggle2.hide();
      // return;
    }
    if (submitCount === 5) {
      // toggle1.hide();
      // toggle2.hide();
      // return;
    }
 
   // const isHistory = sessionStorage.getItem('is_history') === 'true';

    // if (isHistory) {
    //   // Show Toggle 1 if history is true
    //   toggle1.show();
    //   toggle2.hide();
    // } else {
    //   // Show Toggle 2 if history is false
    //   toggle1.hide();
    //   toggle2.show();
    // }
     
  });

  startBtn.on('click', function (e) {
    e.preventDefault();
    sessionStorage.setItem('is_history', 'false'); // user clicked → history false
    toggle1.hide();
    toggle2.show();
  });

  // // Reset button
  resetBtn.on('click', function (e) {
    e.preventDefault();
   // sessionStorage.setItem('is_history', 'false'); // reset → history false
    toggle2.hide();
    toggle1.hide();
  });

  // Continue button
  continueBtn.on('click', function (e) {
    e.preventDefault();
    sessionStorage.setItem('is_history', 'true'); // continue → history true
    toggle2.hide();
    toggle1.hide();
  });

let exitIntentBound = false; 
  function handleFormSubmit() {
    const message = $chatInput.val().trim();
    if (!message) {
      // Show error for empty chat input
      $chatInput.addClass('field-error').focus();
      //showFieldError($chatInput, 'Please enter your question');
      return;
    }

    // Validate required fields if they are visible
    if ($orderField.is(':visible') && selectedSuggestion?.required_fields?.includes('order_number')) {
      const orderValue = $orderField.val().trim();
      if (!orderValue) {
        // Add validation styling and focus on the order field
        $orderField.addClass('field-error').focus();
        // Show error message and remove placeholder
        showFieldError($orderField, 'Order number is required');
        $orderField.attr('placeholder', '');
        return;
      }
    }

    const email = localStorage.getItem('user_email') || '';
    const order = $hiddenOrder.length ? $hiddenOrder.val().trim() : ($orderField.is(':visible') ? $orderField.val().trim() : '');

    let combinedMessage = message;

    if (selectedSuggestion?.required_fields?.includes('order_number') && order) {
      combinedMessage += ` Order number is ${order}`;
      combinedMessage += ` and email address is ${email}`;
      //addTag(`Order ID : ${order}`);
    }
    // if (selectedSuggestion?.required_fields?.includes('email') && email) {
    //   combinedMessage += ` and email address is ${email}`;
    //   addTag(`Email : ${email}`);
    // }

    addTag(`Search Query : ${combinedMessage}`);

    // Reset order field
    resetOrderField();

    $('#type_looader').show();
    $('#change_Filter_suggestion').hide();

    if (shopifyPage != "page.assistant"){
      scrollToElementInDrawer('#type_looader');
    }
 let userInitials = getUserInitials();
   $('#chat_message').append('<div class="user-message">' +
                        '<div class="user-logo">' + userInitials + '</div>' +
                        '<div class="user-text">' + combinedMessage + '</div>' +
                      '</div>');

    $('#prompt_suggestion').hide();
    $('.chat-alternative-section').remove();
    $('.filter-panel').hide();
    $chatInput.val("");
    $('.suggestion-wrapper').html("");
    $('.subcategory-wrapper').empty();
    $('.history-toggle-1').hide();
    $('.history-toggle-2').hide();
    $('.tag-change-notice').hide();

    chatQuery(combinedMessage);


        if (submitCount === 1 && !exitIntentBound) {
          exitIntentBound = true;
          $(document).one("mouseleave", function (e) {
            if (e.clientY <= 0) { 
              console.log("🚨 Exit intent triggered");
              showDiscountIfEligible("exit intent");
            }
          });
        }

     if (submitCount === 1) {

        // Get swipeData from sessionStorage
          let swipeData = sessionStorage.getItem('swipeData');

          if (swipeData) {
              // Parse the stored JSON
              swipeData = JSON.parse(swipeData);
          }

          // Check if swipeData is missing or both likes & dislikes are empty
          if (
              !swipeData || 
              (Object.keys(swipeData.likes).length === 0 && Object.keys(swipeData.dislikes).length === 0)
          ) {
              if ($('.chat_show_swipecards_container').length === 0) {
                // yathu asked to remove 3 oct
                 // showSwipeCardsInChat();
              }
          }


    }



  }

  function resetOrderField() {
    $orderField.hide().prop('required', false).val('').removeClass('field-error');
    $orderField.attr('placeholder', 'Enter your order number');
    hideFieldError($orderField);
  }


  // Helper functions for field validation
  function showFieldError($field, message) {
    hideFieldError($field);
    $field.after(`<div class="field-error-message">${message}</div>`);
  }

  function hideFieldError($field) {
    $field.siblings('.field-error-message').remove();
  }
}

initForm();

function chatVoiceAssistant() {
  const micBtn = document.getElementById('mic_btn');
  const chatInput = document.getElementById('chat_input_text');
  
  //chatInput.focus();
  
  const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
  let recognition = null;
  
  if (SpeechRecognition) {
      recognition = new SpeechRecognition();
      recognition.continuous = false;
      recognition.interimResults = false;
      recognition.lang = 'en-US';
      
      recognition.onresult = function(event) {
          const transcript = event.results[0][0].transcript;
          chatInput.value = transcript;
          chatInput.focus();
          
          const inputEvent = new Event('input', {
              bubbles: true,
              cancelable: true,
          });
          chatInput.dispatchEvent(inputEvent);
      };
      
      recognition.onerror = function(event) {
          console.error('Speech recognition error', event.error);
          micBtn.classList.remove('pulse');
          // Focus back on input after error
          chatInput.focus();
      };
      
      recognition.onend = function() {
          micBtn.classList.remove('pulse');
          chatInput.placeholder = 'Ask me anything about fashion, styling, or products…';
          // Focus back on input after recognition ends
          chatInput.focus();
      };
  } else {
      micBtn.style.opacity = '0.5';
      micBtn.title = 'Speech recognition not supported in this browser';
  }
  
  // Toggle speech recognition
  micBtn.addEventListener('click', function() {
      if (!recognition) return;
      
      if (!micBtn.classList.contains('pulse')) {
          // Start recognition
          try {
              recognition.start();
              micBtn.classList.add('pulse');
              chatInput.placeholder = 'Listening...';
              chatInput.focus();
          } catch (error) {
              console.error('Recognition start failed:', error);
          }
      } else {
          // Stop recognition
          recognition.stop();
          micBtn.classList.remove('pulse');
          chatInput.placeholder = 'Ask me anything about fashion, styling, or products…';
          chatInput.focus();
      }
});

  initForm();

}



chatVoiceAssistant();

function handleReset() {
  const userId = localStorage.getItem('user_id');
  const refresh_token = localStorage.getItem("ai_refresh_token");
  const token = getAiToken();
  if (!userId) {
    console.error('No user_id found in localStorage');
    return;
  }
  $('.chat-reset-overlay').show();
  $.ajax({
    url: 'https://ai.mygoddiva.com/reset',
    type: 'POST',
    contentType: 'application/json',
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: JSON.stringify({
      id: userId, 
      refresh_token: refresh_token 
    }),
    success: function (response) {
      if (response.session_id) {
        // update session_id
        localStorage.setItem('session_id', response.session_id);
        // update history session
        sessionStorage.setItem('is_history', 'true');
        
        if (response.token) {
            localStorage.setItem("ai_access_token", response.token.access);
            localStorage.setItem("ai_refresh_token", response.token.refresh);
        }


        // clear UI chat history
        $('#chat_message').empty();
        $('.tag-container').empty();
        $('.suggestion-wrapper').empty();
        $('.subcategory-wrapper').empty();
        $('.register-chat-suggestions').empty();
        $('#prompt_suggestion').empty();
        $('.chat-alternative-section').remove();
        $('#change_Filter_suggestion').empty();
        $('#type_looader').hide();
        $('.looking-for, #top-bar').hide();
        $('#chat_input_text').val('').focus().trigger('input');
        $('.history-toggle-1, .history-toggle-2').hide();
        $('.show_discount-container').remove();
        $('.message-update-size').remove();
        $(".message-update-user-name-email").remove();
       
        $('.bot-message.size-reminder').remove();
        
        
        submitCount = 0;
        console.log("submitCount reset to", submitCount);

        if (response.prompts && response.prompts.length > 0) {
          // Create wrapper structure
          $('#prompt_suggestion').html(`
            <div class="reset-promt-suggestion-wrapper">
              <strong class="suggested-heading" style="display: none;">Suggested Searches:</strong>
              <div class="prompt-btn-wrapper reset-promt-suggestion"></div>
            </div>
          `);

          const $wrapper = $('#prompt_suggestion .prompt-btn-wrapper');

          // Append buttons
          // response.prompts.forEach(prompt => {
          //   const btn = $(`
          //     <button class="prompt-btn whitebg-greenborder" data-id="${prompt.id}">
          //       ${prompt.message}
          //     </button>
          //   `);
          //   $wrapper.append(btn);
          // });

          response.prompts.forEach(prompt => {
              // Extract type info
              const type = prompt.type || {};
              const isObj = typeof type === "object";
              const typeName = isObj ? (type.name || '') : type;
              const isReset = isObj && 'is_reset' in type ? type.is_reset : null;
              const action = isObj && 'action' in type ? type.action : null;
              const condition = isObj && 'condition' in type ? type.condition : null;

              // Build data attributes string
              let dataAttrs = `data-id="${prompt.id || ''}" data-message="${(prompt.message || '').replace(/"/g, '&quot;')}"`;

              if (isObj) {
                  if (typeName) dataAttrs += ` data-type="${typeName}"`;
                  if (isReset !== null) dataAttrs += ` data-is-reset="${isReset}"`;
                  if (action !== null) dataAttrs += ` data-action="${action}"`;
                  if (condition !== null) dataAttrs += ` data-condition="${condition}"`;
              } else if (type) {
                  dataAttrs += ` data-filter="${type}"`;
              }

              // Determine if filter type (for chevron)
              const isFilter = (type === "filter") || (typeName === "filter");

              // Create message-based class
              const messageClass = prompt.message.toLowerCase().replace(/\s+/g, '-');

              // Build button HTML
              let buttonHtml = `<button class="prompt-btn whitebg-greenborder get-session-btn ${messageClass}" ${dataAttrs}>`;
              buttonHtml += prompt.message; // text content
              if (isFilter) {
                  buttonHtml += `<span class="data-filter-chev">${aiPageGetChevronSVG()}</span>`;
              }
              buttonHtml += `</button>`;

              // Append button
              $wrapper.append(buttonHtml);
          });

          // Show heading only if buttons exist
          if ($wrapper.find('.prompt-btn').length > 0) {
            $('#prompt_suggestion .suggested-heading').show();
          }

          displayChatSuggestions();
        }

        $('.chat-reset-overlay').hide();

        console.log('Reset successful, response:', response);
      } else {
        console.error('No session_id returned from reset API');
      }
    },
    error: function (xhr) {
      $('.api-error').text('An error occurred. Please try again.').show();
       $('#gooeyEffect').hide();
      $('#type_looader').hide();
      setTimeout(function() {
        $('.api-error').fadeOut();
      }, 2000);
      $('.chat-reset-overlay').hide();
      console.error('Reset API error:', xhr.responseText);
    }
  });

}

// attach both buttons to same handler
$('#resetBtn, #reset-btn-top').on('click', handleReset);

// $("#reset-btn-top-link").on("click", function () {
//   const topBarHeight = $("#top-bar").outerHeight(true); // include margins
//   const targetOffset = $(".chat-input-box").offset().top - topBarHeight - 43; // extra 43px

//   $("html, body").animate(
//     { scrollTop: targetOffset },
//     600
//   );

//   $(".tag-change-notice").hide();
//   $(".history-toggle-1").fadeOut();
//   $(".history-toggle-2").fadeIn();
// });

$("#reset-btn-top-link").on("click", function () {
  const $topBar = $("#top-bar");
  const $chatHeader = $(".chat-header");

  // Base offset always includes chat header
  let topOffset = $chatHeader.outerHeight(true) + 9;

  // If top-bar is visible, add its height too
  if ($topBar.is(":visible")) {
    topOffset += $topBar.outerHeight(true);
  }

  // Calculate target scroll position
  const targetOffset = $(".chat-input-box").offset().top - topOffset - 43;

  // Smooth scroll
  $("html, body").animate({ scrollTop: targetOffset }, 600);

  // UI adjustments
  $(".tag-change-notice").hide();
  $(".history-toggle-1").fadeOut();
  $(".history-toggle-2").fadeIn();
});




$("#resetBtn").on("click", function () {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  $(".tag-change-notice").hide();
  $(".history-toggle-1").hide();
  $(".history-toggle-2").hide();
});



// Close sidebar
$(document).on("click", ".chat-sidebar-close, .chat-sidebar-overlay", function() {
    $(".chat-sidebar-details").removeClass("active");
    $("body").removeClass("chat-sidebar-details-active");
    $(".chat-sidebar-overlay").fadeOut();
});


// size chart 

$(document).on('click', '.chat-sidebar-size-guide', function() {
 
  const vendor = $(this).attr('data-sidebar-chat-vendor');
  const producttitle = $(this).attr('data-sidebar-chat-title');
    var url = '';

    if (vendor === 'Goddiva') {
        url = 'https://goddiva.co.uk/pages/size-chart-goddiva';
    } else if (vendor === 'Goddiva Plus') {
        url = 'https://goddiva.co.uk/pages/size-chart-goddiva-plus';
    } else {
      return;
    }
    if (url) {
        $.get(url, function(response) {
            var $table = $(response).find('.size-chart-table').first();

            if ($table.length) {
                // Update title (clear + append)
                $('#size_chart__info').find('.size-chart-h2').empty().append(producttitle);

                // Clear and append new table
                var $wrapper = $('.size-chart-table-wrapper');
                $wrapper.empty().append($table);

                // Initialize toggle logic
                initSizeChartToggle();

                // Show modal
                $('#size_chart__info').addClass('show');
                $('body').addClass('modal-open');
            }
        });
    }

});

function initSizeChartToggle() {
    const cmToInch = 0.393701;

    // Store original values for each cell
    document.querySelectorAll('.size-chart-table-td').forEach(cell => {
        cell.setAttribute('data-original-value', cell.textContent.trim());
    });

    function toggleUnits() {
        const isCm = !document.getElementById('size-chart-switch').checked;

        document.querySelectorAll('.size-chart-table-tr').forEach(row => {
            row.querySelectorAll('.size-chart-table-td').forEach(cell => {
                const originalValue = parseFloat(cell.getAttribute('data-original-value'));

                if (!isNaN(originalValue)) {
                    let convertedValue = isCm
                        ? (originalValue * cmToInch).toFixed(1)
                        : originalValue;

                    if (isCm && convertedValue % 1 === 0) {
                        convertedValue = parseInt(convertedValue, 10);
                    }

                    cell.textContent = convertedValue;
                }
            });
        });
    }

    // Reset listener each time
    $('#size-chart-switch').off('change').on('change', toggleUnits);
}


// Welcome Screen Suggestions starts



function generateChatSuggestions(path) {
    let trafficInfo = sessionStorage.getItem("trafficInfo");
    let parsedTrafficInfo = trafficInfo ? JSON.parse(trafficInfo) : {};

    let suggestions = [];

    if (!path) return Promise.resolve(suggestions);

    // Collection Pages
    if (path.includes("/collections/")) {
        let slug = path.split("/collections/")[1] || "";
        slug = slug.split("/")[0];
        slug = slug.replace(/-/g, " ");
        let words = slug.split(" ").map(w => w.charAt(0).toUpperCase() + w.slice(1));

        if (words.length > 0) {
            suggestions.push(words.join(" ")); // e.g. "Evening Dresses"
        }
        return Promise.resolve(suggestions);
    }

    // Product Pages → Call API
    if (path.includes("/products/")) {
        let code = parsedTrafficInfo.traficProductCode;

        return fetch(`https://ai.mygoddiva.com/get-product-by-code?code=${code}`)
            .then(res => res.json())
            .then(data => {
               let productSuggestions = [];

                if (data) {
                    let temp = [];

                    // ✅ category
                    if (data.category) {
                        temp.push(`Show me ${data.category}`);
                    }

                    // ✅ length
                    if (data.length) {
                        temp.push(`Show me ${data.length} Dresses`);
                    }

                    // ✅ fabric(s)
                    if (Array.isArray(data.fabric) && data.fabric.length > 0) {
                        data.fabric.forEach(fabric => {
                            temp.push(`Show me ${fabric} Dresses`);
                        });
                    }

                    // ✅ Remove duplicates
                    productSuggestions = [...new Set(temp)];
                }

                return productSuggestions.length > 0 ? productSuggestions : suggestions;


            })
            .catch(err => {
                console.error("Chat suggestion API failed:", err);
                $('.api-error').text('An error occurred. Please try again.').show();
                 $('#gooeyEffect').hide();
                $('#type_looader').hide();
                setTimeout(function() {
                  $('.api-error').fadeOut();
                }, 2000);
                return suggestions;
            });
    }

    // Delivery & Returns
    if (path.includes("delivery-returns")) {
        suggestions = ['Delivery Details', 'Returns and Refunds', 'Returns Portal'];
        return Promise.resolve(suggestions);
    }

    return Promise.resolve(suggestions);
}




function displayChatSuggestions() {
  let trafficInfo = sessionStorage.getItem("trafficInfo");
  let parsedTrafficInfo = trafficInfo ? JSON.parse(trafficInfo) : {};

  generateChatSuggestions(parsedTrafficInfo.landingPath).then(suggestions => {
    // Always normalize
    if (!Array.isArray(suggestions)) suggestions = [];

    // ✅ Fallback if no suggestions
      if (!suggestions.length) {
      fallbackSuggestions = [
        "Show me Maxi Dresses for Party",
        "Show me Evening Maxi Dresses",
        "Show me Red Bridesmaid Dresses",
        "Show me Maxi dresses for Black Tie Event",
        "Show Me Maxi Dresses Under £100",
        "Show me Red Prom Dresses",
        "Show me your best Sequin Dresses",
        "Show me Affordable Cocktail Dresses",
        "Show me elegant Maxi Dresses for a Gala Evening"
      ];

      // ✅ Shuffle array
      fallbackSuggestions.sort(() => 0.5 - Math.random());

      // ✅ Take only 4 random suggestions
      suggestions = fallbackSuggestions.slice(0, 4);

      }

    // ✅ Replace product image and code
    if (parsedTrafficInfo.traficProductCode && parsedTrafficInfo.traficProductImage) {
      $(".chat-register-new-product-image-wrapper").show();

      $(".chat-register-new-product-image-container img")
        .attr("src", parsedTrafficInfo.traficProductImage)
        .attr("alt", parsedTrafficInfo.traficProductCode);

      $(".chat-register-new-product-code-number").text(parsedTrafficInfo.traficProductCode);

      function populateInput() {
        $(".chat-register-new-chat-input")
          .val('Similar: ' + parsedTrafficInfo.traficProductCode)
          .focus()
          .trigger('change');
      }

      $('.chat-register-new-product-image-container').off("click").on("click", populateInput);
      $('.chat-register-new-product-code').off("click").on("click", populateInput);
    } else {
      $(".chat-register-new-product-image-wrapper").hide();
    }

    // ✅ Render suggestions (always)
    if (suggestions.length > 0) {
      $('.chat-register-new-suggestions-wrapper').show();
      let $suggestionsGrid = $(".chat-register-new-suggestions-grid");
      $suggestionsGrid.empty();

      suggestions.forEach(text => {
        if (!text) return; // skip empty entries
        let $btn = $('<button class="chat-register-new-suggestion-button"></button>')
          .html(`<span>${text}</span>`);

        $btn.on("click", function () {
          $(".chat-register-new-chat-input").val(text).focus().trigger('input').trigger('change');
        });

        $suggestionsGrid.append($btn);
      });
    } else {
      $('.chat-register-new-suggestions-wrapper').hide();
    }

    $(".chat-register-new-divider").show();
  });
}


displayChatSuggestions();

initSuggestions(
  '.chat-register-new-chat-input', 
  '.register-chat-suggestions', 
  'https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-suugestion-ignore_new_1_1_1.json?v=1760464442',
  3
);

// Welcome Screen Suggestions Ends


// Like Dislike Starts

const cardData = [

  { category: "neck", name: "Sweet Heart Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_1.png?v=1757436876" },
  { category: "neck", name: "Asymmetric Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_2.png?v=1757494768" },
  { category: "neck", name: "Halter Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_3.png?v=1757494768" },
  { category: "neck", name: "Boat Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_4.png?v=1757494768" },
  { category: "neck", name: "Collar Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_5.png?v=1757494768" },
  { category: "neck", name: "Cowl Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_6.png?v=1757494768" },
  { category: "neck", name: "V Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_7.png?v=1757494768" },
  { category: "neck", name: "Surplice Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_8.png?v=1757494768" },
  { category: "neck", name: "Keyhole Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_9.png?v=1757494768" },
  { category: "neck", name: "High Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_10.png?v=1757494768" },
  { category: "neck", name: "Crew Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_11.png?v=1757494768" },
  { category: "neck", name: "Illusion Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_12.png?v=1757494768" },
  { category: "neck", name: "Knotted Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_13.png?v=1757494768" },
  { category: "neck", name: "Turtle Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_14.png?v=1757494768" },
  { category: "neck", name: "Off The Shoulder Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_15.png?v=1757494768" },
  { category: "neck", name: "One Shoulder Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_16.png?v=1757494768" },
  { category: "neck", name: "Open Back Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_17.png?v=1757494768" },
  { category: "neck", name: "Plunging Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_18.png?v=1757494768" },
  { category: "neck", name: "Queen Ann Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_19.png?v=1757494768" },
  { category: "neck", name: "Round Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_20.png?v=1757494768" },
  { category: "neck", name: "Scoop Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_21.png?v=1757494768" },
  { category: "neck", name: "Split Crew Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_22.png?v=1757494768" },
  { category: "neck", name: "Square Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_23.png?v=1757494768" },
  { category: "neck", name: "Strapless Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_24.png?v=1757494768" },
  { category: "neck", name: "Tie Up Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_25.png?v=1757494768" },
  { category: "neck", name: "Mock Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_26.png?v=1757494768" },
  { category: "neck", name: "Scalloped Neckline", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/chat-like-Neck_Line_27.png?v=1757494768" },
  { category: "neck", name: "Jewel Neck", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/jewel_Neck.png?v=1757499181" },

  { category: "sleeve", name: "Flounce Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flounce_Sleeve.png?v=1757500368" },
  { category: "sleeve", name: "Bell Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bell_Sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Bishop Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bishop_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Cap Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cap_sleeve.png?v=1757499911" },
  { category: "sleeve", name: "Cape Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Cold Shoulder Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cold_shoulder_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Detachable Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Detachable_sleeves.png?v=1757499915" },
  { category: "sleeve", name: "Dolman Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dolman_Sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Draped Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/DRAPED_SLEEVES.png?v=1757499913" },
  { category: "sleeve", name: "Fitted Long Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Fitted_long_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Flutter Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flutter_sleeve.png?v=1757499916" },
  { category: "sleeve", name: "Juliet Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Juliet_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Kimono Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Kimono_sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Lantern Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Lantern_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Off Shoulder Bardot Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Off_shoulder_bardot_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Peasant Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Peasant_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Puff Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Puff_sleeve.png?v=1757499915" },
  { category: "sleeve", name: "Raglan Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Raglan_Sleeve.png?v=1757499914" },
  { category: "sleeve", name: "Regular Sleeve", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Regular_sleeve.png?v=1757499913" },
  { category: "sleeve", name: "Sleeveless", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sleeveless.png?v=1757499916" },
  { category: "sleeve", name: "Spaghetti Straps", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Spaghetti_straps.png?v=1757499916" },
  { category: "sleeve", name: "Wings Sleeves", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Wings_SLEEVES.png?v=1757499914" },

  { category: "hem", name: "Asymmetric Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetric_Hem.png?v=1757501250" },
  { category: "hem", name: "Bubble Ballon Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bubble_Ballon_Hem.png?v=1757501249" },
  { category: "hem", name: "Diagonal Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Diagonal_Hem.png?v=1757501248" },
  { category: "hem", name: "Dipped Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dipped_Hem.png?v=1757501250" },
  { category: "hem", name: "Flared Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Flared_Hem.png?v=1757501250" },
  { category: "hem", name: "Fringe Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Fringe_Hem.png?v=1757501249" },
  { category: "hem", name: "High Low Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/High_Low_Hem.png?v=1757501249" },
  { category: "hem", name: "Layered Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Layered_Hem.png?v=1757501249" },
  { category: "hem", name: "Pleated Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Pleated_Hem.png?v=1757501248" },
  { category: "hem", name: "Raw Edge Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Raw_Edge_Hem.png?v=1757501249" },
  { category: "hem", name: "Ruffle Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Ruffle_Hem.png?v=1757501250" },
  { category: "hem", name: "Scalloped Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Scalloped_Hem.png?v=1757501249" },
  { category: "hem", name: "Straight Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Straight_Hem.png?v=1757501247" },
  { category: "hem", name: "Trumpet Hem", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Trumpet_Hem.png?v=1757501250" },
  { category: "hem", name: "Tulip Hemline", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tulip_Hemline.png?v=1757501250" },

  { category: "product_subcategory", name: "Mermaid Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Mermaid_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Corset Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Corset_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Shirt Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Shirt_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Kaftan Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Kaftan_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Straight Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Straight_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Sheath Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sheath_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Peplum Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Peplum_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Smock Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Smock_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Tiered Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tiered_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Shift Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Shift_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Little Black Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Little_Black_Dress.png?v=1757504481" },
  { category: "product_subcategory", name: "A-Line Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/A-Line_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Asymmetrical Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Babydoll Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Babydoll_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Bodycon dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Bodycon_dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Cape Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Empire Waist Line Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Empire_Waist_Line_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Skater Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Skater_Dress.png?v=1757504482" },
  { category: "product_subcategory", name: "Sweater Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Sweater_Dress.png?v=1757504483" },
  { category: "product_subcategory", name: "Wrap Dress", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Wrap_Dress.png?v=1757504482" },
  
  { category: "product_style", name: "Asymmetrical Cutout", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Cutout.png?v=1757766480" },
  { category: "product_style", name: "Asymmetrical Drape", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Drape.png?v=1757766481" },
  { category: "product_style", name: "Asymmetrical Ruffle", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Asymmetrical_Ruffle.png?v=1757766480" },
  { category: "product_style", name: "Belted", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Belted.png?v=1757766479" },
  { category: "product_style", name: "Boho", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Boho.png?v=1757766479" },
  { category: "product_style", name: "Button Front", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Button_Front.png?v=1757766479" },
  { category: "product_style", name: "Cape Overlay", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cape_Overlay.png?v=1757766479" },
  { category: "product_style", name: "Corset", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Corset.png?v=1757766480" },
  { category: "product_style", name: "Cutout", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Cutout.png?v=1757766480" },
  { category: "product_style", name: "Gathered Waist", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Gathered_Waist.png?v=1757766480" },
  { category: "product_style", name: "Ruched Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Ruched_Style.png?v=1757766479" },
  { category: "product_style", name: "Pleated Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Pleated_Style.png?v=1757766480" },
  { category: "product_style", name: "Layering Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Layering_Style.png?v=1757766480" },
  { category: "product_style", name: "Scallop Edge Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Scallop_Edge_Style.png?v=1757766480" },
  { category: "product_style", name: "Slit Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Slit_Style.png?v=1757766480" },
  { category: "product_style", name: "Structured Style", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Structured_Style.png?v=1757766479" },
  { category: "product_style", name: "Tiered Panels", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Tiered_Panels.png?v=1757766479" },
  { category: "product_style", name: "Draped", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Draped.png?v=1757766481" },
  
  { category: "dress_length", name: "Maxi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Maxi.png?v=1758639249" },
  { category: "dress_length", name: "Midi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Midi.png?v=1758639249" },
  { category: "dress_length", name: "Mini", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Mini.png?v=1758639249" },
  { category: "dress_length", name: "Midaxi", background: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Dress_length_Midaxi.png?v=1758639249" }
  
];


// Banner images for categories
const categoryBanners = {
  neck: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Neck.jpg?v=1758639701",
  sleeve: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Sleeve.jpg?v=1758639702",
  hem: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Hem.jpg?v=1758639701",
  product_subcategory: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Product_Subcategory.jpg?v=1758639700",
  product_style: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Style.jpg?v=1758639700",
  dress_length: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Dress_Length.jpg?v=1758639702"
};


/* ---------- Build cards (same structure as you had) ---------- */
function buildLikeDislikeCards(category = null) {
  const container = document.querySelector('.chat-like-dislike-card-container');
  container.innerHTML = "";

  const filteredData = category
    ? cardData.filter(item => item.category === category)
    : cardData;

  // Group items by category
  const grouped = {};
  filteredData.forEach(item => {
    if (!grouped[item.category]) grouped[item.category] = [];
    grouped[item.category].push(item);
  });

  // Build array with banners first
  let finalCards = [];
  Object.keys(grouped).forEach(cat => {
    if (categoryBanners[cat]) {
      finalCards.push({
        category: cat,
        name: `${cat}-banner`,
        background: categoryBanners[cat],
        isBanner: true
      });
    }
    finalCards = finalCards.concat(grouped[cat]);
  });

  const total = finalCards.length;

  finalCards.forEach((item, index) => {
    const card = document.createElement("div");
    card.className = "chat-like-dislike-card";
    card.setAttribute("data-category", item.category);
    card.setAttribute("data-name", item.name);

    if (item.isBanner) {
      card.classList.add("category-banner");
    }

    if (item.background.startsWith("#")) {
      card.style.background = item.background;
    } else {
      card.style.backgroundImage = `url('${item.background}')`;
      card.style.backgroundSize = "cover";
      card.style.backgroundPosition = "center";
    }

    card.style.zIndex = total - index;
    card.style.top = "0";

    if (!item.isBanner) {
      const isLike = document.createElement("div");
      isLike.className = "is-like";
      card.appendChild(isLike);
    }

    container.appendChild(card);
  });
}

buildLikeDislikeCards();

/* ---------- Swipe controller (complete) ---------- */
function initSwipeCards(options) {
  const UNDO_THRESHOLD = 3; // changeable threshold + update UI below
  // document.getElementById('thresholdValue').innerText = UNDO_THRESHOLD;

  let swipeData = sessionStorage.getItem("swipeData")
    ? JSON.parse(sessionStorage.getItem("swipeData"))
    : { likes: {}, dislikes: {} };

  function saveSession() {
    sessionStorage.setItem("swipeData", JSON.stringify(swipeData));
  }

  // undo stack types:
  // { type: 'banner', name, category, html, swipedCount, reversible, originalSwipedCount }
  // { type: 'card',   name, category, html }
  let undoStack = [];

  function getCardName(card) {
    if (!card) return "";
    if (card.dataset && card.dataset.name) return card.dataset.name;
    return card.innerText.trim();
  }

  const frame = document.querySelector(options.container);
  const loveBtn = document.querySelector(options.loveBtn);
  const nopeBtn = document.querySelector(options.nopeBtn);
  const undoBtn = document.querySelector("#undo");
  const buttonsEl = document.querySelector(options.buttons);
  const getStartedEl = document.querySelector('.chat-like-dislike-get-started');

  let current = null;
  let likeText = null;
  let startX = 0, startY = 0, moveX = 0, moveY = 0;
  let pointerId = null;

  function refreshCurrent(hideThumb = false) {
    current = frame.querySelector(".chat-like-dislike-card:first-child");
    likeText = current?.querySelector(".is-like");

    frame.querySelectorAll(".chat-like-dislike-card .is-like")
      .forEach(el => el.style.display = "none");

    if (likeText && !hideThumb) likeText.style.display = "flex";

    if (current && current.classList.contains("category-banner")) {
      if (loveBtn) loveBtn.style.display = "none";
      if (nopeBtn) nopeBtn.style.display = "none";
      if (getStartedEl) getStartedEl.style.display = "block";
    } else {
      if (loveBtn) loveBtn.style.display = "flex";
      if (nopeBtn) nopeBtn.style.display = "flex";
      if (getStartedEl) getStartedEl.style.display = "none";
    }
  }

  function initCard(card) {
    if (!card) return;
    card.style.transition = "";
    card.style.transform = "";
    card.style.touchAction = "none";
    card.removeEventListener("pointerdown", onPointerDown);
    card.addEventListener("pointerdown", onPointerDown);
  }

  // helper: find last banner marker index in undoStack (search from end)
  function findLastBannerIndex() {
    for (let i = undoStack.length - 1; i >= 0; i--) {
      if (undoStack[i].type === 'banner') return i;
    }
    return -1;
  }

  // helper: find first banner index (earliest) in undoStack
  function findFirstBannerIndex() {
    for (let i = 0; i < undoStack.length; i++) {
      if (undoStack[i].type === 'banner') return i;
    }
    return -1;
  }

  // helper: count number of banner markers in undoStack
  function countBanners() {
    let c = 0;
    for (let i = 0; i < undoStack.length; i++) if (undoStack[i].type === 'banner') c++;
    return c;
  }

  function addToSwipeData(target, category, name) {
    if (!swipeData[target][category]) swipeData[target][category] = [];
    if (!swipeData[target][category].includes(name)) {
      swipeData[target][category].push(name);
    }
  }

  function removeFromSwipeData(category, name) {
    ["likes", "dislikes"].forEach(type => {
      if (swipeData[type][category]) {
        swipeData[type][category] = swipeData[type][category].filter(n => n !== name);
        if (!swipeData[type][category].length) {
          delete swipeData[type][category];
        }
      }
    });
  }

  // update Undo button visual (lock/unlock) based on top of undoStack
  function updateUndoVisual() {
    if (!undoBtn) return;
    if (!undoStack.length) {
      undoBtn.style.display = "none";
      undoBtn.disabled = true;
      setUndoLockSvg(false, false);
      return;
    }

    const top = undoStack[undoStack.length - 1];
    if (top.type === 'card') {
      // top is card -> undo allowed
      undoBtn.style.display = "flex";
      undoBtn.disabled = false;
      setUndoLockSvg(false, true);
      return;
    }

    if (top.type === 'banner') {
      // top is banner -> check reversible flag
      // NEW BEHAVIOR: if there is any earlier banner (countBanners() >= 2),
      // allow undo of the top banner so user can continue undoing back to the first banner.
      const bannersCount = countBanners();
      if (top.reversible || bannersCount >= 2) {
        undoBtn.style.display = "flex";
        undoBtn.disabled = false;
        setUndoLockSvg(false, true);
      } else {
        undoBtn.style.display = "flex";
        undoBtn.disabled = true;
        setUndoLockSvg(true, false);
      }
      return;
    }

    undoBtn.style.display = "none";
    undoBtn.disabled = true;
    setUndoLockSvg(false, false);
  }

  // helper to set lock/unlock SVG in undo button
  function setUndoLockSvg(locked, visible) {
    const svg = undoBtn.querySelector('.undo-lock');
    if (!svg) return;
    if (!visible) {
      svg.style.opacity = '0.35';
      svg.innerHTML = '<path d="M3 12v6a2 2 0 0 0 2 2h10"></path><rect x="7" y="7" width="10" height="6" rx="2"></rect>';
      return;
    }
    if (locked) {
      // padlock closed icon
      svg.innerHTML = '<rect x="3" y="11" width="18" height="10" rx="2"/><path d="M7 11V8a5 5 0 0 1 10 0v3"/>';
    } else {
      // unlock icon
      svg.innerHTML = '<path d="M3 12v6a2 2 0 0 0 2 2h10"></path><rect x="7" y="7" width="10" height="6" rx="2"></rect>';
    }
  }

  refreshCurrent();
  initCard(current);
  updateUndoVisual();

  // push banner marker to undoStack (when banner is swiped)
  function pushBannerMarker(cardEl) {
    const marker = {
      type: 'banner',
      name: getCardName(cardEl),
      category: cardEl.dataset.category,
      html: cardEl.outerHTML,
      swipedCount: 0,
      reversible: false,
      originalSwipedCount: 0
    };
    undoStack.push(marker);
    updateUndoVisual();
  }

  // push card entry & increment last banner's swipedCount
  function pushCardEntry(cardEl) {
    const cardName = getCardName(cardEl);
    const category = cardEl.dataset.category;
    const entry = {
      type: 'card',
      name: cardName,
      category,
      html: cardEl.outerHTML
    };
    undoStack.push(entry);

    const bannerIndex = findLastBannerIndex();
    if (bannerIndex !== -1) {
      undoStack[bannerIndex].swipedCount++;
      // mark reversible if threshold reached (persisted once set)
      if (undoStack[bannerIndex].swipedCount >= UNDO_THRESHOLD && !undoStack[bannerIndex].reversible) {
        undoStack[bannerIndex].reversible = true;
        undoStack[bannerIndex].originalSwipedCount = undoStack[bannerIndex].swipedCount;
      }
    }

    updateUndoVisual();
  }

  function setTransform(x, y, deg, duration) {
    if (!current) return;
    current.style.transform = `translate3d(${x}px, ${y}px, 0) rotate(${deg}deg)`;

    if (!current.classList.contains("category-banner")) {
      const likeEl = current.querySelector('.is-like');
      if (likeEl) {
        likeEl.style.opacity = Math.min(1, Math.abs(x) / (window.innerWidth * 0.12));
        if (x > 0) {
          likeEl.className = "is-like like";
          likeEl.innerHTML = '<i class="fa fa-thumbs-up"></i>';
        } else {
          likeEl.className = "is-like nope";
          likeEl.innerHTML = '<i class="fa fa-thumbs-down"></i>';
        }
      }
    }

    if (duration) current.style.transition = `transform ${duration}ms`;
  }

  function onPointerDown(e) {
    refreshCurrent();
    if (!current) return;
    e.preventDefault();
    startX = e.clientX;
    startY = e.clientY;
    moveX = 0; moveY = 0;
    try {
      current.setPointerCapture && current.setPointerCapture(e.pointerId);
      pointerId = e.pointerId;
    } catch (err) {}
    current.addEventListener("pointermove", onPointerMove);
    current.addEventListener("pointerup", onPointerUp);
    current.addEventListener("pointercancel", onPointerUp);
    current.addEventListener("pointerleave", onPointerUp);
  }

  function onPointerMove(e) {
    moveX = e.clientX - startX;
    moveY = e.clientY - startY;
    setTransform(moveX, moveY, (moveX / window.innerWidth) * 50);
  }

  function onPointerUp(e) {
    if (!current) return;
    try {
      current.releasePointerCapture && current.releasePointerCapture(pointerId);
      pointerId = null;
    } catch (err) {}
    current.removeEventListener("pointermove", onPointerMove);
    current.removeEventListener("pointerup", onPointerUp);
    current.removeEventListener("pointercancel", onPointerUp);
    current.removeEventListener("pointerleave", onPointerUp);

    if (Math.abs(moveX) > frame.clientWidth / 2) complete();
    else cancel();
  }

  function complete(duration = 350) {
    if (!current) return;

    // Banner swiped -> push marker & remove visually
    if (current.classList.contains("category-banner")) {
      const prev = current;
      pushBannerMarker(prev);
      const next = prev.nextElementSibling;
      setTimeout(() => {
        try { prev.remove(); } catch (e) {}
        checkCardsLeft();
        if (next) {
          initCard(next);
          refreshCurrent();
        }
      }, 10);
      current = next;
      likeText = current?.querySelector(".is-like");
      updateUndoVisual();
      return;
    }

    // Non-banner card
    const cardName = getCardName(current);
    const category = current.dataset.category;

    removeFromSwipeData(category, cardName);
    const sign = moveX === 0 ? 1 : moveX > 0 ? 1 : -1;
    if (sign > 0) addToSwipeData("likes", category, cardName);
    else addToSwipeData("dislikes", category, cardName);

    saveSession();

    pushCardEntry(current);

    const flyX = sign * window.innerWidth * 1.15;
    const flyY = moveX === 0 ? 0 : (moveY / moveX) * flyX;
    setTransform(flyX, flyY, (flyX / window.innerWidth) * 50, duration);

    const prev = current;
    const next = prev.nextElementSibling;
    if (next) setTimeout(() => {
      initCard(next);
      refreshCurrent();
    }, 100);
    current = next;
    likeText = current?.querySelector(".is-like");

    setTimeout(() => {
      try { prev.remove(); } catch (e) {}
      checkCardsLeft();
      updateUndoVisual();
    }, duration + 10);
  }

  function cancel() {
    if (!current) return;
    setTransform(0, 0, 0, 150);
    setTimeout(() => {
      if (current) current.style.transition = "";
    }, 160);
  }

  function checkCardsLeft() {
    const left = frame.querySelectorAll(".chat-like-dislike-card").length;
    if (left === 0) {
      if (undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }
      if (buttonsEl) buttonsEl.style.display = "none";
      if (getStartedEl) getStartedEl.style.display = "none";
      frame.innerHTML = '<div class="thanks">Thanks!</div>';
    } else {
      if (buttonsEl) buttonsEl.style.display = "flex";
    }
  }

  if (loveBtn) loveBtn.addEventListener("click", () => {
    refreshCurrent();
    if (!current || current.classList.contains("category-banner")) return;
    moveX = 1; moveY = 0;
    complete(350);
  });

  if (nopeBtn) nopeBtn.addEventListener("click", () => {
    refreshCurrent();
    if (!current || current.classList.contains("category-banner")) return;
    moveX = -1; moveY = 0;
    complete(350);
  });

  if (undoBtn) undoBtn.addEventListener("click", () => {
    if (!undoStack.length) return;

    // Peek top entry (do not pop until allowed)
    const topEntry = undoStack[undoStack.length - 1];

    // If top is a card -> pop and restore (original behavior)
    if (topEntry.type === 'card') {
      const entry = undoStack.pop();
      removeFromSwipeData(entry.category, entry.name);
      saveSession();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = entry.html.trim();
      const restoredCard = tempDiv.firstChild;

      frame.insertBefore(restoredCard, frame.firstChild);
      initCard(restoredCard);

      // decrement swipedCount on the nearest banner before this card (if exists)
      const bannerIndex = findLastBannerIndex();
      if (bannerIndex !== -1) {
        if (undoStack[bannerIndex].swipedCount > 0) {
          undoStack[bannerIndex].swipedCount--;
        }
        // Do NOT revert reversible flag once set (per requirement)
      }

      if (!undoStack.length && undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }

      refreshCurrent(true);
      updateUndoVisual();
      return;
    }

    // If top is banner -> determine whether we allow restoring it:
    if (topEntry.type === 'banner') {
      const bannersCount = countBanners();

      // allow if reversible OR there exists at least one earlier banner (we're past the first)
      const allowedBecauseMultipleBanners = (bannersCount >= 2);

      if (!topEntry.reversible && !allowedBecauseMultipleBanners) {
        // Not allowed - keep it on stack and disable undo
        if (undoBtn) {
          undoBtn.disabled = true;
        }
        updateUndoVisual();
        return;
      }

      // Allowed -> pop and restore banner DOM
      const entry = undoStack.pop();

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = entry.html.trim();
      const restoredCard = tempDiv.firstChild;

      frame.insertBefore(restoredCard, frame.firstChild);
      initCard(restoredCard);

      if (!undoStack.length && undoBtn) {
        undoBtn.style.display = "none";
        undoBtn.disabled = true;
      }

      refreshCurrent(true);
      updateUndoVisual();
      return;
    }

    // fallback
    updateUndoVisual();
  });

  if (getStartedEl) {
  getStartedEl.addEventListener("click", () => {
    refreshCurrent();
    if (!current) return;
    
    moveX = 1;
    moveY = 0;
    complete(350);

    getStartedEl.style.display = "none";
  });
}

  return {
    refresh: function () {
      refreshCurrent();
      initCard(current);
      checkCardsLeft();
      updateUndoVisual();
    },
    rebuild: function () {
      refreshCurrent();
      initCard(current);
      updateUndoVisual();
    },
    // expose undo stack for debugging if necessary
    _getUndoStack: () => undoStack.slice(),
    _setThreshold: (n) => {
      console.warn('Changing threshold at runtime may need further re-evaluation of undoStack markers.');
    }
  };
}

/* ---------- Init controller ---------- */
const swipeController = initSwipeCards({
  container: ".chat-like-dislike-card-container",
  loveBtn: "#love",
  nopeBtn: "#nope",
  buttons: ".chat-like-dislike-buttons",
});

/* ---------- Modal open/close handlers ---------- */
document.getElementById('openLikeDislikePopup').addEventListener('click', () => {
  document.getElementById('swipeModal').classList.add('show');
  swipeController.refresh();
});

document.querySelectorAll('.chat-like-dislike-close-popup').forEach(btn => {
  btn.addEventListener('click', () => {
    document.getElementById('swipeModal').classList.remove('show');
  });
});

//  $('#openLikeDislikePopup').on('click', function() {
//     $('#swipeModal').addClass('show');
//     if (typeof swipeController !== 'undefined' && swipeController.refresh) {
//       swipeController.refresh();
//     }
//   });

//   $('.chat-like-dislike-close-popup').on('click', function() {
//     $('#swipeModal').removeClass('show');
//   });



// Like Dislike Ends


// Welcome Intro Start

function WelcomeIntro() {
    // Get all elements
    const $openBtn = $('#chat-welcome-intro-open-btn');
    const $popup = $('#chat-welcome-intro-popup');
    const $closeBtn = $('#chat-welcome-intro-close');
    const $stepItems = $('.chat-welcome-intro-step-item');
    const $steps = $('.chat-welcome-intro-step');
    const $prevBtn = $('#chat-welcome-intro-prev-btn');
    const $nextBtn = $('#chat-welcome-intro-next-btn');
    const $skipBtn = $('#chat-welcome-intro-skip-btn');

    let currentStep = 1;
    const totalSteps = 1; // Updated to 2 steps

    // Open popup
    $openBtn.on('click', function () {
        $popup.addClass('active');
        //$('body').css('overflow', 'hidden');
    });

    // Close popup
    $closeBtn.on('click', function () {
        $popup.removeClass('active');
        //$('body').css('overflow', 'auto');
    });

    // Update the UI based on current step
    function updateUI() {
        // Hide all steps
        $stepItems.removeClass('active');

        // Show current step
        $(`#chat-welcome-intro-step-${currentStep}`).addClass('active');

        // Update step indicators
        $steps.each(function (index) {
            if (index + 1 <= currentStep) {
                $(this).addClass('active');
            } else {
                $(this).removeClass('active');
            }
        });

        // Show/hide previous button
        if (currentStep === 1) {
            $prevBtn.addClass('chat-welcome-intro-hidden');
        } else {
            $prevBtn.removeClass('chat-welcome-intro-hidden');
        }

        // Change next button text on last step
        if (currentStep === totalSteps) {
            $nextBtn.text('Get Started');
            $skipBtn.addClass('chat-welcome-intro-hidden');
        } else {
            $nextBtn.text('Next');
            $skipBtn.removeClass('chat-welcome-intro-hidden');
        }
    }

    // Next button click handler
    $nextBtn.on('click', function () {
        if (currentStep < totalSteps) {
            currentStep++;
            updateUI();
        } else {
            // On the last step, close the popup or redirect
            $popup.removeClass('active');
            //$('body').css('overflow', 'auto');
            $('#openLikeDislikePopup').trigger('click');
        }
    });

    // Previous button click handler
    $prevBtn.on('click', function () {
        if (currentStep > 1) {
            currentStep--;
            updateUI();
        }
    });

    // Skip button click handler
    $skipBtn.on('click', function () {
        // Skip to the last step
        currentStep = totalSteps;
        updateUI();
    });

    // Initialize the UI
    updateUI();
}


WelcomeIntro();


$(document).on('click', '#chat-welcome-intro-next-btn', function() {
  $('#chat-welcome-intro-popup').removeClass('active');
});


// Welcome Intro Ends


// show Discount Code start


function showDiscountCode(delaySeconds, targetSelector, source) {
  const discountCodes = {
    google: {
      code: "GGP10",
      text: "£10 off",
      type: "amount",
      remaining_time: 1 * 60 * 60,
      footerText: "Min. £20"
    },
    awin: {
      code: "GAW20",
      text: "20% off",
      type: "percentage",
      remaining_time: 1 * 60 * 60,
      footerText: "No minimum requirements"
    },
    direct: {
      code: "GDR5",
      text: "£5 off",
      type: "amount",
      remaining_time: 1 * 60 * 60,
      footerText: "Min. £20"
    }
  };

  const discount = discountCodes[source];
  if (!discount) return;

  setTimeout(() => {
    const $target = $(targetSelector);
    const $typingLoader = $("#type_looader");

    // Avoid duplicates in the same container
    if ($target.find(`.show_discount-container-${source}`).length) return;

    const messageTemplate = `
      <div class="show_discount-container show_discount-container-${source}" data-discount-timer="${discount.remaining_time}">
        <div class="show_discount-header">
          <span class="show_discount-title">Exclusive Session Offer</span>
        </div>
        <p class="show_discount-subtitle">
          🎉 Congratulations! You've unlocked a special discount for this styling session.
        </p>
        <div class="show_discount-card">
          <div class="show_discount-amount-image-text">
             
              <img src="https://cdn.shopify.com/s/files/1/0487/8834/0899/files/BIZcoin_lottie_AI.gif?v=1759772275" alt="Offer">
              
            </div>
            <div class="show_discount-timer-button-wrapper">
             <div class="show_discount-card-amount">${discount.text}</div>
              <div class="show_discount-timer">
                Expires: <span class="discount-timer"></span>
              </div>
              <div class="show_discount-code-apply-wrapper">
                <div class="show_discount-card-code">
                  CODE: <span class="show_discount_code">${discount.code}</span>
                </div>
                <button type="button" class="show_discount-btn-primary">Apply Now</button>
              </div>
           </div>
        </div>

        <div class="show_discount-card-text">${discount.footerText}</div>

        <div class="discount-claim"></div>
       
      </div>
    `;

    function insertDiscountBlock() {
      const isChatContext = $target.closest("#section-chat").length > 0;
      let $inserted;

      if (isChatContext && $typingLoader.length && !$typingLoader.is(":visible")) {
        console.log("💬 Chat context → inserting before loader");
        $typingLoader.before(messageTemplate);
        $inserted = $typingLoader.prev(".show_discount-container");
      } else {
        console.log("🧩 Non-chat context → appending to", targetSelector);
        $target.append(messageTemplate);
        $inserted = $target.find(".show_discount-container").last();
      }

      try {
        showConfettiGIF();
      } catch (err) {
        console.warn("Confetti animation failed:", err);
      }

      const timerElement = $inserted.find(".discount-timer")[0];
      if (timerElement) {
        const remainingTime = parseInt($inserted.attr("data-discount-timer"), 10) || 0;
        startCountdownForShowDiscount(remainingTime, timerElement);
      }

      try {
        initDiscountClaim(targetSelector, discount.code);
      } catch (err) {
        console.warn("initDiscountClaim error:", err);
      }
    }

    // For chat sections, wait for loader before inserting
    const isChatContext = $target.closest("#section-chat").length > 0;
    if (isChatContext) {
      const waitForLoader = () => {
        if ($typingLoader.length && $typingLoader.is(":visible")) {
          setTimeout(waitForLoader, 300);
        } else {
          insertDiscountBlock();
        }
      };
      waitForLoader();
    } else {
      insertDiscountBlock();
    }
  }, delaySeconds * 1000);
}



function showDiscountIfEligible(trigger) {
  let trafficData = sessionStorage.getItem("trafficInfo");
  if (!trafficData) {
    console.warn("❌ No trafficInfo found.");
    return;
  }

  trafficData = JSON.parse(trafficData);
  const validSources = ["google", "awin", "direct"];
  const source = trafficData.source;
  if (!validSources.includes(source)) {
    console.warn("⚠️ Unsupported traffic source:", source);
    return;
  }

  console.log(`🎯 showDiscountIfEligible called via trigger: "${trigger}" for source: ${source}`);

  // --- Handle logic based on trigger ---
  if (trigger === "chat-register") {
    // Only show when register section is visible (after preloader hides)
    const waitForPreloader = setInterval(() => {
      const $preloader = $(".preloader");
      const $register = $("#section-register");

      if (!$preloader.is(":visible") && $register.is(":visible")) {
        clearInterval(waitForPreloader);
        console.log("✅ Register section visible → showing discount in .chat-register-new-discount");
        showDiscountCode(0, ".chat-register-new-discount", source);
      }
    }, 300);

  } else if (trigger === "exit intent" || trigger.includes("revisit")) {
    // Only show when chat section is visible (not register)
    const waitForChat = setInterval(() => {
      const $chatSection = $("#section-chat");
      if ($chatSection.is(":visible")) {
        clearInterval(waitForChat);
        console.log(`✅ Chat section visible → showing discount in #chat_message (trigger: ${trigger})`);
        showDiscountCode(0, "#chat_message", source);
      }
    }, 300);
  }
}



// ✅ Countdown function
function startCountdownForShowDiscount(duration, displayElement) {
  let timer = duration;
  if (displayElement._interval) clearInterval(displayElement._interval);

  displayElement._interval = setInterval(() => {
    const hours = String(Math.floor(timer / 3600)).padStart(2, "0");
    const minutes = String(Math.floor((timer % 3600) / 60)).padStart(2, "0");
    const seconds = String(timer % 60).padStart(2, "0");
    displayElement.textContent = `${hours}:${minutes}:${seconds}`;

    if (--timer < 0) {
      clearInterval(displayElement._interval);
      displayElement.textContent = "Expired";
    }
  }, 1000);
}




function initDiscountClaim(targetSelector, discountCode) {
  // Remove any old click listeners to prevent duplicates
  $(document).off('click.discountClaim').on('click.discountClaim', '.show_discount-btn-primary', function () {
    const $btn = $(this);
    const $container = $btn.closest('.show_discount-container');

    // Store claimed code in session storage
    sessionStorage.setItem('claimedDiscountCode', discountCode);

    // Change button text and color
    $btn
      .text('CODE APPLIED')
      .css({
        'background-color': '#28a745', // green
        'color': '#fff',
        'cursor': 'default'
      })
      .prop('disabled', true);

    // Remove any existing notice
    $container.find('.discount-claim-notice').remove();

    // Add success message below button
    $('.discount-claim').html(`
      <div class="discount-claim-notice" 
           style="color: #28a745; margin-top: 8px; text-align: center; font-weight: 500;">
        Discount will apply on checkout automatically. (terms & conditions apply.)
      </div>
    `);
  });
}



$(document).on('click', '.button-checkout', function(e) {
  const code = sessionStorage.getItem('claimedDiscountCode');
  if (code) {
    e.preventDefault();
    window.location.href = '/checkout?discount=' + encodeURIComponent(code);
    sessionStorage.removeItem('claimedDiscountCode');
  }
});






function setupTabCloseDetection() {
    window.addEventListener('beforeunload', function() {
        const timestamp = Date.now().toString();
        // Use cookie instead of localStorage (more reliable during unload)
        document.cookie = `tabClosedTime=${timestamp}; path=/; max-age=30`; // 30 seconds expiry
       // console.log('💾 Tab close time saved to cookie:', timestamp);
    });

    window.addEventListener('pagehide', function() {
        const timestamp = Date.now().toString();
        document.cookie = `tabClosedTime=${timestamp}; path=/; max-age=30`;
       // console.log('📱 Page hide - tab close time saved to cookie');
    });
}

function checkRevisitDiscount() {
    const firstVisit = localStorage.getItem('firstVisitTime');
    const currentTime = Date.now();
     //const oneDay = 1 * 60 * 1000; // for testing 1 minute
    const oneDay = 24 * 60 * 60 * 1000;

    // Get tabClosedTime from cookie instead of localStorage
    const tabClosedTime = getCookie('tabClosedTime');
    // console.log('🔍 firstVisit:', firstVisit, 'tabClosedTime from cookie:', tabClosedTime);

    if (!firstVisit) {
       // console.log('⭐ First ever visit');
        localStorage.setItem('firstVisitTime', currentTime.toString());
        return;
    }

    if (tabClosedTime) {
        const timeSinceTabClose = currentTime - parseInt(tabClosedTime, 10);
        const timeSinceFirstVisit = currentTime - parseInt(firstVisit, 10);
        const daysSinceVisit = Math.floor(timeSinceFirstVisit / oneDay);
        
        // console.log('⏰ Time since tab close:', timeSinceTabClose, 'ms');
        // console.log('📅 Days since first visit:', daysSinceVisit);

        if (timeSinceTabClose > 1000) {
           // console.log('✅ Tab close detected');
            
            if (daysSinceVisit === 7) {
                showDiscountIfEligible("7-day revisit");
            } else if (daysSinceVisit === 1) {
                showDiscountIfEligible("1-day revisit");
            }
        }
        
        // Clear the cookie
        document.cookie = "tabClosedTime=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}


function showConfettiGIF() {
    // remove existing confetti if already there
    const existing = document.getElementById("confetti-gif");
    if (existing) existing.remove();

    const img = document.createElement("img");
    img.id = "confetti-gif";
    img.src = "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Confetti-gif.gif?v=1760093253"; // 👈 adjust path to your asset URL
    img.style.position = "fixed";
    img.style.top = "0";
    img.style.left = "0";
    img.style.width = "100%";
    img.style.height = "100%";
    img.style.pointerEvents = "none";
    img.style.zIndex = "9999";

    document.body.appendChild(img);

    // remove after animation duration (e.g. 3s)
    setTimeout(() => {
        img.remove();
    }, 3000);
}


$(document).ready(function() {
    setupTabCloseDetection();
    checkRevisitDiscount();
});

// show Discount Code ends

// show Swipe Cards start


function showSwipeCardsInChat() {

  const cards = [
    { category: "neck", title: "Neck", desc: "Neck", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Neck.jpg?v=1758639701" },
    { category: "sleeve", title: "Sleeve", desc: "Sleeve", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Sleeve.jpg?v=1758639702" },
    { category: "hem", title: "Hem", desc: "Hem", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Hem.jpg?v=1758639701" },
    { category: "product_subcategory", title: "Product Subcategory", desc: "Product Subcategory", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Product_Subcategory.jpg?v=1758639700" },
    { category: "product_style", title: "Product Style", desc: "Product Style", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Style.jpg?v=1758639700" },
    { category: "dress_length", title: "Dress Length", desc: "Dress Length", img: "https://cdn.shopify.com/s/files/1/0487/8834/0899/files/Card_Banner_Dress_Length.jpg?v=1758639702" }
  ];

  let currentStep = 0;
  const perPage = 3;
  const totalSteps = Math.ceil(cards.length / perPage);

  function renderStep(step) {
    const start = step * perPage;
    const end = start + perPage;
    const visibleCards = cards.slice(start, end);

    let cardsHTML = visibleCards.map(card => `
      <div class="chat_show_swipecards_card" data-category="${card.category}">
        <img src="${card.img}" alt="${card.title}">
        <div class="chat_show_swipecards_card_title">${card.title}</div>
        <div class="chat_show_swipecards_card_desc">${card.desc}</div>
      </div>
    `).join("");

    const preferencesHTML = `
      <div class="chat_show_swipecards_container">
        <div class="chat_show_swipecards_header">
          <h3>Clothing Preferences</h3>
          <div class="chat_show_swipecards_subtext">
            Choose the clothing types that appeal to you most. You can select multiple options:
          </div>
        </div>

        <div class="chat_show_swipecards_cards">
          ${cardsHTML}
        </div>

        <div style="text-align:center; margin-top:10px;">
          ${step > 0 ? `<div class="chat_show_swipecards_back">← Back</div>` : ""}
          <div class="chat_show_swipecards_button">${step + 1 === totalSteps ? "Finish" : "Continue →"}</div>
        </div>

        <div class="chat_show_swipecards_footer">
          <span>🔆 Select your preferences above or type a message...</span>
          <span>Step ${step + 1} of ${totalSteps}</span>
          <div class="chat_show_swipecards_stepbar">
            <div class="chat_show_swipecards_stepbar_fill" 
                 style="width:${((step + 1) / totalSteps) * 100}%"> </div>
          </div>
        </div>
      </div>
    `;

    // create wrapper if it doesn't exist
    if ($('#chat_swipe_wrapper').length === 0) {
      $('#chat_message').append('<div id="chat_swipe_wrapper"></div>');
    }

    $('#chat_swipe_wrapper').html(preferencesHTML);
  }

  // initial render
  renderStep(currentStep);

  // handle Continue/Finish
  $(document).off("click", ".chat_show_swipecards_button").on("click", ".chat_show_swipecards_button", function () {
   
    if (currentStep + 1 < totalSteps) {
      currentStep++;
      renderStep(currentStep);

    } else {
     
      alert("All steps completed!");
    }
    var hidecontinue = totalSteps - 1;
    if (currentStep == hidecontinue ) {
      $(".chat_show_swipecards_button").hide();
    }

  });

  // handle Back
  $(document).off("click", ".chat_show_swipecards_back").on("click", ".chat_show_swipecards_back", function () {
    if (currentStep > 0) {
      currentStep--;
      renderStep(currentStep);
    }
  });

  // card click handler
  $(document).off("click", ".chat_show_swipecards_card").on("click", ".chat_show_swipecards_card", function () {
    const category = $(this).data("category");
    buildLikeDislikeCards(category);
    $("#swipeModal").addClass("show");
    swipeController.refresh();
  });
}


// show Swipe Cards ends

// Product recommendation Feedback start

function productRecommendationFeedback(message_id){
  return  `
      <div class="chat_feedback_step" data-id="${message_id}">
          <div class="chat_feedback_helpful">
              <div class="chat_feedback_helpful_wrapper">
                  <div class="chat_feedback_title">Was this recommendation helpful?</div>
                  
                  <div class="chat_feedback_choices">
                      <button class="chat_feedback_btn chat_feedback_no" data-value="no">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
                               viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                               stroke-linecap="round" stroke-linejoin="round">
                              <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28
                                       a2 2 0 0 0 2-1.7l1.38-9
                                       a2 2 0 0 0-2-2.3zM7 22H4
                                       a2 2 0 0 1-2-2v-7
                                       a2 2 0 0 1 2-2h3"></path>
                          </svg>
                          No
                      </button>

                      <button class="chat_feedback_btn chat_feedback_yes" data-value="yes">
                          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" 
                               viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" 
                               stroke-linecap="round" stroke-linejoin="round">
                              <path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28
                                       a2 2 0 0 0 2-1.7l1.38-9
                                       a2 2 0 0 0-2-2.3zM7 22H4
                                       a2 2 0 0 1-2-2v-7
                                       a2 2 0 0 1 2-2h3"></path>
                          </svg>
                          Yes
                      </button>
                  </div>

                  <div class="validation-error" id="helpful-error" style="display:none;">
                      Please indicate if the recommendation was helpful
                  </div>

                  <button class="chat_feedback_primary" id="submit-product-recommendation">
                      Submit Feedback
                  </button>
              </div>
          </div>
      </div>
  `;
}

$(document).on('click', '.chat_feedback_btn', function() {
    $(this).siblings().removeClass('active');
    $(this).addClass('active');
    $('#helpful-error').hide();
});

$(document).on('click', '#submit-product-recommendation', function() {
    const $step = $(this).closest('.chat_feedback_step');
    const messageId = $step.data('id');
    const $selected = $step.find('.chat_feedback_btn.active');

    if ($selected.length === 0) {
        $step.find('#helpful-error').show();
        return;
    }

    const feedback = $selected.data('value');

    const userId = Number(localStorage.getItem('user_id'));
    const assistantId = Number(localStorage.getItem('session_id'));

    const payload = {
        user_id: userId,
        assistant_id: assistantId,
        type : "product_recommendation",
        data: {
            helpful: feedback
        }
    };
    // 👉 Send to API
    const token = getAiToken();

    $.ajax({
        url: 'https://ai.mygoddiva.com/feedback/store',  
        method: 'POST',
        contentType: 'application/json',
        headers: token ? { "Authorization": "Bearer " + token } : {},
        data: JSON.stringify(payload),
        success: function(res) {
            console.log('Feedback submitted:', res);
            $step.html('<div class="product-recommendation-thanks-msg">Thanks for your feedback!</div>');
        },
        error: function(err) {
            console.error('Feedback error:', err);
            $('.api-error').text('An error occurred. Please try again.').show();
             $('#gooeyEffect').hide();
             $('#type_looader').hide();
            setTimeout(function() {
              $('.api-error').fadeOut();
            }, 2000);
           // alert('Something went wrong, please try again.');
        }
    });
});


// Product recommendation Feedback ends



// $(window).on("scroll", function () {
//   let $chatContent = $(".chat-content");
//   let $chatForm = $(".chat-form");

//   if (!$chatContent.length || !$chatForm.length) return;

//   let chatBottom = $chatContent.offset().top + $chatContent.outerHeight();
//   let windowBottom = $(window).scrollTop() + $(window).height();

//   if (windowBottom >= chatBottom) {
//     $chatForm.addClass("sticky-form");
//   } else {
//     $chatForm.removeClass("sticky-form");
//   }
// });

$(window).on("scroll", function () {
  const $chatContent = $(".chat-content");
  const $chatForm = $(".chat-form");

  if (!$chatContent.length || !$chatForm.length) return;

  const chatBottom = $chatContent.offset().top + $chatContent.outerHeight()+100;
  const windowBottom = $(window).scrollTop() + $(window).height();

  if (windowBottom >= chatBottom) {
    $chatForm.addClass("sticky-form");
  } else {
    $chatForm.removeClass("sticky-form");
  }
});


// Ai Register Start here

(function () {
  // only create one global reference so we can remove listeners reliably
  if (window.__aiChatRegistered) {
    console.log('AI chat already initialized - re-initializing (will remove old handlers).');
  }
  window.__aiChatRegistered = true;
  $("#ai-page-underMaintainance").css("display", "none");

  // Selectors (more specific)
  const $doc = $(document);
  const nameInput = $('input.chat-register-new-input-field[type="text"]');
  const emailInput = $('input.chat-register-new-input-field[type="email"]');
  const chatInput = $('.chat-register-new-chat-input'); // could be multiple; we attach to each
  const $sendBtnSelector = '.chat-register-new-send-button';
  const termsCheckbox = $('#chat-register-new-checkbox');
  const termsLabel = $('.chat-register-new-checkbox-label');
  const sizeCheckboxes = $('.chat-register-new-size-checkbox');
  const $multiSelect = $('#chat-register-new-size-select');
  const $selectBox = $multiSelect.find('.chat-register-new-select-box');


  const $registerOrderField = $('#register-chat-order-id-field');
  const $registerHiddenOrder = $('#hidden-register-chat-order-id');


  // Helper: clear error visuals
  function clearErrors() {
    $('.error-border, .error-borders').removeClass('error-border error-borders');
    $('.chat-register-new-error').text('');
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  // updateSelectedText (kept from original)
  function updateSelectedText() {
    const selected = $multiSelect
      .find('.chat-register-new-size-checkbox:checked')
      .map(function () {
        return $(this).siblings('span').text().trim();
      })
      .get();

    if (selected.length === 0) {
      $selectBox.text('Select your sizes');
    } else if (selected.length === 1) {
      $selectBox.text(selected[0]);
    } else {
      $selectBox.text(`${selected[0]} +${selected.length - 1} more`);
    }
  }

  // ====================
  // remove any previous handlers (namespaced)
  // ====================
  $doc.off('.aiChat'); // removes jQuery handlers we add via .on(...,'.aiChat')
  // remove click/keydown on specific elements we might have attached previously
  $doc.off('click.aiChat', $sendBtnSelector);
  $doc.off('change.aiChat', '#chat-register-new-size-select .chat-register-new-size-checkbox');
  $doc.off('click.aiChat', '#chat-register-new-size-select .chat-register-new-select-box');
  $doc.off('click.aiChat', function () {}); // harmless

  // also remove any previous native keydown handlers stored on window
  if (window.__aiChatKeyHandler) {
    document.querySelectorAll('.chat-register-new-chat-input').forEach(el => {
      try { el.removeEventListener('keydown', window.__aiChatKeyHandler, true); } catch(e) {}
    });
    window.__aiChatKeyHandler = null;
  }

  // ====================
  // Dropdown handlers
  // ====================
  $doc.on('click.aiChat', '#chat-register-new-size-select .chat-register-new-select-box', function (e) {
    e.stopPropagation();
    $('#chat-register-new-size-select').toggleClass('open');
  });

  $doc.on('change.aiChat', '#chat-register-new-size-select .chat-register-new-size-checkbox', updateSelectedText);

  // close when clicking outside
  $doc.on('click.aiChat', function (e) {
    const $multi = $('#chat-register-new-size-select');
    if (!$multi.is(e.target) && $multi.has(e.target).length === 0) {
      $multi.removeClass('open');
    }
  });

  // ====================
  // Auto-check customer sizes (kept from original)
  // ====================
  if (Array.isArray(window.customerSizeTags) && window.customerSizeTags.length > 0) {
    const lowerTags = window.customerSizeTags.map(tag => tag.toLowerCase().trim());
    sizeCheckboxes.each(function () {
      const checkboxId = $(this).data('customer-size')?.toLowerCase().trim();
      if (checkboxId && lowerTags.includes(checkboxId)) {
        $(this).prop('checked', true);
      }
    });
    updateSelectedText();
  }

  // ====================
  // Validation (kept and slightly hardened)
  // ====================
  function validateFields() {
    clearErrors();
    let isValid = true;

    if (!$.trim(nameInput.val())) {
      nameInput.addClass('error-border');
      isValid = false;
    }

    const emailVal = $.trim(emailInput.val());
    if (!emailVal) {
      emailInput.addClass('error-border');
      isValid = false;
    } else if (!isValidEmail(emailVal)) {
      emailInput.addClass('error-border');
      isValid = false;
    }

    const selectedSizes = sizeCheckboxes.filter(':checked');
    if (selectedSizes.length === 0) {
      $('#chat-register-new-size-select').addClass('error-border');
      isValid = false;
    }

    if (!termsCheckbox.is(':checked')) {
      termsLabel.addClass('error-borders')
        .next('.chat-register-new-error')
        .text('You must agree to the terms before continuing.');
      isValid = false;
    }

    if (!$.trim($('.chat-register-new-chat-input').val())) {
      $('.chat-register-new-chat-input').addClass('error-border');
      selectedSuggestion = null;
      isValid = false;
    }

     if ($registerOrderField.is(':visible') && selectedSuggestion?.required_fields?.includes('order_number')) {
      const orderValue = $registerOrderField.val().trim();
      if (!orderValue) {
        // Add validation styling and focus on the order field
        $registerOrderField.addClass('error-border').focus();
         $('.chat-register-new-chat-input').addClass('error-border');
        isValid = false;
      }
    }
   
    return isValid;
  }

   $('.chat-register-new-chat-input').on('input', function() {
      const $this = $(this);
      const value = $.trim($this.val());
      
      if (value === '' || value === '0') {
        $registerOrderField.hide().prop('required', false).val('').removeClass('error-border');
      } 
  });

  // ====================
  // handleSubmit (keeps payload + ajax)
  // ====================
  function handleSubmit() {
    console.log('[aiChat] handleSubmit called');
    if (!validateFields()) {
      console.log('[aiChat] validation failed');
      return;
    }

    const name = $.trim(nameInput.val());
    const email = $.trim(emailInput.val());
    const order = $registerHiddenOrder.length ? $registerHiddenOrder.val().trim() : ($registerOrderField.is(':visible') ? $registerOrderField.val().trim() : '');

    

    const message = $.trim($('.chat-register-new-chat-input').val());

    const sizes = [];
    $('.chat-register-new-size-checkbox:checked').each(function () {
      const ukId = Number($(this).data('id'));
      const ukName = $(this).data('value');
      const intlId = Number($(this).data('international-id'));
      const intlName = $(this).data('international');

      sizes.push({ id: ukId, name: ukName });
      if (intlId && intlName && String(intlName).toLowerCase() !== 'null') {
        sizes.push({ id: intlId, name: intlName });
      }
    });

    // include onesize if present (hidden)
    const oneSizeInput = $('.chat-register-new-size-checkbox[data-id="2"]');
    if (oneSizeInput.length && !sizes.some(s => s.id === 2)) {
      const oneSizeId = Number(oneSizeInput.data('id'));
      const oneSizeName = oneSizeInput.data('value');
      sizes.push({ id: oneSizeId, name: oneSizeName });
    }

    const trafficInfo = JSON.parse(sessionStorage.getItem('trafficInfo') || '{}');
    const swipeData = JSON.parse(sessionStorage.getItem('swipeData') || '{"likes": {}, "dislikes": {}}');

    const payload = {
      name,
      email,
      size: sizes,
      ppc_source: trafficInfo,
      perefernce: swipeData
    };

    console.log('[aiChat] sending payload', payload);

    const $submitBtn = $($sendBtnSelector);
    $.ajax({
      url: "https://ai.mygoddiva.com/user-register",
      type: "POST",
      contentType: "application/json",
      data: JSON.stringify(payload),
      beforeSend: () => $submitBtn.prop('disabled', true),
      success: function (response) {
        console.log('[aiChat] register success', response);
        sessionStorage.setItem('is_history', 'true');
        localStorage.setItem('session_id', response.session_id);
        localStorage.setItem('user_id', response.user_id);
        localStorage.setItem('user_email', email);
        localStorage.setItem('user_name', name);
        $('#span_user_name').text(name);

        if (response.token) {
          localStorage.setItem("ai_access_token", response.token.access);
          localStorage.setItem("ai_refresh_token", response.token.refresh);
        }

        if (typeof updateUserInitials === 'function') updateUserInitials();

        //CRAZY EGG Start here

        try {
            window.CE_API = window.CE_API || [];
            window.CE_API.push(function () {
              if (typeof CE2 !== 'undefined' && email) {
                CE2.identify(email);
                console.log("Crazy Egg identified as:", email);
              } else {
                const fallbackId = "DudeAIVisitor #" + Math.random().toString(36).substring(2, 12);
                CE2.identify(fallbackId);
                console.log("Crazy Egg identified with fallback:", fallbackId);
              }
            });
          } catch (err) {
            console.error("Crazy Egg identify failed:", err);
          }

          //CRAZY EGG Ends here


        // update #your-sizes UI (kept your logic)
        if (payload.size && payload.size.length) {
          $('#your-sizes').empty();
          const ukIds = $('.chat-register-new-size-checkbox').map(function () {
            return Number($(this).data('id'));
          }).get();

          const uniqueUkSizes = payload.size.filter(
            item => ukIds.includes(item.id) && item.name.toLowerCase() !== 'onesize'
          );

          let sizesHtml = '';
          if (uniqueUkSizes.length > 1) {
            const remainingCount = uniqueUkSizes.length - 1;
            const allSizes = uniqueUkSizes.map((item, index) => {
              const hiddenClass = index > 0 ? 'hidden-size' : '';
              return `<li class="your-size-btn ${hiddenClass}" data-id="${item.id}">${item.name.trim()}</li>`;
            }).join('');

            sizesHtml = `${allSizes}<li class="your-size-btn your-size-more">+ ${remainingCount} more</li>`;
          } else if (uniqueUkSizes.length === 1) {
            const onlySize = uniqueUkSizes[0];
            sizesHtml = `<li class="your-size-btn" data-id="${onlySize.id}">${onlySize.name.trim()}</li>`;
          }
          $('#your-sizes').html(sizesHtml);
        }

        // append user message and call chatQuery if available
        let combinedMessage = message;

        if (selectedSuggestion?.required_fields?.includes('order_number') && order) {
          combinedMessage += ` Order number is ${order}`;
          combinedMessage += ` and email address is ${email}`;
        }

        if (combinedMessage) {
          const userInitials = (typeof getUserInitials === 'function') ? getUserInitials() : '';
          $("#chat_message").append(`
            <div class="user-message">
              <div class="user-logo">${userInitials}</div>
              <div class="user-text">${combinedMessage}</div>
            </div>
          `);
          if (typeof chatQuery === 'function') chatQuery(combinedMessage);
        }

        

        $('#chat-order-id-field').hide();
        $registerOrderField.hide();
      },
      error: function (xhr, status, err) {
         $("#ai-page-underMaintainance").css("display", "flex");
        console.error('[aiChat] register error', status, err, xhr);
        $('#type_looader').hide();
        setTimeout(() => $('.api-error').fadeOut(), 2000);
      },
      complete: function () {
         $("#ai-page-underMaintainance").css("display", "none");
        $('#type_looader').show();
        $('#section-register').hide();
        $('#section-chat').show();
        const $last = $('.user-message').last();
        const headerHeight = $('.chat-header').outerHeight() || 0;
        $('html, body').animate({
          scrollTop: $last.offset().top - headerHeight - 150
        }, 800);

        $submitBtn.prop('disabled', false);
      }
    });
  }

  // ====================
  // UI: click handler for send button (delegated)
  // ====================
  $doc.on('click.aiChat', $sendBtnSelector, function (e) {
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log('[aiChat] send button clicked');
    handleSubmit();
  });

  // ====================
  // Keydown handler for Enter (native, capturing) - ensures we intercept before other handlers
  // ====================
  window.__aiChatKeyHandler = function (e) {
    try {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        e.stopImmediatePropagation();
        console.log('[aiChat] Enter pressed (captured) - value:', e.target.value);
        handleSubmit();
      }
    } catch (err) {
      console.error('[aiChat] key handler error', err);
    }
  };

  // attach to each matching input (remove previous first)
  document.querySelectorAll('.chat-register-new-chat-input').forEach(el => {
    try { el.removeEventListener('keydown', window.__aiChatKeyHandler, true); } catch (e) {}
    el.addEventListener('keydown', window.__aiChatKeyHandler, true); // use capture
  });

  // ====================
  // Misc: close dropdown on outside click already handled above
  // Ensure the dropdown text shows current selection on init
  // ====================
  updateSelectedText();

  console.log('[aiChat] initialization complete');


  showDiscountIfEligible("chat-register");
  
})();

// Ai Register ends here


$(".profile-pic").on("click", function () {
    $("#chat-update-user-data-popup").css("display", "flex");
    const name = localStorage.getItem("user_name");
    const email = localStorage.getItem("user_email");

    $(".chat-update-user-data-input-field.username").val(name);
    $(".chat-update-user-data-input-field.useremail").val(email);

});


$("#chat-update-user-data-close").on("click", function () {
  $("#chat-update-user-data-popup").hide();
  $(".chat-update-user-data-input-field").val("");
  $(".update-user-data-error").hide();
});


// Function to handle user update

function updateUserData() {
  const $saveBtn = $("#chat-update-user-data-save");
  const $nameInput = $(".chat-update-user-data-input-field.username");
  const $emailInput = $(".chat-update-user-data-input-field.useremail");
  const errorEl = $(".update-user-data-error");

  const userId = localStorage.getItem("user_id");
  let oldName = localStorage.getItem("user_name") || "";
  let oldEmail = localStorage.getItem("user_email") || "";

  // Prefill existing user data
  $nameInput.val(oldName);
  $emailInput.val(oldEmail);

  // Initially disable button
  $saveBtn.prop("disabled", true).addClass("disabled");

  // Function to check for changes
  function checkForChanges() {
    const name = $nameInput.val().trim();
    const email = $emailInput.val().trim();

    if (name !== oldName || email !== oldEmail) {
      $saveBtn.prop("disabled", false).removeClass("disabled");
    } else {
      $saveBtn.prop("disabled", true).addClass("disabled");
    }
  }

  // Listen for typing/pasting
  $nameInput.on("input", checkForChanges);
  $emailInput.on("input", checkForChanges);

  // Save button click
  $saveBtn.on("click", function () {
    const name = $nameInput.val().trim();
    const email = $emailInput.val().trim();

    errorEl.hide();

    // Validation
    if (!name || !email) {
      errorEl.text("Please enter both name and email.").show();
      return;
    }

    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailPattern.test(email)) {
      errorEl.text("Please enter a valid email address.").show();
      return;
    }

    if (!userId) {
      errorEl.text("User ID not found in local storage.").show();
      return;
    }

    // Disable while saving
    $saveBtn.prop("disabled", true).addClass("disabled").text("Saving...");

    const nameChanged = oldName !== name;
    const emailChanged = oldEmail !== email;

    // 🚫 No change — stop silently
    if (!nameChanged && !emailChanged) {
      $saveBtn.text("Save").prop("disabled", true).addClass("disabled");
      return;
    }

    // 🧠 Save previous values BEFORE overwriting
    const prevName = oldName;
    const prevEmail = oldEmail;

    const payload = { id: userId, name, email };

    const token = getAiToken();


    $.ajax({
      url: "https://ai.mygoddiva.com/user-update",
      method: "POST",
      contentType: "application/json",
      headers: token ? { "Authorization": "Bearer " + token } : {},
      data: JSON.stringify(payload),
      success: function () {
        $(".message-update-user-name-email").remove();

        $("#chat-update-user-data-popup").hide();
        errorEl.hide();

        localStorage.setItem("user_name", name);
        localStorage.setItem("user_email", email);

        // ✅ Update "old" values only AFTER using them in message
        oldName = name;
        oldEmail = email;

        const usrname = localStorage.getItem("user_name");
        const userInitials = getInitials(name);
        $(".profile-pic, .user-logo").text(userInitials);
        $("#span_user_name").text(usrname);

        let changes = [];
        if (nameChanged)
          changes.push(`<b>Name:</b> ${prevName || "N/A"} → ${name}`);
        if (emailChanged)
          changes.push(`<b>Email:</b> ${prevEmail || "N/A"} → ${email}`);

        if (changes.length > 0) {
          const message = `
            <div class="message-update-user-name-email">
              User details updated successfully.<br>
              ${changes.join("<br>")}
            </div>
          `;

          $("#chat_message")
            .append(message)
            .animate({ scrollTop: $("#chat_message")[0].scrollHeight }, 300);
        }

        // Reset button state
        $saveBtn.text("Save");
        $saveBtn.prop("disabled", true).addClass("disabled");
      },
      error: function (xhr) {
        const response = xhr.responseJSON;
        if (response && response.email) {
          errorEl.text(response.email[0]).show();
        } else {
          errorEl.text("An unexpected error occurred. Please try again.").show();
        }
        $saveBtn.text("Save").prop("disabled", false).removeClass("disabled");
      }
    });
  });
}

// Initialize
updateUserData();


function handleMobileRedirect() {
  const isMobileOrTablet =
    /Mobi|Android|iPad|iPhone|Tablet|iPod/i.test(navigator.userAgent) ||
    window.matchMedia("(max-width: 1024px)").matches;

  if (!isMobileOrTablet) return;

  // ✅ Hide only register & chat sections
  const hideTargets = ["#section-register", "#section-chat",".shopify-section-group-header-group",".wrapper-footer"];
  hideTargets.forEach(selector => {
    const el = document.querySelector(selector);
    if (el) el.style.setProperty("display", "none", "important");
  });

  // ✅ Show and style preloader
  const preloader = document.querySelector(".preloader");
  if (!preloader) return;

  preloader.style.setProperty("display", "flex", "important");
  preloader.style.flexDirection = "column";
  preloader.style.justifyContent = "center";
  preloader.style.alignItems = "center";
  preloader.style.height = "100vh";
  preloader.style.textAlign = "center";
  preloader.style.background = "#fff";
  preloader.style.zIndex = "9999";

  // ✅ Hide existing loading text
  const oldText = preloader.querySelector(".loading-text");
  if (oldText) {
    oldText.textContent = "Our AI Assistant is available on desktop for now — the mobile experience is on its way! Stay tuned for the full launch soon.";
  }

  // ✅ Redirect to home after 2 seconds
  setTimeout(() => {
    window.location.href = "/";
  }, 5000);
}

document.addEventListener("DOMContentLoaded", handleMobileRedirect);


// pass user events start
function sendUserFeedback($btn, actionType, extraData = {}) {
  const userId = Number(localStorage.getItem('user_id'));
  const assistantId = Number(localStorage.getItem('session_id'));

  if (!userId || !assistantId) {
    console.warn('⚠️ Missing user_id or session_id, skipping feedback.');
    return;
  }

  // 🧠 Build payload and merge in extra data (like size, colour, etc.)
  const payload = {
    user_id: userId,
    assistant_id: assistantId,
    type: actionType,
    data: {
      product_id: $btn.attr('data-product-id') || '',
      product_name: $btn.attr('data-product-name') || '',
      product_price: $btn.attr('data-product-price') || '',
      ...extraData
    }
  };

  console.log(`📤 Sending "${actionType}" feedback:`, payload);
  const token = getAiToken();


  $.ajax({
    url: 'https://ai.mygoddiva.com/feedback/store',
    method: 'POST',
    contentType: 'application/json',
    headers: token ? { "Authorization": "Bearer " + token } : {},
    data: JSON.stringify(payload),
    success: function (res) {
      console.log(`✅ Feedback recorded for ${actionType}:`, res);
    },
    error: function (err) {
      console.error(`❌ Error sending ${actionType} feedback:`, err);
    }
  });
}

$(document).on('click', '.chat-find-similar-item', function () {
  sendUserFeedback($(this), 'find_similar');
});

// pass user events ends

// crazy egg on load starts

(function () {
  window.CE_API = window.CE_API || [];

  // Generate a random Visitor ID (20-character alphanumeric)
  function generateVisitorId() {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let randomId = '';
    for (let i = 0; i < 20; i++) {
      randomId += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return 'DudeAIVisitor #' + randomId;
  }

  // Use existing ID or create a new one and store it in localStorage
  let visitorId = localStorage.getItem('ce_visitor_id');
  if (!visitorId) {
    visitorId = generateVisitorId();
    localStorage.setItem('ce_visitor_id', visitorId);
  }

  // Identify visitor in Crazy Egg
  window.CE_API.push(function () {
    try {
      if (typeof CE2 !== 'undefined') {
        CE2.identify(visitorId);
        console.log('Crazy Egg identified (persistent):', visitorId);
      } else {
        console.warn('Crazy Egg CE2 not yet loaded; will identify when ready.');
      }
    } catch (e) {
      console.error('Crazy Egg identify error:', e);
    }
  });
})();


// crazy egg on loas ends


// AI Guide start here

function initAIGuideBox() {
  const $guideBox = $('#aiGuideBox');
  const $closeBtn = $guideBox.find('.ai-guide-close-span');
  const $aiGuideOpen = $('#aiGuideOpen');

  if (localStorage.getItem('ai-guide-close')) {
    $guideBox.hide();
  }
  $closeBtn.off('click').on('click', function() {
    $guideBox.fadeOut(200);
    localStorage.setItem('ai-guide-close', 'true');
  });
  $aiGuideOpen.off('click').on('click', function() {
    $guideBox.fadeIn(200);
  });
}

initAIGuideBox();

$(window).on('load scroll', function() {
  if (window.scrollY === 0) {
    $('#chat_form').removeClass('sticky-form');
  } 
});



// AI Guide ends here

// retry button start here

function showRetryButtonInMessage(messageText, retryFn, args) {
  const $chatMessage = $(`
    <div class="user-message error">
      <div class="user-logo">${getUserInitials()}</div>
      <div class="user-text user-text-retry">
        <span class="retry-message">${messageText}</span>
        <button type="button" class="retry-button" title="Retry">
          <svg width="50px" height="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><path d="M25 38c-7.2 0-13-5.8-13-13 0-3.2 1.2-6.2 3.3-8.6l1.5 1.3C15 19.7 14 22.3 14 25c0 6.1 4.9 11 11 11 1.6 0 3.1-.3 4.6-1l.8 1.8c-1.7.8-3.5 1.2-5.4 1.2z"></path><path d="M34.7 33.7l-1.5-1.3c1.8-2 2.8-4.6 2.8-7.3 0-6.1-4.9-11-11-11-1.6 0-3.1.3-4.6 1l-.8-1.8c1.7-.8 3.5-1.2 5.4-1.2 7.2 0 13 5.8 13 13 0 3.1-1.2 6.2-3.3 8.6z"></path><path d="M18 24h-2v-6h-6v-2h8z"></path><path d="M40 34h-8v-8h2v6h6z"></path></svg>
        </button>
      </div>
    </div>
  `);

  $('#chat_message').append($chatMessage);
  //scrollToBottom();

  $chatMessage.find('.retry-button').on('click', function () {
    $(this).prop('disabled', true).addClass('spinning');
    retryFn(...args);
    $(this).fadeOut(200, function () { $(this).remove(); });
  });
}

// retry button ends here


async function sendRegisteredEvent() {
  if (!window.customerLoggedIn) return;

  if (localStorage.getItem("user_id")) return;

  $("#prompt_suggestion").empty();

  const payload = {
    customer_id: window.customerId
  };

  const storedProduct = sessionStorage.getItem("lastProductId");
  if (storedProduct) {
    payload.product_id = storedProduct;
  }

  try {
    const res = await fetch("https://ai.mygoddiva.com/is_shopify_user_registered", {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(payload)
    });

    if (res.status === 404) return;
    if (!res.ok) return;

    const response = await res.json();

    // ✅ Store values exactly as API gives
    localStorage.setItem('session_id', response.session_id);
    localStorage.setItem('user_id', response.user.id);
    localStorage.setItem('user_email',window.customerEmail);
    localStorage.setItem('user_name', window.customerName);

    

    $('#span_user_name').text(window.customerName);

    updateUserInitials();
    

    if (response.token) {
      localStorage.setItem("ai_access_token", response.token.access);
      localStorage.setItem("ai_refresh_token", response.token.refresh);
    }
    window.skipInitialChatLoad = true;
    
    $('#section-register').hide();
    $('#section-chat').show();
    
    setTimeout(function() {
      console.log("HIDING PRELOADER");
       $('.preloader').hide();
    }, 5000);

    promptHandel(response.prompts);
    //renderPromptsRegisteredEvent(response.prompts);
    renderUserSizesRegisteredEvent(response)
     //init_page();
    

  } catch (err) {
    // Silent fail
  }
}
$(document).ready(function() {
sendRegisteredEvent();
});

function renderPromptsRegisteredEvent(prompts = []) {
  const container = document.getElementById("prompt_suggestion");
  if (!container) return;

  container.innerHTML = "";

  let inquiryHTML = "";
  let similarHTML = "";
  let suggestionHTML = "";

  prompts.forEach(value => {
    const type = value.type || {};
    const isObj = typeof type === "object";
    const typeName = isObj ? (type.name || '') : type;
    const isReset = isObj && 'is_reset' in type ? type.is_reset : null;
    const action = isObj && 'action' in type ? type.action : null;
    const condition = isObj && 'condition' in type ? type.condition : null;

    let attrs = `data-id="${value.id || ''}" data-message="${(value.message || '').replace(/"/g, '&quot;')}"`;

    if (isObj) {
      if (typeName) attrs += ` data-type="${typeName}"`;
      if (isReset !== null) attrs += ` data-is-reset="${isReset}"`;
      if (action !== null) attrs += ` data-action="${action}"`;
      if (condition !== null) attrs += ` data-condition="${condition}"`;
    } else if (type) {
      attrs += ` data-filter="${type}"`;
    }

    const btnClass = value.message.toLowerCase().replace(/\s+/g, '-');

    const html =
      (type === "filter" || typeName === "filter" || attrs.includes('data-filter="filter"'))
        ? `<button class="prompt-btn is-registered-btn ${btnClass}" ${attrs}>
             ${value.message}<span class="data-filter-chev">${aiPageGetChevronSVG()}</span>
           </button>`
        : `<button class="prompt-btn is-registered-btn ${btnClass}" ${attrs}>
             ${value.message}
           </button>`;

    // ✅ group
    if (typeName === "specific_product_inquiry") {
      inquiryHTML += html;
    } else if (typeName === "similar_product_request") {
      similarHTML += html;
    } else if (typeName === "product_suggestion_request") {
      suggestionHTML += html;
    }
  });

  if (inquiryHTML) {
    container.innerHTML += `
      <div class="specific-product-inquiry-section">
        <p class="specific-product-heading"><strong>Product details you may want to know</strong></p>
        <div class="prompt-btn-wrapper specific-product-inquiry-wrapper">
          ${inquiryHTML}
        </div>
      </div>`;
  }

  if (similarHTML) {
    container.innerHTML += `
      <div class="similar-product-request-section">
        <p class="similar-product-heading"><strong>Explore similar styles</strong></p>
        <div class="prompt-btn-wrapper similar-product-request-wrapper">
          ${similarHTML}
        </div>
      </div>`;
  }

  if (suggestionHTML) {
    container.innerHTML += `
      <div class="product-suggestion-request-section">
        <p class="product-suggestion-heading"><strong>Recommended for you</strong></p>
        <div class="prompt-btn-wrapper product-suggestion-request-wrapper">
          ${suggestionHTML}
        </div>
      </div>`;
  }
}


function renderUserSizesRegisteredEvent(response) {
  $('#your-sizes').empty();

  if (!response?.user?.size) return;

  const ukIds = $('.chat-register-new-size-checkbox').map(function () {
    return Number($(this).data('id'));
  }).get();

  const uniqueUkSizes = response.user.size.filter(
    item => ukIds.includes(item.id) && item.name.toLowerCase() !== 'onesize'
  );

  let sizesHtml = '';

  if (uniqueUkSizes.length > 1) {
    const remainingCount = uniqueUkSizes.length - 1;

    const allSizes = uniqueUkSizes
      .map((item, index) => {
        const hiddenClass = index > 0 ? 'hidden-size' : '';
        return `
          <li class="your-size-btn ${hiddenClass}" data-id="${item.id}">
            ${item.name.trim()}
          </li>
        `;
      })
      .join('');

    sizesHtml = `
      ${allSizes}
      <li class="your-size-btn your-size-more">+ ${remainingCount} more</li>
    `;

  } else if (uniqueUkSizes.length === 1) {
    const onlySize = uniqueUkSizes[0];
    sizesHtml = `
      <li class="your-size-btn" data-id="${onlySize.id}">
        ${onlySize.name.trim()}
      </li>
    `;
  }

  $('#your-sizes').html(sizesHtml);
}

// window.addEventListener('scroll', function() {
//   const header = document.querySelector('.chat-header');

//   if (window.scrollY > 50) {
//     header.classList.add('chat-sticky-header');
//   } else {
//     header.classList.remove('chat-sticky-header');
//   }
// });


// window.userEmailwws = null;

// const allowedEmails = [
//   'yathu@citygoddess.co.uk',
//   'methan@akhitsolutions.com'
// ];

// function updateTopBarVisibility() {
//   const email = localStorage.getItem('user_email');

//   if (!email) return;

//   window.userEmailwws = email.toLowerCase();
//   if (allowedEmails.includes(window.userEmailwws)) {
   
//   } else {
//      $('#top-bar').attr('style', 'display: none !important;');
//   }
// }

// setInterval(updateTopBarVisibility, 500);

// updateTopBarVisibility();




/****
 ========================================================================
**Return Portal
 ========================================================================
 ***/

  baseEndPointToSubmitAiPage = 'https://mpin.mygoddiva.com';

 function aiPageRenderLineItems(items, lineItemsData) {
  if (!items || !items.length) return '';

  const panelId    = `ai-page-liPanel_${Date.now()}`;
  const returnFee  = parseFloat(lineItemsData.return_fee) || 0;
  const isVip      = lineItemsData.is_vip_customer        ? '1' : '0';
  const isSelfShip = lineItemsData.is_self_ship_available ? '1' : '0';
  const partnerId  = lineItemsData.partner_id || 1;

  const freePartners = [5, 7, 11, 17, 27];
  const effectiveFee = (lineItemsData.is_vip_customer || freePartners.includes(partnerId))
    ? '0.00'
    : returnFee.toFixed(2);

//   const cards = items.map((item, index) =>
//     aiPageBuildLineItemCard(item, index, lineItemsData)
//   ).join('');

    const cards = items.map((item, index) =>
    aiPageBuildLineItemCard(item, index, lineItemsData, panelId)
    ).join('');

    const lastReturnItems = JSON.stringify(lineItemsData.last_return_items || []);


  return `
    <div class="ai-page-li-panel"
         id="${panelId}"
         data-last-return-items='${aiPageEscHtml(lastReturnItems)}'
         data-last-pending-fees-items='${aiPageEscHtml(JSON.stringify(lineItemsData.last_pending_fees_items || []))}'
         data-original-query="${aiPageEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}"
         data-marketplace-id="${lineItemsData.partner_id || ''}"
         data-shipping-code="${lineItemsData.shipping_country_code || ''}"
         data-search-type="${lineItemsData.search_type || ''}"
         data-search-value="${lineItemsData.search_value || ''}"
         data-return-fee="${effectiveFee}"
         data-is-vip="${isVip}"
         data-is-self-ship="${isSelfShip}"
         data-partner-id="${partnerId}">

      <div class="ai-page-li-sticky-top">
        <span><strong>Select Items:</strong> Choose the products you'd like to return and specify your reason</span>
      </div>

      <div class="ai-page-li-select-all-bar">
        <label class="ai-page-li-select-all-label">
          <input type="checkbox"
                 class="ai-page-li-checkbox ai-page-li-select-all-chk"
                 onchange="aiPageToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="ai-page-li-selected-count">0 items selected</span>
      </div>

      <div class="ai-page-li-grid">
        ${cards}
        ${aiPageRenderNonReturnableItems(lineItemsData)}
      </div>

      <!-- Summary — hidden until at least one return option selected -->
      <div class="ai-page-li-summary" style="display:none;">
        <div class="ai-page-li-summary-title">Summary</div>
        <table class="ai-page-li-summary-table">
          <tbody>
            <tr class="ai-page-li-sum-store-credit" style="display:none;">
              <td>Total Store Credit:</td>
              <td>£<span class="ai-page-li-sum-sc-val">0.00</span></td>
            </tr>
            <tr class="ai-page-li-sum-refund" style="display:none;">
              <td>Total Refund:</td>
              <td>£<span class="ai-page-li-sum-ref-val">0.00</span></td>
            </tr>
            <tr class="ai-page-li-sum-return-label" style="display:none;">
              <td>Total Return Fee:</td>
              <td>£<span class="ai-page-li-sum-fee-val">0.00</span></td>
            </tr>
            <tr class="ai-page-li-sum-self-ship" style="display:none;">
              <td>Total Self Ship Qty:</td>
              <td><span class="ai-page-li-sum-ss-val">0</span></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="ai-page-li-sticky-bottom">
        <!-- Add to previous label — hidden until relevant -->
        <div class="ai-page-li-addtoprev-wrapper"
            id="ai-page-addtoprev_${panelId}"
            style="display:none;padding:10px 16px;background:#fff8e1;border-top:1px solid #ffe082;font-size:11px;">
        <p class="ai-page-li-addtoprev-content" style="margin:0 0 8px;color:#374151;line-height:1.5;"></p>
        <div class="ai-page-li-addtoprev-radios" style="display:flex;gap:16px;margin-bottom:6px;">
            <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
            <input type="radio"
                    class="ai-page-li-addtoprev-radio"
                    name="ai-page-addtoprev_${panelId}"
                    value="yes"
                    onchange="aiPageAddToPrevChange(this)" />
            Yes
            </label>
            <label style="display:flex;align-items:center;gap:6px;cursor:pointer;">
            <input type="radio"
                    class="ai-page-li-addtoprev-radio"
                    name="ai-page-addtoprev_${panelId}"
                    value="no"
                    onchange="aiPageAddToPrevChange(this)" />
            No
            </label>
        </div>
        <p class="ai-page-li-addtoprev-error"
            style="display:none;color:#e74c3c;font-size:11px;margin:4px 0 0;">
            Please choose Yes or No.
        </p>
        </div>
        <!-- Terms & Conditions -->
        <div class="ai-page-li-terms-wrapper" id="ai-page-terms_${panelId}" style="display:none;">
            <label class="ai-page-li-terms-label">
            <input type="checkbox"
                    class="ai-page-li-terms-chk"
                    id="ai-page-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
            </label>
            <p class="ai-page-li-terms-error"
            id="ai-page-terms-err_${panelId}"
            style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;">
            Please accept the terms and conditions.
            </p>
        </div>

        <button class="ai-page-li-process-btn" disabled onclick="aiPageHandleProcessReturn(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          PROCESS RETURN
        </button>
      </div>

    </div>

    <!-- Image preview popup — one per panel -->
    <div id="ai-page-img-popup_${panelId}"
         class="ai-page-img-popup" hidden>
      <div class="ai-page-img-popup-overlay"
           onclick="aiPageFaultyPopupClose('${panelId}')"></div>
      
      <div class="ai-page-img-popup-box">
        <button class="ai-page-img-popup-close"
            onclick="aiPageFaultyPopupClose('${panelId}')">✕</button>
        <button class="ai-page-img-popup-nav ai-page-img-popup-prev"
                onclick="aiPageFaultyPopupNav('${panelId}', -1)">&#8249;</button>
        <div class="ai-page-img-popup-img-wrap">
          <img id="ai-page-img-popup-img_${panelId}" src="" alt="" />
        </div>
        <button class="ai-page-img-popup-nav ai-page-img-popup-next"
                onclick="aiPageFaultyPopupNav('${panelId}', 1)">&#8250;</button>
        <div class="ai-page-img-popup-counter"
             id="ai-page-img-popup-counter_${panelId}"></div>
      </div>
    </div>

    <!-- Payment popup — one per panel -->
    <div id="ai-page-pay-popup_${panelId}"
        class="ai-page-pay-popup" hidden>
    <div class="ai-page-pay-overlay"></div>
    <div class="ai-page-pay-box">
        <button class="ai-page-pay-close"
                onclick="aiPagePayPopupClose('${panelId}')">✕</button>
        <div id="ai-page-pay-content_${panelId}">
        <!-- Injected by aiPageShowPaymentPopup() -->
        </div>
    </div>
    </div>

    <!-- Too Big / Too Long popup — one per panel, Goddiva + partner 1 only -->
    <div id="ai-page-tbtl-popup_${panelId}"
         class="ai-page-tbtl-popup" hidden>
      <div class="ai-page-tbtl-overlay"
           onclick="aiPageTbtlClose('${panelId}')"></div>
      <div class="ai-page-tbtl-box">
        <p style="font-size:12px;margin:0 0 12px;line-height:1.5;">
          Did you know you can have your dress altered to the perfect length?
          <a href="https://goddiva.co.uk/pages/alterations" target="_blank" style="color:#ff8080;">
            Learn About Alterations
          </a>
        </p>
        <button class="ai-page-li-process-btn ai-page-li-process-active"
                style="width:100%;margin-top:4px;"
                onclick="aiPageTbtlClose('${panelId}')">
          Continue with Return
        </button>
      </div>
    </div>

  `;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE CARD
// ─────────────────────────────────────────────────────────────
function aiPageBuildLineItemCard(item, index, lineItemsData, panelId) {
  const uid    = `li_${panelId}_${item.id}_${index}`;
  const maxQty = item.availableQty || item.quantity || 1;

  // Price — mirrors portal: price !== gross_price → strikethrough + red
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
    : `<div class="ai-page-li-img-placeholder">G</div>`;

  const size  = item.size  || '—';
  const color = item.color || '—';

  // Reason options
  const reasons    = lineItemsData.reasons || [];
  const reasonOpts = reasons.map(r =>
    `<option value="${r.id}"
             data-name="${aiPageEscHtml(r.name)}"
             data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
             data-is-refund="${r.is_refund ? '1' : '0'}"
             data-faulty="${r.name.toLowerCase() === 'faulty' ? '1' : '0'}"
     >${aiPageEscHtml(r.name)}</option>`
  ).join('');

  // ── All condition flags ───────────────────────────────────
  const isActivePeriod     = lineItemsData.is_active_date == 1;
  const isGiftBagName      = item.name === 'Heart Shaped Foil Shopper Bag - Rose Gold';
  const isGiftBag          = isGiftBagName && !!item.is_gift_bag;    // needs other items checked to enable
  const isNonReturnableBag = isGiftBagName && !item.is_gift_bag;     // completely non-returnable
  const isOutlet           = !!item.is_outlet;
  const isMystery          = !!item.is_mystery;
  const isHygieneSeller    = item.seller_id == 60;
  const isDisabled         = !!item.non_returnable;
  const outletNonPartner1  = isOutlet && lineItemsData.partner_id != 1;
  const isCanReturn        = !!item.can_return;

  // Checkbox disabled when any blocking condition is true
  // Outlet partner-1 checkbox starts disabled too — enabled by Yes radio
  const checkboxDisabled =
    isDisabled         ||   // non_returnable flag
    isGiftBag          ||   // gift bag — enabled when other items checked
    isNonReturnableBag ||   // gift bag name but is_gift_bag = false
    isMystery          ||   // mystery box
    isHygieneSeller    ||   // seller 60 hygiene items
    outletNonPartner1  ||   // outlet but not partner 1
    !isActivePeriod    ||   // return period passed
    !isCanReturn;           // can_return = 0

  // Show the interactive form (reason/qty/options)?
  // Only when: period active + not any blocking non-form condition
  const showForm =
    isActivePeriod    &&
    !isDisabled       &&
    !isNonReturnableBag &&
    !isMystery        &&
    !isHygieneSeller  &&
    !outletNonPartner1 &&
    isCanReturn;

  // Badges
  const outletBadge    = isOutlet
    ? `<div class="ai-page-li-badge ai-page-li-badge-outlet">Outlet</div>` : '';
  const gradeBadge     = item.grade
    ? `<div class="ai-page-li-badge ai-page-li-badge-grade">Grade ${item.grade}</div>` : '';
  const nonReturnBadge = item.non_returnable
    ? `<div class="ai-page-li-badge ai-page-li-badge-warn">Non-returnable</div>` : '';
  const giftBagBadge   = isGiftBag
    ? `<div class="ai-page-li-badge ai-page-li-badge-gift">Promotional Bag</div>` : '';
  const mysteryBadge   = isMystery
    ? `<div class="ai-page-li-badge ai-page-li-badge-warn">Mystery Box</div>` : '';

  // Card CSS classes
  const cardClasses = [
    'ai-page-li-card',
    (isDisabled || isNonReturnableBag || isMystery || isHygieneSeller || outletNonPartner1 || !isActivePeriod || !isCanReturn)
      ? 'ai-page-li-card-disabled' : '',
    isGiftBag          ? 'ai-page-li-gift-bag-card' : '',
    isOutlet           ? 'ai-page-li-outlet-card'   : '',
  ].filter(Boolean).join(' ');

  return `
    <div class="${cardClasses}"
         id="ai-page-card_${uid}"
         data-brand-id="${item.brand_id || ''}"
         data-brand="${aiPageEscHtml(item.brand || '')}"
         data-is-gift-bag="${isGiftBag ? '1' : '0'}"
         data-is-outlet="${isOutlet ? '1' : '0'}"
         data-max-qty="${maxQty}"
         data-item-id="${item.id}"
         data-sku="${aiPageEscHtml(item.sku || '')}"
         data-name="${aiPageEscHtml(item.name || '')}"
         data-grade="${aiPageEscHtml(item.grade || '')}"
         data-is-goddiva="${item.is_goddiva ? '1' : '0'}"
         data-store-credit-amount="${item.store_credit_single_amount || 0}"
         data-refund-amount="${item.refund_single_amount || 0}"
         data-store-credit-pct="${item.store_credit_percentage || 0}"
         data-refund-pct="${item.refund_percentage || 0}">

      <input type="checkbox"
             class="ai-page-li-checkbox"
             id="ai-page-chk_${uid}"
             data-uid="${uid}"
             ${(checkboxDisabled) ? 'disabled' : ''}
             onchange="aiPageOnCheckboxChange(this)" />

      <div class="ai-page-li-img-wrap">
        <div class="ai-page-li-img">${imgHtml}</div>
        <div class="ai-page-li-badges">${outletBadge}${gradeBadge}${mysteryBadge}${giftBagBadge}${nonReturnBadge}</div>
      </div>

      <div class="ai-page-li-body">

        <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
        <div class="ai-page-li-price">${priceHtml}</div>



        <!-- ── View Details — always visible ──────────────── -->
        <button class="ai-page-li-view-details-btn"
                type="button"
                onclick="aiPageToggleDetails(this, 'ai-page-det_${uid}')">
          ${aiPageInfoIcon()}
          View Details
          <span class="ai-page-li-chevron">▾</span>
        </button>

        <div id="ai-page-det_${uid}" class="ai-page-li-detail-panel" hidden>
          <div class="ai-page-li-detail-grid">
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Size</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(size)}</div>
            </div>
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Colour</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(color)}</div>
            </div>
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">SKU</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(item.sku)}</div>
            </div>
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Qty</div>
              <div class="ai-page-li-dv">${item.quantity}</div>
            </div>
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Brand</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div>
            </div>
            ${item.tracking_name ? `
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Tracking Company</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)}</div>
            </div>` : ''}
            ${item.tracking_id ? `
            <div class="ai-page-li-dc">
              <div class="ai-page-li-dl">Tracking ID</div>
              <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_id)}</div>
            </div>` : ''}
          </div>
        </div>

        <!-- ── Status messages — only one will show ───────── -->

        ${!isActivePeriod ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The return period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
            for more information.
          </p>
        ` : ''}

        ${isActivePeriod && !isCanReturn ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for return.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product and as per our return policy, Mystery Box items are non-returnable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && isHygieneSeller ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            For hygiene reasons, we are unable to accept returns on beauty products, ranging from
            pierced jewellery, make-up, skin care, fragrances, hair products and anything that can
            be applied to the skin or body. In addition, we will be unable to accept returns on
            face masks, lingerie &amp; swimwear.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && isNonReturnableBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            Please note: This item is non returnable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && !isNonReturnableBag && isGiftBag ? `
          <p class="ai-page-li-gift-bag-msg" style="color:#d00;font-size:11px;margin:4px 0;">
            The promotional bag can't be returned on its own. It may only be returned if other items
            from the order are also returned.
          </p>
        ` : ''}

        ${isActivePeriod && isCanReturn && !isMystery && !isHygieneSeller && !isNonReturnableBag && outletNonPartner1 ? `
          <p style="font-size:11px;margin:4px 0;">
            Please note: All outlet items are final sale and cannot be exchanged. These are reduced,
            end-of-line or seasonal products and are not eligible for refunds or exchanges.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        <!-- ── Outlet policy (partner 1 only) ─────────────── -->
       ${isActivePeriod && isCanReturn && isOutlet && !outletNonPartner1 ? `
        <div class="ai-page-li-outlet-policy">
          <!-- Accordion — collapsed by default -->
          <button class="ai-page-li-outlet-acc-header" type="button"
                  onclick="this.classList.toggle('open');this.nextElementSibling.hidden=!this.nextElementSibling.hidden;">
            More Information
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div class="ai-page-li-outlet-acc-body" hidden>
            <p><strong>Please note that outlet items are final sale and not eligible for a full refund,</strong>
              as they are end-of-line or seasonal stock.</p>
            <p>However, as a gesture of goodwill, we can offer a 60% refund in the form of a gift card
              if the item is returned and passes our quality checks. Kindly note:</p>
            <ul style="margin:4px 0 8px 16px;font-size:11px;">
              <li>A small fee applies for the return label.
                <strong>(Returns are free for Goddiva Unlimited subscribers)</strong></li>
              <li>If the item does not meet return conditions, it will be sent back and no refund issued.</li>
            </ul>
            <p>Thank you for your understanding.</p>
          </div>

          <!-- Always visible -->
          <div class="ai-page-li-outlet-confirm">
            <label>
              <input type="radio"
                    class="ai-page-li-outlet-radio"
                    name="ai-page-outlet_${uid}"
                    value="yes"
                    data-uid="${uid}"
                    onchange="aiPageOutletRadioChange(this)" />
              <strong>Yes</strong> – I want to return the item
            </label>
            <label>
              <input type="radio"
                    class="ai-page-li-outlet-radio"
                    name="ai-page-outlet_${uid}"
                    value="no"
                    data-uid="${uid}"
                    onchange="aiPageOutletRadioChange(this)" />
              <strong>No</strong> – I do not want to return it
            </label>
          </div>
        </div>
      ` : ''}


        <!-- ── Interactive form — only when showForm is true ─ -->
        ${showForm ? `

          <!-- Reason + Quantity
               gift bag: hidden until another item checked
               outlet p1: hidden until Yes selected
               normal: always visible -->
          <div class="ai-page-li-row${isGiftBag ? ' ai-page-li-gift-bag-row' : ''}${isOutlet ? ' ai-page-li-outlet-row' : ''}"
               ${isOutlet ? 'style="display:none;"' : ''}>
            <div class="ai-page-li-reason-wrap">
              <label class="ai-page-li-label">
                Return Reason <span class="ai-page-li-req">*</span>
              </label>
              <select class="ai-page-li-reason"
                      data-uid="${uid}"
                      ${(isGiftBag || isOutlet) ? 'disabled' : ''}
                      onchange="aiPageOnReasonChange(this)">
                <option value="">Select a reason…</option>
                ${reasonOpts}
              </select>
              <textarea class="ai-page-li-specific-reason"
                        id="ai-page-specificReason_${uid}"
                        data-uid="${uid}"
                        placeholder="Please describe your reason…"
                        maxlength="150"
                        style="display:none;margin-top:6px;width:100%;font-size:11px;
                               padding:6px;border:1px solid #d1d5db;border-radius:6px;resize:vertical;"
                        oninput="aiPageAutoCheck('${uid}')"></textarea>
              <span class="ai-page-li-error-msg"
                    id="ai-page-specificReasonErr_${uid}"
                    hidden>Please describe your reason</span>
            </div>
            <div>
              <label class="ai-page-li-label">Quantity</label>
              <div class="ai-page-li-stepper">
                <button type="button" onclick="aiPageChangeQty(this, -1, '${uid}')" ${maxQty <= 1 ? 'disabled' : ''}>−</button>
                <div class="ai-page-li-qty">1</div>
                <button type="button" onclick="aiPageChangeQty(this, +1, '${uid}')" ${maxQty <= 1 ? 'disabled' : ''}>+</button>
              </div>
            </div>
          </div>

          <!-- Faulty upload — shown only when reason = Faulty AND option = return_label -->
          <div id="ai-page-flt_${uid}" class="ai-page-li-faulty-upload" hidden>
            <div class="ai-page-li-faulty-label">
              📷 Upload Photos
              <span class="ai-page-li-faulty-optional">
                (Optional — min. 3 if uploading, max 3, each up to 5MB)
              </span>
            </div>
            <label class="ai-page-li-upload-btn" for="ai-page-fltInput_${uid}">
              Choose Images
              <input type="file"
                     id="ai-page-fltInput_${uid}"
                     class="ai-page-li-file-input"
                     accept="image/*"
                     multiple
                     data-uid="${uid}"
                     onchange="aiPageFaultyImagesAdded(this)" />
            </label>
            <p class="ai-page-li-faulty-description">
              If you upload images of the fault, our team will review them. If approved, your return
              postage will be free, otherwise we'll deduct the postage fee from your refund amount.
            </p>
            <span class="ai-page-li-warn-msg" id="ai-page-fltWarn_${uid}" hidden></span>
            <div id="ai-page-fltPreviews_${uid}" class="ai-page-li-faulty-previews"></div>
            <span class="ai-page-li-error-msg" id="ai-page-fltErr_${uid}" hidden>
              Please upload at least 3 images
            </span>
          </div>

          <!-- Return options — hidden until reason chosen, built dynamically -->
          <div id="ai-page-opts_${uid}" class="ai-page-li-opts" hidden>
            <div class="ai-page-li-opts-label">
              Return Options <span class="ai-page-li-req">*</span>
            </div>
            <div class="ai-page-li-opts-cards"></div>
            <p class="ai-page-li-opt-description"
               id="ai-page-optDesc_${uid}"
               style="font-size:10px;font-weight:600;padding:4px 0 0;margin:0;"></p>
            <span class="ai-page-li-error-msg" id="ai-page-optErr_${uid}" hidden>
              Please select a return option
            </span>
          </div>

        ` : ''}

      </div><!-- /.ai-page-li-body -->
    </div><!-- /.ai-page-li-card -->
  `;
}

// ─────────────────────────────────────────────────────────────
// REASONS STORE — keyed by panel id
// ─────────────────────────────────────────────────────────────

const _aiPagePanelReasons = {};

function aiPageSetPanelReasons(panel, reasons) {
  if (panel && panel.id) _aiPagePanelReasons[panel.id] = reasons;
}

function aiPageGetPanelReasons(panel) {
  return (panel && _aiPagePanelReasons[panel.id]) || [];
}


// ─────────────────────────────────────────────────────────────
// GIFT BAG LOGIC — mirrors portal Heart Shaped Foil Shopper Bag logic
// ─────────────────────────────────────────────────────────────

const AI_PAGE_GIFT_BAG_REASON_IDS = ['9', '10'];

function aiPageUpdateGiftBag(panel) {
  if (!panel) return;

  const giftBagCards = panel.querySelectorAll('.ai-page-li-card[data-is-gift-bag="1"]');
  if (!giftBagCards.length) return;

  // Any non-gift-bag checkbox checked?
  const anyOtherChecked = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk)'
  )].some(chk => {
    const card = chk.closest('.ai-page-li-card');
    return card && card.dataset.isGiftBag !== '1' && chk.checked;
  });

  const reasons = aiPageGetPanelReasons(panel);

  giftBagCards.forEach(card => {
    const chk       = card.querySelector('.ai-page-li-checkbox');
    const reasonSel = card.querySelector('.ai-page-li-reason');
    const msgEl     = card.querySelector('.ai-page-li-gift-bag-msg');
    const rowEl     = card.querySelector('.ai-page-li-gift-bag-row');
    if (!chk) return;
    if (anyOtherChecked) {
        // Enable the gift bag card
        chk.disabled = false;
        card.classList.add('ai-page-li-gift-bag-enabled');
        if (msgEl) msgEl.style.display = 'none';
        if (rowEl) rowEl.style.display = 'flex';

        if (reasonSel) {
            reasonSel.disabled = false;
            aiPageRebuildGiftBagReason(reasonSel, reasons); // ← keep only this one
        }

    } else {
        if (chk.checked) {
            chk.checked = false;
            aiPageResetCard(chk.dataset.uid);
        }
        chk.disabled = true;
        card.classList.remove('ai-page-li-gift-bag-enabled');
        if (msgEl) msgEl.style.display = '';
        if (rowEl) rowEl.style.display = 'none';

        if (reasonSel) {
            reasonSel.disabled = true;
            aiPageRestoreFullReason(reasonSel, reasons);
        }
    }

  });

  // Refresh summary and count after gift bag state changes
  aiPageUpdateCount(panel);
  aiPageToggleSummary(panel);
}


function aiPageRebuildGiftBagReason(selectEl, reasons) {
  if (!selectEl) return;
  const currentValue = selectEl.value;

  let options = '<option value="">Select a reason…</option>';
  reasons.forEach(r => {
    if (AI_PAGE_GIFT_BAG_REASON_IDS.includes(String(r.id))) {
      options += `<option value="${r.id}"
                           data-name="${aiPageEscHtml(r.name)}"
                           data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
                           data-is-refund="${r.is_refund ? '1' : '0'}"
                           data-faulty="0"
                  >${aiPageEscHtml(r.name)}</option>`;
    }
  });
  selectEl.innerHTML = options;

  // Keep previous selection if it's still allowed
  if (currentValue && AI_PAGE_GIFT_BAG_REASON_IDS.includes(currentValue)) {
    selectEl.value = currentValue;
  } else {
    selectEl.value = '';
  }
}

function aiPageRestoreFullReason(selectEl, reasons) {
  if (!selectEl) return;
  let options = '<option value="">Select a reason…</option>';
  reasons.forEach(r => {
    options += `<option value="${r.id}"
                         data-name="${aiPageEscHtml(r.name)}"
                         data-is-store-credit="${r.is_store_credit ? '1' : '0'}"
                         data-is-refund="${r.is_refund ? '1' : '0'}"
                         data-faulty="${r.name.toLowerCase() === 'faulty' ? '1' : '0'}"
                >${aiPageEscHtml(r.name)}</option>`;
  });
  selectEl.innerHTML = options;
  selectEl.value = '';
}




function aiPageCheckAddToPrev(panel) {
  const wrapper = panel.querySelector('.ai-page-li-addtoprev-wrapper');
  if (!wrapper) return;

  // Get both stored arrays from panel data attributes
  let lastReturnItems = [];
  try { lastReturnItems = JSON.parse(panel.dataset.lastReturnItems || '[]'); } catch(e) { lastReturnItems = []; }

  let lastPendingFeesItems = [];
  try { lastPendingFeesItems = JSON.parse(panel.dataset.lastPendingFeesItems || '[]'); } catch(e) { lastPendingFeesItems = []; }

  // Three categories — mirrors portal toggleSummary() exactly
  const addWithPreviousLabelBrands = []; // complete_label brands within 48h
  const pendingFeeBrands           = []; // pending_label brands (fee not yet paid)
  const newLabelFeeBrands          = []; // brands with no prior label at all

  panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
  ).forEach(chk => {
    const card   = document.getElementById(`ai-page-card_${chk.dataset.uid}`);
    if (!card) return;

    const optVal = card.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected')?.dataset.opt;
    if (optVal !== 'return_label') return;

    const brandId = card.dataset.brandId;
    if (!brandId) return;

    // Check complete_label brands (within 48 hours) — mirrors portal lastReturnItems check
    const matchedComplete = lastReturnItems.find(item => String(item.brand_id) === String(brandId));
    if (matchedComplete) {
      const hoursDiff = Math.abs(new Date() - new Date(matchedComplete.requested_date)) / (1000 * 60 * 60);
      if (hoursDiff < 48) {
        addWithPreviousLabelBrands.push(matchedComplete);
      }
    }

    // Check pending_label brands — mirrors portal lastPendingFeesReturnItems check
    const matchedPending = lastPendingFeesItems.find(item => String(item.brand_id) === String(brandId));
    if (matchedPending) {
      pendingFeeBrands.push(matchedPending);
    }

    // If neither matched → new label fee needed — mirrors portal newLabelFeeBrands
    if (!matchedComplete && !matchedPending) {
      newLabelFeeBrands.push({ brand_id: brandId });
    }
  });

  // Store counts on wrapper so radio handler can read them — mirrors portal data attributes
  wrapper.dataset.newLabelFeeBrands          = newLabelFeeBrands.length;
  wrapper.dataset.addWithPreviousLabelBrands = addWithPreviousLabelBrands.length;
  wrapper.dataset.pendingFeeBrands           = pendingFeeBrands.length;

  // Show add-to-previous wrapper when applicable — mirrors portal show condition
  if (addWithPreviousLabelBrands.length > 0) {
    const brandNames = [...new Set(addWithPreviousLabelBrands.map(i => i.brand_name))];
    const formattedNames = brandNames.length > 1
      ? brandNames.slice(0, -1).join(', ') + ' and ' + brandNames[brandNames.length - 1]
      : brandNames[0];

    const contentEl = wrapper.querySelector('.ai-page-li-addtoprev-content');
    if (contentEl) {
      contentEl.innerHTML =
        `You recently requested returns for items from <strong>${formattedNames}</strong>.<br/>` +
        `If you haven't shipped them yet, you can use the same label for any new returns.<br/>` +
        `Have you sent the previous items?`;
    }
    wrapper.style.display = '';
  } else {
    wrapper.style.display = 'none';
    wrapper.querySelectorAll('.ai-page-li-addtoprev-radio').forEach(r => r.checked = false);
  }

  // KEY PORTAL LOGIC (lines 428-434): if all brands have pending fees and no new labels needed → fee is £0
  // Mirrors: if (refund-option checked && newLabelFeeBrands==0 && addWithPrevious==0 && pendingFee>0) → total-returns = 0.00
  const anyReturnLabelChecked = panel.querySelectorAll(
    '.ai-page-li-opt-card.ai-page-li-opt-selected[data-opt="return_label"]'
  ).length > 0;

  if (anyReturnLabelChecked &&
      newLabelFeeBrands.length    === 0 &&
      addWithPreviousLabelBrands.length === 0 &&
      pendingFeeBrands.length     > 0) {
    const feeValEl = panel.querySelector('.ai-page-li-sum-fee-val');
    const feeRow   = panel.querySelector('.ai-page-li-sum-return-label');
    if (feeValEl) feeValEl.textContent = '0.00';
    if (feeRow)   feeRow.style.display = '';
  }
}

function aiPageAddToPrevChange(radio) {
  const panel   = radio.closest('.ai-page-li-panel');
  const wrapper = radio.closest('.ai-page-li-addtoprev-wrapper');
  const feeValEl = panel.querySelector('.ai-page-li-sum-fee-val');
  const feeRow   = panel.querySelector('.ai-page-li-sum-return-label');
  const errEl    = wrapper?.querySelector('.ai-page-li-addtoprev-error');

  if (errEl) errEl.style.display = 'none';

  // Read stored counts from wrapper — mirrors portal data attributes
  const newLabelFeeBrands          = parseInt(wrapper?.dataset.newLabelFeeBrands          || '0', 10);
  const addWithPreviousLabelBrands = parseInt(wrapper?.dataset.addWithPreviousLabelBrands || '0', 10);

  if (radio.value === 'no') {
    // "No" = haven't sent yet = can add to previous label = fee is £0
    // Only zero the fee if no truly new label brands — mirrors portal click handler lines 242-250
    if (newLabelFeeBrands === 0 && addWithPreviousLabelBrands > 0) {
      if (feeValEl) feeValEl.textContent = '0.00';
      if (feeRow)   feeRow.style.display = '';
    }
  } else {
    // "Yes" = already sent = need new label = restore normal fee
    // Only restore if no new label brands — mirrors portal
    if (newLabelFeeBrands === 0 && addWithPreviousLabelBrands > 0) {
      aiPageUpdateSummary(panel);
    }
  }
}


// function aiPageRenderReturnOptions(uid, reasonId) {
//   const card      = document.getElementById(`ai-page-card_${uid}`);
//   const panel     = card?.closest('.ai-page-li-panel');
//   const optsEl    = document.getElementById(`ai-page-opts_${uid}`);
//   const cardsWrap = optsEl?.querySelector('.ai-page-li-opts-cards');
//   if (!cardsWrap || !panel || !card) return;

//   const returnFee  = parseFloat(panel.dataset.returnFee) || 0;
//   const isVip      = panel.dataset.isVip      === '1';
//   const selfShipOk = panel.dataset.isSelfShip === '1';
//   const partnerId  = parseInt(panel.dataset.partnerId, 10) || 1;

//   const grade          = (card.dataset.grade || '').toUpperCase();
//   const isOutlet       = card.dataset.isOutlet   === '1';
//   const isGoddiva      = card.dataset.isGoddiva  === '1';
//   const storeCreditAmt = parseFloat(card.dataset.storeCreditAmount) || 0;
//   const refundAmt      = parseFloat(card.dataset.refundAmount)      || 0;
//   const scPct          = parseFloat(card.dataset.storeCreditPct)    || 0;
//   const refPct         = parseFloat(card.dataset.refundPct)         || 0;

//   const freePartners = [5, 7, 11, 17, 27];
//   const isFree       = isVip || freePartners.includes(partnerId);
//   const effectiveFee = isFree ? '0.00' : returnFee.toFixed(2);

//   const reasons     = aiPageGetPanelReasons(panel);
//   const checkReason = reasons.find(r => String(r.id) === String(reasonId));

//   // Grade B or C required for keep-item options — confirmed from API (Grade_C tag = grade "C")
//   const hasGradeTag = ['B', 'C'].includes(grade);

//   let html = '';

//   // Outlet + Goddiva → Return Label only
//   if (checkReason && isGoddiva && isOutlet) {
//     html += aiPageOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
//     cardsWrap.innerHTML = html;
//     return;
//   }

//   // Goddiva + Goddiva marketplace → conditional store credit / refund
//   if (checkReason && isGoddiva && partnerId === 1) {
//     if (checkReason.is_store_credit && hasGradeTag && storeCreditAmt > 0) {
//       html += aiPageOptCardHtml(uid, 'store_credit',
//         `£${storeCreditAmt.toFixed(2)} Store Credit (Keep the item)`, '');
//     }
//     if (checkReason.is_refund && hasGradeTag && refundAmt > 0) {
//       html += aiPageOptCardHtml(uid, 'refund',
//         `£${refundAmt.toFixed(2)} Refund (Keep the item)`, '');
//     }
//   }

//   // Return Label — always shown
//   html += aiPageOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);

//   // Self Ship — only if available at order level
//   if (selfShipOk) {
//     html += aiPageOptCardHtml(uid, 'self_ship', 'Self Ship', '');
//   }

//   cardsWrap.innerHTML = html;
// }


function aiPageRenderReturnOptions(uid, reasonId) {
  const card      = document.getElementById(`ai-page-card_${uid}`);
  const panel     = card?.closest('.ai-page-li-panel');
  const optsEl    = document.getElementById(`ai-page-opts_${uid}`);
  const cardsWrap = optsEl?.querySelector('.ai-page-li-opts-cards');
  if (!cardsWrap || !panel || !card) return;

  const returnFee  = parseFloat(panel.dataset.returnFee) || 0;
  const isVip      = panel.dataset.isVip      === '1';
  const selfShipOk = panel.dataset.isSelfShip === '1';
  const partnerId  = parseInt(panel.dataset.partnerId, 10) || 1;

  const shippingCode = panel.dataset.shippingCode || '';
  const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);

  const grade          = (card.dataset.grade || '').toUpperCase();
  const isOutlet       = card.dataset.isOutlet  === '1';
  const isGoddiva      = card.dataset.isGoddiva === '1';
  const storeCreditAmt = parseFloat(card.dataset.storeCreditAmount) || 0;
  const refundAmt      = parseFloat(card.dataset.refundAmount)      || 0;

  const freePartners = [5, 7, 11, 17, 27];
  const isFree       = isVip || freePartners.includes(partnerId);
  const effectiveFee = isFree ? '0.00' : returnFee.toFixed(2);

  const reasons     = aiPageGetPanelReasons(panel);
  const checkReason = reasons.find(r => String(r.id) === String(reasonId));
  const hasGradeTag = ['B', 'C'].includes(grade);

  let html = '';

  // Outlet + Goddiva → Return Label only (hidden for restricted)
  if (checkReason && isGoddiva && isOutlet) {
    if (!isRestricted) {
      html += aiPageOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
    }
    cardsWrap.innerHTML = html;
    return;
  }

  // Goddiva marketplace → conditional store credit / refund
  if (checkReason && isGoddiva && partnerId === 1) {
    if (checkReason.is_store_credit && hasGradeTag && storeCreditAmt > 0) {
      html += aiPageOptCardHtml(uid, 'store_credit',
        `£${storeCreditAmt.toFixed(2)} Store Credit (Keep the item)`, '');
    }
    if (checkReason.is_refund && hasGradeTag && refundAmt > 0) {
      html += aiPageOptCardHtml(uid, 'refund',
        `£${refundAmt.toFixed(2)} Refund (Keep the item)`, '');
    }
  }

  // Return Label — hidden for restricted countries
  if (!isRestricted) {
    html += aiPageOptCardHtml(uid, 'return_label', 'Return Label', '', effectiveFee);
  }

  // Self Ship — only if available at order level
  if (selfShipOk) {
    html += aiPageOptCardHtml(uid, 'self_ship', 'Self Ship', '');
  }

  // Restricted country message
  if (isRestricted) {
    const msgId = `ai-page-intl-msg_${uid}`;
    html += `
      <button class="ai-page-li-view-details-btn"
              type="button"
              style="background:#dc2626;color:#fff;border-radius:8px;padding:6px 10px;width:100%;justify-content:space-between;"
              onclick="
                const msg = document.getElementById('${msgId}');
                const isHidden = msg.hasAttribute('hidden');
                msg.toggleAttribute('hidden', !isHidden);
                this.classList.toggle('ai-page-li-view-details-open', isHidden);
                if (isHidden) msg.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
              ">
        ⚠ Important Note for Customer
        <span class="ai-page-li-chevron">▾</span>
      </button>
      <div id="${msgId}" class="ai-page-li-detail-panel" hidden
           style="font-size:11px;line-height:1.6;color:#374151;overflow-y:auto;max-height:200px;">
        <p style="margin:0 0 6px;">For international locations outside of the EU, USA, Canada, New Zealand, and Australia, customers are responsible for arranging and covering the cost of return postage.</p>
        <p style="margin:0 0 6px;">We recommend using a tracked shipping service with your local courier and ensuring that any applicable duties or taxes are covered.</p>
        <p style="margin:0 0 6px;">Please securely repackage your item(s) in waterproof, non-transparent packaging and include a copy of your order details inside the parcel.</p>
        <p style="margin:0 0 4px;"><strong>Return address:</strong></p>
        <p style="margin:0 0 6px;">Goddiva Returns<br/>CG House, 107B Chadwell Heath Lane<br/>Romford, Essex RM6 4NP<br/>United Kingdom</p>
        <p style="margin:0 0 6px;">Once your return has been received and processed, we will be in touch regarding your refund or exchange.</p>
      </div>`;
  }

  cardsWrap.innerHTML = html;
}

function aiPageOptCardHtml(uid, optValue, title, desc, fee = null) {
  return `
    <div class="ai-page-li-opt-card"
         data-uid="${uid}"
         data-opt="${optValue}"
         ${fee !== null ? `data-return-fee="${fee}"` : ''}
         onclick="aiPageSelectOpt(this)">
      <div class="ai-page-li-radio"></div>
      <div class="ai-page-li-opt-text">
        <div class="ai-page-li-opt-title">${title}</div>
        ${desc ? `<div class="ai-page-li-opt-desc">${desc}</div>` : ''}
      </div>
    </div>
  `;
}


// ─────────────────────────────────────────────────────────────
// OPTION DESCRIPTION — mirrors portal updateDescription()
// ─────────────────────────────────────────────────────────────

function aiPageUpdateOptDescription(uid) {
  const descEl = document.getElementById(`ai-page-optDesc_${uid}`);
  if (!descEl) return;

  const card      = document.getElementById(`ai-page-card_${uid}`);
  const panel     = card?.closest('.ai-page-li-panel');
  const isVip     = panel?.dataset.isVip === '1';
  const partnerId = parseInt(panel?.dataset.partnerId || '1', 10);
  const freePartners = [5, 7, 11, 17, 27];
  const isFree    = isVip || freePartners.includes(partnerId);
  const isOutletCard = card?.dataset.isOutlet === '1';

  const optCard  = card?.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected');
  const optValue = optCard?.dataset.opt || '';
  const scAmt    = parseFloat(card?.dataset.storeCreditAmount || 0);
  const refAmt   = parseFloat(card?.dataset.refundAmount      || 0);
  const qty      = parseInt(card?.querySelector('.ai-page-li-qty')?.textContent || 1, 10);

  const descriptions = {
    store_credit : `Keep the item and receive a gift card worth £${(scAmt * qty).toFixed(2)}. Note: To receive a full refund, please select Return Label or Self Ship instead.`,
    refund       : `Keep the item and get a refund of £${(refAmt * qty).toFixed(2)} to your original payment method. Note: To receive a full refund, please select Return Label or Self Ship instead.`,
    return_label : isOutletCard
      ? ''
      : isFree
        ? 'You can download a return label to send the item back.'
        : 'You will be charged a small fee for all items selected for return. Once paid, you can download the return label.',
    self_ship    : 'Receive a return note and ship the item back at your own expense.',
  };

  descEl.textContent = descriptions[optValue] || '';
}


function aiPageToggleSummary(panel) {
  const summary = panel.querySelector('.ai-page-li-summary');
  if (!summary) return;

  const checkedWithOption = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
  )].some(chk => {
    const card = document.getElementById(`ai-page-card_${chk.dataset.uid}`);
    return card?.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected');
  });

  // Also show summary if any checked item has a reason selected (even without option yet)
  const checkedWithReason = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
  )].some(chk => {
    const card = document.getElementById(`ai-page-card_${chk.dataset.uid}`);
    const reasonSel = card?.querySelector('.ai-page-li-reason');
    return reasonSel && reasonSel.value !== '';
  });

  const hasAnyOption = checkedWithOption;

  summary.style.display = hasAnyOption ? 'block' : 'none';
  if (hasAnyOption) {
    aiPageUpdateSummary(panel);
    aiPageCheckAddToPrev(panel);
  }
}

function aiPageUpdateSummary(panel) {
  const checkedChks = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
  )];

  const partnerId    = parseInt(panel.dataset.partnerId || '1', 10);
  const isVip        = panel.dataset.isVip === '1';
  const freePartners = [5, 7, 11, 17, 27];
  const isFree       = isVip || freePartners.includes(partnerId);
  const returnFee    = isFree ? 0 : parseFloat(panel.dataset.returnFee || 0);

  let totalSC        = 0;
  let totalRefund    = 0;
  let totalFee       = 0;
  let totalSelfShip  = 0;
  let returnFeeAdded = false; // fee added only once per order — mirrors portal

  checkedChks.forEach(chk => {
    const uid    = chk.dataset.uid;
    const card   = document.getElementById(`ai-page-card_${uid}`);
    if (!card) return;
    const qty    = parseInt(card.querySelector('.ai-page-li-qty')?.textContent || 1, 10);
    const optVal = card.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected')?.dataset.opt || '';
    const scAmt  = parseFloat(card.dataset.storeCreditAmount || 0);
    const refAmt = parseFloat(card.dataset.refundAmount      || 0);

    if (optVal === 'store_credit') totalSC       += scAmt * qty;
    if (optVal === 'refund')       totalRefund   += refAmt * qty;
    if (optVal === 'self_ship')    totalSelfShip += qty;
    if (optVal === 'return_label' && !returnFeeAdded && returnFee > 0) {
      totalFee += returnFee;
      returnFeeAdded = true;
    }
  });

  const showRow = (sel, condition) => {
    const row = panel.querySelector(sel);
    if (row) row.style.display = condition ? '' : 'none';
  };
  showRow('.ai-page-li-sum-store-credit', totalSC       > 0);
  showRow('.ai-page-li-sum-refund',        totalRefund   > 0);
  showRow('.ai-page-li-sum-return-label',  totalFee      > 0);
  showRow('.ai-page-li-sum-self-ship',     totalSelfShip > 0);

  const q = s => panel.querySelector(s);
  if (q('.ai-page-li-sum-sc-val'))  q('.ai-page-li-sum-sc-val').textContent  = totalSC.toFixed(2);
  if (q('.ai-page-li-sum-ref-val')) q('.ai-page-li-sum-ref-val').textContent = totalRefund.toFixed(2);
  if (q('.ai-page-li-sum-fee-val')) q('.ai-page-li-sum-fee-val').textContent = totalFee.toFixed(2);
  if (q('.ai-page-li-sum-ss-val'))  q('.ai-page-li-sum-ss-val').textContent  = totalSelfShip;
}


// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function aiPageOnCheckboxChange(chk) {
  const uid  = chk.dataset.uid;
  const card = chk.closest('.ai-page-li-card');
  const panel = chk.closest('.ai-page-li-panel');

  if (!chk.checked) {
    aiPageResetCard(uid);
  } else {
    // Gift bag checked → rebuild reason dropdown to allowed reasons only
    if (card && card.dataset.isGiftBag === '1') {
      const reasons   = aiPageGetPanelReasons(panel);
      const reasonSel = card.querySelector('.ai-page-li-reason');
      if (reasonSel) aiPageRebuildGiftBagReason(reasonSel, reasons);
    }

    // Outlet checked → auto-select "Yes" radio and show form
    if (card && card.dataset.isOutlet === '1') {
      const yesRadio = card.querySelector('.ai-page-li-outlet-radio[value="yes"]');
      if (yesRadio && !yesRadio.checked) {
        yesRadio.checked = true;
        aiPageOutletRadioChange(yesRadio);
      }
    }
  }

  aiPageUpdateCount(panel);
  aiPageToggleSummary(panel);

  // FIX: always update gift bag state on any checkbox change
  aiPageUpdateGiftBag(panel);
}

function aiPageResetCard(uid) {
  const card = document.getElementById(`ai-page-card_${uid}`);
  if (!card) return;

  const qtyEl  = card.querySelector('.ai-page-li-qty');
  if (qtyEl) qtyEl.textContent = 1;

    const reasonSel = card.querySelector('.ai-page-li-reason');
    if (reasonSel) {
        // Restore full reasons if it's a gift bag
        if (card.dataset.isGiftBag === '1') {
        const panel   = card.closest('.ai-page-li-panel');
        const reasons = aiPageGetPanelReasons(panel);
        aiPageRestoreFullReason(reasonSel, reasons);
        } else {
        reasonSel.value = '';
        }
    }

    const specificEl = document.getElementById(`ai-page-specificReason_${uid}`);
    if (specificEl) {
    specificEl.style.display = 'none';
    specificEl.value = '';
    }
    const specificErrEl = document.getElementById(`ai-page-specificReasonErr_${uid}`);
    if (specificErrEl) specificErrEl.hidden = true;


    const optsPanel = document.getElementById(`ai-page-opts_${uid}`);
    if (optsPanel) {
        optsPanel.setAttribute('hidden', '');
        const cardsWrap = optsPanel.querySelector('.ai-page-li-opts-cards');
        if (cardsWrap) cardsWrap.innerHTML = '';
        optsPanel.classList.remove('ai-page-li-opts-error');
        const optErr = document.getElementById(`ai-page-optErr_${uid}`);
        if (optErr) optErr.hidden = true;
    }

    const descEl = document.getElementById(`ai-page-optDesc_${uid}`);
    if (descEl) descEl.textContent = '';

    const detPanel = document.getElementById(`ai-page-det_${uid}`);
    if (detPanel) detPanel.setAttribute('hidden', '');
    const detBtn = card.querySelector('.ai-page-li-view-details-btn');
    if (detBtn) detBtn.classList.remove('ai-page-li-view-details-open');

    aiPageFaultyReset(uid);

    const fltEl = document.getElementById(`ai-page-flt_${uid}`);
    if (fltEl) fltEl.setAttribute('hidden', '');

    const card4 = document.getElementById(`ai-page-card_${uid}`);
    if (card4) card4.dataset.isFaultyReason = '0';

    
    const panel5    = document.getElementById(`ai-page-card_${uid}`)?.closest('.ai-page-li-panel');
    const termsChk  = panel5?.querySelector('.ai-page-li-terms-chk');
    const termsErr  = panel5?.querySelector('.ai-page-li-terms-error');
    // Only uncheck T&C if no items remain checked after this reset
    const stillChecked = panel5?.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
    ).length;
    if (!stillChecked) {
    if (termsChk) termsChk.checked = false;
    if (termsErr) termsErr.style.display = 'none';
    }

    const outletRadios = card?.querySelectorAll('.ai-page-li-outlet-radio');
    if (outletRadios?.length) {
    outletRadios.forEach(r => r.checked = false);
    const rowEl = card.querySelector('.ai-page-li-outlet-row');
    const noMsg = card.querySelector('.ai-page-li-outlet-no-msg');
    if (rowEl) rowEl.style.display = 'none';
    if (noMsg) noMsg.style.display = 'none';
    // Re-disable the reason select for outlet items (form hidden until Yes)
    const reasonSel = card.querySelector('.ai-page-li-reason');
    if (reasonSel && card.dataset.isOutlet === '1') reasonSel.disabled = true;
    // NOTE: checkbox stays enabled so user can re-click it
    }

    aiPageClearCardErrors(card);
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// FIX: calls aiPageUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function aiPageChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`ai-page-card_${uid}`);
  const qtyEl  = btn.closest('.ai-page-li-stepper').querySelector('.ai-page-li-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);
  val          = Math.min(maxQty, Math.max(1, val + delta));
  qtyEl.textContent = val;

  aiPageAutoCheck(uid);
  aiPageUpdateOptDescription(uid);

  const panel = card?.closest('.ai-page-li-panel');
  if (panel) {
    aiPageToggleSummary(panel);
    aiPageUpdateGiftBag(panel); // FIX: update gift bag on qty change
  }
}


// ─────────────────────────────────────────────────────────────
// REASON DROPDOWN
// FIX: calls aiPageUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function aiPageOnReasonChange(sel) {
  const uid    = sel.dataset.uid;
  const optsEl = document.getElementById(`ai-page-opts_${uid}`);
  const fltEl  = document.getElementById(`ai-page-flt_${uid}`);
  const descEl = document.getElementById(`ai-page-optDesc_${uid}`);
  const hasVal = sel.value !== '';

  const selectedOpt = sel.options[sel.selectedIndex];
  const isFaulty    = selectedOpt && selectedOpt.dataset.faulty === '1';
  const isOther      = selectedOpt && selectedOpt.text === 'Other';


  const specificEl   = document.getElementById(`ai-page-specificReason_${uid}`);
  const specificErrEl = document.getElementById(`ai-page-specificReasonErr_${uid}`);
  if (specificEl) {                                                                           
    specificEl.style.display = isOther ? '' : 'none';                                          
    if (!isOther) specificEl.value = '';                                                       
  }                                                                                           
  if (specificErrEl) specificErrEl.hidden = true;  


  sel.classList.remove('ai-page-li-field-error');
  sel.closest('.ai-page-li-reason-wrap')
     .querySelector('.ai-page-li-error-msg:not([id])')?.remove();

  if (descEl) descEl.textContent = '';

  if (optsEl) {
    if (!hasVal) {
      optsEl.setAttribute('hidden', '');
      const cardsWrap = optsEl.querySelector('.ai-page-li-opts-cards');
      if (cardsWrap) cardsWrap.innerHTML = '';
      optsEl.classList.remove('ai-page-li-opts-error');
      const optErr = document.getElementById(`ai-page-optErr_${uid}`);
      if (optErr) optErr.hidden = true;
    } else {
      aiPageRenderReturnOptions(uid, sel.value);
      optsEl.removeAttribute('hidden');
    }
  }
  
    if (fltEl) {
        fltEl.setAttribute('hidden', '');
        aiPageFaultyReset(uid);
    }

    const card3 = document.getElementById(`ai-page-card_${uid}`);
    if (card3) card3.dataset.isFaultyReason = isFaulty ? '1' : '0';

  aiPageAutoCheck(uid);

  const panel = sel.closest('.ai-page-li-panel');
  if (panel) {
    aiPageToggleSummary(panel);
    aiPageUpdateGiftBag(panel);

    // Too Big / Too Long popup — Goddiva items + partner 1 only (reason 4 = Too Big, 6 = Too Long)
    const card2     = document.getElementById(`ai-page-card_${uid}`);
    const isGoddiva = card2?.dataset.isGoddiva === '1';
    const partnerId = parseInt(panel.dataset.partnerId || '1', 10);
    if (isGoddiva && partnerId === 1 && (sel.value === '4' || sel.value === '6')) {
     // aiPageTbtlOpen(panel.id, uid);
    } else {
     // aiPageTbtlClose(panel.id);
    }
  }
}


// ─────────────────────────────────────────────────────────────
// AUTO-CHECK HELPER
// ─────────────────────────────────────────────────────────────

function aiPageAutoCheck(uid) {
  const chk = document.getElementById(`ai-page-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.ai-page-li-panel');
  if (panel) aiPageUpdateCount(panel);
}


// ─────────────────────────────────────────────────────────────
// OPTION SELECTION
// FIX: calls aiPageUpdateGiftBag so gift bag visibility updates
// ─────────────────────────────────────────────────────────────

function aiPageSelectOpt(card) {
  const uid  = card.dataset.uid;
  const opts = card.closest('.ai-page-li-opts');

  opts.querySelectorAll('.ai-page-li-opt-card')
      .forEach(s => s.classList.remove('ai-page-li-opt-selected'));
  card.classList.add('ai-page-li-opt-selected');

  opts.classList.remove('ai-page-li-opts-error');
  const optErr = document.getElementById(`ai-page-optErr_${uid}`);
  if (optErr) optErr.hidden = true;

  const fltEl       = document.getElementById(`ai-page-flt_${uid}`);
  const optValue    = card.dataset.opt;
  const isFaulty    = document.getElementById(`ai-page-card_${uid}`)?.dataset.isFaultyReason === '1';

  if (fltEl) {
    if (isFaulty && optValue === 'return_label') {
      fltEl.removeAttribute('hidden');
    } else {
      fltEl.setAttribute('hidden', '');
      aiPageFaultyReset(uid);
    }
  }


  aiPageUpdateOptDescription(uid);

  const panel = card.closest('.ai-page-li-panel');
  if (panel) {
    aiPageUpdateCount(panel);
    aiPageToggleSummary(panel);
    aiPageUpdateGiftBag(panel);
    aiPageCheckAddToPrev(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// VIEW DETAILS
// ─────────────────────────────────────────────────────────────

function aiPageToggleDetails(btn, panelId) {
  const panel  = document.getElementById(panelId);
  if (!panel) return;
  const isOpen = panel.hasAttribute('hidden');
  panel.toggleAttribute('hidden', !isOpen);
  btn.classList.toggle('ai-page-li-view-details-open', isOpen);
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function aiPageToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.ai-page-li-panel');
  const itemChks = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) aiPageResetCard(c.dataset.uid);
  });
  aiPageUpdateCount(panel);
  aiPageToggleSummary(panel);
  aiPageUpdateGiftBag(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function aiPageUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.ai-page-li-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.ai-page-li-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  // Show/hide T&C wrapper — mirrors portal toggleSubmitBtn()
  const termsWrapper = panel.querySelector('.ai-page-li-terms-wrapper');
  if (termsWrapper) {
    termsWrapper.style.display = count > 0 ? '' : 'none';
    // Clear terms error when items unchecked
    if (count === 0) {
      const termsErr = panel.querySelector('.ai-page-li-terms-error');
      if (termsErr) termsErr.style.display = 'none';
    }
  }

  if (count === 0) {
    const addToPrevWrapper = panel.querySelector('.ai-page-li-addtoprev-wrapper');
    if (addToPrevWrapper) {
        addToPrevWrapper.style.display = 'none';
        addToPrevWrapper.querySelectorAll('.ai-page-li-addtoprev-radio')
                        .forEach(r => r.checked = false);
        const err = addToPrevWrapper.querySelector('.ai-page-li-addtoprev-error');
        if (err) err.style.display = 'none';
    }
    }

  const allValid = count > 0 && aiPageValidateSelected(checkedChks, false);
  const btn      = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('ai-page-li-process-active', allValid);
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION
// ─────────────────────────────────────────────────────────────

function aiPageValidateSelected(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid  = chk.dataset.uid;
    const card = document.getElementById(`ai-page-card_${uid}`);
    if (!card) return;

    const reasonSel = card.querySelector('.ai-page-li-reason');
    if (!reasonSel || reasonSel.value === '') {
      allValid = false;
      if (showErrors) aiPageShowFieldError(reasonSel, 'Please select a return reason');
    }

   
    const selectedReasonText = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    if (selectedReasonText === 'Other') {
    const specificEl = document.getElementById(`ai-page-specificReason_${uid}`);
    if (!specificEl || !specificEl.value.trim()) {
        allValid = false;
        if (showErrors) {
        const specificErrEl = document.getElementById(`ai-page-specificReasonErr_${uid}`);
        if (specificErrEl) specificErrEl.hidden = false;
        }
    }
    }

    const optsPanel = document.getElementById(`ai-page-opts_${uid}`);
    if (optsPanel && !optsPanel.hasAttribute('hidden')) {
      if (!optsPanel.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected')) {
        allValid = false;
        if (showErrors) {
          optsPanel.classList.add('ai-page-li-opts-error');
          const optErr = document.getElementById(`ai-page-optErr_${uid}`);
          if (optErr) optErr.hidden = false;
        }
      }
    }

    const fltPanel = document.getElementById(`ai-page-flt_${uid}`);
    if (fltPanel && !fltPanel.hasAttribute('hidden')) {
      const files = aiPageFaultyGetFiles(uid);
      if (files.length > 0 && files.length < AI_PAGE_FAULTY_MIN) {
        allValid = false;
        if (showErrors) {
          const fltErr = document.getElementById(`ai-page-fltErr_${uid}`);
          if (fltErr) fltErr.hidden = false;
        }
      }
    }


  });

  return allValid;
}

function aiPageShowFieldError(field, message) {
  if (!field) return;
  field.classList.add('ai-page-li-field-error');
  const wrap = field.closest('.ai-page-li-reason-wrap');
  if (wrap && !wrap.querySelector('.ai-page-li-error-msg:not([id])')) {
    const msg       = document.createElement('span');
    msg.className   = 'ai-page-li-error-msg';
    msg.textContent = message;
    wrap.appendChild(msg);
  }
}

function aiPageClearCardErrors(card) {
  if (!card) return;
  card.querySelectorAll('.ai-page-li-field-error').forEach(el => el.classList.remove('ai-page-li-field-error'));
  card.querySelectorAll('.ai-page-li-error-msg:not([id])').forEach(el => el.remove());
  card.querySelectorAll('.ai-page-li-opts-error').forEach(el => el.classList.remove('ai-page-li-opts-error'));
  const uid    = card.id.replace('ai-page-card_', '');
  const optErr = document.getElementById(`ai-page-optErr_${uid}`);
  if (optErr) optErr.hidden = true;
  const fltErr = document.getElementById(`ai-page-fltErr_${uid}`);
  if (fltErr) fltErr.hidden = true;
  const uid2 = card.id.replace('ai-page-card_', '');
  const specificErrEl = document.getElementById(`ai-page-specificReasonErr_${uid2}`);
  if (specificErrEl) specificErrEl.hidden = true;
}


// ─────────────────────────────────────────────────────────────
// FAULTY IMAGE UPLOAD
// ─────────────────────────────────────────────────────────────

const AI_PAGE_FAULTY_MIN  = 3;
const AI_PAGE_FAULTY_MAX  = 3;
const AI_PAGE_FAULTY_SIZE = 5 * 1024 * 1024;

function aiPageFaultyImagesAdded(input) {
  const uid         = input.dataset.uid;
  const existing    = aiPageFaultyGetFiles(uid);
  const incoming    = [...input.files];
  const errorMsgs   = [];
  const limitErrors = [];

  // Allowed types — mirrors portal exactly
  const allowedTypes = { 'image/jpeg': true, 'image/png': true, 'image/jpg': true };

  incoming.forEach(f => {
    if (!allowedTypes[f.type]) {
      errorMsgs.push(`${f.name} — not a valid image (JPG/PNG only).`);
      return;
    }
    if (f.size > AI_PAGE_FAULTY_SIZE) {
      errorMsgs.push(`${f.name} exceeds 5MB.`);
      return;
    }
    if (existing.find(e => e.name === f.name && e.size === f.size)) { return; }
    if (existing.length >= AI_PAGE_FAULTY_MAX) { limitErrors.push(f.name); return; }
    // Rename with timestamp — mirrors portal new File([file], `${Date.now()}-${file.name}`)
    const renamed = new File([f], `${Date.now()}-${f.name}`, { type: f.type, lastModified: f.lastModified });
    existing.push(renamed);
  });

  aiPageFaultySetFiles(uid, existing);
  aiPageFaultyRenderPreviews(uid);
  aiPageFaultyClearError(uid);

  const warnEl = document.getElementById(`ai-page-fltWarn_${uid}`);
  if (warnEl) {
    const msgs = [...errorMsgs];
    if (limitErrors.length) msgs.push(`Max ${AI_PAGE_FAULTY_MAX} images allowed. ${limitErrors.length} file(s) were skipped.`);
    warnEl.textContent = msgs.join(' ');
    warnEl.hidden      = msgs.length === 0;
  }

  input.value = '';
  const panel = input.closest('.ai-page-li-panel');
  if (panel) aiPageUpdateCount(panel);
}

function aiPageFaultyRemove(uid, index) {
  const files = aiPageFaultyGetFiles(uid);
  files.splice(index, 1);
  aiPageFaultySetFiles(uid, files);
  aiPageFaultyRenderPreviews(uid);
  aiPageFaultyClearError(uid);
  const card  = document.getElementById(`ai-page-card_${uid}`);
  const panel = card?.closest('.ai-page-li-panel');
  if (panel) aiPageUpdateCount(panel);
}

function aiPageFaultyPreview(uid, index) {
  const card    = document.getElementById(`ai-page-card_${uid}`);
  const panel   = card?.closest('.ai-page-li-panel');
  const panelId = panel?.id;
  if (!panelId) return;
  aiPageFaultyPopupOpen(panelId, uid, index);
}

function aiPageFaultyRenderPreviews(uid) {
  const container = document.getElementById(`ai-page-fltPreviews_${uid}`);
  if (!container) return;
  container.querySelectorAll('img').forEach(img => URL.revokeObjectURL(img.src));
  const files = aiPageFaultyGetFiles(uid);
  if (!files.length) { container.innerHTML = ''; return; }
  container.innerHTML = files.map((f, i) => {
    const url = URL.createObjectURL(f);
    return `
      <div class="ai-page-li-faulty-thumb">
        <img src="${url}" alt="${aiPageEscHtml(f.name)}"
             onclick="aiPageFaultyPreview('${uid}', ${i})" title="Click to preview" />
        <button type="button" class="ai-page-li-faulty-remove"
                onclick="aiPageFaultyRemove('${uid}', ${i})" title="Remove">✕</button>
        <div class="ai-page-li-faulty-thumb-name">${aiPageEscHtml(f.name)}</div>
      </div>`;
  }).join('');
}

function aiPageFaultyReset(uid) {
  aiPageFaultySetFiles(uid, []);
  const container = document.getElementById(`ai-page-fltPreviews_${uid}`);
  if (container) {
    container.querySelectorAll('img').forEach(img => URL.revokeObjectURL(img.src));
    container.innerHTML = '';
  }
  aiPageFaultyClearError(uid);
  const input = document.getElementById(`ai-page-fltInput_${uid}`);
  if (input) input.value = '';
}

function aiPageFaultyClearError(uid) {
  const err  = document.getElementById(`ai-page-fltErr_${uid}`);
  if (err) err.hidden = true;
  const warn = document.getElementById(`ai-page-fltWarn_${uid}`);
  if (warn) { warn.hidden = true; warn.textContent = ''; }
}

const _aiPageFaultyFiles = {};
function aiPageFaultyGetFiles(uid)      { return _aiPageFaultyFiles[uid] || []; }
function aiPageFaultySetFiles(uid, arr) { _aiPageFaultyFiles[uid] = arr; }


// ─────────────────────────────────────────────────────────────
// IMAGE PREVIEW POPUP
// ─────────────────────────────────────────────────────────────

const _aiPagePopupState = {};

function aiPageFaultyPopupOpen(panelId, uid, index) {
  _aiPagePopupState[panelId] = { uid, index };
  _aiPagePopupRender(panelId);
  const popup = document.getElementById(`ai-page-img-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}

function aiPageFaultyPopupClose(panelId) {
  const popup = document.getElementById(`ai-page-img-popup_${panelId}`);
  if (popup) {
    const img = popup.querySelector('img');
    if (img && img.src.startsWith('blob:')) URL.revokeObjectURL(img.src);
    popup.setAttribute('hidden', '');
  }
  delete _aiPagePopupState[panelId];
}

function aiPageFaultyPopupNav(panelId, direction) {
  const state = _aiPagePopupState[panelId];
  if (!state) return;
  const files = aiPageFaultyGetFiles(state.uid);
  if (!files.length) return;
  state.index = (state.index + direction + files.length) % files.length;
  _aiPagePopupRender(panelId);
}

function _aiPagePopupRender(panelId) {
  const state   = _aiPagePopupState[panelId];
  if (!state) return;
  const files   = aiPageFaultyGetFiles(state.uid);
  const file    = files[state.index];
  if (!file) return;

  const imgEl   = document.getElementById(`ai-page-img-popup-img_${panelId}`);
  const counter = document.getElementById(`ai-page-img-popup-counter_${panelId}`);
  const popup   = document.getElementById(`ai-page-img-popup_${panelId}`);

  if (imgEl && imgEl.src.startsWith('blob:')) URL.revokeObjectURL(imgEl.src);
  if (imgEl)   imgEl.src = URL.createObjectURL(file);
  if (counter) counter.textContent = `${state.index + 1} / ${files.length}`;

  if (popup) {
    const showNav = files.length > 1;
    const prev = popup.querySelector('.ai-page-img-popup-prev');
    const next = popup.querySelector('.ai-page-img-popup-next');
    if (prev) prev.style.visibility = showNav ? '' : 'hidden';
    if (next) next.style.visibility = showNav ? '' : 'hidden';
  }
}

document.addEventListener('keydown', function (e) {
  const openPopup = document.querySelector('.ai-page-img-popup:not([hidden])');
  if (!openPopup) return;
  const panelId = openPopup.id.replace('ai-page-img-popup_', '');
  if (e.key === 'ArrowRight') aiPageFaultyPopupNav(panelId, 1);
  if (e.key === 'ArrowLeft')  aiPageFaultyPopupNav(panelId, -1);
  if (e.key === 'Escape')     aiPageFaultyPopupClose(panelId);
});


function aiPageOutletRadioChange(radio) {
  const uid   = radio.dataset.uid;
  const card  = document.getElementById(`ai-page-card_${uid}`);
  const panel = card?.closest('.ai-page-li-panel');
  const chk   = document.getElementById(`ai-page-chk_${uid}`);
  const rowEl = card?.querySelector('.ai-page-li-outlet-row');
  const noMsg = card?.querySelector('.ai-page-li-outlet-no-msg');

  if (radio.value === 'yes') {
    if (rowEl) rowEl.style.display = 'flex';
    if (noMsg) noMsg.style.display = 'none';
    // Enable reason select and check the card checkbox
    const reasonSel = card?.querySelector('.ai-page-li-reason');
    if (reasonSel) reasonSel.disabled = false;
    if (chk) {
      chk.disabled = false;
      chk.checked  = true;
    }
  } else {
    if (rowEl) rowEl.style.display = 'none';
    if (noMsg) noMsg.style.display = '';
    // Uncheck but keep checkbox enabled so user can re-click
    if (chk) {
      chk.checked = false;
      // chk.disabled = true;  ← REMOVED: keep enabled so user can re-click
    }
    aiPageResetCard(uid);
    if (noMsg) noMsg.style.display = '';
    radio.checked = true;
  }

  if (panel) {
    aiPageUpdateCount(panel);
    aiPageToggleSummary(panel);
    aiPageUpdateGiftBag(panel);
  }
}


// Freeze a panel — disable all interaction, show status message
function aiPageFreezePanel(panel, message) {
  // Disable all checkboxes, selects, buttons
  panel.querySelectorAll('input, select, button, textarea').forEach(el => {
    el.disabled = true;
  });
  panel.classList.add('ai-page-li-panel-frozen');

  // Replace the process button with a status message
  const btn = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.textContent = message || 'Submitted';
    btn.classList.add('ai-page-li-process-done');
  }
}

// Unfreeze on error — allow retry
function aiPageUnfreezePanel(panel) {
  panel.querySelectorAll('input, select, button, textarea').forEach(el => {
    el.disabled = false;
  });
  panel.classList.remove('ai-page-li-panel-frozen');

  const btn = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.textContent = 'PROCESS RETURN';
    btn.classList.remove('ai-page-li-process-done');
  }

  // Re-run gift bag and count to restore correct disabled states
  aiPageUpdateGiftBag(panel);
  aiPageUpdateCount(panel);
}

// ─────────────────────────────────────────────────────────────
// TOO BIG / TOO LONG POPUP
// Triggered by reason 4 (Too Big) or 6 (Too Long) for Goddiva + partner 1
// ─────────────────────────────────────────────────────────────

function aiPageTbtlOpen(panelId) {
  const popup = document.getElementById(`ai-page-tbtl-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}

function aiPageTbtlClose(panelId) {
  const popup = document.getElementById(`ai-page-tbtl-popup_${panelId}`);
  if (popup) popup.setAttribute('hidden', '');
}


// ─────────────────────────────────────────────────────────────
// NON-RETURNABLE ITEMS — rendered inside the return grid
// Mirrors portal getNonReturnableItemHtml(data)
// data.nonReturnableItems is a separate API array (earrings/skincare hygiene items)
// ─────────────────────────────────────────────────────────────

// function aiPageRenderNonReturnableItems(lineItemsData) {
//   const sellers = lineItemsData.nonReturnableItems || [];
//   if (!sellers.length) return '';

//   const isActive = lineItemsData.is_active_date == 1;

//   return sellers.flatMap(seller => (seller.items || []).map(item => {
//     const price = parseFloat(item.price || 0);
//     const gross = parseFloat(item.gross_price || 0);
//     const priceHtml = price !== gross
//       ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
//       : `£${price.toFixed(2)}`;

//     return `
//       <div class="ai-page-li-card ai-page-li-card-disabled">
//         <div class="ai-page-li-img-wrap">
//           <div class="ai-page-li-img">
//             ${item.image
//               ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
//               : `<div class="ai-page-li-img-placeholder">G</div>`}
//           </div>
//           <div class="ai-page-li-badges">
//             <div class="ai-page-li-badge ai-page-li-badge-warn">Non-Returnable</div>
//           </div>
//         </div>
//         <div class="ai-page-li-body">
//           <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
//           <div class="ai-page-li-price">${priceHtml}</div>
//           <div style="font-size:10px;color:#6b7280;margin-bottom:4px;">
//             ${aiPageEscHtml(item.color || '')} / ${aiPageEscHtml(item.size || '')}
//             &nbsp;·&nbsp; SKU: ${aiPageEscHtml(item.sku || '')}
//           </div>
//           ${isActive
//             ? `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
//                  Please note: All earrings / skin care / hair care, etc. items cannot be
//                  returned/exchanged for hygiene reasons.
//                </p>
//                <p style="font-size:11px;">If you have any questions, please contact
//                  <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
//                </p>`
//             : `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
//                  The return period has passed. Please contact customer service at
//                  <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
//                </p>`}
//         </div>
//       </div>`;
//   })).join('');
// }



function aiPageRenderNonReturnableItems(lineItemsData) {
  const sellers = lineItemsData.nonReturnableItems || [];
  if (!sellers.length) return '';
  const isActive = lineItemsData.is_active_date == 1;

  return sellers.flatMap(seller => (seller.items || []).map((item, i) => {
    const uid = `nonret_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = price !== gross
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    return `
      <div class="ai-page-li-card ai-page-li-card-disabled">
        <div class="ai-page-li-img-wrap">
          <div class="ai-page-li-img">
            ${item.image
              ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
              : `<div class="ai-page-li-img-placeholder">G</div>`}
          </div>
          <div class="ai-page-li-badges">
            <div class="ai-page-li-badge ai-page-li-badge-warn">Non-Returnable</div>
          </div>
        </div>
        <div class="ai-page-li-body">
          <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
          <div class="ai-page-li-price">${priceHtml}</div>

          <button class="ai-page-li-view-details-btn" type="button"
                  onclick="aiPageToggleDetails(this, 'ai-page-det_${uid}')">
            ${aiPageInfoIcon()} View Details
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div id="ai-page-det_${uid}" class="ai-page-li-detail-panel" hidden>
            <div class="ai-page-li-detail-grid">
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Size</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Colour</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">SKU</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.sku || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Qty</div>
                <div class="ai-page-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Brand</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.brand || seller.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Tracking</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)} — ${aiPageEscHtml(item.tracking_id || '')}</div>
              </div>` : ''}
            </div>
          </div>

          ${isActive
            ? `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
                 Please note: All earrings / skin care / hair care, etc. items cannot be
                 returned/exchanged for hygiene reasons.
               </p>
               <p style="font-size:11px;">If you have any questions, please contact
                 <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
               </p>`
            : `<p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
                 The return period has passed. Please contact customer service at
                 <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
               </p>`}
        </div>
      </div>`;
  })).join('');
}

// ─────────────────────────────────────────────────────────────
// PROCESS RETURN
// ─────────────────────────────────────────────────────────────
function aiPageHandleProcessReturn(btn) {
  const panel       = btn.closest('.ai-page-li-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.ai-page-li-checkbox:not(.ai-page-li-select-all-chk):checked'
  )];
 
  if (!aiPageValidateSelected(checkedChks, true)) {
    aiPageScrollToFirstError(panel);
    aiPageToast('Please fill all required fields', 'warning');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.ai-page-li-terms-chk');
  const termsErr = panel.querySelector('.ai-page-li-terms-error');
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    aiPageToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  // Add to previous label validation
  const addToPrevWrapper = panel.querySelector('.ai-page-li-addtoprev-wrapper');
  const addToPrevErr     = panel.querySelector('.ai-page-li-addtoprev-error');
  if (addToPrevWrapper && addToPrevWrapper.style.display !== 'none') {
    const selectedRadio = addToPrevWrapper.querySelector('.ai-page-li-addtoprev-radio:checked');
    if (!selectedRadio) {
      if (addToPrevErr) addToPrevErr.style.display = '';
      aiPageToast('Please choose Yes or No for previous label', 'warning');
      return;
    }
    if (addToPrevErr) addToPrevErr.style.display = 'none';
  }
 
  // Build items array
  const addToPrevRadio       = addToPrevWrapper?.querySelector('.ai-page-li-addtoprev-radio:checked');
  const addWithPreviousLabel = addToPrevRadio?.value === 'no';
  const termsAccepted        = termsChk ? termsChk.checked : false;
  const panelId              = panel.id;
 
  const items = checkedChks.map(chk => {
    const uid       = chk.dataset.uid;
    const card      = document.getElementById(`ai-page-card_${uid}`);
    const reasonSel = card.querySelector('.ai-page-li-reason');
    const reason_id = reasonSel?.value || '';
    const reason    = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    const optCard   = card.querySelector('.ai-page-li-opt-card.ai-page-li-opt-selected');
    const option    = optCard?.dataset.opt       || '';
    const returnFee = optCard?.dataset.returnFee || null;
    const qty       = parseInt(card.querySelector('.ai-page-li-qty')?.textContent, 10) || 1;
    const item_id   = card.dataset.itemId || '';
    const item_sku  = card.dataset.sku  || '';
    const item_name = card.dataset.name || '';
    const specificReasonEl = card.querySelector('.ai-page-li-specific-reason');
    const specificReason   = specificReasonEl ? specificReasonEl.value.trim() : '';
    const images    = aiPageFaultyGetFiles(uid);
 
    return { uid, item_id, item_sku, item_name, reason_id, reason, specificReason, option, return_fee: returnFee, qty, images };
  });
 
  // Show confirmation dialog
  aiPageConfirm({
    title: 'Return Items',
    message: 'Are you sure you want to proceed with this return?',
    confirmText: 'Yes, Process Return',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: i.item_name, reason: i.reason, qty: i.qty })),
    onConfirm: function () {
      _aiPageSubmitReturn(btn, panel, panelId, items, termsAccepted, addWithPreviousLabel);
    },
  });
}
 
function _aiPageSubmitReturn(btn, panel, panelId, items, termsAccepted, addWithPreviousLabel) {

  const originalQuery = panel.dataset.originalQuery || '';
  // Build FormData — matches old portal exactly
  const formData = new FormData();
  formData.append('order',    panel.dataset.orderId    || '');
  formData.append('customer', panel.dataset.customerId || '');
  formData.append('type', 'return');
  formData.append('terms_conditions_checkbox', termsAccepted);
  formData.append('add_with_previous_label', addWithPreviousLabel);
 
  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`,             item.item_id);
    formData.append(`items[${index}][sku]`,            item.item_sku);
    formData.append(`items[${index}][product]`,        item.item_name);
    formData.append(`items[${index}][reason]`,         item.reason_id);
    formData.append(`items[${index}][reasonText]`,     item.reason);
    formData.append(`items[${index}][specificReason]`, item.specificReason || '');
    formData.append(`items[${index}][return_option]`,  item.option);
    formData.append(`items[${index}][quantity]`,       item.qty);
    if (item.images && item.images.length > 0) {
      item.images.forEach((file, fileIndex) => {
        formData.append(`items[${index}][images][${fileIndex}]`, file, file.name);
      });
    }
  });
 
  aiPageBtnStartLoading(btn, 'Processing return…');
  aiPageFreezePanel(panel, 'Processing your return…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmitAiPage}/v1/api/return/request-add`, {
    method: 'POST',
    body: formData,
  })
  .then(res => res.json())
  .then(response => {
    if (response.errors) {
      aiPageBtnStopLoading(btn, 'PROCESS RETURN');
      aiPageUnfreezePanel(panel);
      aiPageToast(response.errors || 'Failed to process return', 'error');
      return;
    }
 
    if (response.invoice_url) {
      // Payment required — show payment popup
      //aiPageBtnSuccess(btn, 'Return Submitted');
      aiPageToast('Return submitted! Please complete payment.', 'success');
      aiPageShowPaymentPopup(panelId, response, {
        return_fee            : parseFloat(panel.dataset.returnFee) || 0,
        shipping_country_code : panel.dataset.shippingCode || '',
        is_vip_customer       : panel.dataset.isVip === '1',
      });

      document.querySelectorAll('.ai-page-pay-close').forEach(el => {
        el.setAttribute('data-refresh', 'yes');
      });

      panel.dataset.refreshQuery = originalQuery;
    } else {
      // No payment needed — success
    //  aiPageBtnSuccess(btn, 'Return Processed');
      aiPageToast(response.message || 'Return processed successfully!', 'success', 6000);

      if (originalQuery) {
        aiPageShowPanelLoader(panel, 'Please wait...');
        setTimeout(() => chatQuery(originalQuery), 1000);
      }
      
     // aiPageRefreshPanel(panel, 'return');

    }
  })
  .catch(err => {
    aiPageBtnStopLoading(btn, 'PROCESS RETURN');
    aiPageUnfreezePanel(panel);
    aiPageToast('An unexpected error occurred. Please try again.', 'error');
    console.error('aiPageHandleProcessReturn fetch error:', err);
  });
}
 
 





// restrictedCountries 

Pusher.logToConsole = true;

var pusher = new Pusher('33b7f1cf4c7cf49972bc', {
cluster: 'eu'
});

const AI_PAGE_RESTRICTED_COUNTRIES = [
  'US','CA','AT','BE','BG','CY','CZ','DE','DK','EE',
  'EL','ES','FI','FR','GR','HR','HU','IE','IT','LT',
  'LU','LV','MT','NL','PL','PT','RO','SE','SI','SK','AU','NZ'
];

// Keyed by panelId — stores grouped brand data for label download after payment
const _aiPageGroupedData = {};
// Keyed by panelId — stores allIntervals for cleanup
const _aiPagePayIntervals = {};

function aiPageShowPaymentPopup(panelId, response, allData) {
  const content = document.getElementById(`ai-page-pay-content_${panelId}`);
  if (!content) return;

  _aiPageGroupedData[panelId] = null;

  const shippingCode  = allData.shipping_country_code || '';
  const isRestricted  = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);

  function formatDate(dateString) {
    const date = new Date(dateString);
    const pad  = n => String(n).padStart(2, '0');
    const h    = date.getHours();
    const ampm = h >= 12 ? 'PM' : 'AM';
    return `${pad(date.getDate())}-${pad(date.getMonth()+1)}-${date.getFullYear()} ` +
           `${pad(h % 12 || 12)}:${pad(date.getMinutes())}:${pad(date.getSeconds())} ${ampm}`;
  }

  let html = '<h3 style="margin:0 0 12px;font-size:14px;font-weight:700;">Summary</h3>';

  // ── Return Label Summary ──
  if (response.return_label_response?.items?.length > 0) {
    const rlr       = response.return_label_response;
    const hasError  = rlr.error !== false;

    html += `<div class="ai-page-pay-accordion">
      <div class="ai-page-pay-acc-header" onclick="aiPagePayAccToggle(this)">
        <span class="ai-page-pay-acc-arrow open">▾</span>
        Return Items Summary
      </div>
      <div class="ai-page-pay-acc-body" style="display:block;">`;

    if (!hasError) {
      html += `<p>A return fee of £${allData.return_fee} is required before you can download the return label.</p>
               <p>Once you make this one-time payment, a return label will be provided for each brand.</p>
               <p>Requested Date: ${formatDate(rlr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that your return request could not be processed. Please reach out to our support team at
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for return:</p>`;

    // Group by brand — mirrors portal groupedData reduce
    const groupedData = rlr.items.reduce((acc, item) => {
      let group = acc.find(g => g.brand_id === item.brand_id);
      if (!group) {
        group = { brand_id: item.brand_id, brand_name: item.brand_name, items: [] };
        acc.push(group);
      }
      group.items.push(item);
      return acc;
    }, []);

    _aiPageGroupedData[panelId] = groupedData;

    groupedData.forEach(brand => {
      html += `<h4 data-brand-id="${brand.brand_id}"
                   style="font-size:12px;font-weight:700;margin:8px 0 4px;">
                 ${aiPageEscHtml(brand.brand_name)}
               </h4>
               <ul class="ai-page-pay-sku-list">`;
      brand.items.forEach(item => {
        html += `<li data-lineitem-id="${item.line_item_id}">
                   ${aiPageEscHtml(item.sku)} (Qty: ${item.quantity})
                 </li>`;
      });
      html += `</ul>`;
    });

    html += `<p>Please click the button below to complete the payment and proceed with your return.</p>
             <p style="margin-top:12px;text-align:center;">
               <a class="ai-page-pay-now-btn"
                  href="${aiPageEscHtml(rlr.invoice_url)}"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-return-request-id="${rlr.returnRequestId}"
                  data-panel-id="${panelId}"
                  onclick="aiPagePayNowClick(this)">
                 Pay Now
               </a>
             </p>`;

    html += `</div></div>`; // close acc-body + accordion
  }

  // ── Self Ship Summary ──
  if (response.self_ship_response?.items?.length > 0) {
    const ssr      = response.self_ship_response;
    const hasError = ssr.error !== false;

    html += `<div class="ai-page-pay-accordion">
      <div class="ai-page-pay-acc-header" onclick="aiPagePayAccToggle(this)">
        <span class="ai-page-pay-acc-arrow">▾</span>
        Self Ship Summary
      </div>
      <div class="ai-page-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>Requested Date: ${formatDate(ssr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that the items selected for Self Ship could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for self ship:</p><ul class="ai-page-pay-sku-list">`;
    ssr.items.forEach(item => {
      html += `<li>${aiPageEscHtml(item.sku)} (Qty: ${item.quantity})
               | <a href="${aiPageEscHtml(item.return_note_url)}" target="_blank"
                    style="color:#ff8080;">Download Return Note</a></li>`;
    });
    html += `</ul></div></div>`;
  }

  // ── Store Credit Summary ──
  if (response.store_credit_response?.items?.length > 0) {
    const scr      = response.store_credit_response;
    const hasError = scr.error !== false;

    html += `<div class="ai-page-pay-accordion">
      <div class="ai-page-pay-acc-header" onclick="aiPagePayAccToggle(this)">
        <span class="ai-page-pay-acc-arrow">▾</span>
        Store Credit Summary
      </div>
      <div class="ai-page-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>Thank you for choosing to keep the items. We have sent you an email with the Gift Voucher worth £${scr.total_amount}</p>
               <p>Requested Date: ${formatDate(scr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that the Gift Card worth £${scr.total_amount} could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for store credit:</p><ul class="ai-page-pay-sku-list">`;
    scr.items.forEach(item => {
      html += `<li>${aiPageEscHtml(item.sku)} (Qty: ${item.quantity})</li>`;
    });
    html += `</ul></div></div>`;
  }

  // ── Refund Summary ──
  if (response.refund_response?.items?.length > 0) {
    const rr       = response.refund_response;
    const hasError = rr.error !== false;

    html += `<div class="ai-page-pay-accordion">
      <div class="ai-page-pay-acc-header" onclick="aiPagePayAccToggle(this)">
        <span class="ai-page-pay-acc-arrow">▾</span>
        Refund Summary
      </div>
      <div class="ai-page-pay-acc-body" style="display:none;">`;

    if (!hasError) {
      html += `<p>We are pleased to inform you that a refund of £${rr.total_amount} has been successfully processed to your original payment method.</p>
               <p>Requested Date: ${formatDate(rr.requested_date)}</p>`;
    } else {
      html += `<p>We are sorry to inform you that a refund of £${rr.total_amount} could not be processed. Please reach out to
               <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }

    html += `<p>You have selected the following items for refund while keeping the item:</p>
             <ul class="ai-page-pay-sku-list">`;
    rr.items.forEach(item => {
      html += `<li>${aiPageEscHtml(item.sku)} (Qty: ${item.quantity})</li>`;
    });
    html += `</ul></div></div>`;
  }

  content.innerHTML = html;

  // Show the popup
  const popup = document.getElementById(`ai-page-pay-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}


function aiPagePayNowClick(btn) {
  const panelId        = btn.dataset.panelId;
  const returnRequestId = btn.dataset.returnRequestId;
  const url            = btn.getAttribute('href');

  // Delay button state change — mirrors portal setTimeout 1000
  setTimeout(() => {
    btn.classList.add('ai-page-pay-now-waiting');
    btn.removeAttribute('href');
    btn.removeAttribute('target');
    btn.textContent = '⏳ Waiting for payment…';
    btn.onclick = null; // prevent double click
  }, 1000);

  aiPageCheckForPayment(btn, url, panelId, returnRequestId);
}


function aiPageCheckForPayment(btn, url, panelId, returnRequestId) {
  if (!returnRequestId || typeof pusher === 'undefined') return;

  const channelId = 'retrun-request.' + returnRequestId;
  const channel   = pusher.subscribe(channelId);

  channel.bind('return-label-payment-event', function(data) {
    if (!data || data.status !== 'paid') return;

    pusher.unsubscribe(channelId);

    if (btn.dataset.paymentStatus === 'paid') return;
    btn.dataset.paymentStatus = 'paid';

    // Update button state immediately
    btn.textContent = '✓ Payment Completed';
    btn.classList.remove('ai-page-pay-now-waiting');
    btn.classList.add('ai-page-pay-now-done');

    // Get the panel
    // const panel = document.getElementById(panelId)
    //            || document.querySelector('.ai-page-li-requested-only');
    const panel = document.getElementById(panelId) || document.querySelector(`#ai-page-req-wrapper_${panelId}`);
    
    if (!panel) return;

    const shippingCode = panel.dataset?.shippingCode || '';
    const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);
    const content      = document.getElementById(`ai-page-pay-content_${panelId}`);
    const grouped      = _aiPageGroupedData[panelId];

    // Show download links or omniparcel message in the popup
    if (grouped && Array.isArray(grouped) && content) {
      // Close payment popup after a short delay
      setTimeout(() => {
        aiPagePayPopupClose(panelId);
        aiPageToast('Payment completed successfully!', 'success');

        const panel = document.getElementById(panelId);
        const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
        if (query) {
           aiPageShowPanelLoader(panel, 'Please wait...');
          chatQuery(query);
        }

        // Refresh the panel with fresh data
        //aiPageRefreshPanel(panel, 'return');
      }, 2000);
    } else {
      // No grouped data — just close and refresh
      setTimeout(() => {
        aiPagePayPopupClose(panelId);
        aiPageToast('Payment completed successfully!', 'success');

        const panel = document.getElementById(panelId);
          const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
          if (query) {
             aiPageShowPanelLoader(panel, 'Please wait...');
            chatQuery(query);
          }
       // aiPageRefreshPanel(panel, 'return');
      }, 1500);
    }
  });
}

function aiPageGetLabelUrl(brandId, lineItemId, completedRequest) {
  const brandData = completedRequest.items?.find(b => b.brand_id == brandId);
  if (!brandData) return null;
  const itemData = brandData.items?.find(i => i.id == lineItemId);
  return itemData?.return_tracking?.label_url || null;
}

function aiPageGetQrCodeUrl(brandId, lineItemId, completedRequest) {
  const brandData = completedRequest.items?.find(b => b.brand_id == brandId);
  if (!brandData) return null;
  const itemData = brandData.items?.find(i => i.id == lineItemId);
  return itemData?.return_tracking?.qrcode_url || null;
}


function aiPagePayPopupClose(panelId) {
  const popup = document.getElementById(`ai-page-pay-popup_${panelId}`);
  if (popup) popup.setAttribute('hidden', '');

  // const panel = document.getElementById(panelId)|| document.querySelector('.ai-page-li-requested-only');

  const panel = document.getElementById(panelId) || document.querySelector(`#ai-page-req-wrapper_${panelId}`);
  
  // Check if any .ai-page-pay-close element has data-refresh="yes"
  const payCloseElements = document.querySelectorAll('.ai-page-pay-close');
  let shouldRefresh = false;
  
  payCloseElements.forEach(el => {
    if (el.getAttribute('data-refresh') === 'yes') {
      shouldRefresh = true;
      // Remove the attribute after checking to prevent repeated refreshes
      el.removeAttribute('data-refresh');
    }
  });
  
  // If refresh is needed, call chatQuery
  if (shouldRefresh) {
    const query = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
    if (query) {
       aiPageShowPanelLoader(panel, 'Please wait...');
      chatQuery(query);
    }
  }
}


function aiPagePayAccToggle(header) {
  const body  = header.nextElementSibling;
  const arrow = header.querySelector('.ai-page-pay-acc-arrow');
  const isOpen = body.style.display !== 'none';
  body.style.display  = isOpen ? 'none' : 'block';
  arrow.classList.toggle('open', !isOpen);
}









// already requested item

function aiPageRenderRequestedItems(lineItemsData, panelId) {
  const requested    = lineItemsData.requested || {};
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);
  let html = '';

  const pendingLabels  = requested?.return?.return_label?.pending_label  || [];
  const completeLabels = requested?.return?.return_label?.complete_label || [];

  if (pendingLabels.length  > 0) html += aiPageRenderPendingLabels(pendingLabels, isRestricted, panelId);
  if (completeLabels.length > 0) html += aiPageRenderCompleteLabels(completeLabels, isRestricted, panelId);

  if (requested?.return?.self_ship)    html += aiPageRenderProcessedReturn(requested.return.self_ship,    'self_ship');
  if (requested?.return?.store_credit) html += aiPageRenderProcessedReturn(requested.return.store_credit, 'store_credit');
  if (requested?.return?.refund)       html += aiPageRenderProcessedReturn(requested.return.refund,       'refund');

  if (requested?.exchange?.length  > 0) html += aiPageRenderAlreadyRequestedExchange(requested.exchange, isRestricted);
  if (requested?.alteration?.length > 0) html += aiPageRenderAlreadyRequestedAlteration(requested.alteration, isRestricted);

  return html;
}


// ─────────────────────────────────────────────────────────────
// SHARED HELPERS
// ─────────────────────────────────────────────────────────────

/** Success / info / warning banner at the top of each accordion body */
function aiPageReqBanner(type, title, sub, badgeLabel, badgeColor) {
  if (type === 'cancelled') {
    return `
      <div class="ai-page-req-cancelled-banner">
        <span>⚠</span>
        <div>${title}. Please contact
          <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
        </div>
      </div>`;
  }
  const color = badgeColor || '#16a34a';
  return `
    <div class="ai-page-req-success-banner">
      <span class="ai-page-req-success-icon">✓</span>
      <div>
        <div class="ai-page-req-success-title">${title}</div>
        <div class="ai-page-req-success-sub">${sub}</div>
      </div>
      <span class="ai-page-req-fee-badge" style="background:${color};">${badgeLabel}</span>
    </div>`;
}

/** How-to steps box — left column */
function aiPageReqStepsBox(title, steps) {
  const lis = steps.map(s => `<li>${s}</li>`).join('');
  return `
    <div class="ai-page-req-steps-box">
      <div class="ai-page-req-steps-title">ℹ ${title}</div>
      <ol class="ai-page-req-steps-list">${lis}</ol>
    </div>`;
}

/** Download buttons — left column */
function aiPageReqDownloadBtns(labelUrl, qrUrl, isRestricted) {
  if (isRestricted) {
    return `<p class="ai-page-li-req-note" style="margin-top:6px;">
              Please visit
              <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307"
                 target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a>
              to generate your return label.
            </p>`;
  }
  let html = '';
  if (labelUrl) {
    html += `<a href="${aiPageEscHtml(labelUrl)}" target="_blank"
                class="ai-page-req-dl-btn ai-page-req-dl-btn-label">
               ⬇ Download Return Label
             </a>`;
  }
  if (qrUrl) {
    html += `<a href="${aiPageEscHtml(qrUrl)}" target="_blank"
                class="ai-page-req-dl-btn ai-page-req-dl-btn-qr">
               ⇄ Download QR Code
             </a>`;
  }
  return html;
}

/** Single product card — right column */
function aiPageReqProductCard(item, qtyLabel, statusHtml, badgeHtml) {
  const returning = item.return_qty || item.quantity || 1;

  // Faulty images
  let imagesHtml = '';
  if (Array.isArray(item.images) && item.images.length > 0) {
    const imageUrls = item.images.filter(Boolean);
    if (imageUrls.length > 0) {
      imagesHtml = `
        <div class="ai-page-req-faulty-images">
          <div class="ai-page-req-faulty-label">Uploaded Images:</div>
          <div class="ai-page-req-faulty-thumbs">
            ${imageUrls.map((imgUrl, i) => `
              <div class="ai-page-req-faulty-thumb"
                   onclick="aiPageReqImagePopupOpen(this, ${i})">
                <img src="${aiPageEscHtml(imgUrl)}" alt="Faulty image ${i + 1}" />
              </div>
            `).join('')}
          </div>
        </div>`;
    }
  }

  return `
    <div class="ai-page-req-product-card">
      <div class="ai-page-req-product-img">
        ${item.image
          ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
          : `<div class="ai-page-li-img-placeholder">G</div>`}
      </div>
      <div class="ai-page-req-product-info">
        <div class="ai-page-req-product-name">${aiPageEscHtml(item.name)}</div>
        <div class="ai-page-req-product-meta-grid">
          <div>
            <div class="ai-page-req-meta-label">SKU:</div>
            <div class="ai-page-req-meta-value">${aiPageEscHtml(item.sku)}</div>
          </div>
          <div>
            <div class="ai-page-req-meta-label">Price:</div>
            <div class="ai-page-req-meta-value ai-page-req-price">£${parseFloat(item.price || 0).toFixed(2)}</div>
          </div>
          <div>
            <div class="ai-page-req-meta-label">Ordered:</div>
            <div class="ai-page-req-meta-value">${item.quantity}</div>
          </div>
          <div>
            <div class="ai-page-req-meta-label">${qtyLabel}:</div>
            <div class="ai-page-req-meta-value">${returning}</div>
          </div>
        </div>
        ${imagesHtml}
        ${statusHtml
          ? `<div class="ai-page-req-product-status">${statusHtml}</div>`
          : badgeHtml}
      </div>
    </div>`;
}


/** Outer two-column wrapper */
function aiPageReqTwoCol(leftHtml, rightHtml) {
  return `<div class="ai-page-req-two-col">${leftHtml}${rightHtml}</div>`;
}




// ─────────────────────────────────────────────────────────────
// REQUESTED ITEMS — IMAGE PREVIEW POPUP (for server-hosted URLs)
// Reuses the same popup style as the faulty upload preview
// ─────────────────────────────────────────────────────────────

const _aiPageReqImagePopupState = { images: [], index: 0 };

function aiPageReqImagePopupOpen(thumb, index) {
  const container = thumb.closest('.ai-page-req-faulty-thumbs');
  const allThumbs = container.querySelectorAll('.ai-page-req-faulty-thumb img');
  _aiPageReqImagePopupState.images = [...allThumbs].map(img => img.src);
  _aiPageReqImagePopupState.index = index;

  let popup = document.getElementById('ai-page-req-img-popup');
  if (!popup) {
    const popupHtml = `
      <div id="ai-page-req-img-popup" class="ai-page-img-popup" hidden>
        <div class="ai-page-img-popup-overlay"
             onclick="aiPageReqImagePopupClose()"></div>
        <div class="ai-page-img-popup-box">
          <button class="ai-page-img-popup-close"
                  onclick="aiPageReqImagePopupClose()">✕</button>
          <button class="ai-page-img-popup-nav ai-page-img-popup-prev"
                  onclick="aiPageReqImagePopupNav(-1)">&#8249;</button>
          <div class="ai-page-img-popup-img-wrap">
            <img id="ai-page-req-img-popup-img" src="" alt="" />
          </div>
          <button class="ai-page-img-popup-nav ai-page-img-popup-next"
                  onclick="aiPageReqImagePopupNav(1)">&#8250;</button>
          <div class="ai-page-img-popup-counter"
               id="ai-page-req-img-popup-counter"></div>
        </div>
      </div>`;
    const panel = document.getElementById('ai-page-assistantPanel') || document.body;
    panel.insertAdjacentHTML('beforeend', popupHtml);
    popup = document.getElementById('ai-page-req-img-popup');
  }

  _aiPageReqImagePopupRender();
  popup.removeAttribute('hidden');
}


function aiPageReqImagePopupClose() {
  const popup = document.getElementById('ai-page-req-img-popup');
  if (popup) popup.setAttribute('hidden', '');
}

function aiPageReqImagePopupNav(direction) {
  const state = _aiPageReqImagePopupState;
  if (!state.images.length) return;
  state.index = (state.index + direction + state.images.length) % state.images.length;
  _aiPageReqImagePopupRender();
}

function _aiPageReqImagePopupRender() {
  const state   = _aiPageReqImagePopupState;
  const imgEl   = document.getElementById('ai-page-req-img-popup-img');
  const counter = document.getElementById('ai-page-req-img-popup-counter');
  const popup   = document.getElementById('ai-page-req-img-popup');

  if (imgEl) imgEl.src = state.images[state.index] || '';
  if (counter) counter.textContent = `${state.index + 1} / ${state.images.length}`;

  if (popup) {
    const showNav = state.images.length > 1;
    const prev = popup.querySelector('.ai-page-img-popup-prev');
    const next = popup.querySelector('.ai-page-img-popup-next');
    if (prev) prev.style.visibility = showNav ? '' : 'hidden';
    if (next) next.style.visibility = showNav ? '' : 'hidden';
  }
}

// Keyboard navigation — extend existing listener
document.addEventListener('keydown', function(e) {
  const popup = document.getElementById('ai-page-req-img-popup');
  if (!popup || popup.hasAttribute('hidden')) return;
  if (e.key === 'ArrowRight') aiPageReqImagePopupNav(1);
  if (e.key === 'ArrowLeft')  aiPageReqImagePopupNav(-1);
  if (e.key === 'Escape')     aiPageReqImagePopupClose();
});

// ─────────────────────────────────────────────────────────────
// 1. RETURN FEE PENDING
// ─────────────────────────────────────────────────────────────


function aiPageRenderPendingLabels(pendingLabels, isRestricted, panelId) {
  let html = `
    <div class="ai-page-li-requested-separator" style="grid-column: 1 / -1;">
      <div class="ai-page-li-req-badge ai-page-li-req-badge-danger">Return Fee Pending</div>`;

  pendingLabels.forEach((label, labelIdx) => {
    label.items?.forEach((seller, sellerIdx) => {
      const totalItems = seller.items?.length || 0;
      const listId     = `ai-page-req-pending_${panelId}_${labelIdx}_${sellerIdx}`;

      html += `<div class="ai-page-li-req-accordion">
        <div class="ai-page-li-req-acc-header" onclick="aiPageReqAccToggle(this)">
          <span class="ai-page-li-req-acc-arrow open">▾</span>
          Return Fee Pending — ${aiPageEscHtml(label.requested_date || '')}
        </div>
        <div class="ai-page-li-req-acc-body">`;

      html += aiPageReqBanner('warning',
        'Payment Required',
        'Please complete the return fee payment to download your return label.',
        'Fee Pending', '#f59e0b');

      html += `<div class="ai-page-req-brand-title">${aiPageEscHtml(seller.brand || '')}</div>`;

      const leftCol = `
        <div class="ai-page-req-col-steps">
          <div class="ai-page-req-col-heading"><span>💳</span> Payment Required</div>
          <div class="ai-page-req-col-sub">Complete payment to proceed with your return</div>
          ${aiPageReqStepsBox('How to Complete Your Return:', [
            'Click the "Pay for Return Label" button below',
            'Complete the one-time payment for the return label',
            'Return to this page after payment',
            'Download your return label and QR code',
            'Pack your item and drop off at any authorised location',
          ])}
          ${aiPagePendingLabelPayBtn(seller.items?.[0], label)}
          <p class="ai-page-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const statusHtml = aiPagePendingItemStatus(item);
        const hiddenClass = itemIdx >= 1 ? ' ai-page-req-product-hidden' : '';
        rightItems += `<div class="ai-page-req-product-item${hiddenClass}">
          ${aiPageReqProductCard(
            item,
            'Returning',
            statusHtml,
            `<span class="ai-page-req-ready-badge" style="background:#fef3c7;color:#d97706;">Awaiting Payment</span>`
          )}
        </div>`;
      });

      const showMoreBtn = totalItems > 1
        ? `<button class="ai-page-req-show-more-btn" type="button"
                   onclick="aiPageReqToggleProducts(this, '${listId}')">
             Show ${totalItems - 1} More Item${totalItems - 1 !== 1 ? 's' : ''} ▾
           </button>`
        : '';

      const rightCol = `
        <div class="ai-page-req-col-products">
          <div class="ai-page-req-col-heading-row">
            <div class="ai-page-req-col-heading"><span>📋</span> Return Items</div>
            <span class="ai-page-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="ai-page-req-col-sub">Items pending return fee payment</div>
          <div class="ai-page-req-products-list" id="${listId}">
            ${rightItems}
          </div>
          ${showMoreBtn}
        </div>`;

      html += aiPageReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

/** Pay button or cancelled/declined message — shown in left column */
function aiPagePendingLabelPayBtn(item, label) {
  if (!item) return '';

  if (item.return_request_item_status_id == 4) {
    const type = item.return_request_item_cancelled_type;
    if (type === 'admin' || type === 'system') {
      return `<p class="ai-page-li-req-text-danger">Return request was declined by Admin because return fee was not paid.</p>`;
    }
    return `<p class="ai-page-li-req-text-danger">Return request cancelled by you.</p>`;
  }
  if (item.return_request_item_status_id == 3) {
    return `<p class="ai-page-li-req-text-danger">Return request was declined by Admin.</p>`;
  }
  if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
    let html = `
      <a href="javascript:;"
         class="ai-page-req-dl-btn"
         style="background:#f59e0b;color:#fff !important;margin-bottom:5px;"
         data-invoice-url="${aiPageEscHtml(item.lable_invoice_url || '')}"
         onclick="aiPageOpenPaymentFromPending(this)">
        💳 Pay for Return Label
      </a>
      <p class="ai-page-li-req-note">A one-time payment is required. After payment, your label will be available to download.</p>`;

    // Faulty images — shown in left column below pay button
    if (Array.isArray(item.images) && item.images.length > 0) {
      html += `<div class="ai-page-li-req-faulty-imgs">`;
      item.images.forEach((imgUrl, i) => {
        if (imgUrl) {
          html += `<a href="${aiPageEscHtml(imgUrl)}" target="_blank" class="ai-page-li-req-faulty-thumb">
                     <img src="${aiPageEscHtml(imgUrl)}" alt="Faulty image ${i + 1}" />
                   </a>`;
        }
      });
      html += `</div>`;
    }
    return html;
  }
  return '';
}

/** Per-item status for pending — only error/declined states */
function aiPagePendingItemStatus(item) {
  if (item.return_request_item_status_id == 4) {
    const type = item.return_request_item_cancelled_type;
    if (type === 'admin' || type === 'system') {
      return `<p class="ai-page-li-req-text-danger">Declined by Admin.</p>`;
    }
    return `<p class="ai-page-li-req-text-danger">Cancelled by you.</p>`;
  }
  if (item.return_request_item_status_id == 3) {
    return `<p class="ai-page-li-req-text-danger">Declined by Admin.</p>`;
  }
  return ''; // badge shows instead
}


// ─────────────────────────────────────────────────────────────
// 2. RETURN FEE PAID / DOWNLOAD LABEL
// ─────────────────────────────────────────────────────────────


function aiPageRenderCompleteLabels(completeLabels, isRestricted, panelId) {
  let html = `
    <div class="ai-page-li-requested-separator">
      <div class="ai-page-li-req-badge ai-page-li-req-badge-info">Return Fee Paid</div>`;

  completeLabels.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="ai-page-li-req-accordion">
        <div class="ai-page-li-req-acc-header" onclick="aiPageReqAccToggle(this)">
          <span class="ai-page-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Return on ${aiPageEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="ai-page-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach((seller, sellerIdx) => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;
      const listId      = `ai-page-req-products_${panelId}_${index}_${sellerIdx}`;

      // Banner
      html += isCancelled
        ? aiPageReqBanner('cancelled', 'Return request was cancelled or declined', '', '', '')
        : aiPageReqBanner('success',
            'Return Request Successful!',
            'Your return has been processed and labels are ready for download.',
            'Fee Paid', '#16a34a');

      // Brand title
      html += `<div class="ai-page-req-brand-title">${aiPageEscHtml(seller.brand || '')}</div>`;

      // Left column
      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? aiPageReqStepsBox('How to Return:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
          ])
        : '';

      const leftCol = `
        <div class="ai-page-req-col-steps">
          <div class="ai-page-req-col-heading"><span>📦</span> Next Steps</div>
          <div class="ai-page-req-col-sub">Follow these steps to complete your return</div>
          ${stepsHtml}
          ${!isCancelled ? aiPageReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="ai-page-li-req-note" style="margin-top:8px;">
            If you have any questions, please reach out to
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      // Right column — build cards with show more/less
      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const statusHtml = aiPageCompleteLabelItemStatus(item, isRestricted);
        const hiddenClass = itemIdx >= 1 ? ' ai-page-req-product-hidden' : '';
        rightItems += `<div class="ai-page-req-product-item${hiddenClass}">
          ${aiPageReqProductCard(
            item, 'Returning', statusHtml,
            `<span class="ai-page-req-ready-badge">Ready to Return</span>`
          )}
        </div>`;
      });

      const showMoreBtn = totalItems > 1
        ? `<button class="ai-page-req-show-more-btn" type="button"
                   onclick="aiPageReqToggleProducts(this, '${listId}')">
             Show ${totalItems - 1} More Item${totalItems - 1 !== 1 ? 's' : ''} ▾
           </button>`
        : '';

      const rightCol = `
        <div class="ai-page-req-col-products">
          <div class="ai-page-req-col-heading-row">
            <div class="ai-page-req-col-heading"><span>📋</span> Returned Products</div>
            <span class="ai-page-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="ai-page-req-col-sub">Items included in this return</div>
          <div class="ai-page-req-products-list" id="${listId}">
            ${rightItems}
          </div>
          ${showMoreBtn}
        </div>`;

      html += aiPageReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}



function aiPageReqToggleProducts(btn, listId) {
  const list = document.getElementById(listId);
  if (!list) return;

  const isExpanded = list.dataset.expanded === '1';
  const hiddenItems = list.querySelectorAll('.ai-page-req-product-hidden');
  const totalHidden = hiddenItems.length;

  if (isExpanded) {
    list.dataset.expanded = '0';
    hiddenItems.forEach(el => el.classList.remove('ai-page-req-product-visible'));
    btn.textContent = `Show ${totalHidden} More Item${totalHidden !== 1 ? 's' : ''} ▾`;
  } else {
    list.dataset.expanded = '1';
    hiddenItems.forEach(el => el.classList.add('ai-page-req-product-visible'));
    btn.textContent = 'Show Less ▴';
  }
}

function aiPageCompleteLabelItemStatus(item, isRestricted) {
  if (isRestricted) return ''; // Omniparcel shown in left column
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if ((item.lable_type == 1 || item.lable_type == 2) && item.lable_type_url === 'error') {
        return `<p class="ai-page-li-req-text-danger">Label generation failed. Please contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
      }
      if (item.lable_type == 3) {
        return `<a href="${aiPageEscHtml(item.lable_type_url || '')}" target="_blank" class="ai-page-li-req-btn">Download Return Note</a>
                <p class="ai-page-li-req-note">Self-ship — send back at your own expense.</p>`;
      }
      if (item.lable_type == 6) {
        return `<p class="ai-page-li-req-text-success">Refund of £${parseFloat(item.refund_total_amount || 0).toFixed(2)} processed to your original payment method.</p>`;
      }
      return ''; // label shown at brand level
    }
    if (item.refund_status_id == 3) {
      return `<p class="ai-page-li-req-text-danger">Return request <strong>Declined</strong>. Please contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }
    if (item.refund_status_id == 6) {
      return `<p class="ai-page-li-req-text-success">Refund of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> successfully processed for <strong>${item.return_qty} qty</strong>.</p>`;
    }
    return `<p class="ai-page-li-req-note">Return completed — Qty: ${item.return_qty}.</p>`;
  }
  if (item.is_return == 2 && item.lable_type == 5) {
    return `<p class="ai-page-li-req-text-success">Gift Voucher of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> sent to your email.</p>`;
  }
  if (item.is_return == 3) {
    return `<p class="ai-page-li-req-text-danger">Already requested for exchange — cannot place a return request.</p>`;
  }
  if (item.alteration_request_status != null) {
    return `<p class="ai-page-li-req-text-danger">Already requested for alteration — cannot place a return request.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 3. SELF SHIP / STORE CREDIT / REFUND
// ─────────────────────────────────────────────────────────────

function aiPageRenderProcessedReturn(sellerwiseItems, key) {
  const config = {
    self_ship    : { badge: 'Self-Ship Return Requested', badgeClass: 'ai-page-li-req-badge-info',    bannerTitle: 'Self-Ship Return Confirmed!',   bannerSub: 'Pack your item and send it back using your own courier.',    badgeLabel: 'Self-Ship', badgeColor: '#2563eb', icon: '📦', heading: 'Return Items', qtyLabel: 'Returning',   readyLabel: 'Ready to Ship',      readyBg: '#dbeafe', readyColor: '#2563eb' },
    store_credit : { badge: 'Store Credit Issued',        badgeClass: 'ai-page-li-req-badge-success', bannerTitle: 'Store Credit Issued!',          bannerSub: 'A gift voucher has been sent to your email address.',        badgeLabel: 'Gift Card', badgeColor: '#16a34a', icon: '🎁', heading: 'Items Kept',  qtyLabel: 'Kept',        readyLabel: 'Gift Card Issued',   readyBg: '#dcfce7', readyColor: '#16a34a' },
    refund       : { badge: 'Refund Issued',              badgeClass: 'ai-page-li-req-badge-success', bannerTitle: 'Refund Processed!',             bannerSub: 'Your refund has been issued to your original payment method.', badgeLabel: 'Refunded',  badgeColor: '#16a34a', icon: '💰', heading: 'Refunded Items', qtyLabel: 'Refunded',  readyLabel: 'Refund Issued',      readyBg: '#dcfce7', readyColor: '#16a34a' },
  };
  const c = config[key];

  let html = `
    <div class="ai-page-li-requested-separator">
      <div class="ai-page-li-req-badge ${c.badgeClass}">${c.badge}</div>`;

  sellerwiseItems.forEach((sellerwiseItem, groupIndex) => {
    const totalItems = sellerwiseItem.items?.length || 0;

    html += `<div class="ai-page-li-req-accordion">
      <div class="ai-page-li-req-acc-header" onclick="aiPageReqAccToggle(this)">
        <span class="ai-page-li-req-acc-arrow ${groupIndex === 0 ? 'open' : ''}">▾</span>
        ${c.badge} — ${aiPageEscHtml(sellerwiseItem.requested_date || sellerwiseItem.items?.[0]?.requested_date || '')}
      </div>
      <div class="ai-page-li-req-acc-body" ${groupIndex === 0 ? '' : 'style="display:none;"'}>`;

    // Banner
    html += aiPageReqBanner('success', c.bannerTitle, c.bannerSub, c.badgeLabel, c.badgeColor);

    // Brand title
    const brand = sellerwiseItem.brand || sellerwiseItem.items?.[0]?.brand || '';
    html += `<div class="ai-page-req-brand-title">${aiPageEscHtml(brand)}</div>`;

    // Left column — instructions specific to each type
    let stepsContent = '';
    if (key === 'self_ship') {
      stepsContent = aiPageReqStepsBox('How to Self-Ship:', [
        'Download your return note below',
        'Pack your item(s) securely in the original packaging',
        'Include the return note inside the package',
        'Send using your preferred courier at your own expense',
      ]);
      // Self-ship return note button — per item
      sellerwiseItem.items?.forEach(item => {
        if (item.lable_type == 3 && item.lable_type_url) {
          stepsContent += `<a href="${aiPageEscHtml(item.lable_type_url)}" target="_blank"
                              class="ai-page-req-dl-btn ai-page-req-dl-btn-label">
                             ⬇ Download Return Note
                           </a>`;
        }
        if (item.lable_type == 1 && item.lable_type_url) {
          stepsContent += `<a href="${aiPageEscHtml(item.lable_type_url)}" target="_blank"
                              class="ai-page-req-dl-btn ai-page-req-dl-btn-label">
                             ⬇ Download Return Label
                           </a>`;
        }
        if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
          stepsContent += `<a href="javascript:;"
                              class="ai-page-req-dl-btn"
                              style="background:#f59e0b;color:#fff !important;"
                              data-invoice-url="${aiPageEscHtml(item.lable_invoice_url || '')}"
                              onclick="aiPageOpenPaymentFromPending(this)">
                             💳 Pay for Return Label
                           </a>`;
        }
      });
    } else if (key === 'store_credit') {
      stepsContent = `
        <div class="ai-page-req-steps-box">
          <div class="ai-page-req-steps-title">ℹ Store Credit Details:</div>
          <ol class="ai-page-req-steps-list">
            <li>A gift voucher has been emailed to you</li>
            <li>Check your inbox (and spam/junk folder)</li>
            <li>Use the voucher code on your next Goddiva order</li>
            <li>The item can remain with you — no need to return it</li>
          </ol>
        </div>`;
    } else if (key === 'refund') {
      stepsContent = `
        <div class="ai-page-req-steps-box">
          <div class="ai-page-req-steps-title">ℹ Refund Details:</div>
          <ol class="ai-page-req-steps-list">
            <li>Your refund has been issued to your original payment method</li>
            <li>Please allow 3–5 business days for it to appear</li>
            <li>The item can remain with you — no need to return it</li>
          </ol>
        </div>`;
    }

    const leftCol = `
      <div class="ai-page-req-col-steps">
        <div class="ai-page-req-col-heading"><span>${c.icon}</span> ${key === 'self_ship' ? 'Next Steps' : 'Summary'}</div>
        <div class="ai-page-req-col-sub">${c.bannerSub}</div>
        ${stepsContent}
        <p class="ai-page-li-req-note" style="margin-top:8px;">
          If you have any questions, please contact
          <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
        </p>
      </div>`;

    // Right column — items
    let rightItems = '';
    sellerwiseItem.items?.forEach(item => {
      const statusHtml = aiPageProcessedReturnStatus(item, key);
      rightItems += aiPageReqProductCard(
        item, c.qtyLabel, statusHtml,
        `<span class="ai-page-req-ready-badge" style="background:${c.readyBg};color:${c.readyColor};">${c.readyLabel}</span>`
      );
    });

    const rightCol = `
      <div class="ai-page-req-col-products">
        <div class="ai-page-req-col-heading-row">
          <div class="ai-page-req-col-heading"><span>📋</span> ${c.heading}</div>
          <span class="ai-page-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
        </div>
        <div class="ai-page-req-col-sub">Items included in this ${key.replace('_', ' ')}</div>
        ${rightItems}
      </div>`;

    html += aiPageReqTwoCol(leftCol, rightCol);
    html += `</div></div>`;
  });

  html += `</div>`;
  return html;
}

function aiPageProcessedReturnStatus(item, key) {
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if (item.lable_type == 2 && item.lable_status === 'Pending Payment') {
        return `<p class="ai-page-li-req-text-danger">Return fee payment pending.</p>`;
      }
      if (item.lable_type == 6) {
        return `<p class="ai-page-li-req-text-success">Refund of £${parseFloat(item.refund_total_amount || 0).toFixed(2)} processed.</p>`;
      }
      return ''; // badge shows
    }
    if (item.refund_status_id == 3) {
      return `<p class="ai-page-li-req-text-danger">Request <strong>Declined</strong>. Contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
    }
    if (item.refund_status_id == 6) {
      return `<p class="ai-page-li-req-text-success">Refund of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> processed for <strong>${item.return_qty} qty</strong>.</p>`;
    }
    return `<p class="ai-page-li-req-note">Completed — Qty: ${item.return_qty}.</p>`;
  }
  if (item.is_return == 2 && item.lable_type == 5) {
    return `<p class="ai-page-li-req-text-success">Gift Voucher of <strong>£${parseFloat(item.refund_total_amount || 0).toFixed(2)}</strong> sent.</p>`;
  }
  if (item.is_return == 3) {
    return `<p class="ai-page-li-req-text-danger">Already requested for exchange.</p>`;
  }
  if (item.alteration_request_status != null) {
    return `<p class="ai-page-li-req-text-danger">Already requested for alteration.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 4. ALREADY REQUESTED FOR EXCHANGE
// ─────────────────────────────────────────────────────────────

function aiPageRenderAlreadyRequestedExchange(exchangeRequests, isRestricted) {
  let html = `
    <div class="ai-page-li-requested-separator">
      <div class="ai-page-li-req-badge ai-page-li-req-badge-info">Already Requested for Exchange</div>`;

  exchangeRequests.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="ai-page-li-req-accordion">
        <div class="ai-page-li-req-acc-header" onclick="aiPageReqAccToggle(this)">
          <span class="ai-page-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Exchange on ${aiPageEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="ai-page-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach(seller => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;

      html += isCancelled
        ? aiPageReqBanner('cancelled', 'Exchange request was cancelled or declined', '', '', '')
        : aiPageReqBanner('success',
            'Exchange Request Successful!',
            'Please send back the item using the return label below.',
            'Exchange', '#2563eb');

      html += `<div class="ai-page-req-brand-title">${aiPageEscHtml(seller.brand || '')}</div>`;

      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? aiPageReqStepsBox('How to Return for Exchange:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
          ])
        : '';

      const leftCol = `
        <div class="ai-page-req-col-steps">
          <div class="ai-page-req-col-heading"><span>🔄</span> Next Steps</div>
          <div class="ai-page-req-col-sub">Follow these steps to complete your exchange</div>
          ${stepsHtml}
          ${!isCancelled ? aiPageReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="ai-page-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach(item => {
        const statusHtml = aiPageExchangeItemStatus(item, isRestricted);
        rightItems += aiPageReqProductCard(
          item, 'Exchanging', statusHtml,
          `<span class="ai-page-req-ready-badge" style="background:#dbeafe;color:#2563eb;">Ready to Exchange</span>`
        );
      });

      const rightCol = `
        <div class="ai-page-req-col-products">
          <div class="ai-page-req-col-heading-row">
            <div class="ai-page-req-col-heading"><span>📋</span> Exchanged Items</div>
            <span class="ai-page-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="ai-page-req-col-sub">Items included in this exchange</div>
          ${rightItems}
        </div>`;

      html += aiPageReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

function aiPageExchangeItemStatus(item, isRestricted) {
  if (isRestricted) return '';
  if (item.is_return == 1) {
    if (item.refund_status_id == 1) {
      if ((item.lable_type == 1 || item.lable_type == 2) && item.lable_type_url === 'error') {
        return `<p class="ai-page-li-req-text-danger">Label generation failed. Contact <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a></p>`;
      }
      return ''; // label at brand level
    }
    if (item.refund_status_id == 3) {
      return `<p class="ai-page-li-req-text-danger">Exchange request <strong>Declined</strong>.</p>`;
    }
    return `<p class="ai-page-li-req-text-success">Exchange completed from order ${aiPageEscHtml(item.exchange_order || '')} — Qty: ${item.return_qty}.</p>`;
  }
  return '';
}


// ─────────────────────────────────────────────────────────────
// 5. ALREADY REQUESTED FOR ALTERATION
// ─────────────────────────────────────────────────────────────

function aiPageRenderAlreadyRequestedAlteration(alterationRequests, isRestricted) {
  let html = `
    <div class="ai-page-li-requested-separator">
      <div class="ai-page-li-req-badge ai-page-li-req-badge-info">Already Requested for Alteration</div>`;

  alterationRequests.forEach((returnRequest, index) => {
    const isOpen      = index === 0 ? 'open' : '';
    const statusId    = returnRequest.return_request_status_id;
    const isCancelled = statusId == 4;

    html += `
      <div class="ai-page-li-req-accordion">
        <div class="ai-page-li-req-acc-header" onclick="aiPageReqAccToggle(this)">
          <span class="ai-page-li-req-acc-arrow ${isOpen}">▾</span>
          Items Requested for Alteration on ${aiPageEscHtml(returnRequest.requested_date || '')}
        </div>
        <div class="ai-page-li-req-acc-body" ${isOpen ? '' : 'style="display:none;"'}>`;

    returnRequest.items?.forEach(seller => {
      const labelUrl    = seller.label_url  || '';
      const qrUrl       = seller.qrcode_url || '';
      const hasTracking = seller.items?.[0]?.return_tracking?.tracking_id;
      const totalItems  = seller.items?.length || 0;

      html += isCancelled
        ? aiPageReqBanner('cancelled', 'Alteration request was cancelled or declined', '', '', '')
        : aiPageReqBanner('success',
            'Alteration Request Successful!',
            'Please send back the item so we can complete the alterations for you.',
            'Alteration', '#7c3aed');

      html += `<div class="ai-page-req-brand-title">${aiPageEscHtml(seller.brand || '')}</div>`;

      const stepsHtml = (!isCancelled && (hasTracking || labelUrl || isRestricted))
        ? aiPageReqStepsBox('How to Send for Alteration:', [
            isRestricted
              ? `Visit <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307" target="_blank" style="color:#1d4ed8;">omniparcelreturns.com</a> to generate your return label`
              : 'Download your return label and QR code below',
            'Pack your item(s) securely in the original packaging',
            'Attach the return label to your package',
            'Drop off at any authorised location or schedule pickup',
            'Your item will be tailored and returned within 7–14 days',
          ])
        : '';

      const leftCol = `
        <div class="ai-page-req-col-steps">
          <div class="ai-page-req-col-heading"><span>✂️</span> Next Steps</div>
          <div class="ai-page-req-col-sub">Follow these steps to complete your alteration</div>
          ${stepsHtml}
          ${!isCancelled ? aiPageReqDownloadBtns(labelUrl, qrUrl, isRestricted) : ''}
          <p class="ai-page-li-req-note" style="margin-top:8px;">
            If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>`;

      let rightItems = '';
      seller.items?.forEach((item, itemIdx) => {
        const uid = `alt_req_${item.id}_${index}_${itemIdx}`;
        const returning = item.return_qty || item.quantity || 1;
        const statusHtml = aiPageAlterationItemStatus(item, isRestricted);

        rightItems += `
          <div class="ai-page-req-product-card">
            <div class="ai-page-req-product-img">
              ${item.image
                ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
                : `<div class="ai-page-li-img-placeholder">G</div>`}
            </div>
            <div class="ai-page-req-product-info">
              <div class="ai-page-req-product-name">${aiPageEscHtml(item.name)}</div>
              <div class="ai-page-li-price">£${parseFloat(item.price || 0).toFixed(2)}</div>

              <button class="ai-page-li-view-details-btn" type="button"
                      onclick="aiPageToggleDetails(this, 'ai-page-det_${uid}')">
                ${aiPageInfoIcon()} View Details
                <span class="ai-page-li-chevron">▾</span>
              </button>
              <div id="ai-page-det_${uid}" class="ai-page-li-detail-panel" hidden>
                <div class="ai-page-li-detail-grid">
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">SKU</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.sku || '—')}</div>
                  </div>
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Size</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div>
                  </div>
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Colour</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div>
                  </div>
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Ordered</div>
                    <div class="ai-page-li-dv">${item.quantity || 1}</div>
                  </div>
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Altering</div>
                    <div class="ai-page-li-dv">${returning}</div>
                  </div>
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Brand</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div>
                  </div>
                  ${item.alteration_request_status ? `
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Status</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.alteration_request_status)}</div>
                  </div>` : ''}
                  ${item.alteration_request_length ? `
                  <div class="ai-page-li-dc">
                    <div class="ai-page-li-dl">Requested Length (cm)</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.alteration_request_length)}</div>
                  </div>` : ''}
                  ${item.alteration_request_note?.trim() ? `
                  <div class="ai-page-li-dc" style="grid-column: 1 / -1;">
                    <div class="ai-page-li-dl">Note</div>
                    <div class="ai-page-li-dv">${aiPageEscHtml(item.alteration_request_note)}</div>
                  </div>` : ''}
                </div>

                ${item.alteration_request_trackings?.length > 0 ? `
                <div style="margin-top:6px;display:none">
                  ${item.alteration_request_trackings.map(t => `
                    <a href="${aiPageEscHtml(t.tracking_url)}" target="_blank"
                       class="ai-page-req-dl-btn ai-page-req-dl-btn-label"
                       style="margin-bottom:4px;font-size:10px;">
                      ${aiPageEscHtml(t.tracking_name)} — ${aiPageEscHtml(t.tracking_id)}
                    </a>
                  `).join('')}
                </div>` : ''}

                ${item.alteration_request_status === 'Pending' && item.return_tracking?.label_url && item.return_tracking.label_url !== 'error' ? `
                <div style="margin-top:6px;display:flex;gap:6px;flex-wrap:wrap;display:none">
                  <a href="${aiPageEscHtml(item.return_tracking.label_url)}" target="_blank"
                     class="ai-page-req-dl-btn ai-page-req-dl-btn-label">
                    ⬇ Download Return Label
                  </a>
                  ${item.return_tracking.qrcode_url && item.return_tracking.qrcode_url !== 'error' ? `
                  <a href="${aiPageEscHtml(item.return_tracking.qrcode_url)}" target="_blank"
                     class="ai-page-req-dl-btn ai-page-req-dl-btn-qr">
                    ⇄ Download QR Code
                  </a>` : ''}
                </div>` : ''}
              </div>

              ${statusHtml
                ? `<div class="ai-page-req-product-status">${statusHtml}</div>`
                : `<span class="ai-page-req-ready-badge" style="background:#ede9fe;color:#7c3aed;">Ready to Alter</span>`}
            </div>
          </div>`;
      });

      const rightCol = `
        <div class="ai-page-req-col-products">
          <div class="ai-page-req-col-heading-row">
            <div class="ai-page-req-col-heading"><span>📋</span> Alteration Items</div>
            <span class="ai-page-req-item-count">${totalItems} Item${totalItems !== 1 ? 's' : ''}</span>
          </div>
          <div class="ai-page-req-col-sub">Items included in this alteration</div>
          ${rightItems}
        </div>`;

      html += aiPageReqTwoCol(leftCol, rightCol);
      html += `</div></div>`;
    });
  });

  html += `</div>`;
  return html;
}

function aiPageAlterationItemStatus(item, isRestricted) {
  if (isRestricted) return '';
  if (item.alteration_request_status == null) return '';

  let html = `
    <div class="ai-page-req-meta-label" style="margin-top:4px;display:none">Status:</div>
    <div class="ai-page-req-meta-value" style="margin-bottom:3px;display:none">${aiPageEscHtml(item.alteration_request_status)}</div>`;

  if (item.alteration_request_length) {
    html += `<div class="ai-page-req-meta-label" style="display:none">Requested Length (cm):</div>
             <div class="ai-page-req-meta-value" style="margin-bottom:3px;display:none">${aiPageEscHtml(item.alteration_request_length)}</div>`;
  }

  if (item.alteration_request_note?.trim()) {
    html += `<div class="ai-page-req-meta-label" style="display:none">Note:</div>
             <div class="ai-page-req-meta-value" style="margin-bottom:3px;display:none">${aiPageEscHtml(item.alteration_request_note)}</div>`;
  }

  if (item.alteration_request_trackings?.length > 0) {
    html += `<div class="ai-page-req-meta-label" style="margin-bottom:2px;display:none">Tracking:</div>`;
    item.alteration_request_trackings.forEach(t => {
      html += `<a href="${aiPageEscHtml(t.tracking_url)}" target="_blank" class="ai-page-li-req-btn" style="margin-bottom:2px;">
                 ${aiPageEscHtml(t.tracking_name)} — ${aiPageEscHtml(t.tracking_id)}
               </a>`;
    });
  }

  // Per-item label (alteration pending state)
  if (item.alteration_request_status === 'Pending' && item.return_tracking?.label_url) {
    if (item.return_tracking.label_url !== 'error') {
      html += `<a href="${aiPageEscHtml(item.return_tracking.label_url)}" target="_blank"
                  class="ai-page-req-dl-btn ai-page-req-dl-btn-label" style="margin-top:4px;display:none">
                 ⬇ Download Return Label
               </a>`;
    }
    if (item.return_tracking.qrcode_url && item.return_tracking.qrcode_url !== 'error') {
      html += `<a href="${aiPageEscHtml(item.return_tracking.qrcode_url)}" target="_blank"
                  class="ai-page-req-dl-btn ai-page-req-dl-btn-qr" style="display:none">
                 ⇄ Download QR Code
               </a>`;
    }
  }

  return html;
}


// ─────────────────────────────────────────────────────────────
// SHARED UTILITIES
// ─────────────────────────────────────────────────────────────

function aiPageReqAccToggle(header) {
  const body  = header.nextElementSibling;
  const arrow = header.querySelector('.ai-page-li-req-acc-arrow');
  const isOpen = body.style.display !== 'none';
  body.style.display = isOpen ? 'none' : 'block';
  if (arrow) arrow.classList.toggle('open', !isOpen);
}

function aiPageOpenPaymentFromPending(btn) {
  const invoiceUrl = btn.dataset.invoiceUrl;
  if (!invoiceUrl) return;

  // Walk up to panel or standalone wrapper — mirrors both render paths
  const container = btn.closest('.ai-page-li-panel')
                 || btn.closest('.ai-page-li-requested-only');
  const panelId = container?.id;
  if (!panelId) return;

  const content = document.getElementById(`ai-page-pay-content_${panelId}`);
  if (!content) return;

  const shippingCode = container?.dataset?.shippingCode || '';
  const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);
  const returnFee    = parseFloat(container?.dataset?.returnFee || 0) || 1.99;

  // Read pending labels stored on container
  let pendingLabels = [];
  try {
    pendingLabels = JSON.parse(container.dataset.pendingLabels || '[]');
  } catch(e) { pendingLabels = []; }

  let html = `
    <h3 style="margin:0 0 12px;font-size:14px;font-weight:700;">Return Fee Pending</h3>
    <p style="font-size:12px;margin:0 0 10px;color:#374151;">
      You previously selected the Return Label option for some items but have not yet paid
      the associated fees. Below are the pending return label charges. Once the payment is
      completed, you will be able to download the return label.
    </p>`;

  // Build groupedData for Pusher label download after payment
  const grouped = [];

  pendingLabels.forEach((label, index) => {
    // Same skip condition as old portal
    const skip =
      label.return_request_status_id      == 5 &&
      label.return_request_item_status_id == 4 &&
      label.return_request_financial_status == null &&
      label.is_return_fee                 == 1;
    if (skip) return;

    const invoiceNumber   = index + 1;
    const returnRequestId = label.return_request_id || '';

    html += `
      <div class="ai-page-pay-accordion">
        <div class="ai-page-pay-acc-header" onclick="aiPagePayAccToggle(this)"
             style="display:flex;align-items:center;justify-content:space-between;">
          <span>
            <span class="ai-page-pay-acc-arrow open">▾</span>
            Return Fee #${invoiceNumber}
          </span>
          <a class="ai-page-pay-now-btn"
             href="${aiPageEscHtml(label.invoice_url || '')}"
             target="_blank"
             rel="noopener noreferrer"
             data-return-request-id="${returnRequestId}"
             data-panel-id="${panelId}"
             onclick="aiPagePayNowClick(this)"
             style="font-size:11px;margin-left:8px;">
            Pay Now
          </a>
        </div>
        <div class="ai-page-pay-acc-body" style="display:block;">`;

    if (isRestricted) {
      html += `
        <p style="font-size:12px;color:#374151;display:none;">
          You have selected the following items for return. A return fee of
          £${returnFee.toFixed(2)} is required before you can download the return label.
        </p>
        <p style="font-size:12px;color:#374151;">
          Now please go to this URL
          <a href="https://www.omniparcelreturns.com/bookreturn/booking_return/307"
             target="_blank" rel="noopener noreferrer" style="color:#1d4ed8;">
            https://www.omniparcelreturns.com/bookreturn/booking_return/307
          </a>
          and generate your return label. Thanks.
        </p>`;
    } else {
      html += `
        <p style="font-size:12px;color:#374151;">
          You have selected the following items for return. A return fee of
          £${returnFee.toFixed(2)} is required before you can download the return label.
        </p>`;

      // Error code — mirrors old portal: if (label.error_code !== 0)
      if (label.error_code !== 0) {
        html += `<div style="font-size:11px;color:#e74c3c;margin-bottom:8px;display:none">
                   Some error occurred. Error Code: ${aiPageEscHtml(String(label.error_code || ''))}
                 </div>`;
      }
    }

    html += `
      <p style="font-size:12px;color:#374151;${isRestricted ? 'display:none;' : ''}">
        Once this return fee is paid, you can download the return label for the following items:
      </p>`;

    // Loop sellers — mirrors old: label.items.forEach(sellerwiseItem)
    (label.items || []).forEach(seller => {
      html += `<h4 data-brand-id="${aiPageEscHtml(String(seller.brand_id || ''))}"
                   style="font-size:12px;font-weight:700;margin:8px 0 4px;"
                   class="ai-page-brand-fee-header">
                 ${aiPageEscHtml(seller.brand || '')}
               </h4>
               <ul class="ai-page-pay-sku-list">`;

      (seller.items || []).forEach(item => {
        html += `<li>${aiPageEscHtml(item.sku || '')}</li>`;

        // Build grouped for Pusher label injection after payment
        let group = grouped.find(g => g.brand_id === seller.brand_id);
        if (!group) {
          group = { brand_id: seller.brand_id, brand_name: seller.brand, items: [] };
          grouped.push(group);
        }
        group.items.push({ line_item_id: item.id, brand_id: seller.brand_id });
      });

      html += `</ul>`;
    });

    html += `</div></div>`;
  });

  // Store grouped for Pusher payment confirmation — same as aiPageShowPaymentPopup
  _aiPageGroupedData[panelId] = grouped;

  content.innerHTML = html;

  const popup = document.getElementById(`ai-page-pay-popup_${panelId}`);
  if (popup) popup.removeAttribute('hidden');
}




function aiPageRenderRequestedPopups(panelId) {
    return `
        <div id="ai-page-pay-popup_${panelId}"
             class="ai-page-pay-popup" hidden>
            <div class="ai-page-pay-overlay"></div>
            <div class="ai-page-pay-box">
                <button class="ai-page-pay-close"
                        onclick="aiPagePayPopupClose('${panelId}')">✕</button>
                <div id="ai-page-pay-content_${panelId}"></div>
            </div>
        </div>`;
}

//return implementation ends




//exchange implementation start

// ─────────────────────────────────────────────────────────────
// ENTRY POINT
// ─────────────────────────────────────────────────────────────

function aiPageRenderExchangePanel(items, lineItemsData) {
  const panelId      = `ai-page-exPanel_${Date.now()}`;
  const isActive     = lineItemsData.is_active_date == 1;
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);

  // Only build item cards if there are not_requested items
  const cards = (items && items.length)
    ? items.map((item, index) =>
        aiPageBuildExchangeCard(item, index, lineItemsData, panelId)
      ).join('')
    : '';

  // Already requested sections — mirrors portal exchange tab:
  // processAlreadyExchangeItems + alreadyRequested(Return) + alreadyRequested(Alteration)
  // + getOutletItemHtml + getNonReturnableItemHtml
  const requested = lineItemsData.requested || {};

  let alreadyRequestedHtml = '';

  // 1. Already exchanged — mirrors processAlreadyExchangeItems(data)
  if (requested?.exchange?.length > 0) {
    alreadyRequestedHtml += aiPageRenderAlreadyRequestedExchange(requested.exchange, isRestricted);
  }

  // 2. Already returned (complete_label) — mirrors alreadyRequested(..., 'Return')
  const completeItems = (requested?.return?.return_label?.complete_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  if (completeItems.length > 0) {
    alreadyRequestedHtml += aiPageRenderExAlreadyReturnedCards(completeItems, 'Return');
  }

  // 3. Already returned (pending_label) — mirrors alreadyRequested(..., 'Return')
  const pendingItems = (requested?.return?.return_label?.pending_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  if (pendingItems.length > 0) {
    alreadyRequestedHtml += aiPageRenderExAlreadyReturnedCards(pendingItems, 'Return');
  }

  // 4. Already altered — mirrors alreadyRequested(..., 'Alteration')
  if (requested?.alteration?.length > 0) {
    alreadyRequestedHtml += aiPageRenderAlreadyRequestedAlteration(requested.alteration, isRestricted);
  }

  // 5. Outlet items — mirrors getOutletItemHtml(data, 'exchange') — partner 1 only
  if (lineItemsData.partner_id == 1) {
    const outletItems = (lineItemsData.outlet || []).flatMap(s => s.items || []);
    if (outletItems.length > 0) {
      alreadyRequestedHtml += aiPageRenderExOutletCards(outletItems);
    }
  }

  // 6. Non-returnable items — mirrors getNonReturnableItemHtml(data)
  if ((lineItemsData.nonReturnableItems || []).length > 0) {
    alreadyRequestedHtml += aiPageRenderNonReturnableItems(lineItemsData);
  }

  // If there are no new items AND no already-requested sections — nothing to render
  if (!cards && !alreadyRequestedHtml) return '';

  return `
    <div class="ai-page-ex-panel"
         id="${panelId}"
         data-original-query="${aiPageEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}">

      <div class="ai-page-li-sticky-top">
        <span><strong>Exchange Items:</strong> Select a product and choose the size or colour you'd like instead</span>
      </div>

      <div class="ai-page-li-select-all-bar">
        <label class="ai-page-li-select-all-label">
          <input type="checkbox"
                 class="ai-page-li-checkbox ai-page-ex-select-all-chk"
                 onchange="aiPageExToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="ai-page-ex-selected-count">0 items selected</span>
      </div>

      <div class="ai-page-li-grid">
        ${cards}
        ${alreadyRequestedHtml}
      </div>

      <div class="ai-page-li-sticky-bottom">
        <!-- T&C -->
        <div class="ai-page-li-terms-wrapper" id="ai-page-ex-terms_${panelId}" style="display:none;">
          <label class="ai-page-li-terms-label">
            <input type="checkbox"
                   class="ai-page-ex-terms-chk"
                   id="ai-page-ex-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
          </label>
          <p class="ai-page-li-terms-error"
             id="ai-page-ex-terms-err_${panelId}"
             style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;">
            Please accept the terms and conditions.
          </p>
        </div>

        <button class="ai-page-li-process-btn" disabled onclick="aiPageHandleExchange(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          EXCHANGE ITEMS
        </button>
      </div>

    </div>`;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE EXCHANGE CARD
// ─────────────────────────────────────────────────────────────

function aiPageRenderExAlreadyReturnedCards(items, type, action = 'exchanged') {
  if (!items.length) return '';
  let html = `
    <div class="ai-page-li-req-badge ai-page-li-req-badge-info ai-page-li-grid-full">
      Already Requested for ${type}
    </div>`;
  items.forEach((item, i) => {
    const uid = `already_${type}_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = (price !== gross)
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    html += `
      <div class="ai-page-li-card">
        <div class="ai-page-li-img-wrap">
          <div class="ai-page-li-img">
            ${item.image
              ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
              : `<div class="ai-page-li-img-placeholder">G</div>`}
          </div>
        </div>
        <div class="ai-page-li-body">
          <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
          <div class="ai-page-li-price">${priceHtml}</div>

          <button class="ai-page-li-view-details-btn" type="button"
                  onclick="aiPageToggleDetails(this, 'ai-page-det_${uid}')">
            ${aiPageInfoIcon()} View Details
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div id="ai-page-det_${uid}" class="ai-page-li-detail-panel" hidden>
            <div class="ai-page-li-detail-grid">
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Size</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Colour</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">SKU</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.sku || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Qty</div>
                <div class="ai-page-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Brand</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Tracking</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)} — ${aiPageEscHtml(item.tracking_id || '')}</div>
              </div>` : ''}
            </div>
          </div>

          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item has already been requested for ${type.toLowerCase()} and cannot be ${action}.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>
      </div>`;
  });
  return html;
}


function aiPageRenderExOutletCards(items) {
  if (!items.length) return '';
  let html = `
    <div class="ai-page-li-req-badge ai-page-li-req-badge-warn ai-page-li-grid-full">
      Outlet Item
    </div>`;
  items.forEach((item, i) => {
    const uid = `ex_outlet_${item.id}_${i}`;
    const price = parseFloat(item.price || 0);
    const gross = parseFloat(item.gross_price || 0);
    const priceHtml = (price !== gross)
      ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
      : `£${price.toFixed(2)}`;

    const outletBadge = `<div class="ai-page-li-badge ai-page-li-badge-outlet">Outlet</div>`;
    const gradeBadge = item.grade
      ? `<div class="ai-page-li-badge ai-page-li-badge-grade">Grade ${item.grade}</div>` : '';

    html += `
      <div class="ai-page-li-card">
        <div class="ai-page-li-img-wrap">
          <div class="ai-page-li-img">
            ${item.image
              ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
              : `<div class="ai-page-li-img-placeholder">G</div>`}
          </div>
          <div class="ai-page-li-badges">${outletBadge}${gradeBadge}</div>
        </div>
        <div class="ai-page-li-body">
          <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
          <div class="ai-page-li-price">${priceHtml}</div>



          <button class="ai-page-li-view-details-btn" type="button"
                  onclick="aiPageToggleDetails(this, 'ai-page-det_${uid}')">
            ${aiPageInfoIcon()} View Details
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div id="ai-page-det_${uid}" class="ai-page-li-detail-panel" hidden>
            <div class="ai-page-li-detail-grid">
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Size</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Colour</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">SKU</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.sku || '—')}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Qty</div>
                <div class="ai-page-li-dv">${item.quantity || 1}</div>
              </div>
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Brand</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div>
              </div>
              ${item.tracking_name ? `
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Tracking Company</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)}</div>
              </div>` : ''}
              ${item.tracking_id ? `
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Tracking ID</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_id)}</div>
              </div>` : ''}
            </div>
          </div>

          <p style="font-size:11px;margin:4px 0;">
            Please note: All outlet items are final sale and cannot be exchanged. These are reduced,
            end-of-line or seasonal products and are not eligible for refunds or exchanges.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        </div>
      </div>`;
  });
  return html;
}

function aiPageBuildExchangeCard(item, index, lineItemsData, panelId) {
  const uid    = `ex_${panelId}_${item.id}_${index}`;
  const isActive = lineItemsData.is_active_date == 1;

  // Same conditions as return portal
  const isGiftBag      = !!item.is_gift_bag;
  // const isOutlet       = !!item.is_outlet;
  const isOutlet = item.product_tags?.includes('outlet') || false;
  const isMystery      = !!item.is_mystery;
  const isHygiene      = item.seller_id == 60;
  const isCanExchange  = !!item.can_exchange;
  const hasVariants    = item.variants && item.variants.length > 0;

  // Checkbox disabled when any blocking condition
  const checkboxDisabled =
    isGiftBag     ||
    isOutlet      ||
    isMystery     ||
    isHygiene     ||
    !isActive     ||
    !isCanExchange||
    !hasVariants;

  // Price display
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
    : `<div class="ai-page-li-img-placeholder">G</div>`;

  // Exchange reasons — uses exchange_reasons not reasons
  const exchangeReasons = lineItemsData.exchange_reasons || [];
  const reasonOpts = exchangeReasons.map(r =>
    `<option value="${r.id}">${aiPageEscHtml(r.name)}</option>`
  ).join('');

  // Variant options
  const variantOpts = hasVariants
    ? item.variants.map(v =>
        `<option value="${aiPageEscHtml(v.value)}" data-variant-id="${v.id}">
           ${aiPageEscHtml(v.value)}
         </option>`
      ).join('')
    : '';

  // Badges
  const outletBadge  = isOutlet  ? `<div class="ai-page-li-badge ai-page-li-badge-outlet">Outlet</div>` : '';
  const gradeBadge   = item.grade ? `<div class="ai-page-li-badge ai-page-li-badge-grade">Grade ${item.grade}</div>` : '';
  const mysteryBadge = isMystery  ? `<div class="ai-page-li-badge ai-page-li-badge-warn">Mystery Box</div>` : '';
  const giftBagBadge = isGiftBag  ? `<div class="ai-page-li-badge ai-page-li-badge-gift">Promotional Bag</div>` : '';

  // What to show in the body
  // const showForm = isActive && isCanExchange && !isGiftBag && !isOutlet && !isMystery && !isHygiene;

  const showForm = isActive && isCanExchange && !isGiftBag && !isMystery && !isHygiene;


  return `
    <div class="ai-page-li-card${checkboxDisabled ? ' ai-page-li-card-disabled' : ''}"
         id="ai-page-ex-card_${uid}"
         data-item-id="${item.id}"
         data-sku="${aiPageEscHtml(item.sku || '')}"
         data-name="${aiPageEscHtml(item.name || '')}"
         data-original-size="${aiPageEscHtml(item.color + ' / ' + item.size)}"
         data-max-qty="${item.availableQty || item.quantity || 1}">

      <input type="checkbox"
             class="ai-page-li-checkbox ai-page-ex-chk"
             id="ai-page-ex-chk_${uid}"
             data-uid="${uid}"
             ${checkboxDisabled ? 'disabled' : ''}
             onchange="aiPageExOnCheckboxChange(this)" />

      <div class="ai-page-li-img-wrap">
        <div class="ai-page-li-img">${imgHtml}</div>
        <div class="ai-page-li-badges">${outletBadge}${gradeBadge}${mysteryBadge}${giftBagBadge}</div>
      </div>

      <div class="ai-page-li-body">

        <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
        <div class="ai-page-li-price">${priceHtml}</div>
        <div style="font-size:10px;color:#6b7280;margin-bottom:4px;display:none;">
          ${aiPageEscHtml(item.color)} / ${aiPageEscHtml(item.size)} &nbsp;·&nbsp; SKU: ${aiPageEscHtml(item.sku)}
        </div>

        <!-- Status messages -->
        ${!isActive ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The exchange period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && !isCanExchange ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for exchange.
          </p>
        ` : ''}

        ${isActive && isCanExchange && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product and as per our policy, Mystery Box items are non-exchangeable.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && isCanExchange && !isMystery && isHygiene ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            For hygiene reasons, we are unable to accept exchanges on beauty products, pierced jewellery,
            make-up, skin care, fragrances, hair products, face masks, lingerie &amp; swimwear.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isActive && isCanExchange && !isMystery && !isHygiene && isGiftBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The promotional bag cannot be exchanged.
          </p>
        ` : ''}

        ${showForm ? `

          <!-- View Details -->
          <button class="ai-page-li-view-details-btn" type="button"
                  onclick="aiPageToggleDetails(this, 'ai-page-ex-det_${uid}')">
            ${aiPageInfoIcon()} View Details
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div id="ai-page-ex-det_${uid}" class="ai-page-li-detail-panel" hidden>
            <div class="ai-page-li-detail-grid">
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Size</div><div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Colour</div><div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">SKU</div><div class="ai-page-li-dv">${aiPageEscHtml(item.sku)}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Qty</div><div class="ai-page-li-dv">${item.quantity}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Brand</div><div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div></div>
              ${item.tracking_name ? `<div class="ai-page-li-dc"><div class="ai-page-li-dl">Tracking</div><div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)} — ${aiPageEscHtml(item.tracking_id)}</div></div>` : ''}
            </div>
          </div>

          ${hasVariants ? `

            <!-- Exchange form: Available Option + Qty + Reason -->
            <div class="ai-page-ex-form-row">

              <!-- Available Option -->
              <div class="ai-page-ex-field-wrap">
                <label class="ai-page-li-label">
                  Exchange For <span class="ai-page-li-req">*</span>
                </label>
                <select class="ai-page-ex-available-option"
                        data-uid="${uid}"
                        data-size="${aiPageEscHtml(item.color + ' / ' + item.size)}"
                        onchange="aiPageExOnVariantChange(this)">
                  <option value="">Select option…</option>
                  ${variantOpts}
                </select>
              </div>

              <!-- Quantity -->
              <div class="ai-page-ex-field-wrap ai-page-ex-field-qty">
                <label class="ai-page-li-label">Quantity</label>
                <div class="ai-page-li-stepper">
                  <button type="button" onclick="aiPageExChangeQty(this, -1, '${uid}')" ${(item.availableQty || item.quantity || 1) <= 1 ? 'disabled' : ''}>−</button>
                  <div class="ai-page-ex-qty">1</div>
                  <button type="button" onclick="aiPageExChangeQty(this, +1, '${uid}')" ${(item.availableQty || item.quantity || 1) <= 1 ? 'disabled' : ''}>+</button>
                </div>
                <span class="ai-page-li-error-msg"
                      id="ai-page-ex-qty-err_${uid}"
                      hidden>
                  Quantity cannot exceed available quantity [${item.availableQty || item.quantity}]
                </span>
              </div>

            </div>

            <!-- Same size warning -->
            <p class="ai-page-ex-same-size-msg" id="ai-page-ex-same-msg_${uid}"
               style="display:none;color:#e74c3c;font-size:10px;margin:4px 0;">
              As you've selected the same size as the original item. Please let us know your reason for requesting an exchange using the text box below.
            </p>

            <!-- Circular exchange warning -->
            <p class="ai-page-ex-circular-msg" id="ai-page-ex-circular-msg_${uid}"
               style="display:none;color:#e74c3c;font-size:10px;margin:4px 0;">
              This selection creates a circular exchange. Please select a different option.
            </p>

            <!-- Reason -->
            <div class="ai-page-li-reason-wrap" style="margin-top:6px;">
              <label class="ai-page-li-label">
                Reason <span class="ai-page-li-req">*</span>
              </label>
              <select class="ai-page-ex-reason"
                      id="ai-page-ex-reason_${uid}"
                      data-uid="${uid}"
                      onchange="aiPageExOnReasonChange(this)">
                <option value="">Select a reason…</option>
                ${reasonOpts}
              </select>

              <!-- Specific reason — shown when reason = Other OR same size -->
              <textarea class="ai-page-ex-specific-reason"
                        id="ai-page-ex-specific_${uid}"
                        data-uid="${uid}"
                        placeholder="Please describe your reason…"
                        maxlength="150"
                        style="display:none;margin-top:6px;width:100%;font-size:11px;padding:6px;
                               border:1px solid #d1d5db;border-radius:6px;resize:vertical;"
                        oninput="aiPageExAutoCheck('${uid}')"></textarea>

              <span class="ai-page-li-error-msg" id="ai-page-ex-err_${uid}" hidden>
                Please fill all required fields
              </span>
            </div>

          ` : `
            <!-- No variants available -->
            <p style="font-size:11px;font-weight:600;color:#6b7280;padding:10px 0;">
              Another product option is not available for this item.
            </p>
          `}

        ` : ''}

      </div><!-- /.ai-page-li-body -->
    </div><!-- /.ai-page-li-card -->
  `;
}


// ─────────────────────────────────────────────────────────────
// VARIANT / AVAILABLE OPTION CHANGE
// Mirrors portal .available_option change handler exactly
// ─────────────────────────────────────────────────────────────

function aiPageExOnVariantChange(sel) {
  const uid          = sel.dataset.uid;
  const selectedVal  = sel.value;
  const originalSize = sel.dataset.size; // "Color / Size"
  const isSameSize   = selectedVal.trim().toLowerCase() === originalSize.trim().toLowerCase();

  const reasonSel   = document.getElementById(`ai-page-ex-reason_${uid}`);
  const specificEl  = document.getElementById(`ai-page-ex-specific_${uid}`);
  const sameMsgEl   = document.getElementById(`ai-page-ex-same-msg_${uid}`);

  // Reset specific reason
  if (specificEl) { specificEl.value = ''; specificEl.style.display = 'none'; }

  if (isSameSize) {
    // Same size — auto-set reason to "Other", disable dropdown, show textarea + warning
    if (reasonSel) {
      const otherOpt = [...reasonSel.options].find(o => o.text === 'Other');
      if (otherOpt) {
        reasonSel.value    = otherOpt.value;
        reasonSel.disabled = true;
      }
    }
    if (sameMsgEl) sameMsgEl.style.display = '';
    if (specificEl) specificEl.style.display = '';
  } else {
    // Different size — restore reason dropdown
    if (reasonSel) {
      reasonSel.value    = '';
      reasonSel.disabled = false;
    }
    if (sameMsgEl) sameMsgEl.style.display = 'none';
  }

  // Auto-check card
  aiPageExAutoCheck(uid);

  // Circular exchange detection
  const panel = sel.closest('.ai-page-ex-panel');
  if (panel && aiPageExDetectCircular(panel)) {
    const circularMsg = document.getElementById(`ai-page-ex-circular-msg_${uid}`);
    if (circularMsg) circularMsg.style.display = '';
    sel.value = '';
    if (reasonSel) { reasonSel.value = ''; reasonSel.disabled = false; }
    if (sameMsgEl) sameMsgEl.style.display = 'none';
  } else {
    const circularMsg = document.getElementById(`ai-page-ex-circular-msg_${uid}`);
    if (circularMsg) circularMsg.style.display = 'none';
  }

  if (panel) {
    aiPageExUpdateCount(panel);
    aiPageExUpdateTerms(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// REASON CHANGE
// ─────────────────────────────────────────────────────────────

function aiPageExOnReasonChange(sel) {
  const uid        = sel.dataset.uid;
  const isOther    = sel.options[sel.selectedIndex]?.text === 'Other';
  const specificEl = document.getElementById(`ai-page-ex-specific_${uid}`);

  if (specificEl) {
    specificEl.style.display = isOther ? '' : 'none';
    if (!isOther) specificEl.value = '';
  }

  aiPageExAutoCheck(uid);

  const panel = sel.closest('.ai-page-ex-panel');
  if (panel) {
    aiPageExUpdateCount(panel);
    aiPageExUpdateTerms(panel);
  }
}


// ─────────────────────────────────────────────────────────────
// CIRCULAR EXCHANGE DETECTION
// Mirrors portal detectCircularExchange() — DFS graph traversal
// ─────────────────────────────────────────────────────────────

function aiPageExDetectCircular(panel) {
  const graph = {};

  panel.querySelectorAll('.ai-page-ex-available-option').forEach(sel => {
    const oldSku = String(sel.dataset.size).trim().toLowerCase();
    const newSku = String(sel.value).trim().toLowerCase();
    if (newSku && newSku !== '' && oldSku !== newSku) {
      graph[oldSku] = newSku;
    }
  });

  const visited = new Set();
  const stack   = new Set();

  function dfs(node) {
    if (stack.has(node))   return true;
    if (visited.has(node)) return false;
    visited.add(node);
    stack.add(node);
    const next = graph[node];
    if (next && dfs(next)) return true;
    stack.delete(node);
    return false;
  }

  return Object.keys(graph).some(key => dfs(key));
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// ─────────────────────────────────────────────────────────────

function aiPageExChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`ai-page-ex-card_${uid}`);
  const qtyEl  = btn.closest('.ai-page-li-stepper').querySelector('.ai-page-ex-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);

  // ADD: show/hide exceeded warning
  const exceedErr = document.getElementById(`ai-page-ex-qty-err_${uid}`);

  val = Math.max(1, val + delta);

  if (val > maxQty) {
    val = maxQty;
    if (exceedErr) exceedErr.hidden = false;
  } else {
    if (exceedErr) exceedErr.hidden = true;
  }

  qtyEl.textContent = val;
  aiPageExAutoCheck(uid);
}

// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function aiPageExOnCheckboxChange(chk) {
  const uid   = chk.dataset.uid;
  const panel = chk.closest('.ai-page-ex-panel');
  if (!chk.checked) aiPageExResetCard(uid);
  aiPageExUpdateCount(panel);
  aiPageExUpdateTerms(panel);
}

function aiPageExAutoCheck(uid) {
  const chk = document.getElementById(`ai-page-ex-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.ai-page-ex-panel');
  if (panel) {
    aiPageExUpdateCount(panel);
    aiPageExUpdateTerms(panel); 
  }
}

function aiPageExResetCard(uid) {
  const card = document.getElementById(`ai-page-ex-card_${uid}`);
  if (!card) return;

  const variantSel = card.querySelector('.ai-page-ex-available-option');
  if (variantSel) variantSel.value = '';

  const reasonSel = card.querySelector('.ai-page-ex-reason');
  if (reasonSel) { reasonSel.value = ''; reasonSel.disabled = false; }

  const specificEl = document.getElementById(`ai-page-ex-specific_${uid}`);
  if (specificEl) { specificEl.value = ''; specificEl.style.display = 'none'; }

  const sameMsgEl = document.getElementById(`ai-page-ex-same-msg_${uid}`);
  if (sameMsgEl) sameMsgEl.style.display = 'none';

  const circularMsg = document.getElementById(`ai-page-ex-circular-msg_${uid}`);
  if (circularMsg) circularMsg.style.display = 'none';

  const errEl = document.getElementById(`ai-page-ex-err_${uid}`);
  if (errEl) errEl.hidden = true;

  const qtyEl = card.querySelector('.ai-page-ex-qty');
  if (qtyEl) qtyEl.textContent = 1;
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function aiPageExToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.ai-page-ex-panel');
  const itemChks = [...panel.querySelectorAll(
    '.ai-page-ex-chk:not(.ai-page-ex-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) aiPageExResetCard(c.dataset.uid);
  });
  aiPageExUpdateCount(panel);
  aiPageExUpdateTerms(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function aiPageExUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.ai-page-ex-chk:not(.ai-page-ex-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.ai-page-ex-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.ai-page-ex-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  // Circular check across panel
  const hasCircular = aiPageExDetectCircular(panel);

  const allValid = count > 0 && !hasCircular && aiPageExValidate(checkedChks, false);
  const btn      = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('ai-page-li-process-active', allValid);
  }
}

function aiPageExUpdateTerms(panel) {
  const termsWrapper = panel.querySelector('.ai-page-li-terms-wrapper');
  const checkedCount = panel.querySelectorAll(
    '.ai-page-ex-chk:not(.ai-page-ex-select-all-chk):checked'
  ).length;
  if (termsWrapper) {
    termsWrapper.style.display = checkedCount > 0 ? '' : 'none';
    if (checkedCount === 0) {
      const termsChk = panel.querySelector('.ai-page-ex-terms-chk');
      if (termsChk) termsChk.checked = false;
    }
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION
// ─────────────────────────────────────────────────────────────

function aiPageExValidate(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid  = chk.dataset.uid;
    const card = document.getElementById(`ai-page-ex-card_${uid}`);
    if (!card) return;

    const variantSel  = card.querySelector('.ai-page-ex-available-option');
    const reasonSel   = card.querySelector('.ai-page-ex-reason');
    const specificEl  = document.getElementById(`ai-page-ex-specific_${uid}`);
    const errEl       = document.getElementById(`ai-page-ex-err_${uid}`);
    const qtyEl       = card.querySelector('.ai-page-ex-qty');

    let cardValid = true;

    // Variant required (if variants exist)
    if (variantSel && (!variantSel.value || variantSel.value === '')) cardValid = false;

    // Reason required
    if (reasonSel && (!reasonSel.value || reasonSel.value === '')) cardValid = false;

    // Specific reason required if "Other" or same size
    if (reasonSel && reasonSel.options[reasonSel.selectedIndex]?.text === 'Other') {
      if (!specificEl || !specificEl.value.trim()) cardValid = false;
    }
    if (specificEl && specificEl.style.display !== 'none' && !specificEl.value.trim()) {
      cardValid = false;
    }

    // Quantity required
    if (qtyEl && (!qtyEl.textContent || parseInt(qtyEl.textContent) < 1)) cardValid = false;

    if (!cardValid) {
      allValid = false;
      if (showErrors && errEl) errEl.hidden = false;
    } else {
      if (errEl) errEl.hidden = true;
    }
  });

  return allValid;
}


// ─────────────────────────────────────────────────────────────
// SUBMIT — mirrors portal exchange formData build
// ─────────────────────────────────────────────────────────────
function aiPageHandleExchange(btn) {
  const panel       = btn.closest('.ai-page-ex-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.ai-page-ex-chk:not(.ai-page-ex-select-all-chk):checked'
  )];
 
  if (!aiPageExValidate(checkedChks, true)) {
    aiPageScrollToFirstError(panel);
    aiPageToast('Please fill all required fields', 'warning');
    return;
  }
 
  // Circular check
  if (aiPageExDetectCircular(panel)) {
    aiPageToast('One or more exchange selections create a circular exchange. Please review.', 'error');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.ai-page-ex-terms-chk');
  const termsErr = panel.querySelector(`[id^="ai-page-ex-terms-err_"]`);
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    aiPageToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  const panelId       = panel.id;
  const termsAccepted = termsChk ? termsChk.checked : false;
 
  const items = checkedChks.map(chk => {
    const uid        = chk.dataset.uid;
    const card       = document.getElementById(`ai-page-ex-card_${uid}`);
    const variantSel = card.querySelector('.ai-page-ex-available-option');
    const reasonSel  = card.querySelector('.ai-page-ex-reason');
    const specificEl = document.getElementById(`ai-page-ex-specific_${uid}`);
    const qtyEl      = card.querySelector('.ai-page-ex-qty');
 
    const selectedOpt   = variantSel?.options[variantSel.selectedIndex];
    const to_exchange   = variantSel?.value     || '';
    const variant_id    = selectedOpt?.dataset.variantId || '';
    const reason_id     = reasonSel?.value      || '';
    const reason        = reasonSel?.options[reasonSel.selectedIndex]?.text || '';
    const specificReason = specificEl ? specificEl.value.trim() : '';
    const qty           = parseInt(qtyEl?.textContent || 1, 10) || 1;
    const item_id       = card.dataset.itemId || '';
    const item_name     = card.dataset.name   || '';
    const item_sku      = card.dataset.sku    || '';
 
    return { uid, item_id, item_sku, item_name, to_exchange, variant_id, reason_id, reason, specificReason, qty };
  });
 
  aiPageConfirm({
    title: 'Exchange Items',
    message: 'Please confirm before proceeding with your exchange request.',
    confirmText: 'Exchange',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: i.item_name, reason: i.reason, qty: i.qty })),
    onConfirm: function () {
      _aiPageSubmitExchange(btn, panel, panelId, items, termsAccepted);
    },
  });
}
 
function _aiPageSubmitExchange(btn, panel, panelId, items, termsAccepted) {
  const originalQuery = panel.dataset.originalQuery || '';
  const formData = new FormData();
  formData.append('order',    panel.dataset.orderId    || '');
  formData.append('customer', panel.dataset.customerId || '');
  formData.append('type', 'exchange');
 // formData.append('terms_conditions_checkbox', termsAccepted);
 
  items.forEach((item, index) => {
    formData.append(`items[${index}][id]`,             item.item_id);
    formData.append(`items[${index}][sku]`,            item.item_sku);
    formData.append(`items[${index}][product]`,        item.item_name);
    formData.append(`items[${index}][reasonText]`,     item.reason);
    formData.append(`items[${index}][reason]`,         item.reason_id);
    formData.append(`items[${index}][specificReason]`, item.specificReason || '');
    formData.append(`items[${index}][quantity]`,       item.qty);
    formData.append(`items[${index}][to_exchange]`,    item.to_exchange);
    formData.append(`items[${index}][variant]`,        item.variant_id);
  });
 
  aiPageBtnStartLoading(btn, 'Processing exchange…');
  aiPageFreezePanel(panel, 'Processing your exchange…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmitAiPage}/v1/api/return/request-add`, {
    method: 'POST',
    body: formData,
  })
  .then(res => res.json())
  .then(response => {
    if (response.errors) {
      aiPageBtnStopLoading(btn, 'EXCHANGE ITEMS');
      aiPageUnfreezePanel(panel);
      aiPageToast(response.errors || 'Failed to process exchange', 'error');
      return;
    }
 
    aiPageBtnSuccess(btn, 'Exchange Submitted');
    aiPageToast(response.message || 'Exchange processed successfully!', 'success', 6000);

    if (originalQuery) {
      aiPageShowPanelLoader(panel, 'Please wait...');
      setTimeout(() => chatQuery(originalQuery), 1000);
    }

    // const originalQuery = panel.dataset.originalQuery || '';
    // aiPageRefreshPanel(panel, 'exchange');
  })
  .catch(err => {
    aiPageBtnStopLoading(btn, 'EXCHANGE ITEMS');
    aiPageUnfreezePanel(panel);
    aiPageToast('An unexpected error occurred. Please try again.', 'error');
    console.error('Exchange fetch error:', err);
  });
}
 
//exchange implementation ends



//alteration implementation start

// ─────────────────────────────────────────────────────────────
// ENTRY POINT
// ─────────────────────────────────────────────────────────────

function aiPageRenderAlterationPanel(notRequestedItems, lineItemsData) {
  const outletItems = (lineItemsData.outlet || []).flatMap(s => s.items || []);
  const allItems    = [...(notRequestedItems || []), ...outletItems];

  const goddivaItems = allItems.filter(item => item.is_goddiva);
  const alterations  = lineItemsData.requested?.alteration || [];
  const requested    = lineItemsData.requested || {};
  const shippingCode = lineItemsData.shipping_country_code || '';
  const isRestricted = AI_PAGE_RESTRICTED_COUNTRIES.includes(shippingCode);

  // Already returned/exchanged items
  const completeReturnItems = (requested?.return?.return_label?.complete_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  const pendingReturnItems = (requested?.return?.return_label?.pending_label || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);
  const exchangeItems = (requested?.exchange || [])
    .flatMap(req => req.items?.flatMap(seller => seller.items || []) || []);

  const hasAnything = goddivaItems.length > 0
    || alterations.length > 0
    || completeReturnItems.length > 0
    || pendingReturnItems.length > 0
    || exchangeItems.length > 0;

  if (!hasAnything) return '';

  const panelId = `ai-page-altPanel_${Date.now()}`;

  // Cards for not_requested + outlet
  const cards = goddivaItems.length > 0
    ? allItems.map((item, index) =>
        aiPageBuildAlterationCard(item, index, lineItemsData, panelId)
      ).join('')
    : '';

  // Already-requested sections
  let alreadyHtml = '';

  if (alterations.length > 0) {
    alreadyHtml += aiPageRenderAlreadyRequestedAlteration(alterations, isRestricted);
  }
  if (completeReturnItems.length > 0) {
    alreadyHtml += aiPageRenderExAlreadyReturnedCards(completeReturnItems, 'Return', 'altered');
  }
  if (pendingReturnItems.length > 0) {
    alreadyHtml += aiPageRenderExAlreadyReturnedCards(pendingReturnItems, 'Return', 'altered');
  }
  if (exchangeItems.length > 0) {
    alreadyHtml += aiPageRenderExAlreadyReturnedCards(exchangeItems, 'Exchange', 'altered');
  }

  return `
    <div class="ai-page-alt-panel"
         id="${panelId}"
         data-original-query="${aiPageEscHtml(lineItemsData._originalQuery || '')}"
         data-order-id="${lineItemsData.order || ''}"
         data-customer-id="${lineItemsData.customer || ''}">

      <div class="ai-page-li-sticky-top">
        <span><strong>Made to Measure:</strong> Select items and specify the alterations you need</span>
      </div>

      ${goddivaItems.length > 0 ? `
      <div class="ai-page-li-select-all-bar">
        <label class="ai-page-li-select-all-label">
          <input type="checkbox"
                 class="ai-page-li-checkbox ai-page-alt-select-all-chk"
                 onchange="aiPageAltToggleSelectAll(this)" />
          <strong>Select All Items</strong>
        </label>
        <span class="ai-page-alt-selected-count">0 items selected</span>
      </div>
      ` : ''}

      <div class="ai-page-li-grid">
        ${cards}
        ${alreadyHtml}
      </div>

      ${goddivaItems.length > 0 ? `
      <div class="ai-page-li-sticky-bottom">
        <div class="ai-page-li-terms-wrapper"
             id="ai-page-alt-terms_${panelId}"
             style="display:none;">
          <label class="ai-page-li-terms-label">
            <input type="checkbox"
                   class="ai-page-alt-terms-chk"
                   id="ai-page-alt-terms-chk_${panelId}" />
            By selecting the checkbox, you agree to the
            <a href="https://goddiva.co.uk/pages/terms-conditions" target="_blank">terms and conditions.</a>
          </label>
          <p style="display:none;color:#e74c3c;font-size:10px;margin:4px 0 0;"
             class="ai-page-alt-terms-err"
             id="ai-page-alt-terms-err_${panelId}">
            Please accept the terms and conditions.
          </p>
        </div>

        <button class="ai-page-li-process-btn"
                disabled
                onclick="aiPageHandleAlteration(this)">
          <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M3 8h10M9 4l4 4-4 4"/>
          </svg>
          SUBMIT FOR ALTERATION
        </button>
      </div>
      ` : ''}

    </div>`;
}


// ─────────────────────────────────────────────────────────────
// BUILD A SINGLE CARD
// ─────────────────────────────────────────────────────────────

function aiPageBuildAlterationCard(item, index, lineItemsData, panelId) {
  const uid      = `alt_${panelId}_${item.id}_${index}`;
  const isActive = lineItemsData.is_active_date == 1;

  // Portal: only Goddiva items shown in alteration tab
  const isGoddiva  = !!item.is_goddiva;
  const isGiftBag  = !!item.is_gift_bag;
  const isMystery  = !!item.is_mystery;
  const canAlter   = !!item.can_alteration_request;
  const maxQty     = item.availableQty || item.quantity || 1;

  // Checkbox disabled when: not Goddiva, not eligible, gift bag, mystery, period passed
  const checkboxDisabled = !isGoddiva || !canAlter || isGiftBag || isMystery || !isActive;

  // Price display
  const price = parseFloat(item.price       || 0);
  const gross = parseFloat(item.gross_price || 0);
  const priceHtml = (price !== gross)
    ? `<span style="text-decoration:line-through;">£${price.toFixed(2)}</span> <span style="color:#d00;font-weight:bold;">£${gross.toFixed(2)}</span>`
    : `£${price.toFixed(2)}`;

  const imgHtml = item.image
    ? `<img src="${aiPageEscHtml(item.image)}" alt="${aiPageEscHtml(item.name)}" />`
    : `<div class="ai-page-li-img-placeholder">G</div>`;

  // Badges
  const gradeBadge   = item.grade  ? `<div class="ai-page-li-badge ai-page-li-badge-grade">Grade ${item.grade}</div>` : '';
  const mysteryBadge = isMystery   ? `<div class="ai-page-li-badge ai-page-li-badge-warn">Mystery Box</div>` : '';
  const giftBagBadge = isGiftBag   ? `<div class="ai-page-li-badge ai-page-li-badge-gift">Promotional Bag</div>` : '';

  // Show form only when fully eligible
  const showForm = isGoddiva && isActive && canAlter && !isGiftBag && !isMystery;

  // Card disabled styling
  const cardClass = `ai-page-li-card${checkboxDisabled ? ' ai-page-li-card-disabled' : ''}`;

  return `
    <div class="${cardClass}"
         id="ai-page-alt-card_${uid}"
         data-item-id="${item.id}"
         data-max-qty="${maxQty}">

      <input type="checkbox"
             class="ai-page-li-checkbox ai-page-alt-chk"
             id="ai-page-alt-chk_${uid}"
             data-uid="${uid}"
             ${checkboxDisabled ? 'disabled' : ''}
             onchange="aiPageAltOnCheckboxChange(this)" />

      <div class="ai-page-li-img-wrap">
        <div class="ai-page-li-img">${imgHtml}</div>
        <div class="ai-page-li-badges">${gradeBadge}${mysteryBadge}${giftBagBadge}</div>
      </div>

      <div class="ai-page-li-body">

        <div class="ai-page-li-name">${aiPageEscHtml(item.name)}</div>
        <div class="ai-page-li-price">${priceHtml}</div>
        <div style="font-size:10px;color:#6b7280;margin-bottom:4px;display:none;">
          ${aiPageEscHtml(item.color)} / ${aiPageEscHtml(item.size)}
          &nbsp;·&nbsp; SKU: ${aiPageEscHtml(item.sku)}
        </div>

        <!-- Status messages — mirrors portal conditions exactly -->
        ${!isGoddiva ? `
          <p style="font-size:11px;color:#6b7280;margin:4px 0;">
            Alteration is only available for Goddiva items.
          </p>
        ` : ''}

        ${isGoddiva && !isActive ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The alteration period has passed. Please contact customer service at
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isGoddiva && isActive && !canAlter ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This item is not eligible for alteration.
          </p>
        ` : ''}

        ${isGoddiva && isActive && canAlter && isMystery ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            This is a Mystery Box product — it cannot be altered.
          </p>
          <p style="font-size:11px;">If you have any questions, please contact
            <a href="mailto:info@goddiva.co.uk" style="color:#ff8080;">info@goddiva.co.uk</a>
          </p>
        ` : ''}

        ${isGoddiva && isActive && canAlter && !isMystery && isGiftBag ? `
          <p style="color:#d00;font-size:11px;font-weight:600;margin:4px 0;">
            The promotional bag cannot be altered.
          </p>
        ` : ''}

        ${showForm ? `

          <!-- View Details -->
          <button class="ai-page-li-view-details-btn" type="button"
                  onclick="aiPageToggleDetails(this, 'ai-page-alt-det_${uid}')">
            ${aiPageInfoIcon()} View Details
            <span class="ai-page-li-chevron">▾</span>
          </button>
          <div id="ai-page-alt-det_${uid}" class="ai-page-li-detail-panel" hidden>
            <div class="ai-page-li-detail-grid">
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Size</div><div class="ai-page-li-dv">${aiPageEscHtml(item.size || '—')}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Colour</div><div class="ai-page-li-dv">${aiPageEscHtml(item.color || '—')}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">SKU</div><div class="ai-page-li-dv">${aiPageEscHtml(item.sku)}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Qty</div><div class="ai-page-li-dv">${item.quantity}</div></div>
              <div class="ai-page-li-dc"><div class="ai-page-li-dl">Brand</div><div class="ai-page-li-dv">${aiPageEscHtml(item.brand || '—')}</div></div>
              ${item.tracking_name ? `
              <div class="ai-page-li-dc">
                <div class="ai-page-li-dl">Tracking</div>
                <div class="ai-page-li-dv">${aiPageEscHtml(item.tracking_name)} — ${aiPageEscHtml(item.tracking_id)}</div>
              </div>` : ''}
            </div>
          </div>

          <!-- Alteration form: Qty + Length + Note -->
          <div class="ai-page-alt-form-row">

            <!-- Quantity stepper -->
            <div class="ai-page-ex-field-wrap ai-page-ex-field-qty">
              <label class="ai-page-li-label">Quantity</label>
              <div class="ai-page-li-stepper">
                <button type="button" ${maxQty <= 1 ? 'disabled' : ''} onclick="aiPageAltChangeQty(this, -1, '${uid}')">−</button>
                <div class="ai-page-alt-qty">1</div>
                <button type="button" ${maxQty <= 1 ? 'disabled' : ''} onclick="aiPageAltChangeQty(this, +1, '${uid}')">+</button>
              </div>
            </div>

            <!-- Length input -->
            <div class="ai-page-ex-field-wrap">
              <label class="ai-page-li-label">
                Hem removal (cm) <span class="ai-page-li-req">*</span>
              </label>
              <input type="number"
                class="ai-page-alt-length"
                id="ai-page-alt-length_${uid}"
                data-uid="${uid}"
                placeholder="1–30 cm"
                min="1"
                max="30"
                oninput="aiPageAltLengthInput(this, '${uid}')"
                onblur="aiPageAltLengthBlur(this, '${uid}')" />
              <span style="font-size:9px;color:#9ca3af;line-height:normal">Enter a value between 1 and 30 cm.</span>
              <span id="ai-page-alt-length-error_${uid}" style="font-size:9px;color:red;line-height:normal"></span>
            </div>

          </div>

          <!-- Note textarea -->
          <div style="margin-top:8px;">
            <label class="ai-page-li-label">Note <span style="font-weight:400;color:#9ca3af;">(optional)</span></label>
            <textarea class="ai-page-alt-note"
                      id="ai-page-alt-note_${uid}"
                      data-uid="${uid}"
                      placeholder="Enter any additional notes for the tailor…"
                      maxlength="1000"
                      oninput="aiPageAltNoteInput(this, '${uid}')"></textarea>
            <span class="ai-page-alt-char-count"
                  id="ai-page-alt-chars_${uid}">1000 characters remaining</span>
          </div>

          <!-- Error message -->
          <span class="ai-page-li-error-msg"
                id="ai-page-alt-err_${uid}"
                hidden>
            Please fill all required fields (quantity and hem length)
          </span>

        ` : ''}

      </div><!-- /.ai-page-li-body -->
    </div><!-- /.ai-page-li-card -->
  `;
}


// ─────────────────────────────────────────────────────────────
// QUANTITY STEPPER
// ─────────────────────────────────────────────────────────────

function aiPageAltChangeQty(btn, delta, uid) {
  const card   = document.getElementById(`ai-page-alt-card_${uid}`);
  const qtyEl  = btn.closest('.ai-page-li-stepper').querySelector('.ai-page-alt-qty');
  const maxQty = parseInt(card?.dataset.maxQty, 10) || 99;
  let val      = parseInt(qtyEl.textContent, 10);
  val          = Math.min(maxQty, Math.max(1, val + delta));
  qtyEl.textContent = val;
  aiPageAltAutoCheck(uid);
}


// ─────────────────────────────────────────────────────────────
// NOTE CHARACTER COUNTER — mirrors portal alterationremaining
// ─────────────────────────────────────────────────────────────

function aiPageAltNoteInput(textarea, uid) {
  const max       = 1000;
  const remaining = max - textarea.value.length;
  const counterEl = document.getElementById(`ai-page-alt-chars_${uid}`);
  if (counterEl) counterEl.textContent = `${remaining} character${remaining !== 1 ? 's' : ''} remaining`;
  aiPageAltAutoCheck(uid);
}


// ─────────────────────────────────────────────────────────────
// CHECKBOX
// ─────────────────────────────────────────────────────────────

function aiPageAltOnCheckboxChange(chk) {
  const uid   = chk.dataset.uid;
  const panel = chk.closest('.ai-page-alt-panel');
  if (!chk.checked) aiPageAltResetCard(uid);
  aiPageAltUpdateCount(panel);
  aiPageAltUpdateTerms(panel);
}

function aiPageAltLengthInput(input, uid) {
  const raw = input.value;
  const val = parseFloat(raw);
  const errorEl = document.getElementById(`ai-page-alt-length-error_${uid}`);

  if (errorEl) {
    errorEl.textContent = '';
  }

  if (raw === '' || isNaN(val)) {
    aiPageAltAutoCheck(uid);
    return;
  }

  let messages = [];

  if (/^\d+\.\d{3,}$/.test(raw)) {
    messages.push('Only 2 decimal places allowed.');
  }

  if (val < 1 || val > 30) {
    // messages.push('Value must be between 1 and 30.');
  }

  if (errorEl) {
    errorEl.textContent = messages.join(' ');
  }

  aiPageAltAutoCheck(uid);
}

function aiPageAltLengthBlur(input, uid) {
  let raw = input.value;
  let val = parseFloat(raw);
  const errorEl = document.getElementById(`ai-page-alt-length-error_${uid}`);

  if (errorEl) errorEl.textContent = '';

  if (raw === '' || isNaN(val)) {
    input.value = '';
    aiPageAltAutoCheck(uid);
    return;
  }

  let messages = [];

  // 👉 Check decimal issue
  if (/^\d+\.\d{3,}$/.test(raw)) {
    messages.push('Only 2 decimal places allowed.');
  }

  // 👉 Clamp range
  if (val < 1) {
    val = 1;
  } else if (val > 30) {
    val = 30;
  }

  // 👉 Always trim to 2 decimals (no rounding surprise)
  val = Math.floor(val * 100) / 100;

  // 👉 Set value
  input.value = val.toFixed(2);

  // 👉 Show error if needed
  if (errorEl) {
    errorEl.textContent = messages.join(' ');
  }

  aiPageAltAutoCheck(uid);
}

function aiPageAltAutoCheck(uid) {
  const chk = document.getElementById(`ai-page-alt-chk_${uid}`);
  if (chk && !chk.checked && !chk.disabled) chk.checked = true;
  const panel = chk?.closest('.ai-page-alt-panel');
  if (panel) {
    aiPageAltUpdateCount(panel);
    aiPageAltUpdateTerms(panel);
  }
}

function aiPageAltResetCard(uid) {
  const card = document.getElementById(`ai-page-alt-card_${uid}`);
  if (!card) return;

  const qtyEl = card.querySelector('.ai-page-alt-qty');
  if (qtyEl) qtyEl.textContent = 1;

  const lengthEl = document.getElementById(`ai-page-alt-length_${uid}`);
  if (lengthEl) lengthEl.value = '';

  const noteEl = document.getElementById(`ai-page-alt-note_${uid}`);
  if (noteEl) noteEl.value = '';

  const counterEl = document.getElementById(`ai-page-alt-chars_${uid}`);
  if (counterEl) counterEl.textContent = '1000 characters remaining';

  const errEl = document.getElementById(`ai-page-alt-err_${uid}`);
  if (errEl) errEl.hidden = true;

  const decimalErr = document.getElementById(`ai-page-alt-length-error_${uid}`);
  if(decimalErr) decimalErr.textContent = ''

  // Collapse details
  const detPanel = document.getElementById(`ai-page-alt-det_${uid}`);
  if (detPanel) detPanel.setAttribute('hidden', '');
  const detBtn = card.querySelector('.ai-page-li-view-details-btn');
  if (detBtn) detBtn.classList.remove('ai-page-li-view-details-open');
}


// ─────────────────────────────────────────────────────────────
// SELECT ALL
// ─────────────────────────────────────────────────────────────

function aiPageAltToggleSelectAll(selectAllChk) {
  const panel    = selectAllChk.closest('.ai-page-alt-panel');
  const itemChks = [...panel.querySelectorAll(
    '.ai-page-alt-chk:not(.ai-page-alt-select-all-chk):not([disabled])'
  )];
  itemChks.forEach(c => {
    c.checked = selectAllChk.checked;
    if (!selectAllChk.checked) aiPageAltResetCard(c.dataset.uid);
  });
  aiPageAltUpdateCount(panel);
  aiPageAltUpdateTerms(panel);
}


// ─────────────────────────────────────────────────────────────
// COUNT + BUTTON STATE
// ─────────────────────────────────────────────────────────────

function aiPageAltUpdateCount(panel) {
  if (!panel) return;

  const allChks     = [...panel.querySelectorAll(
    '.ai-page-alt-chk:not(.ai-page-alt-select-all-chk):not([disabled])'
  )];
  const checkedChks = allChks.filter(c => c.checked);
  const count       = checkedChks.length;

  const countEl = panel.querySelector('.ai-page-alt-selected-count');
  if (countEl) countEl.textContent = `${count} item${count !== 1 ? 's' : ''} selected`;

  const selectAllChk = panel.querySelector('.ai-page-alt-select-all-chk');
  if (selectAllChk) {
    selectAllChk.checked       = count === allChks.length && allChks.length > 0;
    selectAllChk.indeterminate = count > 0 && count < allChks.length;
  }

  const allValid = count > 0 && aiPageAltValidate(checkedChks, false);
  const btn      = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.disabled = !allValid;
    btn.classList.toggle('ai-page-li-process-active', allValid);
  }
}

function aiPageAltUpdateTerms(panel) {
  const termsWrapper = panel.querySelector('.ai-page-li-terms-wrapper');
  const checkedCount = panel.querySelectorAll(
    '.ai-page-alt-chk:not(.ai-page-alt-select-all-chk):checked'
  ).length;
  if (termsWrapper) {
    termsWrapper.style.display = checkedCount > 0 ? '' : 'none';
    if (checkedCount === 0) {
      const termsChk = panel.querySelector('.ai-page-alt-terms-chk');
      if (termsChk) termsChk.checked = false;
    }
  }
}


// ─────────────────────────────────────────────────────────────
// VALIDATION — mirrors portal: length + quantity required
// ─────────────────────────────────────────────────────────────

function aiPageAltValidate(checkedChks, showErrors) {
  let allValid = true;

  checkedChks.forEach(chk => {
    const uid    = chk.dataset.uid;
    const card   = document.getElementById(`ai-page-alt-card_${uid}`);
    const errEl  = document.getElementById(`ai-page-alt-err_${uid}`);
    if (!card) return;

    const qtyEl    = card.querySelector('.ai-page-alt-qty');
    const lengthEl = document.getElementById(`ai-page-alt-length_${uid}`);

    const qty    = parseInt(qtyEl?.textContent || 0, 10);
    
    const rawLength = parseFloat(lengthEl?.value || 0);
    const valid = qty >= 1 && !isNaN(rawLength) && rawLength >= 1 && rawLength <= 30;

    if (!valid) {
      allValid = false;
      if (showErrors && errEl) errEl.hidden = false;
    } else {
      if (errEl) errEl.hidden = true;
    }
  });

  return allValid;
}


// ─────────────────────────────────────────────────────────────
// SUBMIT — mirrors portal submitDataAlteration()
// Payload is JSON (not FormData) — matches /v1/api/web/made-to-measure
// ─────────────────────────────────────────────────────────────
function aiPageHandleAlteration(btn) {
  const panel       = btn.closest('.ai-page-alt-panel');
  const checkedChks = [...panel.querySelectorAll(
    '.ai-page-alt-chk:not(.ai-page-alt-select-all-chk):checked'
  )];
 
  if (checkedChks.length === 0) {
    aiPageToast('Please select an item to proceed', 'warning');
    return;
  }
 
  if (!aiPageAltValidate(checkedChks, true)) {
    aiPageScrollToFirstError(panel);
    aiPageToast('Please fill all required fields', 'warning');
    return;
  }
 
  // T&C validation
  const termsChk = panel.querySelector('.ai-page-alt-terms-chk');
  const termsErr = panel.querySelector('.ai-page-alt-terms-err');
  if (termsChk && !termsChk.checked) {
    if (termsErr) termsErr.style.display = '';
    termsChk.focus();
    aiPageToast('Please accept the terms and conditions', 'warning');
    return;
  }
  if (termsErr) termsErr.style.display = 'none';
 
  const items = checkedChks.map(chk => {
    const uid      = chk.dataset.uid;
    const card     = document.getElementById(`ai-page-alt-card_${uid}`);
    const qtyEl    = card.querySelector('.ai-page-alt-qty');
    const lengthEl = document.getElementById(`ai-page-alt-length_${uid}`);
    const noteEl   = document.getElementById(`ai-page-alt-note_${uid}`);
 
    return {
      id       : card.dataset.itemId || '',
      length   : parseFloat(lengthEl?.value || 0),
      quantity : parseInt(qtyEl?.textContent || 1, 10),
      note     : noteEl?.value.trim() || null,
    };
  });
 
  const payload = {
    order    : panel.dataset.orderId    || '',
    customer : panel.dataset.customerId || '',
    type     : 'alteration',
    items    : items,
  };
 
  aiPageConfirm({
    title: 'Made to Measure',
    message: 'Please confirm before proceeding with your alteration request.',
    confirmText: 'Submit Alteration',
    cancelText: 'Cancel',
    items: items.map(i => ({ product: `Item ${i.id}`, reason: `${i.length}cm`, qty: i.quantity })),
    onConfirm: function () {
      _aiPageSubmitAlteration(btn, panel, payload);
    },
  });
}
 
function _aiPageSubmitAlteration(btn, panel, payload) {
  const originalQuery = panel.dataset.originalQuery || '';

  aiPageBtnStartLoading(btn, 'Submitting alteration…');
  aiPageFreezePanel(panel, 'Submitting alteration…');
 
  // TODO: Replace with actual API URL
  fetch(`${baseEndPointToSubmitAiPage}/v1/api/web/made-to-measure`, {
    method  : 'POST',
    headers : { 'Content-Type': 'application/json' },
    body    : JSON.stringify(payload),
  })
  .then(res => res.json())
  .then(response => {
    if (response.error) {
      aiPageBtnStopLoading(btn, 'SUBMIT FOR ALTERATION');
      aiPageUnfreezePanel(panel);
      aiPageToast(response.message || 'Failed to submit alteration', 'error');
      return;
    }
 
    aiPageBtnSuccess(btn, 'Alteration Submitted');
    aiPageToast('Alteration submitted successfully!', 'success', 6000);

    if (originalQuery) {
       aiPageShowPanelLoader(panel, 'Please wait...');
      setTimeout(() => chatQuery(originalQuery), 1000);
    }

    //aiPageRefreshPanel(panel, 'alteration');

  })
  .catch(err => {
    aiPageBtnStopLoading(btn, 'SUBMIT FOR ALTERATION');
    aiPageUnfreezePanel(panel);
    aiPageToast('An unexpected error occurred. Please try again.', 'error');
    console.error('Alteration fetch error:', err);
  });
}
 

//alteration implementation ends

// ─────────────────────────────────────────────────────────────
// UTILITIES
// ─────────────────────────────────────────────────────────────


// document.addEventListener('visibilitychange', function() {
//   if (document.visibilityState !== 'visible') return;

//   const waitingBtns = document.querySelectorAll('.ai-page-pay-now-waiting');
//   if (!waitingBtns.length) return;

//   waitingBtns.forEach(btn => {
//     if (btn.dataset.paymentStatus === 'paid') return;
//     const panelId = btn.dataset.panelId;
//     const panel   = document.getElementById(panelId);
//     const query   = panel?.dataset.refreshQuery || panel?.dataset.originalQuery || '';
//     if (query) {
//       chatQuery(query);
//     }
//   });
// });


// document.addEventListener('visibilitychange', function() {
//   if (document.visibilityState !== 'visible') return;

//   // Find any "waiting for payment" buttons
//   const waitingBtns = document.querySelectorAll('.ai-page-pay-now-waiting');
//   if (!waitingBtns.length) return;

//   waitingBtns.forEach(btn => {
//     if (btn.dataset.paymentStatus === 'paid') return;

//     const panelId = btn.dataset.panelId;
//     const panel   = document.getElementById(panelId)
//                  || document.querySelector('.ai-page-li-requested-only');

//     if (panel) {
//       aiPageRefreshPanel(panel, 'return');
//     }
//   });
// });


function aiPageResetPanel(panel) {
  if (!panel) return;

  // Uncheck all checkboxes
  panel.querySelectorAll('input[type="checkbox"]').forEach(chk => {
    chk.checked = false;
    chk.indeterminate = false;
  });

  // Uncheck all radios
  panel.querySelectorAll('input[type="radio"]').forEach(r => {
    r.checked = false;
  });

  // Reset all selects
  panel.querySelectorAll('select').forEach(sel => {
    sel.value = '';
  });

  // Clear all textareas
  panel.querySelectorAll('textarea').forEach(ta => {
    ta.value = '';
    ta.style.display = 'none';
  });

  // Hide all option panels
  panel.querySelectorAll('.ai-page-li-opts').forEach(el => {
    el.setAttribute('hidden', '');
    const cardsWrap = el.querySelector('.ai-page-li-opts-cards');
    if (cardsWrap) cardsWrap.innerHTML = '';
  });

  // Hide all faulty upload panels
  panel.querySelectorAll('.ai-page-li-faulty-upload').forEach(el => {
    el.setAttribute('hidden', '');
  });

  // Hide all detail panels
  panel.querySelectorAll('.ai-page-li-detail-panel').forEach(el => {
    el.setAttribute('hidden', '');
  });

  // Reset view details buttons
  panel.querySelectorAll('.ai-page-li-view-details-btn').forEach(btn => {
    btn.classList.remove('ai-page-li-view-details-open');
  });

  // Reset all qty displays
  panel.querySelectorAll('.ai-page-li-qty, .ai-page-ex-qty, .ai-page-alt-qty').forEach(el => {
    el.textContent = '1';
  });

  // Hide all error messages
  panel.querySelectorAll('.ai-page-li-error-msg').forEach(el => {
    el.hidden = true;
  });
  panel.querySelectorAll('.ai-page-li-opts-error').forEach(el => {
    el.classList.remove('ai-page-li-opts-error');
  });
  panel.querySelectorAll('.ai-page-li-field-error').forEach(el => {
    el.classList.remove('ai-page-li-field-error');
  });

  // Clear option descriptions
  panel.querySelectorAll('[id^="ai-page-optDesc_"]').forEach(el => {
    el.textContent = '';
  });

  // Hide summary
  const summary = panel.querySelector('.ai-page-li-summary');
  if (summary) summary.style.display = 'none';

  // Hide terms wrapper
  const termsWrapper = panel.querySelector('.ai-page-li-terms-wrapper');
  if (termsWrapper) termsWrapper.style.display = 'none';

  // Hide terms error
  const termsErr = panel.querySelector('.ai-page-li-terms-error');
  if (termsErr) termsErr.style.display = 'none';

  // Hide add to previous wrapper
  const addToPrev = panel.querySelector('.ai-page-li-addtoprev-wrapper');
  if (addToPrev) {
    addToPrev.style.display = 'none';
    const addToPrevErr = addToPrev.querySelector('.ai-page-li-addtoprev-error');
    if (addToPrevErr) addToPrevErr.style.display = 'none';
  }

  // Reset count
  const countEl = panel.querySelector('.ai-page-li-selected-count, .ai-page-ex-selected-count, .ai-page-alt-selected-count');
  if (countEl) countEl.textContent = '0 items selected';

  // Reset button
  const btn = panel.querySelector('.ai-page-li-process-btn');
  if (btn) {
    btn.disabled = true;
    btn.classList.remove('ai-page-li-process-active', 'ai-page-btn-loading', 'ai-page-btn-success', 'ai-page-li-process-done');
    btn.removeAttribute('data-original-text');
  }

  // Clear faulty files from memory
  panel.querySelectorAll('.ai-page-li-faulty-previews').forEach(el => {
    el.querySelectorAll('img').forEach(img => {
      if (img.src.startsWith('blob:')) URL.revokeObjectURL(img.src);
    });
    el.innerHTML = '';
  });
}


function aiPageSilentRefresh(message, onSuccess) {
  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;

  const payload = {
    query        : message,
    assistant_id : localStorage.getItem('session_id'),
    is_history   : isHistory
  };

  if (window.isProductPage && window.productId) {
    payload.product_id = window.productId;
  }

  const token = getAiToken();

  fetch('https://ai.mygoddiva.com/user-query', {
    method  : 'POST',
    headers : Object.assign(
      { 'Content-Type': 'application/json' },
      token ? { 'Authorization': 'Bearer ' + token } : {}
    ),
    body: JSON.stringify(payload)
  })
  .then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  })
  .then(response => {
    if (typeof onSuccess === 'function' && response.line_items) {
      onSuccess(response.line_items);
    }
  })
  .catch(err => {
    console.error('aiPageSilentRefresh error:', err);
  });
}


function aiPageRefreshPanel(panel, type) {
  // Try to get order/customer from panel or parent
  const orderId    = panel.dataset.orderId
                  || panel.closest('[data-order-id]')?.dataset.orderId;
  const customerId = panel.dataset.customerId
                  || panel.closest('[data-customer-id]')?.dataset.customerId;

  if (!orderId && !customerId) {
    // Fallback — find any panel on the page with order data
    const anyPanel = document.querySelector('[data-order-id][data-customer-id]');
    if (anyPanel) {
      return aiPageRefreshPanel(anyPanel, type);
    }
    console.warn('Cannot refresh: missing order/customer ID');
    return;
  }

  const query = panel.dataset.originalQuery
             || `return request order ${orderId}`;

  const isHistory = sessionStorage.getItem('is_history') === 'false' ? false : true;
  const payload = {
    query        : query,
    assistant_id : localStorage.getItem('session_id'),
    is_history   : isHistory
  };

  if (window.isProductPage && window.productId) {
    payload.product_id = window.productId;
  }

  const token = getAiToken();

  fetch('https://ai.mygoddiva.com/user-query', {
    method  : 'POST',
    headers : Object.assign(
      { 'Content-Type': 'application/json' },
      token ? { 'Authorization': 'Bearer ' + token } : {}
    ),
    body: JSON.stringify(payload)
  })
  .then(res => {
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    return res.json();
  })
  .then(response => {
    if (!response.line_items) return;

    response._originalQuery = query;
    response.type = type === 'return' ? 'return_request'
                  : type === 'exchange' ? 'exchange_request'
                  : 'alteration_request';

    if (typeof chatReponse === 'function') {
      chatReponse(response, null, null, null);
    }
  })
  .catch(err => {
    console.error('aiPageRefreshPanel error:', err);
  });
}


function aiPageShowPanelLoader(panel, message) {
  
  if (!panel) return;

  // Remove existing loader if any
  panel.classList.add('ai-page-panel-stale');

  //aiPageHidePanelLoader(panel);
  
  const loader = document.createElement('div');
  loader.className = 'ai-page-panel-loader';
  loader.innerHTML = `
    <div class="ai-page-panel-loader-inner">
      <div class="ai-page-panel-loader-spinner"></div>
      <p class="ai-page-panel-loader-text">${aiPageEscHtml(message || 'Refreshing...')}</p>
    </div>
  `;
  panel.style.position = 'relative';
  panel.appendChild(loader);
}

function aiPageHidePanelLoader(panel) {
  if (!panel) return;
  const loader = panel.querySelector('.ai-page-panel-loader');
  if (loader) loader.remove();
}

function aiPageToast(message, type = 'info', duration = 4000) {
  // type: 'success' | 'error' | 'warning' | 'info'
 
  // Create container if it doesn't exist
  let container = document.getElementById('ai-page-toast-container');
  if (!container) {
    container = document.createElement('div');
    container.id = 'ai-page-toast-container';
    const panel = document.getElementById('#shopify-section-chat-assistant-mobile') || document.body;
    panel.appendChild(container);
  }
 
  const toast = document.createElement('div');
  toast.className = `ai-page-toast ai-page-toast-${type}`;
 
  const icons = {
    success: '✓',
    error: '✕',
    warning: '⚠',
    info: 'ℹ',
  };
 
  toast.innerHTML = `
    <span class="ai-page-toast-icon">${icons[type] || icons.info}</span>
    <span class="ai-page-toast-msg">${aiPageEscHtml(message)}</span>
    <button class="ai-page-toast-close" onclick="this.parentElement.remove()">✕</button>
  `;
 
  container.appendChild(toast);
 
  // Trigger enter animation
  requestAnimationFrame(() => toast.classList.add('ai-page-toast-show'));
 
  // Auto dismiss
  const timer = setTimeout(() => {
    toast.classList.remove('ai-page-toast-show');
    toast.classList.add('ai-page-toast-hide');
    toast.addEventListener('animationend', () => toast.remove(), { once: true });
    // Fallback removal
    setTimeout(() => { if (toast.parentElement) toast.remove(); }, 400);
  }, duration);
 
  // Cancel auto-dismiss on hover
  toast.addEventListener('mouseenter', () => clearTimeout(timer));
  toast.addEventListener('mouseleave', () => {
    setTimeout(() => {
      toast.classList.remove('ai-page-toast-show');
      toast.classList.add('ai-page-toast-hide');
      toast.addEventListener('animationend', () => toast.remove(), { once: true });
      setTimeout(() => { if (toast.parentElement) toast.remove(); }, 400);
    }, 1500);
  });
}
 
 
// ═══════════════════════════════════════════════════════════════
// 2. CONFIRMATION DIALOG — custom, no jQuery
// ═══════════════════════════════════════════════════════════════
 function aiPageConfirm(options) {
  const {
    title = 'Confirm',
    message = 'Are you sure?',
    confirmText = 'Yes',
    cancelText = 'No',
    onConfirm,
    onCancel,
    items = [],
  } = options;

  let itemsHtml = '';
  if (items.length > 0) {
    itemsHtml = `
      <table class="ai-page-confirm-table" style="display:none">
        <thead><tr><th>Product</th><th>Reason</th><th>Qty</th></tr></thead>
        <tbody>
          ${items.map(item => `
            <tr>
              <td>${aiPageEscHtml(item.product || item.item_name || '')}</td>
              <td>${aiPageEscHtml(item.reason || item.reasonText || '')}</td>
              <td>${item.qty || item.quantity || 1}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>`;
  }

  const overlay = document.createElement('div');
  overlay.className = 'ai-page-confirm-overlay';
  overlay.innerHTML = `
    <div class="ai-page-confirm-box">
      <div class="ai-page-confirm-header">
        <span class="ai-page-confirm-title">${aiPageEscHtml(title)}</span>
        <button class="ai-page-confirm-close" data-action="cancel">✕</button>
      </div>
      <div class="ai-page-confirm-body">
        <p>${aiPageEscHtml(message)}</p>
        ${itemsHtml}
      </div>
      <div class="ai-page-confirm-footer">
        <button class="ai-page-confirm-btn ai-page-confirm-btn-cancel" data-action="cancel">
          ${aiPageEscHtml(cancelText)}
        </button>
        <button class="ai-page-confirm-btn ai-page-confirm-btn-confirm" data-action="confirm">
          ${aiPageEscHtml(confirmText)}
        </button>
      </div>
    </div>
  `;

  function close(action) {
    overlay.classList.add('ai-page-confirm-closing');
    overlay.addEventListener('animationend', () => overlay.remove(), { once: true });
    setTimeout(() => { if (overlay.parentElement) overlay.remove(); }, 300);
    if (action === 'confirm' && typeof onConfirm === 'function') onConfirm();
    if (action === 'cancel' && typeof onCancel === 'function') onCancel();
  }

  overlay.addEventListener('click', (e) => {
    const action = e.target.dataset.action;
    if (action) close(action);
    if (e.target === overlay) close('cancel');
  });

  const escHandler = (e) => {
    if (e.key === 'Escape') { close('cancel'); document.removeEventListener('keydown', escHandler); }
  };
  document.addEventListener('keydown', escHandler);

  // Append inside chat panel, not body
  const container = document.getElementById('#shopify-section-chat-assistant-mobile') || document.body;
  container.appendChild(overlay);
  requestAnimationFrame(() => overlay.classList.add('ai-page-confirm-open'));
}
 
 
// ═══════════════════════════════════════════════════════════════
// 3. LOADING SPINNER HELPERS
// ═══════════════════════════════════════════════════════════════
 
function aiPageBtnStartLoading(btn, text) {
  if (!btn) return;
  btn.disabled = true;
  btn.dataset.originalText = btn.innerHTML;
  btn.innerHTML = `
    <span class="ai-page-btn-spinner"></span>
    ${aiPageEscHtml(text || 'Processing…')}
  `;
  btn.classList.add('ai-page-btn-loading');
}
 
function aiPageBtnStopLoading(btn, text) {
  if (!btn) return;
  btn.disabled = false;
  btn.innerHTML = btn.dataset.originalText || text || 'Submit';
  btn.classList.remove('ai-page-btn-loading');
}
 
function aiPageBtnSuccess(btn, text) {
  if (!btn) return;
  btn.innerHTML = `<span style="margin-right:4px;">✓</span> ${aiPageEscHtml(text || 'Done')}`;
  btn.classList.remove('ai-page-btn-loading');
  btn.classList.add('ai-page-btn-success');
  btn.disabled = true;
}
 
 
// ═══════════════════════════════════════════════════════════════
// 4. SMOOTH SCROLL TO FIRST ERROR
// ═══════════════════════════════════════════════════════════════
 
function aiPageScrollToFirstError(panel) {
  if (!panel) return;
  const firstError = panel.querySelector(
    '.ai-page-li-field-error, .ai-page-li-error-msg:not([hidden]), .ai-page-li-opts-error'
  );
  if (firstError) {
    const card = firstError.closest('.ai-page-li-card');
    const target = card || firstError;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // Brief highlight
    target.classList.add('ai-page-card-highlight');
    setTimeout(() => target.classList.remove('ai-page-card-highlight'), 2000);
  }
}
 

function aiPageEscHtml(str) {
  return String(str)
    .replace(/&/g,  '&amp;')
    .replace(/</g,  '&lt;')
    .replace(/>/g,  '&gt;')
    .replace(/"/g,  '&quot;')
    .replace(/'/g, '&#39;');
}

function aiPageInfoIcon() {
  return `<svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2" width="13" height="13">
    <circle cx="8" cy="8" r="6"/><path d="M8 7v4M8 5.5v.5"/>
  </svg>`;
}